import { i as e, n as t, r as n, t as r } from "./vendor-CFofnF5K.mjs";
import i, { forwardRef as a, useCallback as o, useEffect as s, useId as c, useImperativeHandle as l, useRef as u, useState as d } from "react";
import { Fragment as f, jsx as p, jsxs as m } from "react/jsx-runtime";
import h from "react-modal";
import { DndProvider as g, useDrag as _, useDrop as v } from "react-dnd";
import { TouchBackend as y } from "react-dnd-touch-backend";
import b from "react-calendar";
import { HexColorPicker as x } from "react-colorful";
//#region hooks/useBeforeNavigateAway.tsx
function S(e) {
	s(() => {
		if (!e) return;
		let t = (e) => {
			e.preventDefault(), e.returnValue = "";
		};
		return window.addEventListener("beforeunload", t), () => {
			window.removeEventListener("beforeunload", t);
		};
	}, [e]);
}
//#endregion
//#region hooks/useClickAwayClose.tsx
var C = (e, t, n) => {
	s(() => {
		if (!t?.current) return;
		let r = (r) => {
			e && t.current && !t.current.contains(r.target) && n();
		};
		return document.addEventListener("click", r), () => {
			document.removeEventListener("click", r);
		};
	}, [e]);
}, w = ({ initialValue: e, tickInSeconds: t, onCountdownComplete: n, startCountDown: r = !0 }) => {
	let [i, a] = d(e), o = u(0);
	function c() {
		o.current &&= (clearInterval(o.current), null);
	}
	return s(() => r ? (o.current && clearInterval(o.current), i <= 0 ? (n?.(), () => {
		c();
	}) : (o.current = setTimeout(() => {
		a(i - 1);
	}, t * 1e3), () => {
		c();
	})) : () => {
		c();
	}, [i, r]), s(() => {
		a(e);
	}, [e]), i;
}, T = (e, t) => {
	let [n, r] = d(e);
	return s(() => {
		let n = setTimeout(() => {
			r(e);
		}, t);
		return () => {
			clearTimeout(n);
		};
	}, [e, t]), n;
}, E = (e, t, n) => {
	s(() => {
		function r(e) {
			i(e) ? t(!0) : t(!1);
		}
		function i(t) {
			let r = t.path || t.composedPath && t.composedPath();
			if (r) {
				for (let t of r) if (n) {
					if (typeof t.className == "string" && Array.isArray(t.className.split(" ")) && t.className.split(" ").find((t) => t === e)) return !0;
				} else if (t.className === e) return !0;
			}
			return !1;
		}
		return window.addEventListener("click", r), () => {
			window.removeEventListener("click", r);
		};
	}, [e]);
}, D = (e, t) => {
	let n = u(null);
	return s(() => {
		if (e) {
			let r = new IntersectionObserver((n) => {
				n[0].isIntersecting && t && e();
			}, {
				root: null,
				rootMargin: "20px",
				threshold: 1
			});
			return n.current && r.observe(n.current), () => {
				n.current && r.unobserve(n.current);
			};
		}
	}, [e]), n;
}, O = "pause-other-media";
function k(e) {
	return s(() => {
		let t = (t) => {
			let n = t;
			e.current && n.detail !== e.current && e.current.pause();
		};
		return window.addEventListener(O, t), () => window.removeEventListener(O, t);
	}, [e]), () => {
		e.current && window.dispatchEvent(new CustomEvent(O, { detail: e.current }));
	};
}
//#endregion
//#region hooks/useResizeListener.tsx
function A(e) {
	let t = () => {
		e();
	};
	return window.addEventListener("resize", t), () => {
		window.removeEventListener("resize", t);
	};
}
//#endregion
//#region interfaces/global/content/content.ts
var j = /* @__PURE__ */ function(e) {
	return e.List = "list", e.Page = "page", e.Rss = "rss", e.Contact = "contact", e.Web = "web", e.Image = "image", e.File = "file", e.Video = "video", e.NotAccepted = "notAccepted", e.Audio = "audio", e.Form = "form", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.ACKNOWLEDGED = "ACKNOWLEDGED", e.ACKNOWLEDGEMENT_DISABLED = "ACKNOWLEDGEMENT_DISABLED", e.ACTIVITY = "ACTIVITY", e.ALERT_INFO = "ALERT_INFO", e.ALIGN_LEFT = "ALIGN_LEFT", e.ARCHIVE = "ARCHIVE", e.ARTICLE = "ARTICLE", e.ARROW_LEFT = "ARROW_LEFT", e.AUDIO = "AUDIO", e.BELL = "BELL", e.BELL_RING = "BELL_RING", e.BIN = "BIN", e.BOOKMARK = "BOOKMARK", e.BROADCAST = "BROADCAST", e.BRIEFCASE = "BRIEFCASE", e.BUOY = "BUOY", e.CALENDAR = "CALENDAR", e.CAMERA = "CAMERA", e.CAMERA_OFF = "CAMERA_OFF", e.CHECK = "CHECK", e.CHECKBOX = "CHECKBOX", e.CHECK_DOUBLE = "CHECK_DOUBLE", e.CHEVRON_DOWN = "CHEVRON_DOWN", e.CHEVRON_UP_DOWN = "CHEVRON_UP_DOWN", e.CHEVRON_RIGHT = "CHEVRON_RIGHT", e.CHOICE_PILL = "CHOICE_PILL", e.CIRCLE_CHECK = "CIRCLE_CHECK", e.CIRCLE_CLOSE = "CIRCLE_CLOSE", e.CIRCLE_LEFT = "CIRCLE_LEFT", e.CIRCLE_RIGHT = "CIRCLE_RIGHT", e.CLEAR_FIELD = "CLEAR_FIELD", e.CLOCK = "CLOCK", e.CLOSE = "CLOSE", e.COG = "COG", e.COMMENT = "COMMENT", e.COMMENT_ACTIVE = "COMMENT_ACTIVE", e.COMPETITION = "COMPETITION", e.COMPUTER_EXTERNAL = "COMPUTER_EXTERNAL", e.CONTACT = "CONTACT", e.COPY = "COPY", e.DASH = "DASH", e.DASH_CIRCLE = "DASH_CIRCLE", e.DOWNLOAD = "DOWNLOAD", e.DRAG = "DRAG", e.DROPDOWN = "DROPDOWN", e.EMPTY_SEARCH = "EMPTY_SEARCH", e.EXISTING = "EXISTING", e.EXTERNAL_LINK = "EXTERNAL_LINK", e.EYE_ON = "EYE_ON", e.EYE_OFF = "EYE_OFF", e.FACE_ID = "FACE_ID", e.FILE_DOWNLOAD = "FILE_DOWNLOAD", e.FILE_RESPONSE = "FILE_RESPONSE", e.FILE_UPLOAD = "FILE_UPLOAD", e.FILTERS = "FILTERS", e.FILTERS_ACTIVE = "FILTERS_ACTIVE", e.FLAG = "FLAG", e.GLOBE = "GLOBE", e.HOME = "HOME", e.HEART = "HEART", e.HEART_ACTIVE = "HEART_ACTIVE", e.IMAGE = "IMAGE", e.IMAGE_UPLOAD = "IMAGE_UPLOAD", e.INFO = "INFO", e.INPUT_DOTS = "INPUT_DOTS", e.KEY = "KEY", e.LIBRARY = "LIBRARY", e.LIKE = "LIKE", e.LIKE_ACTIVE = "LIKE_ACTIVE", e.LINK = "LINK", e.LINKED = "LINKED", e.LIST = "LIST", e.LIST_ITEM = "LIST_ITEM", e.LOCK = "LOCK", e.LOCKER = "LOCKER", e.LOGOUT = "LOGOUT", e.MAIL = "MAIL", e.MAP_PIN = "MAP_PIN", e.MAXIMISE = "MAXIMISE", e.MENTIONS = "MENTIONS", e.MENU = "MENU", e.MENU_MORE = "MENU_MORE", e.MIDDOT = "MIDDOT", e.MINIMISE = "MINIMISE", e.OLD_PHONE = "OLD_PHONE", e.ORDER_BOTTOM = "ORDER_BOTTOM", e.ORDER_DOWN = "ORDER_DOWN", e.ORDER_TOP = "ORDER_TOP", e.ORDER_UP = "ORDER_UP", e.PARAGRAPH = "PARAGRAPH", e.PASSKEY = "PASSKEY", e.PAUSE = "PAUSE", e.PENCIL = "PENCIL", e.PERSON = "PERSON", e.PHONE = "PHONE", e.PLAY = "PLAY", e.POLL = "POLL", e.RECOVERY = "RECOVERY", e.REPEAT = "REPEAT", e.RIBBON = "RIBBON", e.RSS = "RSS", e.SEARCH_GLASS = "SEARCH_GLASS", e.SEND = "SEND", e.SETTINGS = "SETTINGS", e.SHARE = "SHARE", e.SKIP_BACK = "SKIP_BACK", e.SKIP_FORWARD = "SKIP_FORWARD", e.SKIP_TO_FIRST = "SKIP_TO_FIRST", e.SKIP_TO_LAST = "SKIP_TO_LAST", e.SKIP_TO_NEXT = "SKIP_TO_NEXT", e.SKIP_TO_PREVIOUS = "SKIP_TO_PREVIOUS", e.SMILEY_BELL = "SMILEY_BELL", e.SOCIAL_FACEBOOK = "SOCIAL_FACEBOOK", e.SOCIAL_X = "SOCIAL_X", e.SOCIAL_LINKED_IN = "SOCIAL_LINKED_IN", e.SPOTLIGHT = "SPOTLIGHT", e.THRIVE = "THRIVE", e.TOUCH_ID = "TOUCH_ID", e.UNLOCK = "UNLOCK", e.USER_COG = "USER_COG", e.USER_EXTERNAL = "USER_EXTERNAL", e.USER_NONE = " USER_NONE", e.USER_PASSKEY = "USER_PASSKEY", e.USER_PLUS = "USER_PLUS", e.USER_SEARCH = "USER_SEARCH", e.USERS = "USERS", e.VIDEO = "VIDEO", e.WARNING = "WARNING", e.WARNING_BADGE = "WARNING_BADGE", e.WEBPAGE = "WEBPAGE", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.SUCCESS = "SUCCESS", e.ERROR = "ERROR", e.DELETED = "DELETED", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.SHORT_TEXT = "Short Text", e.LONG_TEXT = "Long Text", e.DROPDOWN = "Dropdown", e.USER_SELECT = "User Select", e.CHECKBOX = "Checkbox", e.IMAGE_SELECT = "Image Select", e.VIDEO_SELECT = "Video Select", e.FILE_SELECT = "File Select", e.SUBMIT_BUTTON = "Submit Button", e.CHOICE_BUTTON = "Choice Button", e.VIEW_FORM_BUTTON = "View Form Button", e.SINGLE_SELECT = "Single Select", e.POLL = "Poll", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.TITLE_IS_REQUIRED = "titleIsRequired", e.RULES_ARE_INVALID = "rulesAreInvalid", e.DROPDOWN_REQUIRES_OPTIONSETS = "dropDownRequiresOptionSets", e.MUST_HAVE_AT_LEAST_1_OPTION = "mustHaveAtLeastOneOption", e.OPTIONS_MUST_HAVE_LABEL_TEXT = "optionsMustHaveLabelText", e.CONDITIONAL_EXPRESSION_IS_INVALID = "condtionalExpressionIsInvalid", e;
}({}), F = ({ content: e, ariaLabel: t, className: n, isClassicThriveStyle: r = !1, isDisabled: i = !1, onButtonClick: a, isLink: o, linkUrl: s, openInNewTab: c = !1 }) => o ? /* @__PURE__ */ p("a", {
	className: `basic-button ${r && "classic-style-button"} ${n ?? ""} ${i && "disabled-style-link"}`,
	"aria-label": t,
	href: s,
	target: c ? "_blank" : void 0,
	rel: c ? "noopener noreferrer" : void 0,
	children: e
}) : /* @__PURE__ */ p("button", {
	className: `basic-button ${r && "classic-style-button"} ${n ?? ""}`,
	disabled: i,
	"aria-label": t,
	onClick: a,
	type: "button",
	children: e
}), te = ({ content: e, ariaLabel: t, onAddConditionClick: n }) => n ? /* @__PURE__ */ p(F, {
	className: "add-condition-button",
	content: e,
	ariaLabel: t,
	onButtonClick: n
}) : /* @__PURE__ */ p(f, {}), I = /* @__PURE__ */ function(e) {
	return e.UP = "UP", e.DOWN = "DOWN", e.BOTH = "BOTH", e;
}({});
//#endregion
//#region helpers/Toggle.tsx
function ne(e) {
	return e === I.DOWN ? /* @__PURE__ */ m("svg", {
		width: "12",
		height: "12",
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ p("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.29289 14.2929C6.68342 13.9024 7.31658 13.9024 7.70711 14.2929L12 18.5858L16.2929 14.2929C16.6834 13.9024 17.3166 13.9024 17.7071 14.2929C18.0976 14.6834 18.0976 15.3166 17.7071 15.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L6.29289 15.7071C5.90237 15.3166 5.90237 14.6834 6.29289 14.2929Z",
			fill: "#343D4C"
		}), /* @__PURE__ */ p("path", {
			opacity: "0.4",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711C17.3166 10.0976 16.6834 10.0976 16.2929 9.70711L12 5.41421L7.70711 9.70711C7.31658 10.0976 6.68342 10.0976 6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289L11.2929 3.29289Z",
			fill: "#343D4C"
		})]
	}) : e === I.UP ? /* @__PURE__ */ m("svg", {
		width: "12",
		height: "12",
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ p("path", {
			opacity: "0.4",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.29289 14.2929C6.68342 13.9024 7.31658 13.9024 7.70711 14.2929L12 18.5858L16.2929 14.2929C16.6834 13.9024 17.3166 13.9024 17.7071 14.2929C18.0976 14.6834 18.0976 15.3166 17.7071 15.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L6.29289 15.7071C5.90237 15.3166 5.90237 14.6834 6.29289 14.2929Z",
			fill: "#343D4C"
		}), /* @__PURE__ */ p("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711C17.3166 10.0976 16.6834 10.0976 16.2929 9.70711L12 5.41421L7.70711 9.70711C7.31658 10.0976 6.68342 10.0976 6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289L11.2929 3.29289Z",
			fill: "#343D4C"
		})]
	}) : /* @__PURE__ */ m("svg", {
		width: "12",
		height: "12",
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ p("path", {
			opacity: "0.4",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.29289 14.2929C6.68342 13.9024 7.31658 13.9024 7.70711 14.2929L12 18.5858L16.2929 14.2929C16.6834 13.9024 17.3166 13.9024 17.7071 14.2929C18.0976 14.6834 18.0976 15.3166 17.7071 15.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L6.29289 15.7071C5.90237 15.3166 5.90237 14.6834 6.29289 14.2929Z",
			fill: "#343D4C"
		}), /* @__PURE__ */ p("path", {
			opacity: "0.4",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711C17.3166 10.0976 16.6834 10.0976 16.2929 9.70711L12 5.41421L7.70711 9.70711C7.31658 10.0976 6.68342 10.0976 6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289L11.2929 3.29289Z",
			fill: "#343D4C"
		})]
	});
}
//#endregion
//#region components/global/toggles/ToggleSelectButton.tsx
var L = ({ selectedItem: e, defaultTitle: t, className: n, ariaLabel: r, toggleDisabled: i = !1, buttonList: a }) => {
	let o = u(null), [s, c] = d(!1);
	return C(s, o, () => {
		c(!1);
	}), /* @__PURE__ */ m("div", {
		className: "toggle-select-container",
		ref: o,
		children: [/* @__PURE__ */ p(F, {
			content: /* @__PURE__ */ m("span", {
				className: "toggle-select-button-content",
				children: [/* @__PURE__ */ p("span", {
					className: "toggle-select-label",
					children: e?.text || t || ""
				}), /* @__PURE__ */ p("span", {
					className: "toggle-select-icon",
					children: ne(I.BOTH)
				})]
			}),
			ariaLabel: r,
			className: `toggle-select-button ${n ?? ""}`,
			isDisabled: i || !a || !a?.length,
			onButtonClick: () => c(!s)
		}), s && a && a.length > 0 && /* @__PURE__ */ p("div", {
			className: `toggle-select-button-list ${a.length === 1 ? "single-button" : ""}`,
			children: a?.map((t, n) => /* @__PURE__ */ p(F, {
				className: `toggle-select-button-list-item ${t.id === e?.id ? "toggle-select-button-selected" : ""} `,
				content: t.text,
				ariaLabel: t.label,
				isDisabled: t.isDisabled,
				onButtonClick: () => {
					c(!s), t.onButtonClick?.();
				}
			}, n))
		})]
	});
};
//#endregion
//#region helpers/IconLibrary.ts
function re(e) {
	return ce[e];
}
function ie(e) {
	let t = e.match(/<path([^>]*)\/>/g);
	return t ? t.map((e) => {
		let t = e.match(/d="([^"]+)"/);
		if (t?.[1]) return t[1];
	}) : [];
}
function ae(e) {
	switch (e) {
		case N.SUCCESS: return M.ACKNOWLEDGED;
		case N.ERROR: return M.CLEAR_FIELD;
		case N.DELETED: return M.BIN;
		default: return M.ACKNOWLEDGED;
	}
}
function oe(e) {
	switch (e) {
		case "accountRecoveryRequest": return M.USER_PASSKEY;
		case "contentLike":
		case "commentLike": return M.LIKE_ACTIVE;
		case "comment":
		case "commentReply": return M.COMMENT_ACTIVE;
		case "objectionableComment": return M.WARNING_BADGE;
		case "moderatedRecognition":
		case "recognition": return M.RIBBON;
		case "acknowledgementResponse": return M.FLAG;
		case "contentPosted":
		case "moderatedContent": return M.ARTICLE;
		case "competitionPost": return M.COMPETITION;
		case "compliancePost": return M.FLAG;
		case "eventPost": return M.CALENDAR;
		case "formResponse": return M.FILE_RESPONSE;
		default: return M.LIKE_ACTIVE;
	}
}
function se(e) {
	switch (e.toLowerCase()) {
		case "list": return M.LIST;
		case "page": return M.LIST_ITEM;
		case "web": return M.WEBPAGE;
		case "image": return M.IMAGE;
		case "video": return M.VIDEO;
		case "file": return M.LIST_ITEM;
		case "contact": return M.CONTACT;
		case "rss": return M.RSS;
		case "audio": return M.AUDIO;
		default: return M.IMAGE_UPLOAD;
	}
}
var ce = {
	[M.ACKNOWLEDGED]: "<path d=\"M39.9905 4C46.5127 4 52.5601 5.63291 58.1329 8.89873C63.5538 12.1171 67.8734 16.4367 71.0918 21.8576C74.3576 27.4209 75.9905 33.4684 75.9905 40C75.9905 46.5316 74.3576 52.5696 71.0918 58.1424C67.8734 63.5633 63.5538 67.8829 58.1329 71.1013C52.5696 74.3671 46.5222 76 39.9905 76C33.4589 76 27.4209 74.3671 21.8481 71.1013C16.4272 67.8829 12.1076 63.5633 8.88924 58.1424C5.63291 52.5696 4 46.5222 4 39.9905C4 33.4589 5.63291 27.4209 8.89873 21.8481C12.1171 16.4272 16.4367 12.1076 21.8576 8.88924C27.4209 5.63291 33.4684 4 39.9905 4ZM56.6899 25.019L35.0253 46.3228L26.3196 37.8259L22 42.0696L35.0253 54.9525L61.0095 29.2532L56.6899 25.0095V25.019Z\"/>",
	[M.ACKNOWLEDGEMENT_DISABLED]: "<path d=\"M39.9905 4C46.5127 4 52.5601 5.63291 58.1329 8.89873C63.5538 12.1171 67.8734 16.4367 71.0918 21.8576C74.3576 27.4209 75.9905 33.4684 75.9905 40C75.9905 46.5316 74.3576 52.5696 71.0918 58.1424C67.8734 63.5633 63.5538 67.8829 58.1329 71.1013C52.5696 74.3671 46.5222 76 39.9905 76C33.4589 76 27.4209 74.3671 21.8481 71.1013C16.4272 67.8829 12.1076 63.5633 8.88924 58.1424C5.63291 52.5696 4 46.5222 4 39.9905C4 33.4589 5.63291 27.4209 8.89873 21.8481C12.1171 16.4272 16.4367 12.1076 21.8576 8.88924C27.4209 5.63291 33.4684 4 39.9905 4ZM22.4272 36.3924L22.2848 43.5222L57.7057 43.4462V36.4684L22.4367 36.3924H22.4272Z\"/>",
	[M.ACTIVITY]: "<path d=\"M26.5215 23.8451L38.1004 73.078C38.9855 76.8411 44.2757 77.019 45.4115 73.3238L56.5703 37.0197L58.0293 42.8081C58.4536 44.4916 59.9677 45.6714 61.7038 45.6714H73.9999C76.0927 45.6714 77.7893 43.9748 77.7893 41.882C77.7893 39.7891 76.0927 38.0925 73.9999 38.0925H64.6567L60.6059 22.0212C59.6688 18.3034 54.4355 18.1692 53.3091 21.834L42.2761 57.7285L30.3271 6.92191C29.4177 3.05506 23.928 3.01513 22.9625 6.86834L15.1379 38.0925H5.78947C3.6966 38.0925 2 39.7891 2 41.882C2 43.9748 3.6966 45.6714 5.78947 45.6714H18.095C19.833 45.6714 21.3483 44.489 21.7708 42.8031L26.5215 23.8451Z\"/>",
	[M.ALERT_INFO]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4.00024 40C4.00024 20.1177 20.118 4 40.0002 4C59.8825 4 76.0002 20.1177 76.0002 40C76.0002 59.8823 59.8825 76 40.0002 76C20.118 76 4.00024 59.8823 4.00024 40ZM40.0002 10.5455C23.7329 10.5455 10.5457 23.7327 10.5457 40C10.5457 56.2673 23.7329 69.4545 40.0002 69.4545C56.2675 69.4545 69.4548 56.2673 69.4548 40C69.4548 23.7327 56.2675 10.5455 40.0002 10.5455ZM40.0002 23.6364C41.8077 23.6364 43.273 25.1016 43.273 26.9091V40.0001C43.273 41.8076 41.8077 43.2728 40.0002 43.2728C38.1928 43.2728 36.7275 41.8076 36.7275 40.0001V26.9091C36.7275 25.1016 38.1928 23.6364 40.0002 23.6364ZM36.7275 53.0909C36.7275 51.2834 38.1928 49.8182 40.0002 49.8182H40.0335C41.8409 49.8182 43.3062 51.2834 43.3062 53.0909C43.3062 54.8984 41.8409 56.3637 40.0335 56.3637H40.0002C38.1928 56.3637 36.7275 54.8984 36.7275 53.0909Z\" />",
	[M.ALIGN_LEFT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M3.99976 18.6359C3.99976 16.6278 5.62758 15 7.63561 15H72.364C74.372 15 75.9998 16.6278 75.9998 18.6359C75.9998 20.6439 74.372 22.2717 72.364 22.2717H7.63561C5.62758 22.2717 3.99976 20.6439 3.99976 18.6359ZM3.99976 32.8618C3.99976 30.8537 5.62758 29.226 7.63561 29.226H57.9799C59.9879 29.226 61.6157 30.8537 61.6157 32.8618C61.6157 34.8699 59.9879 36.4976 57.9799 36.4976H7.63561C5.62758 36.4976 3.99976 34.8699 3.99976 32.8618ZM3.99976 47.0877C3.99976 45.0797 5.62758 43.4518 7.63561 43.4518H72.364C74.372 43.4518 75.9998 45.0797 75.9998 47.0877C75.9998 49.0958 74.372 50.7236 72.364 50.7236H7.63561C5.62758 50.7236 3.99976 49.0958 3.99976 47.0877ZM3.99976 61.314C3.99976 59.306 5.62758 57.6782 7.63561 57.6782H57.9799C59.9879 57.6782 61.6157 59.306 61.6157 61.314C61.6157 63.3221 59.9879 64.9499 57.9799 64.9499H7.63561C5.62758 64.9499 3.99976 63.3221 3.99976 61.314Z\"/>",
	[M.ARCHIVE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4 13.5455C4 9.9305 6.9305 7 10.5455 7H69.4545C73.0695 7 76 9.9305 76 13.5455V23.3636C76 26.9786 73.0695 29.9091 69.4545 29.9091V62.6364C69.4545 65.2403 68.4201 67.7376 66.5789 69.5789C64.7376 71.4201 62.2403 72.4545 59.6364 72.4545H20.3636C17.7597 72.4545 15.2624 71.4201 13.4211 69.5789C11.5799 67.7376 10.5455 65.2403 10.5455 62.6364V29.9091C6.9305 29.9091 4 26.9786 4 23.3636V13.5455ZM17.0909 29.9091V62.6364C17.0909 63.5043 17.4357 64.3368 18.0495 64.9505C18.6632 65.5643 19.4957 65.9091 20.3636 65.9091H59.6364C60.5043 65.9091 61.3368 65.5643 61.9505 64.9505C62.5643 64.3368 62.9091 63.5043 62.9091 62.6364V29.9091H17.0909ZM10.5455 23.3636V13.5455H69.4545V23.3636H10.5455ZM30.1818 39.7273C30.1818 37.9198 31.6471 36.4545 33.4545 36.4545H46.5455C48.3529 36.4545 49.8182 37.9198 49.8182 39.7273C49.8182 41.5348 48.3529 43 46.5455 43H33.4545C31.6471 43 30.1818 41.5348 30.1818 39.7273Z\" />",
	[M.ARTICLE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M21.1031 5.94654C23.3838 4.62973 26.2382 4 29.0273 4H63.7469C66.536 4 69.3904 4.62973 71.6711 5.94654C73.8947 7.23031 76 9.48306 76 12.5846V65.0949C76 67.7512 74.9214 70.2831 73.027 72.1378C71.1351 73.99 68.585 75.0174 65.9414 75.0174H14.0586C11.415 75.0174 8.86489 73.99 6.97301 72.1378C5.07855 70.2831 4 67.7512 4 65.0949V36.523C4 33.8666 5.07855 31.3348 6.97301 29.4801C8.86489 27.6279 11.415 26.6005 14.0586 26.6005H16.7742V12.5846C16.7742 9.48307 18.8795 7.23031 21.1031 5.94654ZM16.7742 33.7469H14.0586C13.2621 33.7469 12.513 34.0574 11.9724 34.5866C11.4344 35.1134 11.1464 35.8115 11.1464 36.523V65.0949C11.1464 65.8064 11.4344 66.5045 11.9724 67.0312C12.513 67.5605 13.2621 67.871 14.0586 67.871H16.7742V33.7469ZM23.9206 67.871H65.9414C66.7379 67.871 67.487 67.5605 68.0276 67.0312C68.5656 66.5045 68.8536 65.8064 68.8536 65.0949V12.7373C68.7705 12.6265 68.5535 12.3986 68.0979 12.1355C67.123 11.5726 65.5619 11.1464 63.7469 11.1464H29.0273C27.2123 11.1464 25.6512 11.5726 24.6763 12.1355C24.2207 12.3986 24.0037 12.6265 23.9206 12.7373V67.871Z\"/>\n<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M31 20.2727C31 18.4653 32.4652 17 34.2727 17H60.4545C62.262 17 63.7273 18.4653 63.7273 20.2727V33.3636C63.7273 35.1711 62.262 36.6364 60.4545 36.6364H34.2727C32.4652 36.6364 31 35.1711 31 33.3636V20.2727ZM37.5455 23.5455V30.0909H57.1818V23.5455H37.5455ZM31 46.4529C31 44.6455 32.4652 43.1802 34.2727 43.1802H60.4545C62.262 43.1802 63.7273 44.6455 63.7273 46.4529C63.7273 48.2604 62.262 49.7257 60.4545 49.7257H34.2727C32.4652 49.7257 31 48.2604 31 46.4529ZM31 59.5455C31 57.738 32.4652 56.2727 34.2727 56.2727H50.6364C52.4438 56.2727 53.9091 57.738 53.9091 59.5455C53.9091 61.3529 52.4438 62.8182 50.6364 62.8182H34.2727C32.4652 62.8182 31 61.3529 31 59.5455Z\"/>",
	[M.ARROW_LEFT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M43.182 5.31802C44.9393 7.07538 44.9393 9.92462 43.182 11.682L19.364 35.5H71.5C73.9853 35.5 76 37.5147 76 40C76 42.4853 73.9853 44.5 71.5 44.5H19.364L43.182 68.318C44.9393 70.0754 44.9393 72.9246 43.182 74.682C41.4246 76.4393 38.5754 76.4393 36.818 74.682L5.31802 43.182C3.56066 41.4246 3.56066 38.5754 5.31802 36.818L36.818 5.31802C38.5754 3.56066 41.4246 3.56066 43.182 5.31802Z\"/>",
	[M.AUDIO]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 11.2C32.3618 11.2 25.0364 14.2343 19.6353 19.6353C14.2343 25.0364 11.2 32.3618 11.2 40V61.6C11.2 63.5882 9.58823 65.2 7.6 65.2C5.61177 65.2 4 63.5882 4 61.6V40C4 30.4522 7.79285 21.2955 14.5442 14.5442C21.2955 7.79285 30.4522 4 40 4C49.5478 4 58.7045 7.79285 65.4558 14.5442C72.2072 21.2955 76 30.4522 76 40V61.6C76 63.5882 74.3882 65.2 72.4 65.2C70.4118 65.2 68.8 63.5882 68.8 61.6V40C68.8 32.3618 65.7657 25.0364 60.3647 19.6353C54.9636 14.2343 47.6382 11.2 40 11.2Z\"/><path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4 47.2C4 45.2118 5.61177 43.6 7.6 43.6H18.4C21.2643 43.6 24.0114 44.7379 26.0368 46.7633C28.0621 48.7886 29.2 51.5357 29.2 54.4V65.2C29.2 68.0643 28.0621 70.8114 26.0368 72.8368C24.0114 74.8621 21.2643 76 18.4 76H14.8C11.9357 76 9.18864 74.8621 7.16325 72.8368C5.13785 70.8114 4 68.0643 4 65.2V47.2ZM11.2 50.8V65.2C11.2 66.1548 11.5793 67.0705 12.2544 67.7456C12.9295 68.4207 13.8452 68.8 14.8 68.8H18.4C19.3548 68.8 20.2705 68.4207 20.9456 67.7456C21.6207 67.0705 22 66.1548 22 65.2V54.4C22 53.4452 21.6207 52.5296 20.9456 51.8544C20.2705 51.1793 19.3548 50.8 18.4 50.8H11.2ZM61.6 50.8C60.6452 50.8 59.7296 51.1793 59.0544 51.8544C58.3793 52.5296 58 53.4452 58 54.4V65.2C58 66.1548 58.3793 67.0704 59.0544 67.7456C59.7296 68.4207 60.6452 68.8 61.6 68.8H65.2C66.1548 68.8 67.0705 68.4207 67.7456 67.7456C68.4207 67.0704 68.8 66.1548 68.8 65.2V50.8H61.6ZM53.9633 46.7633C55.9886 44.7379 58.7357 43.6 61.6 43.6H72.4C74.3882 43.6 76 45.2118 76 47.2V65.2C76 68.0643 74.8621 70.8114 72.8368 72.8368C70.8114 74.8621 68.0643 76 65.2 76H61.6C58.7357 76 55.9886 74.8621 53.9633 72.8368C51.9379 70.8114 50.8 68.0643 50.8 65.2V54.4C50.8 51.5357 51.9379 48.7886 53.9633 46.7633Z\"/>",
	[M.BELL]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M23.531 10.711C27.828 6.41402 33.6559 4 39.7327 4C45.8096 4 51.6375 6.41402 55.9345 10.711C60.2315 15.008 62.6455 20.8359 62.6455 26.9128C62.6455 37.8869 64.9926 44.7017 67.1557 48.6673C68.2417 50.6584 69.2992 51.9646 70.0338 52.74C70.402 53.1286 70.6913 53.3863 70.8655 53.5314C70.9526 53.6041 71.0111 53.6486 71.0363 53.6674C71.0402 53.6703 71.0433 53.6726 71.0456 53.6743C72.219 54.4803 72.7383 55.9548 72.3248 57.3206C71.9068 58.7011 70.6344 59.6453 69.192 59.6453H10.2735C8.83109 59.6453 7.55869 58.7011 7.1407 57.3206C6.72715 55.9547 7.24641 54.4803 8.41982 53.6743C8.42211 53.6726 8.42524 53.6703 8.42918 53.6674C8.45438 53.6486 8.51282 53.6041 8.59996 53.5314C8.77415 53.3863 9.06345 53.1286 9.43161 52.74C10.1662 51.9646 11.2238 50.6584 12.3098 48.6673C14.4729 44.7017 16.82 37.8869 16.82 26.9128C16.82 20.8359 19.234 15.008 23.531 10.711ZM8.45365 53.6514C8.45363 53.6514 8.45361 53.6514 8.45359 53.6514ZM17.3088 53.0988H62.1567C61.9076 52.6907 61.6576 52.2588 61.4085 51.8021C58.6617 46.7663 56.099 38.8515 56.099 26.9128C56.099 22.5722 54.3747 18.4093 51.3054 15.3401C48.2361 12.2708 44.0733 10.5465 39.7327 10.5465C35.3921 10.5465 31.2293 12.2708 28.1601 15.3401C25.0908 18.4093 23.3665 22.5722 23.3665 26.9128C23.3665 38.8515 20.8038 46.7663 18.0569 51.8021C17.8079 52.2588 17.5578 52.6907 17.3088 53.0988ZM32.4276 66.6337C33.9913 65.7266 35.9943 66.2589 36.9014 67.8227C37.1891 68.3187 37.6021 68.7304 38.099 69.0166C38.5959 69.3028 39.1593 69.4535 39.7327 69.4535C40.3062 69.4535 40.8696 69.3028 41.3665 69.0166C41.8634 68.7304 42.2764 68.3187 42.5641 67.8227C43.4712 66.2589 45.4742 65.7266 47.0379 66.6337C48.6016 67.5408 49.1339 69.5438 48.2268 71.1075C47.3636 72.5956 46.1246 73.8308 44.6339 74.6894C43.1432 75.5481 41.453 76 39.7327 76C38.0124 76 36.3223 75.5481 34.8316 74.6894C33.3408 73.8308 32.1019 72.5956 31.2387 71.1075C30.3316 69.5438 30.8639 67.5408 32.4276 66.6337Z\"/>",
	[M.BELL_RING]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M23.8008 10.71C28.0971 6.41378 33.9241 4.00019 40 4.00019C46.0759 4.00019 51.9029 6.41378 56.1992 10.71C60.4955 15.0062 62.9091 20.8331 62.9091 26.9088C62.9091 37.881 65.2559 44.6946 67.4186 48.6595C68.5044 50.6502 69.5618 51.9561 70.2963 52.7314C70.6644 53.12 70.9537 53.3776 71.1278 53.5227C71.2149 53.5953 71.2734 53.6399 71.2986 53.6586L71.3079 53.6655C72.4811 54.4714 73.0003 55.9456 72.5868 57.3112C72.1689 58.6915 70.8967 59.6355 69.4545 59.6355H10.5455C9.10327 59.6355 7.83108 58.6915 7.41315 57.3112C6.99967 55.9456 7.51885 54.4714 8.69208 53.6655L8.70143 53.6586C8.72663 53.6399 8.78506 53.5953 8.87218 53.5227C9.04634 53.3776 9.3356 53.12 9.7037 52.7314C10.4382 51.9561 11.4956 50.6502 12.5814 48.6595C14.7441 44.6946 17.0909 37.881 17.0909 26.9088C17.0909 20.8331 19.5045 15.0062 23.8008 10.71Z\"/><path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M32.696 66.6226C34.2595 65.7157 36.2622 66.2479 37.1691 67.8114C37.4568 68.3073 37.8697 68.719 38.3665 69.0051C38.8634 69.2913 39.4266 69.4419 40 69.4419C40.5734 69.4419 41.1366 69.2913 41.6335 69.0051C42.1303 68.719 42.5432 68.3073 42.8309 67.8114C43.7378 66.2479 45.7405 65.7157 47.304 66.6226C48.8674 67.5296 49.3997 69.5322 48.4927 71.0956C47.6297 72.5834 46.3909 73.8184 44.9004 74.6769C43.4099 75.5354 41.72 75.9872 40 75.9872C38.28 75.9872 36.5901 75.5354 35.0996 74.6769C33.6091 73.8184 32.3703 72.5834 31.5073 71.0956C30.6003 69.5322 31.1326 67.5296 32.696 66.6226Z\"/><path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M15.8062 4.67319C17.242 5.77112 17.5159 7.82508 16.4179 9.26084C12.6128 14.2366 10.5455 20.4059 10.5455 26.9088C10.5455 28.7163 9.0802 30.1815 7.27273 30.1815C5.46525 30.1815 4 28.7163 4 26.9088C4 19.0121 6.51443 11.4362 11.2185 5.28488C12.3164 3.84912 14.3704 3.57526 15.8062 4.67319Z\"/><path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M64.2182 4.65473C65.6642 3.57026 67.7155 3.8633 68.8 5.30926C73.4736 11.5406 76 19.1197 76 26.9088C76 28.7163 74.5347 30.1815 72.7273 30.1815C70.9198 30.1815 69.4545 28.7163 69.4545 26.9088C69.4545 20.5359 67.3875 14.3348 63.5636 9.23646C62.4791 7.7905 62.7722 5.73919 64.2182 4.65473Z\"/>",
	[M.BIN]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M7.27258 20.3636C7.27258 18.5562 8.73784 17.0909 10.5453 17.0909H69.4547C71.2622 17.0909 72.7274 18.5562 72.7274 20.3636C72.7274 22.1711 71.2622 23.6364 69.4547 23.6364H10.5453C8.73784 23.6364 7.27258 22.1711 7.27258 20.3636Z\"/> <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M33.4545 10.5455C32.5865 10.5455 31.7541 10.8903 31.1403 11.504C30.5266 12.1178 30.1818 12.9502 30.1818 13.8182V20.3636C30.1818 22.1711 28.7165 23.6364 26.909 23.6364C25.1016 23.6364 23.6363 22.1711 23.6363 20.3636V13.8182C23.6363 11.2142 24.6707 8.71694 26.512 6.87568C28.3533 5.03441 30.8506 4 33.4545 4H46.5455C49.1494 4 51.6468 5.03441 53.488 6.87568C55.3293 8.71694 56.3637 11.2142 56.3637 13.8182V20.3636C56.3637 22.1711 54.8985 23.6364 53.091 23.6364C51.2835 23.6364 49.8182 22.1711 49.8182 20.3636V13.8182C49.8182 12.9502 49.4734 12.1178 48.8597 11.504C48.2459 10.8903 47.4135 10.5455 46.5455 10.5455H33.4545ZM17.0908 17.0909C18.8983 17.0909 20.3636 18.5562 20.3636 20.3636V66.1818C20.3636 67.0498 20.7084 67.8822 21.3221 68.496C21.9359 69.1097 22.7683 69.4545 23.6363 69.4545H56.3637C57.2317 69.4545 58.0641 69.1097 58.6779 68.496C59.2917 67.8822 59.6365 67.0498 59.6365 66.1818V20.3636C59.6365 18.5562 61.1017 17.0909 62.9092 17.0909C64.7167 17.0909 66.1819 18.5562 66.1819 20.3636V66.1818C66.1819 68.7858 65.1475 71.2831 63.3063 73.1243C61.465 74.9656 58.9677 76 56.3637 76H23.6363C21.0323 76 18.535 74.9656 16.6938 73.1243C14.8525 71.2831 13.8181 68.7858 13.8181 66.1818V20.3636C13.8181 18.5562 15.2833 17.0909 17.0908 17.0909Z\"/>",
	[M.BOOKMARK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M20 8C18.9391 8 17.9217 8.42143 17.1716 9.17157C16.4214 9.92172 16 10.9391 16 12V69.1073L38.0154 56.527C39.2452 55.8243 40.7548 55.8243 41.9846 56.527L64 69.1073V12C64 10.9391 63.5786 9.92172 62.8284 9.17157C62.0783 8.42143 61.0609 8 60 8H20ZM11.5147 3.51472C13.7652 1.26428 16.8174 0 20 0H60C63.1826 0 66.2348 1.26428 68.4853 3.51472C70.7357 5.76515 72 8.8174 72 12V76C72 77.4259 71.241 78.7439 70.0077 79.4596C68.7744 80.1753 67.2535 80.1804 66.0154 79.473L40 64.607L13.9846 79.473C12.7465 80.1804 11.2256 80.1753 9.99229 79.4596C8.75903 78.7439 8 77.4259 8 76V12C8 8.8174 9.26428 5.76516 11.5147 3.51472Z\"/>",
	[M.BRIEFCASE]: "<path fillRule=\"evenodd\"clipRule=\"evenodd\" d=\"M13.8182 26.6365C12.0107 26.6365 10.5454 28.1017 10.5454 29.9092V62.6366C10.5454 64.4441 12.0107 65.9094 13.8182 65.9094H66.1818C67.9893 65.9094 69.4545 64.4441 69.4545 62.6366V29.9092C69.4545 28.1017 67.9893 26.6365 66.1818 26.6365H13.8182ZM3.99999 29.9092C3.99999 24.4867 8.39574 20.091 13.8182 20.091H66.1818C71.6042 20.091 76 24.4867 76 29.9092V62.6366C76 68.0591 71.6042 72.4549 66.1818 72.4549H13.8182C8.39574 72.4549 3.99999 68.0591 3.99999 62.6366V29.9092Z\"/> <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M26.512 9.87569C28.3533 8.03442 30.8506 7 33.4545 7H46.5454C49.1494 7 51.6467 8.03442 53.4879 9.87569C55.3292 11.717 56.3636 14.2143 56.3636 16.8182V69.1821C56.3636 70.9896 54.8984 72.4549 53.0909 72.4549C51.2834 72.4549 49.8182 70.9896 49.8182 69.1821V16.8182C49.8182 15.9502 49.4734 15.1178 48.8596 14.5041C48.2459 13.8903 47.4134 13.5455 46.5454 13.5455H33.4545C32.5866 13.5455 31.7541 13.8903 31.1404 14.5041C30.5266 15.1178 30.1818 15.9502 30.1818 16.8182V69.1821C30.1818 70.9896 28.7166 72.4549 26.9091 72.4549C25.1016 72.4549 23.6364 70.9896 23.6364 69.1821V16.8182C23.6364 14.2143 24.6708 11.717 26.512 9.87569Z\" /> ",
	[M.BROADCAST]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M19.1253 14.9564C20.4004 16.2316 20.4004 18.299 19.1253 19.5742C7.66575 31.0337 7.66575 49.8642 19.1253 61.3237C20.4004 62.5989 20.4004 64.6664 19.1253 65.9416C17.8501 67.2168 15.7826 67.2168 14.5074 65.9416C0.497546 51.9317 0.497546 28.9663 14.5074 14.9564C15.7826 13.6812 17.8501 13.6812 19.1253 14.9564ZM60.8748 14.9564C62.1499 13.6812 64.2174 13.6812 65.4926 14.9564C79.5025 28.9663 79.5025 51.6052 65.4926 65.615C64.2174 66.8902 62.1499 66.8902 60.8748 65.615C59.5996 64.3399 59.5996 62.2724 60.8748 60.9972C72.3343 49.5377 72.3343 31.0337 60.8748 19.5742C59.5996 18.299 59.5996 16.2316 60.8748 14.9564ZM28.545 24.0468C29.847 25.2946 29.891 27.3616 28.6432 28.6636C22.317 35.2649 22.386 45.6419 28.5946 51.8505C29.8698 53.1257 29.8698 55.1932 28.5946 56.4684C27.3194 57.7435 25.252 57.7435 23.9768 56.4684C15.165 47.6565 15.234 33.2172 23.9282 24.1451C25.176 22.843 27.243 22.7991 28.545 24.0468ZM51.4053 24.427C52.6805 23.1519 54.748 23.1519 56.0232 24.427C64.835 33.2389 64.7659 47.6782 56.0718 56.7503C54.824 58.0524 52.757 58.0963 51.455 56.8486C50.153 55.6008 50.109 53.5338 51.3568 52.2318C57.683 45.6305 57.6139 35.2535 51.4053 29.0449C50.1302 27.7697 50.1302 25.7022 51.4053 24.427ZM40 37.1824C38.1966 37.1824 36.7347 38.6443 36.7347 40.4477C36.7347 42.2511 38.1966 43.713 40 43.713C41.8034 43.713 43.2653 42.2511 43.2653 40.4477C43.2653 38.6443 41.8034 37.1824 40 37.1824ZM30.2041 40.4477C30.2041 35.0376 34.5899 30.6518 40 30.6518C45.4101 30.6518 49.7959 35.0376 49.7959 40.4477C49.7959 45.8578 45.4101 50.2436 40 50.2436C34.5899 50.2436 30.2041 45.8578 30.2041 40.4477Z\"/>",
	[M.BUOY]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M16.9865 21.6148C12.9557 26.6538 10.5455 33.0454 10.5455 40C10.5455 46.9546 12.9557 53.3462 16.9865 58.3852L26.3475 49.0242C24.6341 46.4373 23.6364 43.3352 23.6364 40C23.6364 36.6648 24.6341 33.5627 26.3475 30.9758L16.9865 21.6148ZM21.6148 16.9865L30.9758 26.3475C33.5627 24.6341 36.6648 23.6364 40 23.6364C43.3352 23.6364 46.4373 24.6341 49.0242 26.3475L58.3852 16.9865C53.3462 12.9557 46.9546 10.5455 40 10.5455C33.0454 10.5455 26.6538 12.9557 21.6148 16.9865ZM63.0135 21.6148L53.6525 30.9758C55.3659 33.5627 56.3636 36.6648 56.3636 40C56.3636 43.3352 55.3659 46.4373 53.6525 49.0242L63.0135 58.3852C67.0443 53.3462 69.4545 46.9546 69.4545 40C69.4545 33.0454 67.0443 26.6538 63.0135 21.6148ZM58.3852 63.0135L49.0242 53.6525C46.4373 55.3659 43.3352 56.3636 40 56.3636C36.6648 56.3636 33.5627 55.3659 30.9758 53.6525L21.6148 63.0135C26.6538 67.0443 33.0454 69.4545 40 69.4545C46.9546 69.4545 53.3462 67.0443 58.3852 63.0135ZM4 40C4 20.1177 20.1177 4 40 4C59.8823 4 76 20.1177 76 40C76 59.8823 59.8823 76 40 76C20.1177 76 4 59.8823 4 40ZM40 30.1818C34.5776 30.1818 30.1818 34.5776 30.1818 40C30.1818 45.4224 34.5776 49.8182 40 49.8182C45.4224 49.8182 49.8182 45.4224 49.8182 40C49.8182 34.5776 45.4224 30.1818 40 30.1818Z\"/>",
	[M.CALENDAR]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M26.6361 4C28.4436 4 29.9088 5.46525 29.9088 7.27272V10.5455H49.5452V7.27272C49.5452 5.46525 51.0104 4 52.8178 4C54.6254 4 56.0906 5.46525 56.0906 7.27272V10.5455H62.6361C68.0586 10.5455 72.4543 14.9412 72.4543 20.3637V66.1818C72.4543 71.6043 68.0586 76 62.6361 76H16.8179C11.3955 76 6.99976 71.6043 6.99976 66.1818V20.3637C6.99976 14.9412 11.3955 10.5455 16.8179 10.5455H23.3634V7.27272C23.3634 5.46525 24.8286 4 26.6361 4ZM23.3634 17.091H16.8179C15.0105 17.091 13.5452 18.5562 13.5452 20.3637V30.1818H65.9088V20.3637C65.9088 18.5562 64.4436 17.091 62.6361 17.091H56.0906V20.3636C56.0906 22.1711 54.6254 23.6363 52.8178 23.6363C51.0104 23.6363 49.5452 22.1711 49.5452 20.3636V17.091H29.9088V20.3636C29.9088 22.1711 28.4436 23.6363 26.6361 23.6363C24.8286 23.6363 23.3634 22.1711 23.3634 20.3636V17.091ZM65.9088 36.7271H13.5452V66.1818C13.5452 67.9893 15.0105 69.4546 16.8179 69.4546H62.6361C64.4437 69.4546 65.9088 67.9893 65.9088 66.1818V36.7271Z\"/>",
	[M.CAMERA]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M29.3042 12.1776C29.926 11.4314 30.8471 11 31.8184 11H48.1821C49.1533 11 50.0744 11.4314 50.6962 12.1776L57.8967 20.8182H66.1821C68.786 20.8182 71.2833 21.8526 73.1246 23.6938C74.9658 25.5351 76.0002 28.0324 76.0002 30.6363V60.0908C76.0002 62.6947 74.9658 65.192 73.1246 67.0333C71.2833 68.8745 68.786 69.909 66.1821 69.909H13.8184C11.2145 69.909 8.71719 68.8746 6.87592 67.0333C5.03466 65.192 4.00024 62.6947 4.00024 60.0908V30.6363C4.00024 28.0324 5.03466 25.5351 6.87592 23.6938C8.71719 21.8526 11.2145 20.8182 13.8184 20.8182H22.1037L29.3042 12.1776ZM33.3513 17.5454L26.1508 26.186C25.529 26.9322 24.6079 27.3636 23.6366 27.3636H13.8184C12.9504 27.3636 12.118 27.7084 11.5043 28.3222C10.8905 28.9359 10.5457 29.7683 10.5457 30.6363V60.0908C10.5457 60.9588 10.8905 61.7912 11.5043 62.405C12.118 63.0187 12.9504 63.3635 13.8184 63.3635H66.1821C67.05 63.3635 67.8825 63.0187 68.4962 62.405C69.11 61.7912 69.4548 60.9588 69.4548 60.0908V30.6363C69.4548 29.7683 69.11 28.9359 68.4962 28.3222C67.8825 27.7084 67.05 27.3636 66.1821 27.3636H56.3639C55.3926 27.3636 54.4715 26.9322 53.8497 26.186L46.6492 17.5454H33.3513ZM40.0002 37.1818C36.3853 37.1818 33.4548 40.1123 33.4548 43.7272C33.4548 47.3421 36.3853 50.2726 40.0002 50.2726C43.6152 50.2726 46.5457 47.3421 46.5457 43.7272C46.5457 40.1123 43.6152 37.1818 40.0002 37.1818ZM26.9093 43.7272C26.9093 36.4973 32.7703 30.6363 40.0002 30.6363C47.2301 30.6363 53.0911 36.4973 53.0911 43.7272C53.0911 50.9571 47.2301 56.8181 40.0002 56.8181C32.7703 56.8181 26.9093 50.9571 26.9093 43.7272Z\"/>",
	[M.CAMERA_OFF]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4.95868 4.95856C6.23677 3.68048 8.30895 3.68048 9.58703 4.95856L75.0418 70.4131C76.3199 71.6912 76.3199 73.7634 75.0418 75.0414C73.7637 76.3195 71.6915 76.3195 70.4134 75.0414L64.8265 69.4545H13.8183C11.2144 69.4545 8.71708 68.4201 6.87581 66.5789C5.03454 64.7376 4.00012 62.2403 4.00012 59.6364V30.1818C4.00012 27.5779 5.03454 25.0806 6.87581 23.2393C8.71708 21.3981 11.2144 20.3636 13.8183 20.3636H15.7355L4.95868 9.5869C3.6806 8.30882 3.6806 6.23664 4.95868 4.95856ZM22.2809 26.9091H13.8183C12.9504 26.9091 12.1179 27.2539 11.5042 27.8677C10.8904 28.4814 10.5456 29.3138 10.5456 30.1818V59.6364C10.5456 60.5043 10.8904 61.3368 11.5042 61.9505C12.1179 62.5643 12.9504 62.9091 13.8183 62.9091H58.281L48.5681 53.1961C47.5316 54.1293 46.3509 54.8924 45.0697 55.4547C43.4674 56.1579 41.7405 56.5327 39.9909 56.5571C38.2413 56.5814 36.5045 56.2547 34.8833 55.5964C33.2621 54.938 31.7894 53.9614 30.5521 52.7241C29.3148 51.4868 28.3382 50.0141 27.6798 48.3929C27.0215 46.7717 26.6948 45.035 26.7191 43.2854C26.7435 41.5358 27.1183 39.8088 27.8215 38.2066C28.3838 36.9254 29.1469 35.7447 30.0801 34.7082L22.2809 26.9091ZM34.7212 39.3493C34.355 39.8016 34.05 40.3018 33.8151 40.837C33.4636 41.6381 33.2761 42.5016 33.264 43.3764C33.2518 44.2512 33.4151 45.1196 33.7443 45.9301C34.0735 46.7407 34.5618 47.4771 35.1805 48.0958C35.7991 48.7144 36.5355 49.2027 37.3461 49.5319C38.1567 49.8611 39.025 50.0244 39.8998 50.0122C40.7746 50.0001 41.6381 49.8127 42.4392 49.4611C42.9745 49.2262 43.4746 48.9212 43.927 48.5551L34.7212 39.3493ZM28.5457 13.8182C28.5457 12.0107 30.0109 10.5455 31.8184 10.5455H48.1821C49.1534 10.5455 50.0745 10.9769 50.6963 11.723L57.8968 20.3636H66.1821C68.7861 20.3636 71.2834 21.398 73.1247 23.2393C74.9659 25.0806 76.0004 27.5779 76.0004 30.1818V54.7273C76.0004 56.5348 74.5351 58 72.7276 58C70.9201 58 69.4549 56.5348 69.4549 54.7273V30.1818C69.4549 29.3138 69.1101 28.4814 68.4963 27.8677C67.8826 27.2539 67.0501 26.9091 66.1821 26.9091H56.3639C55.3926 26.9091 54.4715 26.4777 53.8497 25.7315L46.6492 17.0909H31.8184C30.0109 17.0909 28.5457 15.6257 28.5457 13.8182Z\"/>",
	[M.CHECK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M74.8284 15.1716C76.3905 16.7337 76.3905 19.2663 74.8284 20.8284L30.8284 64.8284C29.2663 66.3905 26.7337 66.3905 25.1716 64.8284L5.17157 44.8284C3.60948 43.2663 3.60948 40.7337 5.17157 39.1716C6.73367 37.6095 9.26633 37.6095 10.8284 39.1716L28 56.3431L69.1716 15.1716C70.7337 13.6095 73.2663 13.6095 74.8284 15.1716Z\"/>",
	[M.CHECKBOX]: "<path d=\"M68.7949 14.7992C68.7934 12.8133 67.1867 11.2066 65.2008 11.2051H14.7992C12.8133 11.2066 11.2066 12.8133 11.2051 14.7992V65.2008C11.2066 67.1867 12.8133 68.7934 14.7992 68.7949H65.2008C67.1867 68.7934 68.7934 67.1867 68.7949 65.2008V14.7992ZM48.2512 30.2554C49.657 28.8497 51.9413 28.8497 53.3471 30.2554C54.7505 31.6604 54.7496 33.9373 53.3471 35.3429L38.9454 49.7446C37.5401 51.1499 35.2639 51.1489 33.858 49.7446L26.6529 42.5479C25.2471 41.1422 25.2471 38.8579 26.6529 37.4521C28.0587 36.0463 30.343 36.0463 31.7488 37.4521L36.3975 42.1092L48.2512 30.2554ZM76 65.2008C75.9985 71.1628 71.1628 75.9985 65.2008 76H14.7992C8.83718 75.9985 4.00152 71.1628 4 65.2008V14.7992C4.00152 8.83718 8.83718 4.00152 14.7992 4H65.2008C71.1628 4.00152 75.9985 8.83718 76 14.7992V65.2008Z\"/>",
	[M.CHECK_DOUBLE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M61.9503 18.9586C63.2284 20.2366 63.2284 22.3088 61.9503 23.5869L25.9503 59.5869C24.6722 60.865 22.6 60.865 21.322 59.5869L4.95832 43.2233C3.68024 41.9452 3.68024 39.873 4.95832 38.5949C6.23639 37.3168 8.30857 37.3168 9.58665 38.5949L23.6361 52.6444L57.322 18.9586C58.6 17.6805 60.6722 17.6805 61.9503 18.9586ZM75.0412 32.0495C76.3193 33.3276 76.3193 35.3997 75.0412 36.6778L50.4957 61.2233C49.2177 62.5013 47.1455 62.5013 45.8674 61.2233L40.9583 56.3142C39.6802 55.0361 39.6802 52.9639 40.9583 51.6858C42.2364 50.4078 44.3086 50.4078 45.5866 51.6858L48.1816 54.2808L70.4129 32.0495C71.6909 30.7714 73.7631 30.7714 75.0412 32.0495Z\"/>",
	[M.CHEVRON_DOWN]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M74.4937 20.5063C76.5021 22.5147 76.5021 25.7709 74.4937 27.7793L43.6365 58.6362C41.6281 60.6446 38.3719 60.6446 36.3634 58.6362L5.50632 27.7793C3.4979 25.7709 3.4979 22.5147 5.50632 20.5063C7.51472 18.4979 10.771 18.4979 12.7794 20.5063L40 47.7267L67.2206 20.5063C69.229 18.4979 72.4853 18.4979 74.4937 20.5063Z\" />",
	[M.CHEVRON_UP_DOWN]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M37.1716 5.17157C38.7337 3.60948 41.2663 3.60948 42.8284 5.17157L62.8284 25.1716C64.3905 26.7337 64.3905 29.2663 62.8284 30.8284C61.2663 32.3905 58.7337 32.3905 57.1716 30.8284L40 13.6569L22.8284 30.8284C21.2663 32.3905 18.7337 32.3905 17.1716 30.8284C15.6095 29.2663 15.6095 26.7337 17.1716 25.1716L37.1716 5.17157ZM17.1716 49.1716C18.7337 47.6095 21.2663 47.6095 22.8284 49.1716L40 66.3431L57.1716 49.1716C58.7337 47.6095 61.2663 47.6095 62.8284 49.1716C64.3905 50.7337 64.3905 53.2663 62.8284 54.8284L42.8284 74.8284C41.2663 76.3905 38.7337 76.3905 37.1716 74.8284L17.1716 54.8284C15.6095 53.2663 15.6095 50.7337 17.1716 49.1716Z\"/>",
	[M.CHEVRON_RIGHT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M20.5061 5.50631C22.5145 3.4979 25.7707 3.4979 27.7791 5.50631L58.636 36.3634C60.6444 38.3719 60.6444 41.6281 58.636 43.6365L27.7791 74.4937C25.7707 76.5021 22.5145 76.5021 20.5061 74.4937C18.4977 72.4853 18.4977 69.229 20.5061 67.2206L47.7264 40L20.5061 12.7794C18.4977 10.771 18.4977 7.51472 20.5061 5.50631Z\"/>",
	[M.CHOICE_PILL]: "<path  transform=\"scale(7)\" d=\"M10.7393 1.25288C10.9702 1.48146 11.1537 1.75383 11.2788 2.05369C11.4039 2.35351 11.468 2.67515 11.468 3.00001C11.468 3.32486 11.4039 3.6465 11.2788 3.94632C11.1537 4.24618 10.9702 4.51855 10.7393 4.74713C10.5085 4.97566 10.2344 5.15602 9.93338 5.27806C9.63358 5.39958 9.31281 5.46023 8.98935 5.45751V5.45808H3.14658C2.82313 5.4608 2.50235 5.39958 2.20255 5.27806C1.9015 5.15602 1.62748 4.97566 1.3966 4.74713C1.1657 4.51855 0.982212 4.24618 0.857117 3.94632C0.732065 3.6465 0.667969 3.32486 0.667969 3.00001C0.667969 2.67515 0.732064 2.35351 0.857117 2.05369C0.982211 1.75383 1.1657 1.48146 1.3966 1.25288C1.62748 1.02436 1.9015 0.843989 2.20255 0.721952C2.50359 0.599932 2.82577 0.538675 3.15058 0.541932H8.98935C9.31281 0.539214 9.63358 0.600432 9.93338 0.721952C10.2344 0.843989 10.5085 1.02436 10.7393 1.25288ZM3.14259 1.36814C2.92693 1.36596 2.71283 1.40666 2.51295 1.48767C2.31305 1.56871 2.13103 1.68855 1.97774 1.84029C1.82448 1.99203 1.70274 2.17275 1.6197 2.37179C1.53669 2.57082 1.49417 2.78436 1.49417 3.00001C1.49417 3.21565 1.53669 3.42919 1.6197 3.62822C1.70274 3.82726 1.82449 4.00798 1.97774 4.15972C2.13103 4.31146 2.31305 4.43131 2.51295 4.51234C2.71283 4.59335 2.92693 4.63405 3.14259 4.63187H5.65487V1.36814H3.14259ZM10.1582 1.84029C10.0049 1.68855 9.82288 1.56871 9.62299 1.48767C9.42311 1.40666 9.20901 1.36596 8.99335 1.36814H6.48107V4.63187H8.99335C9.20901 4.63405 9.42311 4.59335 9.62299 4.51234C9.82288 4.43131 10.0049 4.31146 10.1582 4.15972C10.3115 4.00798 10.4332 3.82726 10.5162 3.62822C10.5992 3.42919 10.6418 3.21565 10.6418 3.00001C10.6418 2.78436 10.5992 2.57082 10.5162 2.37179C10.4332 2.17275 10.3115 1.99203 10.1582 1.84029Z\"/>,",
	[M.CIRCLE_CHECK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M51.988 13.0954C46.1862 10.5103 39.7042 9.86984 33.5088 11.2696C27.3133 12.6694 21.7363 16.0344 17.6095 20.8627C13.4827 25.691 11.0272 31.724 10.6093 38.0618C10.1914 44.3997 11.8334 50.7028 15.2905 56.0312C18.7475 61.3596 23.8344 65.4278 29.7924 67.6289C35.7505 69.8301 42.2604 70.0464 48.3514 68.2455C54.4424 66.4446 59.788 62.723 63.5911 57.6358C67.3942 52.5486 69.4509 46.3683 69.4545 40.0167V37.0077C69.4545 35.2002 70.9198 33.7349 72.7273 33.7349C74.5347 33.7349 76 35.2002 76 37.0077V40.0204C75.9956 47.7835 73.4818 55.3372 68.8336 61.5549C64.1854 67.7726 57.6518 72.3212 50.2073 74.5223C42.7627 76.7234 34.8061 76.4591 27.5241 73.7687C20.242 71.0784 14.0248 66.1062 9.79946 59.5938C5.57416 53.0813 3.56725 45.3774 4.07804 37.6312C4.58882 29.8849 7.58994 22.5113 12.6338 16.61C17.6777 10.7087 24.494 6.59597 32.0663 4.88513C39.6385 3.17428 47.561 3.95702 54.652 7.11659C56.303 7.85223 57.045 9.78698 56.3094 11.438C55.5738 13.089 53.639 13.831 51.988 13.0954ZM75.0403 11.5216C76.319 12.799 76.32 14.8712 75.0426 16.1499L42.3153 48.9097C41.7017 49.524 40.8691 49.8692 40.0008 49.8694C39.1326 49.8696 38.2998 49.5248 37.6858 48.9108L27.8677 39.0927C26.5896 37.8146 26.5896 35.7425 27.8677 34.4644C29.1457 33.1863 31.2179 33.1863 32.496 34.4644L39.9989 41.9672L70.4119 11.5239C71.6894 10.2452 73.7616 10.2441 75.0403 11.5216Z\"/>",
	[M.CIRCLE_CLOSE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 10.5454C23.7327 10.5454 10.5455 23.7326 10.5455 39.9998C10.5455 56.2671 23.7327 69.4542 40 69.4542C56.2673 69.4542 69.4546 56.2671 69.4546 39.9998C69.4546 23.7326 56.2673 10.5454 40 10.5454ZM4.00002 39.9998C4.00002 20.1177 20.1178 4 40 4C59.8823 4 76 20.1177 76 39.9998C76 59.882 59.8823 75.9997 40 75.9997C20.1178 75.9997 4.00002 59.882 4.00002 39.9998ZM27.8677 27.8675C29.1457 26.5895 31.2179 26.5895 32.496 27.8675L40 35.3715L47.504 27.8675C48.7821 26.5895 50.8543 26.5895 52.1324 27.8675C53.4104 29.1456 53.4104 31.2178 52.1324 32.4959L44.6283 39.9998L52.1324 47.5038C53.4104 48.7819 53.4104 50.8541 52.1324 52.1321C50.8543 53.4102 48.7821 53.4102 47.504 52.1321L40 44.6281L32.496 52.1321C31.2179 53.4102 29.1457 53.4102 27.8677 52.1321C26.5896 50.8541 26.5896 48.7819 27.8677 47.5038L35.3717 39.9998L27.8677 32.4959C26.5896 31.2178 26.5896 29.1456 27.8677 27.8675Z\"/>",
	[M.CIRCLE_LEFT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 10.5455C23.7327 10.5455 10.5455 23.7329 10.5455 40.0003C10.5455 56.2678 23.7327 69.4551 40 69.4551C56.2673 69.4551 69.4545 56.2678 69.4545 40.0003C69.4545 23.7329 56.2673 10.5455 40 10.5455ZM4 40.0003C4 20.1179 20.1177 4 40 4C59.8822 4 76 20.1179 76 40.0003C76 59.8827 59.8822 76.0006 40 76.0006C20.1177 76.0006 4 59.8827 4 40.0003ZM42.3142 24.5951C43.5922 25.8732 43.5922 27.9454 42.3142 29.2235L34.8102 36.7276H53.0909C54.8984 36.7276 56.3636 38.1928 56.3636 40.0003C56.3636 41.8078 54.8984 43.2731 53.0909 43.2731H34.8102L42.3142 50.7771C43.5922 52.0552 43.5922 54.1274 42.3142 55.4055C41.0361 56.6836 38.9639 56.6836 37.6858 55.4055L24.5949 42.3145C23.3168 41.0364 23.3168 38.9642 24.5949 37.6861L37.6858 24.5951C38.9639 23.317 41.0361 23.317 42.3142 24.5951Z\"/>",
	[M.CIRCLE_RIGHT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 10.5455C23.7327 10.5455 10.5455 23.7329 10.5455 40.0003C10.5455 56.2678 23.7327 69.4551 40 69.4551C56.2673 69.4551 69.4545 56.2678 69.4545 40.0003C69.4545 23.7329 56.2673 10.5455 40 10.5455ZM4 40.0003C4 20.1179 20.1177 4 40 4C59.8822 4 76 20.1179 76 40.0003C76 59.8827 59.8822 76.0006 40 76.0006C20.1177 76.0006 4 59.8827 4 40.0003ZM37.6858 29.2235C36.4078 27.9454 36.4078 25.8732 37.6858 24.5951C38.9639 23.317 41.0361 23.317 42.3142 24.5951L55.4051 37.6861C56.6832 38.9642 56.6832 41.0364 55.4051 42.3145L42.3142 55.4055C41.0361 56.6836 38.9639 56.6836 37.6858 55.4055C36.4078 54.1274 36.4078 52.0552 37.6858 50.7771L45.1898 43.2731H26.9091C25.1016 43.2731 23.6364 41.8078 23.6364 40.0003C23.6364 38.1928 25.1016 36.7276 26.9091 36.7276H45.1898L37.6858 29.2235Z\"/>",
	[M.CLEAR_FIELD]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 4C20.1123 4 4 20.1218 4 40C4 59.8782 20.1123 76 40 76C59.8877 76 76 59.8782 76 40C76 20.1218 59.8782 4 40 4ZM55.9693 52.6706L52.661 55.9693L39.9905 43.3083L27.3294 55.9693L24.0212 52.6706L36.6917 40L24.0212 27.339L27.3294 24.0307L39.9905 36.7013L52.661 24.0307L55.9693 27.339L43.2987 40L55.9693 52.6706Z\"/>",
	[M.CLOCK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4.00005 40C4.00005 20.12 20.1044 4 39.9753 4C59.8463 4 75.9506 20.12 75.9506 40C75.9506 59.8799 59.8463 76 39.9753 76C20.1044 76 4.00005 59.8799 4.00005 40ZM39.9753 10.5455C23.724 10.5455 10.5455 23.7304 10.5455 40C10.5455 56.2697 23.724 69.4545 39.9753 69.4545C56.2267 69.4545 69.4053 56.2697 69.4053 40C69.4053 23.7304 56.2267 10.5455 39.9753 10.5455ZM39.9754 17.091C41.7829 17.091 43.2482 18.5562 43.2482 20.3637V37.9781L54.521 43.6188C56.1373 44.4276 56.792 46.3936 55.9833 48.01C55.1744 49.6264 53.2084 50.2811 51.592 49.4723L38.511 42.9268C37.4027 42.3723 36.7027 41.2394 36.7027 40V20.3637C36.7027 18.5562 38.168 17.091 39.9754 17.091Z\"/>",
	[M.CLOSE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M5.50631 5.50631C7.51472 3.4979 10.771 3.4979 12.7794 5.50631L40 32.7269L67.2206 5.50631C69.229 3.4979 72.4853 3.4979 74.4937 5.50631C76.5021 7.51472 76.5021 10.771 74.4937 12.7794L47.2731 40L74.4937 67.2206C76.5021 69.229 76.5021 72.4853 74.4937 74.4937C72.4853 76.5021 69.229 76.5021 67.2206 74.4937L40 47.2731L12.7794 74.4937C10.771 76.5021 7.51472 76.5021 5.50631 74.4937C3.4979 72.4853 3.4979 69.229 5.50631 67.2206L32.7269 40L5.50631 12.7794C3.4979 10.771 3.4979 7.51472 5.50631 5.50631Z\"/>",
	[M.COG]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M35.0971 5.3174C36.5882 4.45817 38.279 4.00586 40 4.00586C41.7211 4.00586 43.412 4.45821 44.9031 5.31753C44.9054 5.31885 44.9077 5.32017 44.91 5.32149L67.8107 18.4076L67.8234 18.4148C69.3147 19.2759 70.5534 20.5139 71.4152 22.0049C72.277 23.4958 72.7316 25.1871 72.7334 26.9091V53.1026C72.7316 54.8246 72.277 56.5159 71.4152 58.0069C70.5534 59.4978 69.3147 60.7358 67.8234 61.5969L67.8107 61.6041L44.91 74.6902C44.9077 74.6916 44.9054 74.6929 44.903 74.6942C43.4119 75.5535 41.7211 76.0059 40 76.0059C38.279 76.0059 36.5883 75.5536 35.0972 74.6944C35.0948 74.693 35.0924 74.6916 35.09 74.6902L12.1893 61.6041L12.1766 61.5969C10.6853 60.7358 9.44655 59.4978 8.58475 58.0069C7.72295 56.5159 7.26837 54.8246 7.2666 53.1026V26.9091C7.26837 25.1871 7.72295 23.4958 8.58475 22.0049C9.44655 20.5139 10.6853 19.2759 12.1766 18.4148L12.1893 18.4076L35.0971 5.3174ZM40 10.5525C39.4254 10.5525 38.8609 10.7038 38.3633 10.9911L15.4448 24.0874C14.95 24.3743 14.539 24.7859 14.2527 25.2811C13.9656 25.7777 13.8141 26.341 13.8133 26.9145V53.0972C13.8141 53.6707 13.9656 54.234 14.2527 54.7306C14.539 55.2259 14.9501 55.6375 15.445 55.9244L15.45 55.9273L38.3633 69.0206C38.8609 69.3079 39.4254 69.4592 40 69.4592C40.5746 69.4592 41.1391 69.3079 41.6367 69.0206L64.55 55.9273L64.5551 55.9244C65.0499 55.6375 65.461 55.2259 65.7473 54.7306C66.0346 54.2336 66.1861 53.6699 66.1867 53.0959V26.9159C66.1861 26.3418 66.0346 25.7781 65.7473 25.2811C65.4611 24.7859 65.0501 24.3744 64.5553 24.0875C64.5535 24.0865 64.5518 24.0854 64.55 24.0844L41.6367 10.9911C41.1391 10.7038 40.5746 10.5525 40 10.5525ZM40 30.1798C34.5766 30.1798 30.18 34.5763 30.18 39.9998C30.18 45.4232 34.5766 49.8198 40 49.8198C45.4234 49.8198 49.82 45.4232 49.82 39.9998C49.82 34.5763 45.4234 30.1798 40 30.1798ZM23.6333 39.9998C23.6333 30.9607 30.9609 23.6331 40 23.6331C49.0391 23.6331 56.3667 30.9607 56.3667 39.9998C56.3667 49.0389 49.0391 56.3665 40 56.3665C30.9609 56.3665 23.6333 49.0389 23.6333 39.9998Z\"/>",
	[M.COMMENT]: "<path d=\"M73.4582 73.1706C73.0848 73.1706 72.8116 73.1251 72.6295 73.034L59.2336 68.681C58.3138 68.3623 57.4578 68.426 56.6746 68.8905C53.4509 70.5479 50.045 71.6953 46.4569 72.3419C42.8689 72.9885 39.2262 73.1251 35.5471 72.7608C30.1196 72.2053 25.0745 70.5297 20.4209 67.7157C15.9131 65.0019 12.2249 61.505 9.37455 57.2157C6.47863 52.8445 4.75747 48.1273 4.20196 43.0639C3.64645 38.0006 4.23839 33.1103 5.95955 28.3931C7.68982 23.6758 10.4127 19.5414 14.1464 15.9989C17.8711 12.4564 22.215 9.81546 27.1599 8.0943C32.1139 6.36403 37.2501 5.70835 42.5957 6.11815C47.9322 6.52795 52.9318 8.03055 57.5762 10.6077C62.1295 13.0939 65.9088 16.3814 68.9049 20.4794C72.0376 24.6229 74.0137 29.1763 74.8424 34.1485C75.3979 37.5089 75.4253 40.8601 74.9426 44.1932C74.46 47.5353 73.4309 50.7227 71.8736 53.7552C71.4547 54.5384 71.391 55.2487 71.6642 55.8953L75.9443 70.1927C76.0354 70.6481 76.0172 71.0943 75.8715 71.5041C75.7349 71.9139 75.4981 72.26 75.1794 72.5423C74.7149 72.9612 74.1412 73.1615 73.4491 73.1615L73.4582 73.1706ZM39.6269 9.50583C35.3468 9.50583 31.2397 10.2799 27.3056 11.8189C23.3715 13.358 19.8837 15.58 16.842 18.485C13.5272 21.6632 11.0866 25.3515 9.52026 29.5678C7.95391 33.7842 7.41662 38.1463 7.89927 42.6541C8.38192 47.162 9.91185 51.3783 12.489 55.2942C15.0662 59.119 18.3811 62.2244 22.4335 64.6195C26.5315 67.1511 31.0211 68.6719 35.9023 69.1728C39.1716 69.4915 42.4136 69.3822 45.6373 68.8267C48.8611 68.2712 51.9209 67.2604 54.8169 65.7851C55.6456 65.3207 56.5562 65.0475 57.5489 64.9564C58.5415 64.8653 59.4886 64.9746 60.4175 65.3025L71.6733 68.9633L68.0124 56.8788C67.7848 56.0956 67.7028 55.3033 67.7665 54.4928C67.8394 53.6914 68.0762 52.9174 68.4951 52.1797C69.8246 49.4659 70.7262 46.6064 71.1907 43.6195C71.646 40.6234 71.6278 37.6364 71.1178 34.6403C70.3801 30.2235 68.6317 26.1437 65.8724 22.4191C63.1586 18.8311 59.7709 15.9078 55.7184 13.6494C51.5293 11.3454 47.0671 10.0158 42.3225 9.64243C41.7215 9.55136 40.829 9.50583 39.6269 9.50583Z\" /> <path d=\"M71.1347 70.8383C70.7873 70.8383 70.533 70.7959 70.3636 70.7112L57.8979 66.6605C57.042 66.3639 56.2454 66.4232 55.5167 66.8554C52.5168 68.3977 49.3474 69.4655 46.0085 70.0672C42.6697 70.6688 39.28 70.7959 35.8564 70.457C30.8057 69.94 26.111 68.3808 21.7806 65.7622C17.5858 63.2369 14.1538 59.9828 11.5013 55.9914C8.8065 51.9237 7.20487 47.5341 6.68794 42.8224C6.17101 38.1107 6.72183 33.56 8.32347 29.1703C9.93358 24.7806 12.4674 20.9333 15.9418 17.6368C19.4078 14.3403 23.45 11.8828 28.0516 10.2812C32.6616 8.67105 37.441 8.0609 42.4154 8.44224C47.3814 8.82358 52.0337 10.2218 56.3556 12.6201C60.5927 14.9335 64.1096 17.9927 66.8976 21.8062C69.8127 25.662 71.6517 29.8991 72.4228 34.5261C72.9398 37.6531 72.9652 40.7716 72.516 43.8732C72.0669 46.9832 71.1093 49.9492 69.6602 52.7712C69.2704 53.5 69.2111 54.161 69.4653 54.7626L73.4482 68.0672C73.5329 68.4909 73.516 68.9062 73.3804 69.2875C73.2533 69.6689 73.033 69.9909 72.7364 70.2536C72.3042 70.6434 71.7703 70.8298 71.1263 70.8298L71.1347 70.8383ZM39.6528 11.5947C35.6699 11.5947 31.848 12.315 28.1871 13.7471C24.5263 15.1793 21.2806 17.247 18.4502 19.9503C15.3656 22.9078 13.0945 26.3399 11.6369 30.2635C10.1793 34.1871 9.67935 38.2463 10.1285 42.441C10.5776 46.6358 12.0013 50.5594 14.3995 54.2033C16.7977 57.7625 19.8824 60.6522 23.6534 62.881C27.4668 65.2368 31.6446 66.652 36.1869 67.1181C39.2291 67.4147 42.246 67.313 45.2458 66.7961C48.2457 66.2792 51.0931 65.3385 53.7879 63.9657C54.5591 63.5335 55.4065 63.2793 56.3302 63.1945C57.2539 63.1098 58.1352 63.2115 58.9996 63.5166L69.4738 66.9232L66.0671 55.6778C65.8553 54.9491 65.779 54.2118 65.8383 53.4576C65.9061 52.7119 66.1264 51.9915 66.5163 51.3051C67.7535 48.7798 68.5924 46.1189 69.0246 43.3393C69.4483 40.5513 69.4314 37.7717 68.9568 34.9837C68.2704 30.8736 66.6434 27.0772 64.0757 23.6112C61.5503 20.2723 58.3979 17.5521 54.6269 15.4505C50.7287 13.3065 46.5763 12.0692 42.1612 11.7218C41.6019 11.637 40.7714 11.5947 39.6528 11.5947Z\"/> ",
	[M.COMMENT_ACTIVE]: "<path d=\"M73.4582 73.1705C73.0848 73.1705 72.8116 73.125 72.6295 73.0339L59.2336 68.681C58.3138 68.3622 57.4578 68.426 56.6746 68.8904C53.4509 70.5478 50.045 71.6953 46.4569 72.3418C42.8689 72.9884 39.2262 73.125 35.5471 72.7607C30.1196 72.2052 25.0745 70.5296 20.4209 67.7156C15.9131 65.0019 12.2249 61.5049 9.37455 57.2157C6.47863 52.8445 4.75747 48.1272 4.20196 43.0639C3.64645 38.0006 4.23839 33.1103 5.95955 28.3931C7.68982 23.6758 10.4127 19.5414 14.1464 15.9989C17.8711 12.4564 22.215 9.81545 27.1599 8.09429C32.1139 6.36403 37.2501 5.70835 42.5957 6.11815C47.9322 6.52795 52.9318 8.03055 57.5762 10.6077C62.1295 13.0939 65.9088 16.3814 68.9049 20.4794C72.0376 24.6229 74.0137 29.1762 74.8424 34.1485C75.3979 37.5088 75.4253 40.8601 74.9426 44.1931C74.4599 47.5353 73.4309 50.7226 71.8736 53.7551C71.4547 54.5383 71.391 55.2486 71.6642 55.8952L75.9443 70.1927C76.0354 70.648 76.0172 71.0942 75.8715 71.504C75.7349 71.9138 75.4981 72.2599 75.1794 72.5422C74.7149 72.9611 74.1412 73.1614 73.4491 73.1614L73.4582 73.1705Z\"/>",
	[M.COMPETITION]: "<path d=\"M75.9998 60.654C75.9523 62.0976 75.4109 63.3418 74.3757 64.396C73.3405 65.4502 72.0868 65.9821 70.5957 65.9821H9.7552C8.07415 65.9821 6.75401 65.5262 5.79477 64.6145C5.21543 64.1396 4.77854 63.5508 4.46513 62.8479C4.15171 62.1546 3.99976 61.4233 3.99976 60.654V49.4186C3.99976 49.1812 4.08523 48.9817 4.25619 48.8393C4.42714 48.6968 4.60759 48.6208 4.79754 48.6208C6.71602 48.6208 8.47304 48.0225 10.0591 46.8163C11.3983 45.7146 12.3005 44.3185 12.7564 42.6375C13.2123 40.9564 13.1553 39.3134 12.5759 37.7083C11.9966 36.1032 10.9899 34.8021 9.55575 33.8239C8.11214 32.8361 6.53557 32.3518 4.80704 32.3518C4.61709 32.3518 4.43664 32.2663 4.26568 32.0953C4.09473 31.9244 4.00925 31.7439 4.00925 31.554V20.328C4.05674 18.837 4.59809 17.5833 5.63331 16.5481C6.66853 15.5129 7.9032 15 9.39429 15H70.3108C71.9444 15 73.236 15.4559 74.1952 16.3676C74.7746 16.852 75.2115 17.4408 75.5249 18.1341C75.8383 18.8275 75.9903 19.5588 75.9903 20.328V31.5635C75.9903 31.7534 75.9143 31.9339 75.7718 32.1048C75.6294 32.2758 75.4394 32.3613 75.1925 32.3613C74.0908 32.3613 73.0366 32.5702 72.0203 32.9691C71.0136 33.3775 70.1208 33.9663 69.3516 34.7356C67.813 36.2267 66.9962 38.1452 66.9012 40.5005C66.9487 41.6022 67.1766 42.647 67.585 43.6347C67.9934 44.6224 68.5823 45.4962 69.3516 46.2655C70.1208 47.0348 71.0041 47.6236 72.0203 48.032C73.0271 48.4404 74.0813 48.6398 75.1925 48.6398C75.4299 48.6398 75.6294 48.7158 75.7718 48.8583C75.9143 49.0007 75.9903 49.1907 75.9903 49.4376V60.673L75.9998 60.654ZM60.9083 36.1317C60.7374 35.8183 60.462 35.6379 60.0821 35.5904L46.2538 34.5077C44.1454 29.9964 42.5308 26.6153 41.4291 24.3549L41.2867 24.07C41.2392 23.8801 41.1917 23.7376 41.1442 23.6426L40.7833 22.9968V22.8544C40.6408 22.6169 40.4224 22.4935 40.1375 22.4935H39.8525C39.5676 22.4935 39.3492 22.6169 39.2067 22.8544L34.2396 33.368C34.0496 33.8524 33.8787 34.2322 33.7362 34.5172L21.7125 35.4574C21.2756 35.4574 20.6772 35.5049 19.9079 35.5999C19.6705 35.5999 19.4616 35.6759 19.3001 35.8183C19.1292 35.9608 19.0342 36.1412 19.0152 36.3597C18.9867 36.5781 19.0722 36.7586 19.2716 36.901V36.977L29.8613 45.2587L26.6891 57.5009C26.5941 57.8333 26.7081 58.1087 27.05 58.3272C27.3824 58.5456 27.7243 58.5551 28.0567 58.3652L30.868 56.8551C34.4675 54.9366 37.1553 53.474 38.9313 52.4578C39.1687 52.3628 39.5296 52.1729 40.014 51.8784L51.9713 58.3557C52.3037 58.5456 52.6266 58.5361 52.94 58.3177C53.2534 58.0992 53.3579 57.8048 53.2629 57.4154L50.4517 46.3225C50.3567 46.085 50.2617 45.7241 50.1668 45.2397L59.3888 38.0407C59.7212 37.8033 60.177 37.4424 60.7564 36.958C61.0413 36.7206 61.1078 36.4451 60.9368 36.1317H60.9083Z\"/>",
	[M.COMPUTER_EXTERNAL]: "<path d=\"M4 49.8189V17.0916C4 14.4877 5.03515 11.9911 6.87642 10.1499C8.71769 8.30859 11.2142 7.27344 13.8182 7.27344H43.2727C45.0802 7.27344 46.5455 8.73869 46.5455 10.5462C46.5455 12.3536 45.0802 13.8189 43.2727 13.8189H13.8182C12.9502 13.8189 12.118 14.1639 11.5043 14.7777C10.8905 15.3915 10.5455 16.2236 10.5455 17.0916V49.8189C10.5455 50.6869 10.8905 51.5191 11.5043 52.1328C12.118 52.7466 12.9502 53.0916 13.8182 53.0916H66.1818C67.0498 53.0916 67.882 52.7466 68.4957 52.1328C69.1095 51.5191 69.4545 50.6869 69.4545 49.8189V40.0007C69.4545 38.1932 70.9198 36.728 72.7273 36.728C74.5347 36.728 76 38.1932 76 40.0007V49.8189C76 52.4228 74.9648 54.9194 73.1236 56.7607C71.2823 58.6019 68.7858 59.6371 66.1818 59.6371H43.2727V66.1825H53.0909C54.8984 66.1825 56.3636 67.6478 56.3636 69.4553C56.3636 71.2627 54.8984 72.728 53.0909 72.728H26.9091C25.1016 72.728 23.6364 71.2627 23.6364 69.4553C23.6364 67.6478 25.1016 66.1825 26.9091 66.1825H36.7273V59.6371H13.8182C11.2142 59.6371 8.71769 58.6019 6.87642 56.7607C5.03515 54.9194 4 52.4228 4 49.8189ZM76 26.9098C76 28.7173 74.5347 30.1825 72.7273 30.1825C70.9198 30.1825 69.4545 28.7173 69.4545 26.9098V18.4467L58.6776 29.2237C57.3995 30.5018 55.3278 30.5018 54.0497 29.2237C52.7716 27.9456 52.7716 25.874 54.0497 24.5959L64.8267 13.8189H56.3636C54.5562 13.8189 53.0909 12.3536 53.0909 10.5462C53.0909 8.73869 54.5562 7.27344 56.3636 7.27344H72.7273C74.5347 7.27344 76 8.73869 76 10.5462V26.9098Z\"/>",
	[M.CONTACT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M26.6361 4C28.4436 4 29.9089 5.46525 29.9089 7.27273V10.5455H49.5452V7.27273C49.5452 5.46525 51.0105 4 52.818 4C54.6254 4 56.0907 5.46525 56.0907 7.27273V10.5455H62.6361C68.0586 10.5455 72.4543 14.9412 72.4543 20.3636V66.1818C72.4543 71.6043 68.0586 76 62.6361 76H16.818C11.3955 76 6.99978 71.6043 6.99978 66.1818V20.3636C6.99978 14.9412 11.3955 10.5455 16.818 10.5455H23.3634V7.27273C23.3634 5.46525 24.8287 4 26.6361 4ZM16.818 17.0909C15.0105 17.0909 13.5452 18.5562 13.5452 20.3636V66.1818C13.5452 67.9893 15.0105 69.4545 16.818 69.4545H62.6361C64.4436 69.4545 65.9089 67.9893 65.9089 66.1818V20.3636C65.9089 18.5562 64.4436 17.0909 62.6361 17.0909H16.818ZM39.7271 30.1818C37.9196 30.1818 36.4543 31.6471 36.4543 33.4545C36.4543 35.262 37.9196 36.7273 39.7271 36.7273C41.5345 36.7273 42.9998 35.262 42.9998 33.4545C42.9998 31.6471 41.5345 30.1818 39.7271 30.1818ZM29.9089 33.4545C29.9089 28.0321 34.3046 23.6364 39.7271 23.6364C45.1495 23.6364 49.5452 28.0321 49.5452 33.4545C49.5452 38.877 45.1495 43.2727 39.7271 43.2727C34.3046 43.2727 29.9089 38.877 29.9089 33.4545ZM22.9664 52.6939C24.8076 50.8526 27.3049 49.8182 29.9089 49.8182H49.5452C52.1492 49.8182 54.6465 50.8526 56.4877 52.6939C58.329 54.5351 59.3634 57.0324 59.3634 59.6364C59.3634 61.4438 57.8982 62.9091 56.0907 62.9091C54.2832 62.9091 52.818 61.4438 52.818 59.6364C52.818 58.7684 52.4732 57.936 51.8594 57.3222C51.2456 56.7084 50.4132 56.3636 49.5452 56.3636H29.9089C29.0409 56.3636 28.2085 56.7084 27.5947 57.3222C26.9809 57.9359 26.6361 58.7684 26.6361 59.6364C26.6361 61.4438 25.1709 62.9091 23.3634 62.9091C21.5559 62.9091 20.0907 61.4438 20.0907 59.6364C20.0907 57.0324 21.1251 54.5351 22.9664 52.6939Z\"/>",
	[M.COPY]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M13.8182 10.5455C12.0257 10.5455 10.5455 12.0257 10.5455 13.8182V46.5455C10.5455 48.338 12.0257 49.8182 13.8182 49.8182C15.6257 49.8182 17.0909 51.2834 17.0909 53.0909C17.0909 54.8984 15.6257 56.3636 13.8182 56.3636C8.4107 56.3636 4 51.9529 4 46.5455V13.8182C4 8.4107 8.4107 4 13.8182 4H46.5455C51.9529 4 56.3636 8.4107 56.3636 13.8182C56.3636 15.6257 54.8984 17.0909 53.0909 17.0909C51.2834 17.0909 49.8182 15.6257 49.8182 13.8182C49.8182 12.0257 48.338 10.5455 46.5455 10.5455H13.8182ZM33.4545 30.1818C31.6471 30.1818 30.1818 31.6471 30.1818 33.4545V66.1818C30.1818 67.9893 31.6471 69.4545 33.4545 69.4545H66.1818C67.9893 69.4545 69.4545 67.9893 69.4545 66.1818V33.4545C69.4545 31.6471 67.9893 30.1818 66.1818 30.1818H33.4545ZM23.6364 33.4545C23.6364 28.0321 28.0321 23.6364 33.4545 23.6364H66.1818C71.6043 23.6364 76 28.0321 76 33.4545V66.1818C76 71.6043 71.6043 76 66.1818 76H33.4545C28.0321 76 23.6364 71.6043 23.6364 66.1818V33.4545Z\" />",
	[M.DASH]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M3.99999 40.4996C3.99999 38.0145 6.01471 36 8.49999 36H71.5C73.9853 36 76 38.0145 76 40.4996C76 42.9846 73.9853 44.9991 71.5 44.9991H8.49999C6.01471 44.9991 3.99999 42.9846 3.99999 40.4996Z\" />",
	[M.DASH_CIRCLE]: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40 10.5455C23.7327 10.5455 10.5455 23.7329 10.5455 40.0003C10.5455 56.2678 23.7327 69.4551 40 69.4551C56.2673 69.4551 69.4545 56.2678 69.4545 40.0003C69.4545 23.7329 56.2673 10.5455 40 10.5455ZM4 40.0003C4 20.1179 20.1177 4 40 4C59.8822 4 76 20.1179 76 40.0003C76 59.8827 59.8822 76.0006 40 76.0006C20.1177 76.0006 4 59.8827 4 40.0003Z\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 39.9997C16 38.343 17.3431 37 19 37H61C62.6569 37 64 38.343 64 39.9997C64 41.6564 62.6569 42.9994 61 42.9994H19C17.3431 42.9994 16 41.6564 16 39.9997Z\" />",
	[M.DOWNLOAD]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 4C41.9882 4 43.6 5.61177 43.6 7.6V42.1088L55.4544 30.2544C56.8603 28.8485 59.1397 28.8485 60.5456 30.2544C61.9515 31.6603 61.9515 33.9397 60.5456 35.3456L42.5456 53.3456C41.1397 54.7515 38.8603 54.7515 37.4544 53.3456L19.4544 35.3456C18.0485 33.9397 18.0485 31.6603 19.4544 30.2544C20.8603 28.8485 23.1397 28.8485 24.5456 30.2544L36.4 42.1088V7.6C36.4 5.61177 38.0118 4 40 4ZM7.6 47.2C9.58823 47.2 11.2 48.8118 11.2 50.8V65.2C11.2 66.1548 11.5793 67.0704 12.2544 67.7456C12.9295 68.4207 13.8452 68.8 14.8 68.8H65.2C66.1548 68.8 67.0704 68.4207 67.7456 67.7456C68.4207 67.0704 68.8 66.1548 68.8 65.2V50.8C68.8 48.8118 70.4118 47.2 72.4 47.2C74.3882 47.2 76 48.8118 76 50.8V65.2C76 68.0643 74.8621 70.8114 72.8368 72.8368C70.8114 74.8621 68.0643 76 65.2 76H14.8C11.9357 76 9.18864 74.8621 7.16325 72.8368C5.13785 70.8114 4 68.0643 4 65.2V50.8C4 48.8118 5.61177 47.2 7.6 47.2Z\"/>",
	[M.DRAG]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4 28C4 23.5818 7.58176 20 12 20C16.4182 20 20 23.5818 20 28C20 32.4182 16.4182 36 12 36C7.58176 36 4 32.4182 4 28ZM32 28C32 23.5818 35.5818 20 40 20C44.4182 20 48 23.5818 48 28C48 32.4182 44.4182 36 40 36C35.5818 36 32 32.4182 32 28ZM60 28C60 23.5818 63.5818 20 68 20C72.4184 20 76 23.5818 76 28C76 32.4182 72.4184 36 68 36C63.5818 36 60 32.4182 60 28ZM4 52C4 47.5818 7.58176 44 12 44C16.4182 44 20 47.5818 20 52C20 56.4182 16.4182 60 12 60C7.58176 60 4 56.4182 4 52ZM32 52C32 47.5818 35.5818 44 40 44C44.4182 44 48 47.5818 48 52C48 56.4182 44.4182 60 40 60C35.5818 60 32 56.4182 32 52ZM60 52C60 47.5818 63.5818 44 68 44C72.4184 44 76 47.5818 76 52C76 56.4182 72.4184 60 68 60C63.5818 60 60 56.4182 60 52Z\"/>",
	[M.DROPDOWN]: "<path d=\"M4 19H76L39.5955 61.0674L4 19Z\"/>",
	[M.EMPTY_SEARCH]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M36.3998 11.2C22.4822 11.2 11.1998 22.4825 11.1998 36.4001C11.1998 50.3177 22.4822 61.6002 36.3998 61.6002C50.3173 61.6002 61.5998 50.3177 61.5998 36.4001C61.5998 22.4825 50.3173 11.2 36.3998 11.2ZM3.99976 36.4001C3.99976 18.506 18.5057 4 36.3998 4C54.2938 4 68.7998 18.506 68.7998 36.4001C68.7998 54.2942 54.2938 68.8002 36.3998 68.8002C18.5057 68.8002 3.99976 54.2942 3.99976 36.4001Z\" /><path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M26.0516 26.052C26.6542 25.4494 27.6311 25.4494 28.2336 26.052L36.3998 34.2182L44.5659 26.052C45.1685 25.4494 46.1453 25.4494 46.7479 26.052C47.3504 26.6545 47.3504 27.6314 46.7479 28.2339L38.5817 36.4001L46.7479 44.5663C47.3504 45.1689 47.3504 46.1457 46.7479 46.7483C46.1453 47.3508 45.1685 47.3508 44.5659 46.7483L36.3998 38.5821L28.2336 46.7483C27.6311 47.3508 26.6542 47.3508 26.0516 46.7483C25.4491 46.1457 25.4491 45.1689 26.0516 44.5663L34.2178 36.4001L26.0516 28.2339C25.4491 27.6314 25.4491 26.6545 26.0516 26.052Z\"/><path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M54.1942 54.1946C55.6001 52.7887 57.8794 52.7887 59.2853 54.1946L74.9453 69.8547C76.3512 71.2605 76.3512 73.54 74.9453 74.9458C73.5395 76.3517 71.2601 76.3517 69.8542 74.9458L54.1942 59.2858C52.7883 57.8799 52.7883 55.6005 54.1942 54.1946Z\"/>",
	[M.EXISTING]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M13.8757 6.87568C15.717 5.03441 18.2143 4 20.8182 4H48.6364C49.5044 4 50.3368 4.3448 50.9506 4.95856L68.9506 22.9586C69.5643 23.5723 69.9091 24.4047 69.9091 25.2727V66.1818C69.9091 68.7858 68.8747 71.2831 67.0335 73.1243C65.1922 74.9656 62.6949 76 60.091 76H14.2728C12.4653 76 11 74.5347 11 72.7273C11 70.9198 12.4653 69.4545 14.2728 69.4545H60.091C60.9589 69.4545 61.7914 69.1097 62.4051 68.496C63.0189 67.8822 63.3637 67.0498 63.3637 66.1818V30.1818H47C45.1926 30.1818 43.7273 28.7166 43.7273 26.9091V10.5455H20.8182C19.9502 10.5455 19.1178 10.8903 18.5041 11.504C17.8903 12.1178 17.5455 12.9502 17.5455 13.8182V36.7273C17.5455 38.5348 16.0803 40 14.2728 40C12.4653 40 11 38.5348 11 36.7273V13.8182C11 11.2142 12.0345 8.71695 13.8757 6.87568ZM50.2728 13.5374V23.6364H60.3717L50.2728 13.5374ZM31.595 37.6858C32.873 36.4078 34.9452 36.4078 36.2233 37.6858L46.0415 47.504C47.3196 48.7821 47.3196 50.8543 46.0415 52.1323L36.2233 61.9505C34.9452 63.2286 32.873 63.2286 31.595 61.9505C30.3169 60.6724 30.3169 58.6003 31.595 57.3222L35.8263 53.0909H20.8182C19.9502 53.0909 19.1178 53.4357 18.5041 54.0495C17.8903 54.6632 17.5455 55.4957 17.5455 56.3636V59.6364C17.5455 61.4438 16.0803 62.9091 14.2728 62.9091C12.4653 62.9091 11 61.4438 11 59.6364V56.3636C11 53.7597 12.0345 51.2624 13.8757 49.4211C15.717 47.5799 18.2143 46.5455 20.8182 46.5455H35.8263L31.595 42.3142C30.3169 41.0361 30.3169 38.9639 31.595 37.6858Z\"/>",
	[M.EXTERNAL_LINK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M50.3333 13.6667C48.4924 13.6667 47 12.1743 47 10.3333C47 8.49238 48.4924 7 50.3333 7H70.3333C72.1743 7 73.6667 8.49238 73.6667 10.3333V30.3333C73.6667 32.1743 72.1743 33.6667 70.3333 33.6667C68.4924 33.6667 67 32.1743 67 30.3333V18.3807L36.0237 49.357C34.7219 50.6588 32.6114 50.6588 31.3096 49.357C30.0079 48.0553 30.0079 45.9447 31.3096 44.643L62.286 13.6667H50.3333ZM17 23.6667C16.1159 23.6667 15.2681 24.0179 14.643 24.643C14.0179 25.2681 13.6667 26.1159 13.6667 27V63.6667C13.6667 64.5507 14.0179 65.3986 14.643 66.0237C15.2681 66.6488 16.1159 67 17 67H53.6667C54.5507 67 55.3986 66.6488 56.0237 66.0237C56.6488 65.3986 57 64.5507 57 63.6667V43.6667C57 41.8257 58.4924 40.3333 60.3333 40.3333C62.1743 40.3333 63.6667 41.8257 63.6667 43.6667V63.6667C63.6667 66.3188 62.6131 68.8624 60.7377 70.7377C58.8624 72.6131 56.3188 73.6667 53.6667 73.6667H17C14.3478 73.6667 11.8043 72.6131 9.92893 70.7377C8.05357 68.8624 7 66.3188 7 63.6667V27C7 24.3478 8.05357 21.8043 9.92893 19.9289C11.8043 18.0536 14.3478 17 17 17H37C38.841 17 40.3333 18.4924 40.3333 20.3333C40.3333 22.1743 38.841 23.6667 37 23.6667H17Z\"/>",
	[M.EYE_OFF]: "\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.87868 4.87868C6.05025 3.70711 7.94975 3.70711 9.12132 4.87868L24.2663 20.0237C24.2882 20.0449 24.3097 20.0664 24.331 20.0883L35.7495 31.5069C35.7565 31.5138 35.7635 31.5208 35.7704 31.5278L48.472 44.2294C48.4792 44.2364 48.4863 44.2435 48.4933 44.2507L59.9063 55.6637C59.9281 55.6848 59.9497 55.7064 59.971 55.7284L75.1213 70.8787C76.2929 72.0503 76.2929 73.9497 75.1213 75.1213C73.9497 76.2929 72.0503 76.2929 70.8787 75.1213L57.4783 61.7209C52.2887 65.0607 46.2543 66.8981 40.049 66.9996L40 67C28.3015 67 19.3134 60.3207 13.4364 54.0518C10.4705 50.8882 8.2062 47.7361 6.68301 45.3776C5.91955 44.1954 5.33738 43.2051 4.94191 42.502C4.74407 42.1503 4.59262 41.8699 4.48826 41.6727C4.43607 41.5741 4.39563 41.4962 4.36701 41.4405L4.33297 41.3739L4.32262 41.3534L4.31911 41.3464C4.31911 41.3464 4.31672 41.3416 7 40L4.31672 41.3416C3.88078 40.4698 3.89563 39.4405 4.35653 38.5815C7.75106 32.2555 12.2791 26.619 17.7054 21.9481L4.87868 9.12132C3.70711 7.94975 3.70711 6.05025 4.87868 4.87868ZM21.9613 26.2039C17.3509 30.1041 13.448 34.7745 10.4277 40.0095C10.7549 40.5746 11.1878 41.2933 11.7232 42.1224C13.1063 44.2639 15.1545 47.1118 17.8136 49.9482C23.1818 55.6743 30.6853 60.9907 39.9755 61C44.6119 60.92 49.1311 59.6572 53.1142 57.3569L46.1492 50.3919C45.673 50.6904 45.1752 50.9558 44.6594 51.1857C43.1875 51.8415 41.5984 52.1942 39.9872 52.2226C38.376 52.2511 36.7755 51.9547 35.2813 51.3511C33.7871 50.7476 32.4297 49.8493 31.2902 48.7098C30.1507 47.5703 29.2524 46.2129 28.6489 44.7187C28.0453 43.2245 27.7489 41.6241 27.7774 40.0128C27.8058 38.4016 28.1585 36.8125 28.8143 35.3406C29.0442 34.8248 29.3096 34.327 29.6081 33.8508L21.9613 26.2039ZM34.0837 38.3263C33.8911 38.9036 33.7872 39.5079 33.7764 40.1187C33.7622 40.9243 33.9104 41.7245 34.2122 42.4716C34.514 43.2187 34.9631 43.8974 35.5329 44.4671C36.1026 45.0369 36.7813 45.486 37.5284 45.7878C38.2755 46.0896 39.0757 46.2378 39.8813 46.2236C40.4921 46.2128 41.0964 46.1088 41.6737 45.9163L34.0837 38.3263Z\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M39.9944 16L40 16C51.6044 16 59.8453 21.8284 65.0734 27.4587C67.6883 30.2747 69.5917 33.0814 70.8435 35.1843C71.4711 36.2386 71.9395 37.124 72.2555 37.756C72.4137 38.0723 72.534 38.3258 72.6173 38.5062C72.6589 38.5964 72.6914 38.6683 72.7147 38.7208L72.7429 38.7846L72.7518 38.8053L72.7563 38.8157C72.7563 38.8157 72.7574 38.8182 70 40L72.7563 38.8157C73.093 39.6012 73.0797 40.4954 72.7181 41.2697C71.2749 44.3592 69.465 47.2638 67.3274 49.9206C66.2887 51.2115 64.4003 51.416 63.1094 50.3774C61.8185 49.3388 61.614 47.4503 62.6526 46.1594C64.1939 44.2437 65.5368 42.1781 66.6615 39.9943C66.4158 39.5235 66.0919 38.9322 65.6877 38.2532C64.5957 36.4187 62.9367 33.9753 60.6766 31.5414C56.1551 26.6721 49.3969 22.0009 40.0028 22C38.8522 22.0023 37.7027 22.0747 36.5609 22.217C34.9167 22.4218 33.4178 21.255 33.213 19.6109C33.0082 17.9668 34.1749 16.4679 35.8191 16.263C37.2042 16.0905 38.5986 16.0026 39.9944 16Z\"/>\n    ",
	[M.EYE_ON]: "<path d=\"M40 14C47.6152 14 55.0594 16.2609 61.3879 20.4965C67.7164 24.7322 72.6444 30.7517 75.5478 37.7916C75.5627 37.8276 75.5774 37.8643 75.591 37.9009C76.1363 39.3702 76.1364 40.9866 75.591 42.4559C75.5774 42.4924 75.5626 42.5283 75.5478 42.5643C72.6444 49.6043 67.7165 55.6246 61.3879 59.8602C55.0594 64.0959 47.6152 66.3568 40 66.3568C32.3848 66.3568 24.9406 64.0959 18.612 59.8602C12.2835 55.6246 7.35558 49.6042 4.45215 42.5643C4.43734 42.5283 4.42253 42.4923 4.40901 42.4559C3.86361 40.9866 3.86372 39.3702 4.40901 37.9009L4.45215 37.7916C7.35554 30.7517 12.2836 24.7322 18.612 20.4965C24.9406 16.2609 32.3848 14 40 14ZM40 20.5445C33.681 20.5445 27.5038 22.4209 22.2524 25.9356C17.034 29.4283 12.9639 34.3833 10.5489 40.1779C12.9638 45.9726 17.034 50.9275 22.2524 54.4202C27.5038 57.9349 33.681 59.8113 40 59.8113C46.319 59.8113 52.4962 57.9349 57.7475 54.4202C62.966 50.9275 67.0361 45.9726 69.4511 40.1779C67.0361 34.3833 62.966 29.4283 57.7475 25.9356C52.4962 22.4209 46.319 20.5445 40 20.5445ZM46.5454 40.1769C46.5454 36.5622 43.6148 33.6315 40 33.6315C36.3852 33.6315 33.4546 36.5622 33.4546 40.1769C33.4546 43.7917 36.3852 46.7224 40 46.7224C43.6148 46.7224 46.5454 43.7917 46.5454 40.1769ZM53.0899 40.1769C53.0899 47.4065 47.2295 53.2669 40 53.2669C32.7705 53.2669 26.9101 47.4065 26.9101 40.1769C26.9101 32.9474 32.7705 27.087 40 27.087C47.2295 27.087 53.0899 32.9474 53.0899 40.1769Z\" />",
	[M.FACE_ID]: "<path d=\"M26.1564 29.467V35.6054C26.1564 37.1841 24.884 38.4566 23.3288 38.4566C21.7736 38.4566 20.5012 37.1841 20.5012 35.6054V29.467C20.5012 27.9 21.7618 26.6158 23.3288 26.6158C24.8958 26.6158 26.1564 27.9 26.1564 29.467Z\" /><path d=\"M59.5107 29.467V35.6171C59.5107 37.1841 58.25 38.4566 56.683 38.4566C55.1161 38.4566 53.8554 37.1841 53.8554 35.6171V29.467C53.8554 27.9 55.1278 26.6158 56.683 26.6158C58.2383 26.6158 59.5107 27.9 59.5107 29.467Z\" /> <path d=\"M43.511 28.9604V43.6759C43.511 47.2223 40.648 50.097 37.137 50.097H35.7586C34.5686 50.097 33.5907 49.1191 33.5907 47.9174C33.5907 46.7156 34.5686 45.726 35.7586 45.726H37.137C38.2563 45.726 39.1753 44.807 39.1753 43.6759V28.9604C39.1753 27.7587 40.1414 26.7808 41.3431 26.7808C42.5449 26.7808 43.511 27.7587 43.511 28.9604Z\" /> <path d=\"M54.2678 58.3325C51.0985 61.9731 45.7849 64.1527 40.0354 64.1527C34.2858 64.1527 28.8898 61.9495 25.7322 58.2501C24.9546 57.3429 25.0607 55.9644 25.9679 55.175C26.8751 54.3856 28.2418 54.4917 29.0194 55.4106C31.3286 58.1087 35.5465 59.7935 40.0354 59.7935C44.5242 59.7935 48.6832 58.1322 51.0042 55.4578C51.7936 54.5506 53.1603 54.4563 54.0557 55.2457C54.9629 56.0468 55.0454 57.4253 54.2678 58.3325Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M14.8 11.2C13.8452 11.2 12.9295 11.5793 12.2544 12.2544C11.5793 12.9295 11.2 13.8452 11.2 14.8V22C11.2 23.9882 9.58822 25.6 7.59999 25.6C5.61177 25.6 3.99999 23.9882 3.99999 22V14.8C3.99999 11.9357 5.13785 9.18864 7.16324 7.16325C9.18863 5.13785 11.9357 4 14.8 4H22C23.9882 4 25.6 5.61178 25.6 7.6C25.6 9.58823 23.9882 11.2 22 11.2H14.8Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M54.4 7.6C54.4 5.61178 56.0118 4 58 4H65.2C68.0643 4 70.8114 5.13785 72.8367 7.16325C74.8621 9.18864 76 11.9357 76 14.8V22C76 23.9882 74.3882 25.6 72.4 25.6C70.4118 25.6 68.8 23.9882 68.8 22V14.8C68.8 13.8452 68.4207 12.9296 67.7456 12.2544C67.0704 11.5793 66.1548 11.2 65.2 11.2H58C56.0118 11.2 54.4 9.58823 54.4 7.6Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M72.4 54.4001C74.3882 54.4001 76 56.0119 76 58.0001V65.2001C76 68.0645 74.8621 70.8115 72.8367 72.8369C70.8114 74.8623 68.0643 76.0001 65.2 76.0001H58C56.0118 76.0001 54.4 74.3883 54.4 72.4001C54.4 70.4119 56.0118 68.8001 58 68.8001H65.2C66.1548 68.8001 67.0704 68.4208 67.7456 67.7457C68.4207 67.0706 68.8 66.1549 68.8 65.2001V58.0001C68.8 56.0119 70.4118 54.4001 72.4 54.4001Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M7.59999 54.4001C9.58822 54.4001 11.2 56.0119 11.2 58.0001V65.2001C11.2 66.1549 11.5793 67.0706 12.2544 67.7457C12.9295 68.4208 13.8452 68.8001 14.8 68.8001H22C23.9882 68.8001 25.6 70.4119 25.6 72.4001C25.6 74.3883 23.9882 76.0001 22 76.0001H14.8C11.9357 76.0001 9.18863 74.8623 7.16324 72.8369C5.13785 70.8115 3.99999 68.0644 3.99999 65.2001V58.0001C3.99999 56.0119 5.61177 54.4001 7.59999 54.4001Z\"/>\n        ",
	[M.FILE_DOWNLOAD]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M13.8757 6.87568C15.7169 5.03441 18.2142 4 20.8182 4H50.2727C51.1407 4 51.9731 4.3448 52.5869 4.95856L68.9505 21.3222C69.5643 21.936 69.9091 22.7684 69.9091 23.6364V66.1818C69.9091 68.7858 68.8747 71.2831 67.0334 73.1243C65.1921 74.9656 62.6949 76 60.0909 76H20.8182C18.2142 76 15.7169 74.9656 13.8757 73.1243C12.0344 71.2831 11 68.7858 11 66.1818V13.8182C11 11.2142 12.0344 8.71694 13.8757 6.87568ZM20.8182 10.5455C19.9502 10.5455 19.1178 10.8903 18.504 11.504C17.8903 12.1178 17.5455 12.9502 17.5455 13.8182V66.1818C17.5455 67.0498 17.8903 67.8822 18.504 68.496C19.1178 69.1097 19.9502 69.4545 20.8182 69.4545H60.0909C60.9589 69.4545 61.7913 69.1097 62.4051 68.496C63.0188 67.8822 63.3636 67.0498 63.3636 66.1818V24.992L48.9171 10.5455H20.8182Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M46.9961 4C48.8035 4 50.2688 5.46525 50.2688 7.27273V20.3636C50.2688 21.2316 50.6136 22.064 51.2274 22.6778C51.8411 23.2916 52.6735 23.6364 53.5415 23.6364H66.6324C68.4399 23.6364 69.9052 25.1016 69.9052 26.9091C69.9052 28.7166 68.4399 30.1818 66.6324 30.1818H53.5415C50.9376 30.1818 48.4403 29.1474 46.599 27.3061C44.7578 25.4649 43.7233 22.9676 43.7233 20.3636V7.27273C43.7233 5.46525 45.1886 4 46.9961 4Z\"/>\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40.4555 36.7263C42.263 36.7263 43.7283 38.1915 43.7283 39.999V59.6354C43.7283 61.4429 42.263 62.9081 40.4555 62.9081C38.6481 62.9081 37.1828 61.4429 37.1828 59.6354V39.999C37.1828 38.1915 38.6481 36.7263 40.4555 36.7263Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M28.3232 47.503C29.6013 46.225 31.6734 46.225 32.9515 47.503L40.4555 55.007L47.9595 47.503C49.2376 46.225 51.3098 46.225 52.5879 47.503C53.866 48.7811 53.866 50.8533 52.5879 52.1314L42.7697 61.9495C41.4916 63.2276 39.4194 63.2276 38.1414 61.9495L28.3232 52.1314C27.0451 50.8533 27.0451 48.7811 28.3232 47.503Z\"/>\n    ",
	[M.FILE_UPLOAD]: "<path d=\"M11 66.1823V13.8187C11 11.2148 12.0342 8.71724 13.8755 6.87596C15.7167 5.03469 18.2143 4.00049 20.8182 4.00049H50.2729L50.4349 4.00432C51.2437 4.04446 52.0112 4.38315 52.5865 4.95834L68.9505 21.3224C69.5643 21.9361 69.9094 22.769 69.9094 23.6369V66.1823C69.9094 68.7862 68.8742 71.2837 67.0329 73.125C65.1918 74.966 62.6948 76.0004 60.0911 76.0005H20.8182C18.2143 76.0005 15.7167 74.9662 13.8755 73.125C12.0342 71.2837 11 68.7862 11 66.1823ZM37.1813 59.6365V47.9016L32.9501 52.1328C31.672 53.4107 29.5999 53.4108 28.3219 52.1328C27.0438 50.8548 27.044 48.7827 28.3219 47.5046L38.1401 37.6864L38.2619 37.5704C39.5466 36.4093 41.53 36.4481 42.7683 37.6864L52.5865 47.5046C53.8646 48.7827 53.8646 50.8547 52.5865 52.1328C51.3084 53.4107 49.2364 53.4108 47.9583 52.1328L43.7271 47.9016V59.6365C43.7271 61.4438 42.262 62.9097 40.4547 62.9098C38.6472 62.9098 37.1813 61.4439 37.1813 59.6365ZM50.2729 20.3636C50.2729 21.2315 50.6171 22.0644 51.2308 22.6781C51.8445 23.2919 52.6773 23.6369 53.5453 23.6369H62.0088L50.2729 11.9011V20.3636ZM17.5448 66.1823L17.5496 66.3443C17.5897 67.1533 17.9282 67.9214 18.5037 68.4968C19.1174 69.1105 19.9503 69.4547 20.8182 69.4547H60.0911C60.9588 69.4546 61.7911 69.1103 62.4047 68.4968C63.0185 67.8831 63.3635 67.0502 63.3635 66.1823V30.1818H53.5453C50.9414 30.1818 48.4438 29.1476 46.6026 27.3063C44.7614 25.465 43.7271 22.9674 43.7271 20.3636V10.5453H20.8182C19.9502 10.5453 19.1174 10.8904 18.5037 11.5041C17.8899 12.1179 17.5448 12.9507 17.5448 13.8187V66.1823Z\" />",
	[M.FILE_RESPONSE]: "<path d=\"M11 36.7271V13.8182C11 11.2143 12.0342 8.71675 13.8755 6.87547C15.7167 5.0342 18.2143 4 20.8182 4H50.2729L50.4349 4.00384C51.2437 4.04397 52.0112 4.38267 52.5865 4.95785L68.9505 21.3219C69.5643 21.9356 69.9094 22.7685 69.9094 23.6365V66.1818C69.9094 68.7857 68.8742 71.2832 67.0329 73.1245C65.1917 74.9655 62.6948 75.9999 60.0911 76H20.8182C18.2143 76 15.7167 74.9657 13.8755 73.1245C12.0342 71.2832 11 68.7857 11 66.1818V56.3635C11 53.7596 12.0342 51.2621 13.8755 49.4208C15.7167 47.5796 18.2143 46.5453 20.8182 46.5453H35.8284L31.5943 42.3112C30.3162 41.0331 30.3162 38.9602 31.5943 37.6821C32.8724 36.404 34.9454 36.404 36.2234 37.6821L46.0417 47.5003C46.6204 48.079 46.9353 48.8211 46.9899 49.578C46.9957 49.6572 46.9995 49.7371 46.9995 49.8177C46.9995 50.7497 46.6093 51.59 45.9841 52.186L36.2234 61.9477C34.9454 63.2257 32.8724 63.2257 31.5943 61.9477C30.3162 60.6696 30.3162 58.5966 31.5943 57.3185L35.8217 53.0911H20.8182C19.9503 53.0911 19.1174 53.4353 18.5037 54.049C17.8899 54.6627 17.5448 55.4956 17.5448 56.3635V66.1818L17.5496 66.3438C17.5897 67.1528 17.9282 67.9209 18.5037 68.4963C19.1174 69.11 19.9503 69.4542 20.8182 69.4542H60.0911C60.9588 69.4541 61.7911 69.1098 62.4047 68.4963C63.0185 67.8826 63.3635 67.0498 63.3635 66.1818V30.1813H53.4945C50.8906 30.1813 48.393 29.1471 46.5518 27.3058C44.7105 25.4645 43.6763 22.967 43.6763 20.3631V10.5448H20.8182C19.9502 10.5448 19.1174 10.8899 18.5037 11.5037C17.8899 12.1174 17.5448 12.9502 17.5448 13.8182V36.7271C17.5448 38.5346 16.0799 39.9995 14.2724 39.9995C12.4649 39.9995 11 38.5346 11 36.7271ZM50.2211 20.3631C50.2211 21.2311 50.5662 22.0639 51.1799 22.6776C51.7937 23.2914 52.6265 23.6365 53.4945 23.6365H62.0088L50.2211 11.8488V20.3631Z\" />",
	[M.FILTERS]: "<path d=\"M67.8799 38.9479C67.8799 40.1901 66.8078 41.2401 65.536 41.2401H35.582C34.8425 41.2401 34.0366 41.6394 33.6373 42.2901C32.432 44.1978 30.3542 45.4474 27.9437 45.4474C25.5332 45.4474 23.3815 44.1978 22.2428 42.2901C21.8435 41.6394 21.1041 41.2401 20.2981 41.2401H15.344C14.0722 41.2401 13 40.1901 13 38.9479C13 37.7056 14.0722 36.6483 15.344 36.6483H20.2981C21.0375 36.6483 21.8435 36.2564 22.2428 35.5983C23.448 33.6906 25.5258 32.4483 27.9437 32.4483C30.3616 32.4483 32.432 33.6906 33.6373 35.5983C34.0366 36.2564 34.776 36.6483 35.582 36.6483H65.536C66.8078 36.6483 67.8799 37.6982 67.8799 38.9479ZM67.8799 54.8307C67.8799 56.0803 66.8078 57.1303 65.536 57.1303H61.1808C60.4414 57.1303 59.6354 57.5222 59.2361 58.1803C58.0308 60.088 55.9531 61.3302 53.5351 61.3302C51.1172 61.3302 48.9803 60.088 47.8416 58.1803C47.4423 57.5222 46.7029 57.1303 45.8969 57.1303H15.344C14.0722 57.1303 13 56.0803 13 54.8307C13 53.5811 14.0722 52.5385 15.344 52.5385H45.8969C46.6363 52.5385 47.4423 52.1392 47.8416 51.4811C49.0468 49.5808 51.1246 48.3312 53.5351 48.3312C55.9457 48.3312 58.0308 49.5808 59.2361 51.4811C59.6354 52.1392 60.3748 52.5385 61.1808 52.5385H65.536C66.8078 52.5385 67.8799 53.5885 67.8799 54.8307ZM67.8799 24.4995C67.8799 25.7492 66.8078 26.7991 65.5286 26.7991H61.1734C60.3674 26.7991 59.628 27.191 59.2213 27.8491C58.0826 29.7568 55.9383 30.9991 53.5204 30.9991C51.1024 30.9991 49.0247 29.7568 47.8194 27.8491C47.4127 27.191 46.6141 26.7991 45.8747 26.7991H15.344C14.0722 26.7991 13 25.7492 13 24.4995C13 23.2499 14.0722 22.2073 15.344 22.2073H45.9413C46.7472 22.2073 47.4793 21.808 47.886 21.1573C49.0247 19.2496 51.1764 18 53.5869 18C55.9974 18 58.0826 19.2496 59.2878 21.1573C59.6945 21.808 60.5005 22.2073 61.2399 22.2073H65.5286C66.8078 22.2073 67.8799 23.2573 67.8799 24.4995Z\" />\n        ",
	[M.FILTERS_ACTIVE]: "<path d=\"M67.8799 38.9479C67.8799 40.1901 66.8078 41.2401 65.536 41.2401H35.582C34.8425 41.2401 34.0366 41.6394 33.6373 42.2901C32.432 44.1978 30.3542 45.4474 27.9437 45.4474C25.5332 45.4474 23.3815 44.1978 22.2428 42.2901C21.8435 41.6394 21.1041 41.2401 20.2981 41.2401H15.344C14.0722 41.2401 13 40.1901 13 38.9479C13 37.7056 14.0722 36.6483 15.344 36.6483H20.2981C21.0375 36.6483 21.8435 36.2564 22.2428 35.5983C23.448 33.6906 25.5258 32.4483 27.9437 32.4483C30.3616 32.4483 32.432 33.6906 33.6373 35.5983C34.0366 36.2564 34.776 36.6483 35.582 36.6483H65.536C66.8078 36.6483 67.8799 37.6982 67.8799 38.9479ZM67.8799 54.8307C67.8799 56.0803 66.8078 57.1303 65.536 57.1303H61.1808C60.4414 57.1303 59.6354 57.5222 59.2361 58.1803C58.0308 60.088 55.9531 61.3302 53.5351 61.3302C51.1172 61.3302 48.9803 60.088 47.8416 58.1803C47.4423 57.5222 46.7029 57.1303 45.8969 57.1303H15.344C14.0722 57.1303 13 56.0803 13 54.8307C13 53.5811 14.0722 52.5385 15.344 52.5385H45.8969C46.6363 52.5385 47.4423 52.1392 47.8416 51.4811C49.0468 49.5808 51.1246 48.3312 53.5351 48.3312C55.9457 48.3312 58.0308 49.5808 59.2361 51.4811C59.6354 52.1392 60.3748 52.5385 61.1808 52.5385H65.536C66.8078 52.5385 67.8799 53.5885 67.8799 54.8307ZM67.8799 24.4995C67.8799 25.7492 66.8078 26.7991 65.5286 26.7991H61.1734C60.3674 26.7991 59.628 27.191 59.2213 27.8491C58.0826 29.7568 55.9383 30.9991 53.5204 30.9991C51.1024 30.9991 49.0247 29.7568 47.8194 27.8491C47.4127 27.191 46.6141 26.7991 45.8747 26.7991H15.344C14.0722 26.7991 13 25.7492 13 24.4995C13 23.2499 14.0722 22.2073 15.344 22.2073H45.9413C46.7472 22.2073 47.4793 21.808 47.886 21.1573C49.0247 19.2496 51.1764 18 53.5869 18C55.9974 18 58.0826 19.2496 59.2878 21.1573C59.6945 21.808 60.5005 22.2073 61.2399 22.2073H65.5286C66.8078 22.2073 67.8799 23.2573 67.8799 24.4995Z\" />\n        <path d=\"M71.1354 18.7297C74.3757 18.7297 77.0002 16.1052 77.0002 12.8649C77.0002 9.62452 74.3757 7 71.1354 7C67.895 7 65.2705 9.62452 65.2705 12.8649C65.2705 16.1052 67.895 18.7297 71.1354 18.7297Z\" />\n        ",
	[M.FLAG]: "<path d=\"M16.6188 72.6953C16.6188 73.607 16.3055 74.3857 15.6787 75.0314C15.052 75.6771 14.2733 76 13.3427 76C12.412 76 11.6144 75.6771 10.9686 75.0314C10.3229 74.3857 10 73.607 10 72.6953V7.31417C10 6.40253 10.3229 5.62385 10.9686 4.97811C11.6144 4.32287 12.4025 4 13.3427 4C14.2828 4 15.0615 4.31337 15.6787 4.94012C16.3055 5.56687 16.6188 6.35505 16.6188 7.31417V7.45661H66.5118C67.5184 7.45661 68.3825 7.81746 69.1042 8.53917C69.8259 9.26088 70.1868 10.144 70.1868 11.2076C70.1868 12.2712 69.7785 13.1543 68.9618 13.876L54.6321 26.9807C53.8629 27.655 53.464 28.5096 53.445 29.5352C53.4165 30.5703 53.7489 31.4724 54.4136 32.2321L68.9618 45.5553C69.731 46.2295 70.1393 47.0841 70.1868 48.1097C70.2343 49.1448 69.9114 50.0565 69.2182 50.8446C68.525 51.6328 67.6228 52.0317 66.5213 52.0317H16.6188V72.6953Z\" />",
	[M.GLOBE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 10.5455C23.7326 10.5455 10.5453 23.7327 10.5453 40C10.5453 56.2673 23.7326 69.4545 40 69.4545C56.2674 69.4545 69.4547 56.2673 69.4547 40C69.4547 23.7327 56.2674 10.5455 40 10.5455ZM3.99983 40C3.99983 20.1177 20.1177 4 40 4C59.8823 4 76.0001 20.1177 76.0001 40C76.0001 59.8823 59.8823 76 40 76C20.1177 76 3.99983 59.8823 3.99983 40Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M3.99983 40C3.99983 38.1925 5.46509 36.7273 7.27257 36.7273H72.7274C74.5349 36.7273 76.0001 38.1925 76.0001 40C76.0001 41.8075 74.5349 43.2727 72.7274 43.2727H7.27257C5.46509 43.2727 3.99983 41.8075 3.99983 40Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 4C40.9194 4 41.7964 4.38671 42.4164 5.06552C51.1375 14.6132 56.0937 27.0035 56.363 39.9318C56.3639 39.9773 56.3639 40.0227 56.363 40.0682C56.0937 52.9965 51.1375 65.3869 42.4164 74.9345C41.7964 75.6133 40.9194 76 40 76C39.0806 76 38.2036 75.6133 37.5836 74.9345C28.8625 65.3869 23.9063 52.9965 23.637 40.0682C23.636 40.0227 23.636 39.9773 23.637 39.9318C23.9063 27.0035 28.8625 14.6132 37.5836 5.06552C38.2036 4.38671 39.0806 4 40 4ZM30.1825 40C30.4068 50.0631 33.8677 59.7514 40 67.6519C46.1323 59.7514 49.5932 50.0631 49.8175 40C49.5932 29.9369 46.1323 20.2486 40 12.3481C33.8677 20.2486 30.4068 29.9369 30.1825 40Z\" />\n        ",
	[M.HEART]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M16.9463 8.60017C19.4904 7.54379 22.218 7 24.9727 7C27.7274 7 30.455 7.54379 32.999 8.60017C35.5431 9.65656 37.8536 11.2048 39.7981 13.156L39.809 13.1669L39.9998 13.3603L40.1906 13.167L40.2015 13.156C42.1459 11.2048 44.4564 9.65656 47.0005 8.60017C49.5446 7.54379 52.2722 7 55.0269 7C57.7816 7 60.5092 7.54379 63.0532 8.60017C65.5964 9.6562 67.9063 11.2037 69.8503 13.154C78.1733 21.4793 78.3584 35.2446 68.4961 45.2917L68.4749 45.3133L42.3122 71.4759C41.6989 72.0892 40.8671 72.4338 39.9998 72.4338C39.1324 72.4338 38.3006 72.0892 37.6873 71.4759L11.5033 45.2918C1.64106 35.2447 1.82622 21.4793 10.1493 13.154C12.0933 11.2037 14.4031 9.6562 16.9463 8.60017ZM24.9727 13.5407C23.0788 13.5407 21.2036 13.9145 19.4546 14.6408C17.7055 15.3671 16.117 16.4315 14.7802 17.7729L14.7762 17.777C9.23753 23.3157 8.57125 32.9584 16.1609 40.6994L39.9998 64.5385L63.8387 40.6994C71.4283 32.9584 70.762 23.3157 65.2234 17.777L65.2194 17.7729C63.8825 16.4315 62.2941 15.3671 60.545 14.6408C58.7959 13.9145 56.9207 13.5407 55.0269 13.5407C53.133 13.5407 51.2578 13.9145 49.5088 14.6408C47.762 15.3661 46.1754 16.4287 44.8397 17.7676C44.8379 17.7694 44.8362 17.7712 44.8344 17.7729L42.3271 20.3129C41.7126 20.9353 40.8744 21.2857 39.9998 21.2857C39.1251 21.2857 38.2869 20.9353 37.6724 20.3129L35.1652 17.7729C35.1634 17.7712 35.1616 17.7694 35.1599 17.7676C33.8242 16.4287 32.2376 15.3661 30.4908 14.6408C28.7417 13.9145 26.8665 13.5407 24.9727 13.5407Z\" />",
	[M.HEART_ACTIVE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M16.9466 8.60017C19.4906 7.54379 22.2182 7 24.9729 7C27.7276 7 30.4552 7.54379 32.9993 8.60017C35.5434 9.65656 37.8539 11.2048 39.7984 13.156L39.8092 13.1669L40 13.3603L40.1908 13.167L40.2017 13.156C42.1462 11.2048 44.4567 9.65656 47.0008 8.60017C49.5448 7.54379 52.2724 7 55.0271 7C57.7818 7 60.5094 7.54379 63.0535 8.60017C65.5967 9.6562 67.9065 11.2037 69.8505 13.154C78.1736 21.4793 78.3586 35.2446 68.4964 45.2917L68.4751 45.3133L42.3125 71.4759C41.6992 72.0892 40.8674 72.4338 40 72.4338C39.1327 72.4338 38.3009 72.0892 37.6876 71.4759L11.5036 45.2918C1.6413 35.2447 1.82647 21.4793 10.1495 13.154C12.0936 11.2037 14.4034 9.6562 16.9466 8.60017Z\" />  /> ",
	[M.HOME]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M37.7163 4.68935C38.898 3.77022 40.5528 3.77022 41.7346 4.68935L71.1874 27.5971C71.9846 28.2171 72.4508 29.1704 72.4508 30.1803V66.1783C72.4508 68.7821 71.4165 71.2792 69.5753 73.1204C67.7341 74.9615 65.237 75.9959 62.6332 75.9959H49.7083C49.6535 75.9986 49.5984 76 49.543 76C49.4876 76 49.4325 75.9986 49.3778 75.9959H30.073C30.0183 75.9986 29.9632 76 29.9078 76C29.8524 76 29.7973 75.9986 29.7425 75.9959H16.8176C14.2138 75.9959 11.7167 74.9615 9.87551 73.1204C8.03435 71.2792 7 68.7821 7 66.1783V30.1803C7 29.1704 7.46625 28.2171 8.2634 27.5971L37.7163 4.68935ZM33.1803 69.4508H46.2705V43.2746H33.1803V69.4508ZM52.8156 69.4508V40.002C52.8156 38.1947 51.3504 36.7295 49.543 36.7295H29.9078C28.1004 36.7295 26.6352 38.1947 26.6352 40.002V69.4508H16.8176C15.9497 69.4508 15.1173 69.106 14.5036 68.4923C13.8899 67.8786 13.5451 67.0462 13.5451 66.1783V31.7809L39.7254 11.4184L65.9057 31.7809V66.1783C65.9057 67.0462 65.5609 67.8786 64.9472 68.4923C64.3335 69.106 63.5011 69.4508 62.6332 69.4508H52.8156Z\" />",
	[M.IMAGE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M63.7857 66.7143C64.5624 66.7143 65.3073 66.4057 65.8565 65.8565C66.4057 65.3073 66.7143 64.5624 66.7143 63.7857V51.6987L57.2848 42.2692C56.7356 41.7204 55.9906 41.4117 55.2143 41.4117C54.4379 41.4117 53.6932 41.7201 53.1441 42.2689L28.6987 66.7143H63.7857ZM62.8398 36.7125L66.7143 40.587V39.7857C66.7143 38.4561 66.7141 36.7783 66.7139 34.9297C66.7138 34.468 66.7137 33.9956 66.7137 33.5153C66.7132 30.9605 66.7127 28.1827 66.7121 25.5982L66.71 15.7813C66.71 15.2977 66.66 14.9397 66.5405 14.6333C66.4247 14.3366 66.2302 14.0544 65.8887 13.7449C65.3053 13.292 65.0022 13.087 64.7415 12.9806C64.5012 12.8825 64.2702 12.8571 63.78 12.8571H15.7857C15.009 12.8571 14.2641 13.1657 13.7149 13.7149C13.1657 14.2641 12.8571 15.009 12.8571 15.7857V63.7857C12.8571 64.5624 13.1657 65.3073 13.7149 65.8565C14.2641 66.4057 15.009 66.7143 15.7857 66.7143H17.587L47.5884 36.7129C49.611 34.6909 52.3543 33.5546 55.2143 33.5546C57.5734 33.5546 59.8528 34.3275 61.714 35.733C62.0628 35.9964 62.3969 36.282 62.7141 36.5889C62.7563 36.6297 62.7982 36.6709 62.8398 36.7125ZM71.2536 7.99705C71.3123 8.05725 71.3638 8.11008 71.4087 8.15414C72.3193 9.04628 73.1236 9.93094 73.6902 11.1181C74.2584 12.3087 74.5697 13.7636 74.57 15.7812C74.5714 24.4954 74.5714 34.522 74.5714 39.7857V63.7857C74.5714 66.6463 73.4351 69.3897 71.4124 71.4124C69.3897 73.4351 66.6463 74.5714 63.7857 74.5714H15.7857C12.9252 74.5714 10.1818 73.4351 8.15906 71.4124C6.13635 69.3896 5 66.6463 5 63.7857V15.7857C5 12.9252 6.13635 10.1818 8.15906 8.15906C10.1818 6.13635 12.9252 5 15.7857 5L63 5.00001C65.8235 5.00001 67.7437 5.59539 69.0626 6.30457C70.2008 6.91655 70.8757 7.60916 71.2536 7.99705Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M24.318 28.318C22.5607 30.0754 22.5607 32.9246 24.318 34.682C26.0754 36.4393 28.9246 36.4393 30.682 34.682L34.9246 38.9246C30.8241 43.0251 24.1759 43.0251 20.0754 38.9246C15.9749 34.8241 15.9749 28.1759 20.0754 24.0754C24.1759 19.9749 30.8241 19.9749 34.9246 24.0754C39.0251 28.1759 39.0251 34.8241 34.9246 38.9246L30.682 34.682C32.4393 32.9246 32.4393 30.0754 30.682 28.318C28.9246 26.5607 26.0754 26.5607 24.318 28.318Z\" />\n        ",
	[M.IMAGE_UPLOAD]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M62.2857 4C64.1793 4 65.7143 5.53502 65.7143 7.42857V14.2857H72.5714C74.465 14.2857 76 15.8207 76 17.7143C76 19.6078 74.465 21.1429 72.5714 21.1429H65.7143V28C65.7143 29.8935 64.1793 31.4286 62.2857 31.4286C60.3922 31.4286 58.8571 29.8935 58.8571 28V21.1429H52C50.1065 21.1429 48.5714 19.6078 48.5714 17.7143C48.5714 15.8207 50.1065 14.2857 52 14.2857H58.8571V7.42857C58.8571 5.53502 60.3922 4 62.2857 4ZM14.2857 14.2857C13.3764 14.2857 12.5043 14.6469 11.8613 15.2899C11.2184 15.9329 10.8571 16.805 10.8571 17.7143V65.7143C10.8571 66.6236 11.2184 67.4957 11.8613 68.1386C12.5043 68.7816 13.3764 69.1429 14.2857 69.1429H16.2941L46.4419 38.9951C48.3708 37.0668 50.9869 35.9832 53.7143 35.9832C56.4417 35.9832 59.0574 37.0664 60.9863 38.9947L65.7143 43.7227V41.7143C65.7143 39.8207 67.2493 38.2857 69.1429 38.2857C71.0364 38.2857 72.5714 39.8207 72.5714 41.7143V51.9966C72.5714 51.9989 72.5714 52.0011 72.5714 52.0034V65.7143C72.5714 68.4422 71.4878 71.0584 69.5588 72.9874C67.6299 74.9163 65.0137 76 62.2857 76H17.7176C17.7154 76 17.7132 76 17.7109 76H14.2857C11.5578 76 8.94156 74.9163 7.01262 72.9874C5.08367 71.0584 4 68.4422 4 65.7143V17.7143C4 14.9863 5.08367 12.3701 7.01262 10.4412C8.94156 8.51224 11.5578 7.42857 14.2857 7.42857H38.2857C40.1793 7.42857 41.7143 8.9636 41.7143 10.8571C41.7143 12.7507 40.1793 14.2857 38.2857 14.2857H14.2857ZM25.9916 69.1429H62.2857C63.195 69.1429 64.0671 68.7816 64.7101 68.1386C65.3531 67.4957 65.7143 66.6236 65.7143 65.7143V53.4202L56.1383 43.8442C55.4954 43.2016 54.6232 42.8403 53.7143 42.8403C52.8053 42.8403 51.9336 43.2013 51.2907 43.8438L25.9916 69.1429ZM28 28C26.1065 28 24.5714 29.535 24.5714 31.4286C24.5714 33.3221 26.1065 34.8571 28 34.8571C29.8935 34.8571 31.4286 33.3221 31.4286 31.4286C31.4286 29.535 29.8935 28 28 28ZM17.7143 31.4286C17.7143 25.7479 22.3194 21.1429 28 21.1429C33.6806 21.1429 38.2857 25.7479 38.2857 31.4286C38.2857 37.1092 33.6806 41.7143 28 41.7143C22.3194 41.7143 17.7143 37.1092 17.7143 31.4286Z\" />\n    ",
	[M.INFO]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 10.5455C23.7327 10.5455 10.5455 23.7327 10.5455 40C10.5455 56.2673 23.7327 69.4545 40 69.4545C56.2673 69.4545 69.4545 56.2673 69.4545 40C69.4545 23.7327 56.2673 10.5455 40 10.5455ZM4 40C4 20.1177 20.1177 4 40 4C59.8823 4 76 20.1177 76 40C76 59.8823 59.8823 76 40 76C20.1177 76 4 59.8823 4 40ZM36.7273 26.9091C36.7273 25.1016 38.1925 23.6364 40 23.6364H40.0327C41.8402 23.6364 43.3055 25.1016 43.3055 26.9091C43.3055 28.7166 41.8402 30.1818 40.0327 30.1818H40C38.1925 30.1818 36.7273 28.7166 36.7273 26.9091ZM40 36.7273C41.8075 36.7273 43.2727 38.1925 43.2727 40V53.0909C43.2727 54.8984 41.8075 56.3636 40 56.3636C38.1925 56.3636 36.7273 54.8984 36.7273 53.0909V40C36.7273 38.1925 38.1925 36.7273 40 36.7273Z\"/>",
	[M.INPUT_DOTS]: "<path d=\"M69.4573 26.8176C69.456 25.0114 67.9887 23.5502 66.1822 23.5502H13.8178C12.0124 23.5515 10.5517 25.0123 10.5503 26.8176V53.0037C10.5517 54.809 12.0124 56.2698 13.8178 56.2711H66.1822C67.9887 56.2711 69.456 54.8099 69.4573 53.0037V26.8176ZM23.674 36.6355C25.4814 36.6355 26.9492 38.1032 26.9492 39.9107C26.9492 41.7181 25.4814 43.1858 23.674 43.1858H23.6357C21.8294 43.1844 20.3682 41.7172 20.3682 39.9107C20.3682 38.1041 21.8294 36.6369 23.6357 36.6355H23.674ZM40.0422 36.6355C41.8488 36.6364 43.3097 38.1038 43.3097 39.9107C43.3097 41.7175 41.8488 43.1849 40.0422 43.1858H40.0038C38.1964 43.1858 36.7287 41.7181 36.7287 39.9107C36.7287 38.1032 38.1964 36.6355 40.0038 36.6355H40.0422ZM56.4027 36.6355C58.2101 36.6355 59.6779 38.1032 59.6779 39.9107C59.6779 41.7181 58.2101 43.1858 56.4027 43.1858H56.3643C54.5569 43.1858 53.0892 41.7181 53.0892 39.9107C53.0892 38.1032 54.5569 36.6355 56.3643 36.6355H56.4027ZM76 53.0037C75.9986 58.4247 71.6036 62.8215 66.1822 62.8215H13.8178C8.39762 62.8201 4.00138 58.4239 4 53.0037V26.8176C4.00138 21.3974 8.39762 17.0012 13.8178 16.9998H66.1822C71.6036 16.9998 75.9986 21.3966 76 26.8176V53.0037Z\" />",
	[M.KEY]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M75.9998 39.3415C75.9998 40.837 74.7875 42.0493 73.292 42.0493L68.3411 42.0493V50.8295C68.3411 52.325 67.1288 53.5373 65.6334 53.5373L52.2308 53.5373C50.7353 53.5373 49.523 52.325 49.523 50.8295L49.523 42.0493L39.006 42.0493C38.7986 43.4341 38.4261 44.7925 37.8942 46.0949C37.0167 48.2438 35.7228 50.198 34.087 51.8449C32.4511 53.4917 30.5057 54.7987 28.3626 55.6906C26.2196 56.5825 23.9213 57.0416 21.6 57.0416C19.2788 57.0416 16.9805 56.5825 14.8375 55.6906C12.6944 54.7987 10.749 53.4917 9.11314 51.8449C7.4773 50.198 6.18337 48.2438 5.30586 46.0949C4.42835 43.9459 3.9846 41.6446 4.00015 39.3234L4.00034 39.2945C4.08054 34.6802 5.96999 30.2821 9.26146 27.0473C12.5529 23.8126 16.9832 22 21.5981 22C26.213 22 30.6433 23.8126 33.9348 27.0473C36.5861 29.653 38.3277 33.0135 38.9467 36.6338L73.292 36.6338C74.7875 36.6338 75.9998 37.8461 75.9998 39.3415ZM33.7848 39.4905C33.7829 39.4567 33.7817 39.4227 33.7811 39.3886C33.7256 36.1941 32.4176 33.1493 30.1389 30.9098C27.8602 28.6703 24.7931 27.4155 21.5981 27.4155C18.4032 27.4155 15.3361 28.6704 13.0574 30.9098C10.7821 33.1459 9.47461 36.185 9.41541 39.3742C9.40659 40.9762 9.71378 42.5644 10.3195 44.0476C10.927 45.5354 11.8228 46.8883 12.9553 48.0284C14.0878 49.1685 15.4346 50.0734 16.9183 50.6908C18.4019 51.3083 19.993 51.6262 21.6001 51.6262C23.2071 51.6262 24.7982 51.3083 26.2818 50.6908C27.7655 50.0734 29.1123 49.1685 30.2448 48.0284C31.3773 46.8883 32.2731 45.5354 32.8806 44.0476C33.4717 42.6002 33.7785 41.053 33.7848 39.4905ZM54.9385 42.0493V48.1218H62.9256V42.0493L54.9385 42.0493Z\"/>",
	[M.LIBRARY]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M3.99976 7.60003C3.99976 5.61179 5.61153 4 7.59976 4H32.7998C34.788 4 36.3998 5.61179 36.3998 7.60003V32.8002C36.3998 34.7885 34.788 36.4002 32.7998 36.4002H7.59976C5.61153 36.4002 3.99976 34.7885 3.99976 32.8002V7.60003ZM11.1998 11.2001V29.2002H29.1998V11.2001H11.1998ZM43.5998 7.60003C43.5998 5.61179 45.2115 4 47.1998 4H72.3998C74.388 4 75.9998 5.61179 75.9998 7.60003V32.8002C75.9998 34.7885 74.388 36.4002 72.3998 36.4002H47.1998C45.2115 36.4002 43.5998 34.7885 43.5998 32.8002V7.60003ZM50.7998 11.2001V29.2002H68.7998V11.2001H50.7998ZM3.99976 47.2003C3.99976 45.2121 5.61153 43.6003 7.59976 43.6003H32.7998C34.788 43.6003 36.3998 45.2121 36.3998 47.2003V72.4005C36.3998 74.3887 34.788 76.0005 32.7998 76.0005H7.59976C5.61153 76.0005 3.99976 74.3887 3.99976 72.4005V47.2003ZM11.1998 50.8003V68.8005H29.1998V50.8003H11.1998ZM43.5998 47.2003C43.5998 45.2121 45.2115 43.6003 47.1998 43.6003H72.3998C74.388 43.6003 75.9998 45.2121 75.9998 47.2003V72.4005C75.9998 74.3887 74.388 76.0005 72.3998 76.0005H47.1998C45.2115 76.0005 43.5998 74.3887 43.5998 72.4005V47.2003ZM50.7998 50.8003V68.8005H68.7998V50.8003H50.7998Z\" />",
	[M.LIKE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M45.8038 13.9521C45.6862 14.017 45.4947 14.1868 45.3523 14.4713L36.3913 32.3672L36.3891 32.3717C35.8801 33.3946 35.1806 34.3053 34.3329 35.0574V65.4079C34.3329 66.225 34.9954 66.8875 35.8126 66.8875L60.2269 66.8875C60.8672 66.8875 61.4903 66.6798 62.0025 66.2957C62.5148 65.9115 62.8886 65.3715 63.0679 64.7568L69.9627 41.0835C70.0914 40.6424 70.1159 40.1764 70.0337 39.7244C69.9515 39.2724 69.7652 38.8457 69.4896 38.4782C69.2139 38.1107 68.8565 37.8124 68.4455 37.6069C68.0346 37.4014 67.5815 37.2945 67.1221 37.2945H55.5146C50.7225 37.2945 47.1948 32.8081 48.3251 28.1512L49.9529 21.4448L49.9556 21.4335C50.1833 20.5114 50.1996 19.5498 50.0034 18.6206C49.8072 17.6913 49.4036 16.8184 48.8227 16.067C48.2417 15.3157 47.4985 14.7053 46.6485 14.2815C46.3815 14.1484 46.1062 14.0348 45.8247 13.9412C45.8247 13.9412 45.8116 13.9478 45.8038 13.9521ZM40.06 11.8213C41.2107 9.5234 44.0877 7.15998 47.5934 8.2926C48.1736 8.48004 48.7406 8.71116 49.2893 8.98474C50.9374 9.8064 52.3785 10.9899 53.5049 12.4467C54.6313 13.9036 55.414 15.5962 55.7944 17.398C56.1743 19.1975 56.1432 21.0595 55.7034 22.8452L55.7017 22.8522L54.0767 29.5472C53.8507 30.4786 54.5562 31.3759 55.5146 31.3759H67.1221C68.5004 31.3759 69.8597 31.6968 71.0924 32.3131C72.3252 32.9295 73.3975 33.8244 74.2244 34.927C75.0514 36.0296 75.6103 37.3096 75.8568 38.6656C76.1033 40.0213 76.0309 41.4157 75.6452 42.7385L68.7501 66.4129C68.2122 68.257 67.0904 69.878 65.5537 71.0306C64.0169 72.1831 62.1479 72.8061 60.2269 72.8061L35.8126 72.8061C31.7266 72.8061 28.4143 69.4938 28.4143 65.4079V34.4977C28.4143 34.1723 28.4485 33.8478 28.5164 33.5296C28.7906 32.2442 29.5583 31.314 30.2926 30.7249C30.6264 30.4571 30.8993 30.1192 31.091 29.7334L31.095 29.7254L40.06 11.8213ZM21.7555 31.3758C23.3899 31.3758 24.7148 32.7007 24.7148 34.3351V69.8467C24.7148 71.4811 23.3899 72.806 21.7555 72.806L12.8779 72.8061C10.5234 72.8061 8.26525 71.8708 6.60031 70.2058C4.93538 68.5409 4.00003 66.2828 4.00003 63.9282V40.2538C4.00003 37.8992 4.93538 35.6411 6.60031 33.9761C8.26524 32.3112 10.5234 31.3759 12.8779 31.3759H21.0456C21.1656 31.3759 21.2839 31.383 21.4002 31.3969C21.5167 31.3829 21.6353 31.3758 21.7555 31.3758ZM18.7962 37.2945H12.8779C12.0931 37.2945 11.3404 37.6063 10.7854 38.1612C10.2304 38.7162 9.91864 39.4689 9.91864 40.2538V63.9282C9.91864 64.7131 10.2304 65.4658 10.7854 66.0208C11.3404 66.5757 12.0931 66.8875 12.8779 66.8875L18.7962 66.8875V37.2945Z\" />",
	[M.LIKE_ACTIVE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40.06 11.8213C41.2107 9.5234 44.0877 7.15998 47.5934 8.2926C48.1736 8.48004 48.7406 8.71116 49.2893 8.98474C50.9374 9.8064 52.3785 10.9899 53.5049 12.4467C54.6313 13.9036 55.414 15.5962 55.7944 17.398C56.1743 19.1975 56.1432 21.0595 55.7034 22.8452L55.7017 22.8522L54.0767 29.5472C53.8507 30.4786 54.5562 31.3759 55.5146 31.3759H67.1221C68.5004 31.3759 69.8597 31.6968 71.0924 32.3131C72.3252 32.9295 73.3975 33.8244 74.2244 34.927C75.0514 36.0296 75.6103 37.3096 75.8568 38.6656C76.1033 40.0213 76.0309 41.4157 75.6452 42.7385L68.7501 66.4129C68.2122 68.257 67.0904 69.878 65.5537 71.0306C64.0169 72.1831 62.1479 72.8061 60.2269 72.8061L35.8126 72.8061C31.7266 72.8061 28.4143 69.4938 28.4143 65.4079V34.4977C28.4143 34.1723 28.4485 33.8478 28.5164 33.5296C28.7906 32.2442 29.5583 31.314 30.2926 30.7249C30.6264 30.4571 30.8993 30.1192 31.091 29.7334L31.095 29.7254L40.06 11.8213ZM21.7555 31.3758C23.3899 31.3758 24.7148 32.7007 24.7148 34.3351V69.8467C24.7148 71.4811 23.3899 72.806 21.7555 72.806L12.8779 72.8061C10.5234 72.8061 8.26525 71.8708 6.60031 70.2058C4.93538 68.5409 4.00003 66.2828 4.00003 63.9282V40.2538C4.00003 37.8992 4.93538 35.6411 6.60031 33.9761C8.26524 32.3112 10.5234 31.3759 12.8779 31.3759H21.0456C21.1656 31.3759 21.2839 31.383 21.4002 31.3969C21.5167 31.3829 21.6353 31.3758 21.7555 31.3758Z\" />",
	[M.LINK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M42.5492 9.54069C46.2719 5.94525 51.2578 3.95577 56.4332 4.00075C61.6085 4.04572 66.5591 6.12154 70.2188 9.78113C73.8784 13.4407 75.9543 18.3913 75.9992 23.5665C76.0442 28.7417 74.0547 33.7276 70.4592 37.4502L70.4195 37.4914L60.5504 47.3596C60.5502 47.3597 60.5505 47.3594 60.5504 47.3596C58.5494 49.3611 56.1411 50.9093 53.4894 51.8985C50.8375 52.8877 48.0039 53.295 45.1807 53.0928C42.3576 52.8906 39.6109 52.0837 37.1271 50.7266C34.6432 49.3696 32.4803 47.4943 30.785 45.2279C29.6967 43.773 29.9939 41.7114 31.4488 40.6232C32.9037 39.5349 34.9653 39.8321 36.0536 41.287C37.1838 42.7979 38.6257 44.0482 40.2816 44.9528C41.9375 45.8575 43.7686 46.3955 45.6507 46.5303C47.5328 46.6651 49.4219 46.3935 51.1898 45.734C52.9578 45.0746 54.5632 44.0426 55.8972 42.7081L65.7455 32.86C68.1306 30.3804 69.45 27.0648 69.4201 23.6237C69.3901 20.1735 68.0062 16.8731 65.5664 14.4334C63.1266 11.9937 59.8262 10.6098 56.376 10.5798C52.9332 10.5499 49.6162 11.8704 47.1361 14.2576L41.4957 19.8652C40.2072 21.1461 38.1243 21.14 36.8433 19.8516C35.5624 18.5632 35.5684 16.4803 36.8569 15.1993L42.5492 9.54069ZM26.5106 28.0379C29.1625 27.0487 31.9961 26.6414 34.8193 26.8436C37.6424 27.0458 40.3891 27.8527 42.8729 29.2097C45.3567 30.5668 47.5197 32.4421 49.215 34.7085C50.3033 36.1634 50.0061 38.225 48.5512 39.3132C47.0963 40.4014 45.0347 40.1042 43.9464 38.6494C42.8162 37.1384 41.3743 35.8882 39.7184 34.9835C38.0625 34.0789 36.2314 33.5409 34.3493 33.4061C32.4672 33.2713 30.5781 33.5429 28.8102 34.2023C27.0423 34.8618 25.4368 35.8938 24.1028 37.2283L14.2546 47.0763C11.8694 49.556 10.55 52.8715 10.5799 56.3127C10.6099 59.7629 11.9938 63.0632 14.4336 65.503C16.8734 67.9427 20.1738 69.3266 23.624 69.3566C27.0652 69.3865 30.3808 68.0671 32.8605 65.682L38.4646 60.078C39.7494 58.7933 41.8323 58.7933 43.117 60.078C44.4017 61.3627 44.4017 63.4456 43.117 64.7303L37.4512 70.3961C33.7285 73.9915 28.7422 75.9806 23.5668 75.9356C18.3915 75.8907 13.4409 73.8148 9.78123 70.1553C6.12158 66.4957 4.04572 61.5451 4.00075 56.3699C3.95577 51.1947 5.94529 46.2088 9.54079 42.4862L9.58051 42.445L19.4496 32.5768C19.4498 32.5767 19.4495 32.5769 19.4496 32.5768C21.4505 30.5753 23.8589 29.0271 26.5106 28.0379Z\" />\n    ",
	[M.LINKED]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M31.3103 8.96552C18.9696 8.96552 8.96552 18.9696 8.96552 31.3103C8.96552 40.1363 14.0826 47.7671 21.5119 51.3978C21.4242 50.507 21.3793 49.6036 21.3793 48.6896C21.3793 33.6066 33.6066 21.3793 48.6896 21.3793C49.6036 21.3793 50.507 21.4242 51.3978 21.5119C47.7671 14.0826 40.1363 8.96552 31.3103 8.96552ZM57.2516 22.7483C53.6597 11.8592 43.4028 4 31.3103 4C16.2273 4 4 16.2273 4 31.3103C4 43.4028 11.8592 53.6597 22.7483 57.2516C26.3403 68.1408 36.5972 76 48.6896 76C63.7727 76 76 63.7727 76 48.6896C76 36.5972 68.1408 26.3403 57.2516 22.7483ZM53.1998 26.8002C51.7431 26.5016 50.2347 26.3448 48.6896 26.3448C36.3489 26.3448 26.3448 36.3489 26.3448 48.6896C26.3448 50.2347 26.5016 51.7431 26.8002 53.1998C28.2569 53.4984 29.7653 53.6552 31.3103 53.6552C43.651 53.6552 53.6552 43.651 53.6552 31.3103C53.6552 29.7653 53.4984 28.2569 53.1998 26.8002ZM28.6022 58.4881C29.493 58.5758 30.3964 58.6207 31.3103 58.6207C46.3934 58.6207 58.6207 46.3934 58.6207 31.3103C58.6207 30.3964 58.5758 29.493 58.4881 28.6022C65.9174 32.2329 71.0345 39.8637 71.0345 48.6896C71.0345 61.0304 61.0304 71.0345 48.6896 71.0345C39.8637 71.0345 32.2329 65.9174 28.6022 58.4881Z\" />",
	[M.LIST]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4 7.6C4 5.61177 5.61177 4 7.6 4H32.8C34.7882 4 36.4 5.61177 36.4 7.6V32.8C36.4 34.7882 34.7882 36.4 32.8 36.4H7.6C5.61177 36.4 4 34.7882 4 32.8V7.6ZM11.2 11.2V29.2H29.2V11.2H11.2ZM43.6 11.2C43.6 9.21177 45.2118 7.6 47.2 7.6H72.4C74.3882 7.6 76 9.21177 76 11.2C76 13.1882 74.3882 14.8 72.4 14.8H47.2C45.2118 14.8 43.6 13.1882 43.6 11.2ZM43.6 29.2C43.6 27.2118 45.2118 25.6 47.2 25.6H72.4C74.3882 25.6 76 27.2118 76 29.2C76 31.1882 74.3882 32.8 72.4 32.8H47.2C45.2118 32.8 43.6 31.1882 43.6 29.2ZM4 47.2C4 45.2118 5.61177 43.6 7.6 43.6H32.8C34.7882 43.6 36.4 45.2118 36.4 47.2V72.4C36.4 74.3882 34.7882 76 32.8 76H7.6C5.61177 76 4 74.3882 4 72.4V47.2ZM11.2 50.8V68.8H29.2V50.8H11.2ZM43.6 50.8C43.6 48.8118 45.2118 47.2 47.2 47.2H72.4C74.3882 47.2 76 48.8118 76 50.8C76 52.7882 74.3882 54.4 72.4 54.4H47.2C45.2118 54.4 43.6 52.7882 43.6 50.8ZM43.6 68.8C43.6 66.8118 45.2118 65.2 47.2 65.2H72.4C74.3882 65.2 76 66.8118 76 68.8C76 70.7882 74.3882 72.4 72.4 72.4H47.2C45.2118 72.4 43.6 70.7882 43.6 68.8Z\" />",
	[M.LIST_ITEM]: "\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M13.8602 6.86016C15.6915 5.02883 18.1753 4 20.7652 4H48.6395C49.4899 4 50.3055 4.33783 50.9068 4.93916L68.9432 22.9756C69.5445 23.5769 69.8823 24.3925 69.8823 25.2429V66.2348C69.8823 68.8247 68.8535 71.3085 67.0222 73.1398C65.1909 74.9712 62.7071 76 60.1172 76H20.7652C18.1753 76 15.6915 74.9712 13.8602 73.1398C12.0288 71.3085 11 68.8247 11 66.2348V13.7652C11 11.1753 12.0288 8.69149 13.8602 6.86016ZM20.7652 10.4129C19.8761 10.4129 19.0235 10.7661 18.3948 11.3948C17.7662 12.0234 17.413 12.8761 17.413 13.7652V66.2348C17.413 67.1239 17.7662 67.9766 18.3948 68.6052C19.0235 69.2339 19.8761 69.5871 20.7652 69.5871H60.1172C61.0062 69.5871 61.8589 69.2339 62.4875 68.6052C63.1162 67.9766 63.4694 67.1239 63.4694 66.2348V26.5711L47.3113 10.4129H20.7652Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M46.9995 4C48.7704 4 50.206 5.43558 50.206 7.20647V23.6761H66.6755C68.4464 23.6761 69.882 25.1117 69.882 26.8826C69.882 28.6535 68.4464 30.0891 66.6755 30.0891H46.9995C45.2286 30.0891 43.7931 28.6535 43.7931 26.8826V7.20647C43.7931 5.43558 45.2286 4 46.9995 4Z\" />\n        ",
	[M.LOCK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M24.9043 10.1024C29.0907 6.16303 34.7053 4 40.5 4C46.2947 4 51.9093 6.16303 56.0957 10.1024C60.2929 14.0519 62.7203 19.484 62.7203 25.2273V34.1473C66.2655 35.4437 69 38.7282 69 42.9545V66.5909C69 72.0938 64.3641 76 59.339 76H21.661C16.6359 76 12 72.0938 12 66.5909V42.9545C12 38.7282 14.7345 35.4437 18.2797 34.1473V25.2273C18.2797 19.484 20.7071 14.0519 24.9043 10.1024ZM25.0424 33.5455H55.9576V25.2273C55.9576 21.5674 54.4155 17.9815 51.5466 15.282C48.6671 12.5724 44.6981 11 40.5 11C36.3019 11 32.3329 12.5724 29.4534 15.282C26.5845 17.9815 25.0424 21.5674 25.0424 25.2273V33.5455ZM21.661 40.5455C19.7498 40.5455 18.7627 41.9305 18.7627 42.9545V66.5909C18.7627 67.615 19.7498 69 21.661 69H59.339C61.2502 69 62.2373 67.615 62.2373 66.5909V42.9545C62.2373 41.9305 61.2502 40.5455 59.339 40.5455H21.661Z\"/>\n        ",
	[M.LOCKER]: "<path d=\"M72.8157 4H6.92448C5.31659 4 4.00006 5.31655 4.00006 6.93525V73.0755C4.00006 74.6835 5.31659 76 6.92448 76H72.8157C74.4344 76 75.7509 74.6835 75.7509 73.0755V6.93525C75.7509 5.31655 74.4344 4 72.8157 4ZM38.5104 69.9365H10.2578C10.1499 69.9365 10.0635 69.8501 10.0635 69.7422V61.6918H38.5104V69.9365ZM38.5104 55.6283H10.0635V10.2686C10.0635 10.1607 10.1499 10.0635 10.2578 10.0635H38.5104V55.6283ZM69.6767 69.7422C69.6767 69.8501 69.5903 69.9365 69.4824 69.9365H44.5739V61.6918H69.6767V69.7422ZM69.6767 55.6283H44.5739V10.0635H69.4824C69.5903 10.0635 69.6767 10.1607 69.6767 10.2686V55.6283Z\" />\n        <path d=\"M17.4028 18.6642H28.5609C29.3163 18.6642 29.9314 18.0491 29.9314 17.2937C29.9314 16.5383 29.3163 15.9232 28.5609 15.9232H17.4028C16.6474 15.9232 16.0323 16.5383 16.0323 17.2937C16.0323 18.0491 16.6474 18.6642 17.4028 18.6642Z\"/>\n        <path d=\"M17.4028 25.9269H28.5609C29.3163 25.9269 29.9314 25.3118 29.9314 24.5564C29.9314 23.801 29.3163 23.1967 28.5609 23.1967H17.4028C16.6474 23.1967 16.0323 23.801 16.0323 24.5564C16.0323 25.3118 16.6474 25.9269 17.4028 25.9269Z\" />\n        <path d=\"M17.4028 33.2003H28.5609C29.3163 33.2003 29.9314 32.5852 29.9314 31.8298C29.9314 31.0744 29.3163 30.4593 28.5609 30.4593H17.4028C16.6474 30.4593 16.0323 31.0744 16.0323 31.8298C16.0323 32.5852 16.6474 33.2003 17.4028 33.2003Z\" />\n        <path d=\"M16.3224 47.295C17.0778 47.295 17.6929 46.6799 17.6929 45.9245V38.9641C17.6929 38.2087 17.0778 37.5936 16.3224 37.5936C15.567 37.5936 14.9627 38.2087 14.9627 38.9641V45.9245C14.9627 46.6799 15.567 47.295 16.3224 47.295Z\" />\n        <path d=\"M50.6062 37.7769C49.8508 37.7769 49.2357 38.3812 49.2357 39.1366V46.097C49.2357 46.8524 49.8508 47.4675 50.6062 47.4675C51.3616 47.4675 51.9659 46.8524 51.9659 46.097V39.1366C51.9659 38.3812 51.3616 37.7769 50.6062 37.7769Z\" />\n        <path d=\"M62.8447 15.9232H51.6865C50.9311 15.9232 50.316 16.5383 50.316 17.2937C50.316 18.0491 50.9311 18.6642 51.6865 18.6642H62.8447C63.6 18.6642 64.2151 18.0491 64.2151 17.2937C64.2151 16.5383 63.6 15.9232 62.8447 15.9232Z\" />\n        <path d=\"M62.8447 23.1967H51.6865C50.9311 23.1967 50.316 23.801 50.316 24.5564C50.316 25.3118 50.9311 25.9269 51.6865 25.9269H62.8447C63.6 25.9269 64.2151 25.3118 64.2151 24.5564C64.2151 23.801 63.6 23.1967 62.8447 23.1967Z\" />\n        <path d=\"M62.8447 30.4593H51.6865C50.9311 30.4593 50.316 31.0744 50.316 31.8298C50.316 32.5852 50.9311 33.2003 51.6865 33.2003H62.8447C63.6 33.2003 64.2151 32.5852 64.2151 31.8298C64.2151 31.0744 63.6 30.4593 62.8447 30.4593Z\" />\n        ",
	[M.LOGOUT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M14.7999 11.2C13.8451 11.2 12.9295 11.5793 12.2544 12.2544C11.5792 12.9295 11.1999 13.8452 11.1999 14.8V65.2C11.1999 66.1548 11.5792 67.0705 12.2544 67.7456C12.9295 68.4207 13.8452 68.8 14.7999 68.8H29.1998C31.188 68.8 32.7998 70.4118 32.7998 72.4C32.7998 74.3882 31.188 76 29.1998 76H14.7999C11.9356 76 9.1886 74.8621 7.16322 72.8367C5.13785 70.8114 4 68.0643 4 65.2V14.8C4 11.9357 5.13784 9.18864 7.16322 7.16325C9.1886 5.13785 11.9356 4 14.7999 4H29.1998C31.188 4 32.7998 5.61177 32.7998 7.6C32.7998 9.58823 31.188 11.2 29.1998 11.2H14.7999ZM51.8541 19.4544C53.2599 18.0485 55.5393 18.0485 56.9452 19.4544L74.9451 37.4544C75.6202 38.1295 75.9995 39.0452 75.9995 40C75.9995 40.9548 75.6202 41.8705 74.9451 42.5456L56.9452 60.5456C55.5393 61.9515 53.2599 61.9515 51.8541 60.5456C50.4482 59.1397 50.4482 56.8603 51.8541 55.4544L63.7084 43.6H29.1998C27.2116 43.6 25.5998 41.9882 25.5998 40C25.5998 38.0118 27.2116 36.4 29.1998 36.4H63.7084L51.8541 24.5456C50.4482 23.1397 50.4482 20.8603 51.8541 19.4544Z\" />",
	[M.MAIL]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M13.8184 17.5454C12.0259 17.5454 10.5457 19.0256 10.5457 20.8181V60.0905C10.5457 61.883 12.0259 63.3632 13.8184 63.3632H66.1816C67.9741 63.3632 69.4543 61.883 69.4543 60.0905V20.8181C69.4543 19.0256 67.9741 17.5454 66.1816 17.5454H13.8184ZM4.00027 20.8181C4.00027 15.4107 8.41094 11 13.8184 11H66.1816C71.589 11 75.9997 15.4107 75.9997 20.8181V60.0905C75.9997 65.498 71.589 69.9086 66.1816 69.9086H13.8184C8.41093 69.9086 4.00027 65.498 4.00027 60.0905V20.8181Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4.59187 18.9413C5.62838 17.4606 7.66901 17.1005 9.14974 18.137L40 39.7322L70.8502 18.137C72.331 17.1005 74.3716 17.4606 75.4081 18.9413C76.4446 20.4221 76.0845 22.4627 74.6038 23.4992L41.8768 46.4081C40.7499 47.1969 39.2501 47.1969 38.1232 46.4081L5.3962 23.4992C3.91546 22.4627 3.55535 20.4221 4.59187 18.9413Z\" />\n        ",
	[M.MAP_PIN]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40 9.99999C26.7451 9.99999 15.9999 20.7451 15.9999 34C15.9999 43.2941 22.0472 52.3127 28.6779 59.3117C31.9318 62.7465 35.196 65.5584 37.6501 67.5125C38.5633 68.2398 39.3611 68.8455 40 69.3177C40.6389 68.8455 41.4367 68.2398 42.35 67.5125C44.804 65.5584 48.0682 62.7465 51.3222 59.3117C57.9529 52.3127 64.0001 43.2941 64.0001 34C64.0001 20.7451 53.2549 9.99999 40 9.99999ZM40 73C38.3359 75.4961 38.3351 75.4956 38.3343 75.495L38.3321 75.4935L38.3257 75.4893L38.3057 75.4759L38.237 75.4294C38.1786 75.3897 38.0952 75.3327 37.9886 75.259C37.7756 75.1114 37.4694 74.8964 37.0834 74.6175C36.3116 74.0602 35.2191 73.2466 33.9125 72.2062C31.304 70.129 27.8181 67.1285 24.3221 63.4382C17.4527 56.1872 9.99992 45.7058 9.99992 34C9.99992 17.4315 23.4314 4 40 4C56.5686 4 70.0001 17.4315 70.0001 34C70.0001 45.7058 62.5473 56.1872 55.6779 63.4382C52.1819 67.1285 48.696 70.129 46.0876 72.2062C44.7809 73.2466 43.6884 74.0602 42.9167 74.6175C42.5307 74.8964 42.2244 75.1114 42.0113 75.259C41.9048 75.3327 41.8215 75.3897 41.7631 75.4294L41.6943 75.4759L41.6743 75.4893L41.668 75.4935L41.6657 75.495C41.6649 75.4956 41.6641 75.4961 40 73ZM40 73L41.6641 75.4961C40.6564 76.168 39.3436 76.168 38.3359 75.4961L40 73ZM28 33.9999C28 27.3725 33.3726 21.9999 40.0001 21.9999C46.6275 21.9999 52.0001 27.3725 52.0001 33.9999C52.0001 40.6273 46.6275 45.9999 40.0001 45.9999C33.3726 45.9999 28 40.6273 28 33.9999ZM40.0001 27.9999C36.6863 27.9999 34.0001 30.6861 34.0001 33.9999C34.0001 37.3136 36.6863 39.9999 40.0001 39.9999C43.3137 39.9999 46.0001 37.3136 46.0001 33.9999C46.0001 30.6861 43.3137 27.9999 40.0001 27.9999Z\" />\n        ",
	[M.MAXIMISE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M47.2 7.6C47.2 5.61177 48.8117 4 50.8 4H72.3998C74.3881 4 75.9998 5.61177 75.9998 7.6V29.2C75.9998 31.1882 74.3881 32.8 72.3998 32.8C70.4116 32.8 68.7999 31.1882 68.7999 29.2V11.2H50.8C48.8117 11.2 47.2 9.58822 47.2 7.6Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M7.60015 47.2C9.58837 47.2 11.2001 48.8118 11.2001 50.8V68.8H29.2C31.1883 68.8 32.8 70.4118 32.8 72.4C32.8 74.3882 31.1883 76 29.2 76H7.60015C5.61194 76 4.00017 74.3882 4.00017 72.4V50.8C4.00017 48.8118 5.61194 47.2 7.60015 47.2Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M74.9454 5.05442C76.3513 6.4603 76.3513 8.7397 74.9454 10.1456L49.7455 35.3456C48.3397 36.7515 46.0603 36.7515 44.6544 35.3456C43.2485 33.9397 43.2485 31.6603 44.6544 30.2544L69.8543 5.05442C71.2602 3.64853 73.5395 3.64853 74.9454 5.05442Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M35.3456 44.6544C36.7515 46.0603 36.7515 48.3397 35.3456 49.7456L10.1457 74.9456C8.73984 76.3515 6.46046 76.3515 5.05458 74.9456C3.6487 73.5397 3.6487 71.2603 5.05458 69.8544L30.2545 44.6544C31.6603 43.2485 33.9397 43.2485 35.3456 44.6544Z\" />\n        ",
	[M.MENTIONS]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M24.6185 7.45149C31.9646 3.97992 40.269 3.0955 48.1815 4.94204C56.094 6.78858 63.1491 11.2575 68.1998 17.6221C73.2504 23.9867 75.9995 31.8727 76 39.9977V43.2707C76 46.7426 74.6208 50.0723 72.1658 52.5273C69.7107 54.9824 66.381 56.3616 62.9091 56.3616C59.4372 56.3616 56.1075 54.9824 53.6524 52.5273C53.1328 52.0077 52.6613 51.4488 52.2409 50.8577C49.2433 54.2341 44.8701 56.3616 40 56.3616C30.9626 56.3616 23.6364 49.0353 23.6364 39.998C23.6364 30.9606 30.9626 23.6343 40 23.6343C43.6838 23.6343 47.0833 24.8516 49.8182 26.9059C49.8188 25.0989 51.2838 23.6343 53.0909 23.6343C54.8984 23.6343 56.3636 25.0996 56.3636 26.9071V43.2707C56.3636 45.0066 57.0533 46.6715 58.2808 47.899C59.5083 49.1265 61.1731 49.8161 62.9091 49.8161C64.6451 49.8161 66.3099 49.1265 67.5374 47.899C68.7649 46.6715 69.4546 45.0066 69.4546 43.2707V39.9982C69.4546 39.9981 69.4546 39.9982 69.4546 39.9982C69.4541 33.3504 67.2048 26.8981 63.0726 21.6908C58.9402 16.4834 53.1678 12.827 46.694 11.3162C40.2201 9.80541 33.4256 10.529 27.4151 13.3694C21.4047 16.2098 16.5318 20.9999 13.5889 26.9608C10.646 32.9217 9.80608 39.7028 11.2058 46.2016C12.6054 52.7004 16.1624 58.5346 21.2982 62.7555C26.4341 66.9765 32.8468 69.3359 39.4936 69.4502C46.1404 69.5645 52.6304 67.4269 57.9084 63.3851C59.3434 62.2861 61.3976 62.5586 62.4965 63.9936C63.5955 65.4286 63.323 67.4828 61.888 68.5817C55.4372 73.5218 47.505 76.1344 39.3811 75.9947C31.2572 75.855 23.4194 72.9712 17.1423 67.8123C10.8651 62.6534 6.51776 55.5227 4.80704 47.5798C3.09631 39.6368 4.12286 31.3487 7.71976 24.0632C11.3167 16.7776 17.2724 10.9231 24.6185 7.45149ZM49.8182 39.998C49.8182 34.5755 45.4224 30.1798 40 30.1798C34.5776 30.1798 30.1818 34.5755 30.1818 39.998C30.1818 45.4204 34.5776 49.8161 40 49.8161C45.4224 49.8161 49.8182 45.4204 49.8182 39.998Z\" />\n        ",
	[M.MENU]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4 16C4 13.7909 5.79086 12 8 12H72C74.2091 12 76 13.7909 76 16C76 18.2091 74.2091 20 72 20H8C5.79086 20 4 18.2091 4 16ZM4 40C4 37.7908 5.79086 36 8 36H72C74.2091 36 76 37.7908 76 40C76 42.2091 74.2091 44 72 44H8C5.79086 44 4 42.2091 4 40ZM4 64C4 61.7908 5.79086 60 8 60H72C74.2091 60 76 61.7908 76 64C76 66.2091 74.2091 67.9999 72 67.9999H8C5.79086 67.9999 4 66.2091 4 64Z\" />\n        ",
	[M.MENU_MORE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M32.0002 12C32.0002 7.58172 35.5819 4 40.0002 4C44.4186 4 48.0003 7.58172 48.0003 12C48.0003 16.4183 44.4186 20 40.0002 20C35.5819 20 32.0002 16.4183 32.0002 12ZM32.0002 40C32.0002 35.5817 35.5819 32 40.0002 32C44.4186 32 48.0003 35.5817 48.0003 40C48.0003 44.4183 44.4186 48 40.0002 48C35.5819 48 32.0002 44.4183 32.0002 40ZM32.0002 68C32.0002 63.5817 35.5819 60 40.0002 60C44.4186 60 48.0003 63.5817 48.0003 68C48.0003 72.4183 44.4186 76 40.0002 76C35.5819 76 32.0002 72.4183 32.0002 68Z\"/>\n        ",
	[M.MIDDOT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M22 40C22 30.0589 30.0589 22 40 22C49.9411 22 58 30.0589 58 40C58 49.9411 49.9411 58 40 58C30.0589 58 22 49.9411 22 40Z\" />",
	[M.MINIMISE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M69.8541 5.05442C71.2599 3.64853 73.5393 3.64853 74.9452 5.05442C76.3511 6.4603 76.3511 8.7397 74.9452 10.1456L55.8909 29.2H68.7997C70.7879 29.2 72.3996 30.8118 72.3996 32.8C72.3996 34.7882 70.7879 36.4 68.7997 36.4H47.1997C45.2115 36.4 43.5997 34.7882 43.5997 32.8V11.2C43.5997 9.21177 45.2115 7.6 47.1997 7.6C49.188 7.6 50.7997 9.21177 50.7997 11.2V24.1088L69.8541 5.05442ZM7.59988 47.2C7.59988 45.2118 9.21165 43.6 11.1999 43.6H32.7998C34.788 43.6 36.3998 45.2118 36.3998 47.2V68.8C36.3998 70.7882 34.788 72.4 32.7998 72.4C30.8116 72.4 29.1998 70.7882 29.1998 68.8V55.8912L10.1455 74.9456C8.73957 76.3515 6.46019 76.3515 5.0543 74.9456C3.64842 73.5397 3.64842 71.2603 5.0543 69.8544L24.1087 50.8H11.1999C9.21165 50.8 7.59988 49.1882 7.59988 47.2Z\"/>\n        ",
	[M.ORDER_BOTTOM]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M39.8 4C41.7882 4 43.4 5.61179 43.4 7.6V49.3088L58.8544 33.8544C60.2603 32.4485 62.5397 32.4485 63.9456 33.8544C65.3515 35.2603 65.3515 37.5397 63.9456 38.9456L42.3456 60.5456C40.9397 61.9515 38.6603 61.9515 37.2544 60.5456L15.6544 38.9456C14.2485 37.5397 14.2485 35.2603 15.6544 33.8544C17.0603 32.4485 19.3397 32.4485 20.7456 33.8544L36.2 49.3088V7.6C36.2 5.61179 37.8118 4 39.8 4ZM11 72.4C11 70.4121 12.6118 68.8 14.6 68.8H65C66.9882 68.8 68.6 70.4121 68.6 72.4C68.6 74.3879 66.9882 76 65 76H14.6C12.6118 76 11 74.3879 11 72.4Z\" />",
	[M.OLD_PHONE]: "<path d=\"M26.9091 13.8182C26.9091 12.9502 26.564 12.118 25.9503 11.5043C25.3365 10.8905 24.5043 10.5455 23.6364 10.5455H13.8182C12.9502 10.5455 12.118 10.8905 11.5043 11.5043C10.8905 12.118 10.5455 12.9502 10.5455 13.8182C10.5455 28.5739 16.4071 42.7252 26.8409 53.1591C37.2748 63.5929 51.4261 69.4545 66.1818 69.4545C67.0498 69.4545 67.882 69.1095 68.4957 68.4957C69.1095 67.882 69.4545 67.0498 69.4545 66.1818V56.3636C69.4545 55.4957 69.1095 54.6635 68.4957 54.0497C67.882 53.436 67.0498 53.0909 66.1818 53.0909H56.3636C55.8556 53.0909 55.3543 53.2089 54.8999 53.4361C54.4454 53.6633 54.0499 53.9938 53.745 54.4002C53.7395 54.4075 53.7346 54.4153 53.729 54.4226L52.5668 55.9439C51.6658 57.1257 50.3896 57.9658 48.9478 58.326C47.5047 58.6865 45.9817 58.5451 44.63 57.9244C44.6045 57.9126 44.5785 57.9005 44.5533 57.8881C34.8138 53.1081 26.9328 45.2356 22.1406 35.5021L22.1342 35.4904C21.4719 34.1315 21.3001 32.585 21.6484 31.114C21.9968 29.643 22.844 28.3379 24.0455 27.4205L24.0689 27.4034L25.5998 26.255C26.0062 25.9501 26.3367 25.5546 26.5639 25.1001C26.7911 24.6457 26.9091 24.1444 26.9091 23.6364V13.8182ZM33.4545 23.6364C33.4545 25.1606 33.0996 26.6644 32.418 28.0277C31.7364 29.3908 30.7469 30.5767 29.5277 31.4911L28.0181 32.6214C32.1593 41.0269 38.9593 47.8288 47.3615 51.9734L47.3636 51.9723L48.5259 50.4499C49.438 49.2411 50.6176 48.2595 51.9723 47.582C53.3356 46.9004 54.8394 46.5455 56.3636 46.5455H66.1818C68.7858 46.5455 71.2834 47.5795 73.1246 49.4208C74.9659 51.2621 76 53.7597 76 56.3636V66.1818C76 68.7858 74.9659 71.2834 73.1246 73.1246C71.2834 74.9659 68.7858 76 66.1818 76C49.6902 76 33.8744 69.4483 22.2131 57.7869C10.5517 46.1256 4 30.3098 4 13.8182C4 11.2142 5.03409 8.71662 6.87536 6.87536C8.71662 5.03409 11.2142 4 13.8182 4H23.6364C26.2403 4 28.7379 5.03409 30.5792 6.87536C32.4205 8.71662 33.4545 11.2142 33.4545 13.8182V23.6364Z\"/>",
	[M.ORDER_DOWN]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40.0001 4C42.4853 4 44.5001 6.01474 44.5001 8.50001V60.6361L68.3182 36.8181C70.0755 35.0607 72.9247 35.0607 74.6821 36.8181C76.4393 38.5754 76.4393 41.4247 74.6821 43.182L43.182 74.682C41.4247 76.4393 38.5755 76.4393 36.8181 74.682L5.31807 43.182C3.56064 41.4247 3.56064 38.5754 5.31807 36.8181C7.07542 35.0607 9.92464 35.0607 11.682 36.8181L35.5001 60.6361V8.50001C35.5001 6.01474 37.5148 4 40.0001 4Z\" />\n    ",
	[M.ORDER_TOP]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M11 7.6C11 5.61179 12.6118 4 14.6 4H65C66.9882 4 68.6 5.61179 68.6 7.6C68.6 9.58821 66.9882 11.2 65 11.2H14.6C12.6118 11.2 11 9.58821 11 7.6ZM37.2544 19.4544C38.6603 18.0485 40.9397 18.0485 42.3456 19.4544L63.9456 41.0544C65.3515 42.4603 65.3515 44.7397 63.9456 46.1456C62.5397 47.5515 60.2603 47.5515 58.8544 46.1456L43.4 30.6912V72.4C43.4 74.3879 41.7882 76 39.8 76C37.8118 76 36.2 74.3879 36.2 72.4V30.6912L20.7456 46.1456C19.3397 47.5515 17.0603 47.5515 15.6544 46.1456C14.2485 44.7397 14.2485 42.4603 15.6544 41.0544L37.2544 19.4544Z\" />\n        ",
	[M.ORDER_UP]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M36.8181 5.31807C38.5754 3.56064 41.4246 3.56064 43.182 5.31807L74.6819 36.8181C76.4392 38.5754 76.4392 41.4246 74.6819 43.182C72.9246 44.9394 70.0754 44.9394 68.3181 43.182L44.5 19.364V71.5C44.5 73.9853 42.4853 76 40 76C37.5148 76 35.5 73.9853 35.5 71.5V19.364L11.682 43.182C9.92463 44.9394 7.07541 44.9394 5.31807 43.182C3.56064 41.4246 3.56064 38.5754 5.31807 36.8181L36.8181 5.31807Z\" />",
	[M.POLL]: "  <path d=\"M9 38H21A4 4 0 0 1 25 42V68A4 4 0 0 1 21 72H9A4 4 0 0 1 5 68V42A4 4 0 0 1 9 38ZM12 44A1 1 0 0 0 11 45V65A1 1 0 0 0 12 66H18A1 1 0 0 0 19 65V45A1 1 0 0 0 18 44Z\"/>\n  <path d=\"M34 8H46A4 4 0 0 1 50 12V68A4 4 0 0 1 46 72H34A4 4 0 0 1 30 68V12A4 4 0 0 1 34 8ZM37 14A1 1 0 0 0 36 15V65A1 1 0 0 0 37 66H43A1 1 0 0 0 44 65V15A1 1 0 0 0 43 14Z\"/>\n  <path d=\"M59 24H71A4 4 0 0 1 75 28V68A4 4 0 0 1 71 72H59A4 4 0 0 1 55 68V28A4 4 0 0 1 59 24ZM62 30A1 1 0 0 0 61 31V65A1 1 0 0 0 62 66H68A1 1 0 0 0 69 65V31A1 1 0 0 0 68 30Z\"/>\n",
	[M.PASSKEY]: "<path d=\"M6 72.4V65.2C6 60.4261 7.89778 55.8491 11.2734 52.4734C14.6491 49.0978 19.2261 47.2 24 47.2H35.8793L36.2484 47.2176C38.0636 47.4021 39.4793 48.9361 39.4793 50.8C39.4793 52.6639 38.0636 54.1979 36.2484 54.3824L35.8793 54.4H24C21.1357 54.4 18.3895 55.5387 16.3641 57.5641C14.3387 59.5895 13.2 62.3357 13.2 65.2V72.4C13.2 74.3882 11.5882 76 9.6 76C7.61177 76 6 74.3882 6 72.4ZM52.8 65.2C52.8 63.2118 51.1882 61.6 49.2 61.6C47.2118 61.6 45.6 63.2118 45.6 65.2C45.6 67.1882 47.2118 68.8 49.2 68.8C51.1882 68.8 52.8 67.1882 52.8 65.2ZM45.6 22C45.6 16.0353 40.7647 11.2 34.8 11.2C28.8353 11.2 24 16.0353 24 22C24 27.9647 28.8353 32.8 34.8 32.8C40.7647 32.8 45.6 27.9647 45.6 22ZM60 65.2C60 71.1647 55.1647 76 49.2 76C43.2353 76 38.4 71.1647 38.4 65.2C38.4 59.2353 43.2353 54.4 49.2 54.4C50.8648 54.4 52.4359 54.7889 53.8441 55.4617L68.2547 41.0547C69.6606 39.6488 71.9394 39.6488 73.3453 41.0547C74.7512 42.4606 74.7512 44.7394 73.3453 46.1453L70.4906 49L73.3453 51.8547L73.5914 52.1289C74.7447 53.5429 74.6633 55.6273 73.3453 56.9453C72.0273 58.2633 69.9429 58.3447 68.5289 57.1914L68.2547 56.9453L65.4 54.0906L58.9348 60.5523C59.6088 61.9617 60 63.5335 60 65.2ZM52.8 22C52.8 31.9411 44.7411 40 34.8 40C24.8589 40 16.8 31.9411 16.8 22C16.8 12.0589 24.8589 4 34.8 4C44.7411 4 52.8 12.0589 52.8 22Z\"/>",
	[M.PARAGRAPH]: "<path d=\"M57.9958 61.4018C59.9829 61.4018 61.5968 63.0092 61.5983 64.9959C61.5983 66.984 59.9839 68.5985 57.9958 68.5985H7.60253C5.61446 68.5985 4 66.984 4 64.9959C4.00152 63.0092 5.6154 61.4018 7.60253 61.4018H57.9958ZM50.7992 36.201C52.7872 36.201 54.4017 37.8155 54.4017 39.8035C54.4002 41.7903 52.7863 43.3976 50.7992 43.3976H7.60253C5.6154 43.3976 4.00152 41.7903 4 39.8035C4 37.8155 5.61446 36.201 7.60253 36.201H50.7992ZM72.3975 11.0002C74.3855 11.0002 76 12.6146 76 14.6027C76 16.5908 74.3855 18.2052 72.3975 18.2052H7.60253C5.61446 18.2052 4 16.5908 4 14.6027C4 12.6146 5.61446 11.0002 7.60253 11.0002H72.3975Z\" />",
	[M.PAUSE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M12 16C12 9.37258 17.3726 4 24 4C30.6274 4 36 9.37258 36 16V64C36 70.6274 30.6274 76 24 76C17.3726 76 12 70.6274 12 64V16Z\"/>\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M44 16C44 9.37258 49.3726 4 56 4C62.6274 4 68 9.37258 68 16V64C68 70.6274 62.6274 76 56 76C49.3726 76 44 70.6274 44 64V16Z\" />",
	[M.PENCIL]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M57.3225 4.95856C58.6006 3.68048 60.6727 3.68048 61.9508 4.95856L75.0417 18.0495C76.3198 19.3275 76.3198 21.3997 75.0417 22.6778C73.7636 23.9559 71.6915 23.9559 70.4134 22.6778L57.3225 9.58689C56.0444 8.30881 56.0444 6.23664 57.3225 4.95856Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M47.5043 14.7767C48.7824 13.4987 50.8545 13.4987 52.1326 14.7767L65.2235 27.8676C66.5016 29.1457 66.5016 31.2179 65.2235 32.496L27.5872 70.1323C27.1845 70.535 26.6836 70.8257 26.1341 70.9755L8.13413 75.8846C7.00107 76.1936 5.7893 75.8718 4.95885 75.0414C4.12839 74.2109 3.80659 72.9992 4.11561 71.8661L9.0247 53.8661C9.17455 53.3166 9.46521 52.8158 9.86794 52.4131L47.5043 14.7767Z\" />\n        ",
	[M.PERSON]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M39.8 11.2C33.8353 11.2 29 16.0353 29 22C29 27.9647 33.8353 32.8 39.8 32.8C45.7647 32.8 50.6001 27.9647 50.6001 22C50.6001 16.0353 45.7647 11.2 39.8 11.2ZM21.8 22C21.8 12.0589 29.8589 4 39.8 4C49.7412 4 57.8001 12.0589 57.8001 22C57.8001 31.9411 49.7412 40 39.8 40C29.8589 40 21.8 31.9411 21.8 22ZM16.272 52.4721C19.6477 49.0964 24.2261 47.2 29 47.2H50.6001C55.374 47.2 59.9524 49.0964 63.3281 52.4721C66.7037 55.8477 68.6001 60.4261 68.6001 65.2V72.4C68.6001 74.3882 66.9884 76 65.0001 76C63.0119 76 61.4001 74.3882 61.4001 72.4V65.2C61.4001 62.3357 60.2623 59.5886 58.2369 57.5633C56.2115 55.5379 53.4644 54.4 50.6001 54.4H29C26.1357 54.4 23.3886 55.5379 21.3632 57.5633C19.3378 59.5886 18.2 62.3357 18.2 65.2V72.4C18.2 74.3882 16.5882 76 14.6 76C12.6117 76 10.9999 74.3882 10.9999 72.4V65.2C10.9999 60.4261 12.8964 55.8477 16.272 52.4721Z\" />\n        ",
	[M.PHONE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M23.8182 10.5455C22.0107 10.5455 20.5455 12.0107 20.5455 13.8182V66.1818C20.5455 67.9893 22.0107 69.4545 23.8182 69.4545H56.5456C58.3531 69.4545 59.8183 67.9893 59.8183 66.1818V13.8182C59.8183 12.0107 58.3531 10.5455 56.5456 10.5455H23.8182ZM14 13.8182C14 8.39575 18.3957 4 23.8182 4H56.5456C61.968 4 66.3638 8.39575 66.3638 13.8182V66.1818C66.3638 71.6042 61.968 76 56.5456 76H23.8182C18.3957 76 14 71.6042 14 66.1818V13.8182ZM36.9091 59.6364C36.9091 57.8289 38.3744 56.3636 40.1819 56.3636H40.2146C42.0221 56.3636 43.4874 57.8289 43.4874 59.6364C43.4874 61.4438 42.0221 62.9091 40.2146 62.9091H40.1819C38.3744 62.9091 36.9091 61.4438 36.9091 59.6364Z\" />\n        ",
	[M.PLAY]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M10 11.8632C10 5.65225 16.871 1.90105 22.0955 5.25964L65.8643 33.3965C70.6713 36.4866 70.6713 43.5133 65.8643 46.6035L22.0955 74.7404C16.871 78.099 10 74.3477 10 68.1368V11.8632Z\" />",
	[M.RECOVERY]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M53.8001 15.5037C48.6443 12.3506 42.63 11.0907 36.7177 11.9106C30.8043 12.7307 25.3071 15.5882 21.1168 20.0522C16.9245 24.5182 14.2864 30.3323 13.6496 36.5671C13.4625 38.3985 11.8262 39.7315 9.99478 39.5444C8.16336 39.3574 6.83035 37.7211 7.01742 35.8896C7.80011 28.2269 11.0453 21.0406 16.2561 15.4895C21.4689 9.93629 28.3493 6.34065 35.8019 5.30713C43.2555 4.27346 50.8205 5.86693 57.2783 9.81634C63.7336 13.7642 68.6983 19.8295 71.4012 27.0191C74.1036 34.2073 74.3967 42.122 72.2361 49.5005C70.0752 56.88 65.5778 63.3174 59.4394 67.7637C53.2985 72.2117 45.8772 74.403 38.3679 73.9656C30.8591 73.5283 23.7276 70.4898 18.1136 65.3633L18.0878 65.3395L13.6668 61.216V68.3334C13.6668 70.1743 12.1744 71.6667 10.3335 71.6667C8.49255 71.6667 7.00017 70.1743 7.00017 68.3334V53.5488C7.00017 51.7079 8.49255 50.2155 10.3335 50.2155H24.3892C26.2302 50.2155 27.7225 51.7079 27.7225 53.5488C27.7225 55.3898 26.2302 56.8821 24.3892 56.8821H18.7944L22.6218 60.452C27.1235 64.5575 32.8062 66.9637 38.7556 67.3102C44.7102 67.6571 50.6166 65.9225 55.5287 62.3646C60.4432 58.8048 64.0831 53.6203 65.8381 47.6269C67.5935 41.6325 67.3541 35.1986 65.161 29.3651C62.9684 23.533 58.9585 18.6584 53.8001 15.5037Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M34.7542 29.2884C36.2966 27.8111 38.3651 27 40.5 27C42.6349 27 44.7034 27.8111 46.2458 29.2884C47.7921 30.7695 48.6864 32.8065 48.6864 34.9602V38.3052C49.9926 38.7914 51 40.0231 51 41.608V50.4716C51 52.5352 49.292 54 47.4407 54H33.5593C31.708 54 30 52.5352 30 50.4716V41.608C30 40.0231 31.0074 38.7914 32.3136 38.3052V34.9602C32.3136 32.8065 33.2079 30.7695 34.7542 29.2884ZM34.8051 38.0795H46.1949V34.9602C46.1949 33.5878 45.6268 32.2431 44.5698 31.2307C43.5089 30.2146 42.0467 29.625 40.5 29.625C38.9533 29.625 37.4911 30.2146 36.4302 31.2307C35.3732 32.2431 34.8051 33.5878 34.8051 34.9602V38.0795ZM33.5593 40.7045C32.8552 40.7045 32.4915 41.2239 32.4915 41.608V50.4716C32.4915 50.8556 32.8552 51.375 33.5593 51.375H47.4407C48.1448 51.375 48.5085 50.8556 48.5085 50.4716V41.608C48.5085 41.2239 48.1448 40.7045 47.4407 40.7045H33.5593Z\" />\n        ",
	[M.REPEAT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M52.8912 4.879C54.0626 3.70725 55.9621 3.70696 57.1339 4.87835L69.1376 16.8783C69.7003 17.441 70.0166 18.2041 70.0166 19C70.0166 19.7958 69.7003 20.559 69.1376 21.1216L57.1339 33.1216C55.9621 34.293 54.0626 34.2927 52.8912 33.121C51.7198 31.9492 51.7201 30.0497 52.8919 28.8783L59.7723 22L25.0037 22.0001C20.0303 22.0001 16 26.0304 16 31.0001V37C16 38.6569 14.6569 40 13 40C11.3432 40 10 38.6569 10 37V31.0001C10 22.715 16.7183 16.0001 25.0037 16.0001L59.7723 16L52.8919 9.12164C51.7201 7.95025 51.7198 6.05075 52.8912 4.879ZM67.0166 40C68.6735 40 70.0166 41.3432 70.0166 43V49C70.0166 57.2851 63.2984 64 55.0129 64H20.2443L27.1247 70.8784C28.2964 72.0497 28.2968 73.9492 27.1254 75.121C25.9539 76.2927 24.0544 76.2931 22.8827 75.1216L10.879 63.1217C10.3162 62.5591 10 61.7958 10 61.0001C10 60.2042 10.3162 59.441 10.879 58.8784L22.8827 46.8784C24.0544 45.707 25.9539 45.7074 27.1254 46.8791C28.2968 48.0508 28.2964 49.9503 27.1247 51.1217L20.2443 58H55.0129C59.9864 58 64.0166 53.9697 64.0166 49V43C64.0166 41.3432 65.3597 40 67.0166 40Z\" />",
	[M.RIBBON]: "<path d=\"M51.8478 28.8212C51.8478 35.3807 46.5202 40.7083 39.9299 40.7083C33.3397 40.7083 28.0428 35.3807 28.0428 28.8212C28.0428 22.2618 33.3704 16.9341 39.9299 16.9341C46.5202 16.9341 51.8478 22.2618 51.8478 28.8212ZM54.1267 43.8802L61.8872 42.4021L60.0087 35.4423L65.8906 30.7921L60.6862 25.2181L63.5194 17.6424L55.6049 15.4867L54.1267 7.4799L46.2122 10.4979L40.4534 4L35.095 10.0359L26.9958 6.83319L25.2404 14.8092L17.2027 16.9649L19.7588 23.8323L14 29.4063L19.7588 34.3644L17.7571 41.509L25.2404 43.2951L25.9487 46.1899L16.9564 71.5039L26.8418 68.9478L34.3251 76L39.9299 55.7057L46.089 76L52.7717 69.5637L63.7349 70.0257L53.5724 46.0975L54.1267 43.8494V43.8802ZM25.1172 28.8212C25.1172 20.6296 31.7691 13.9778 39.9607 13.9778C48.1523 13.9778 54.8042 20.6296 54.8042 28.8212C54.8042 37.0128 48.1523 43.6647 39.9607 43.6647C31.7999 43.6647 25.148 37.0128 25.148 28.8212H25.1172Z\" />\n        ",
	[M.RSS]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4 8C4 5.79086 5.79086 4 8 4C26.0347 4 43.3308 11.1643 56.0833 23.9167C68.8357 36.6692 76 53.9653 76 72C76 74.2091 74.2091 76 72 76C69.7909 76 68 74.2091 68 72C68 56.087 61.6786 40.8258 50.4264 29.5736C39.1742 18.3214 23.913 12 8 12C5.79086 12 4 10.2091 4 8ZM4 36C4 33.7909 5.79086 32 8 32C18.6087 32 28.7828 36.2143 36.2843 43.7157C43.7857 51.2172 48 61.3913 48 72C48 74.2091 46.2091 76 44 76C41.7909 76 40 74.2091 40 72C40 63.5131 36.6286 55.3737 30.6274 49.3726C24.6263 43.3714 16.4869 40 8 40C5.79086 40 4 38.2091 4 36ZM4 68C4 63.5817 7.58172 60 12 60C16.4183 60 20 63.5817 20 68C20 72.4183 16.4183 76 12 76C7.58172 76 4 72.4183 4 68Z\" />\n        ",
	[M.SEARCH_GLASS]: "<path d=\"M74.875 70.2344L56.0313 51.3906C60.1094 46.4688 62.3594 40.1406 62.3594 33.25C62.3594 17.2188 49.1406 4 33.1094 4C16.9375 4 4 17.2188 4 33.25C4 49.4219 17.0781 62.5 33.1094 62.5C39.8594 62.5 46.1875 60.25 51.25 56.1719L70.0938 75.0156C70.7969 75.7188 71.6406 76 72.625 76C73.4688 76 74.3125 75.7188 74.875 75.0156C76.2813 73.75 76.2813 71.6406 74.875 70.2344ZM10.75 33.25C10.75 20.875 20.7344 10.75 33.25 10.75C45.625 10.75 55.75 20.875 55.75 33.25C55.75 45.7656 45.625 55.75 33.25 55.75C20.7344 55.75 10.75 45.7656 10.75 33.25Z\" />\n        ",
	[M.SEND]: "<path d=\"M74.13 36.8274L9.74055 4.4528C6.50305 3.01392 2.9059 5.89165 4.34478 9.12915L13.3377 33.2302L54.3455 40.0649L13.3377 46.8995L4.34478 70.9996C3.2656 74.2371 6.50305 77.1156 9.74055 75.317L74.13 42.9424C76.648 41.8634 76.648 38.2663 74.13 36.8274Z\"/>",
	[M.SETTINGS]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M32.1224 6.87568C33.9637 5.03441 36.461 4 39.0649 4H40.5049C43.1089 4 45.6062 5.03441 47.4474 6.87568C49.2887 8.71694 50.3231 11.2142 50.3231 13.8182V14.4039C50.3237 14.9778 50.4752 15.5415 50.7624 16.0384C51.0496 16.5352 51.4625 16.9479 51.9595 17.2348L51.9681 17.2398L53.3668 18.053L53.3702 18.055C53.8669 18.3409 54.43 18.4915 55.0031 18.4915C55.5776 18.4915 56.142 18.3402 56.6395 18.053C56.6713 18.0347 56.7034 18.0168 56.7358 17.9996L57.1835 17.7608C59.4256 16.4856 62.0803 16.1436 64.5737 16.8103C67.0863 17.4821 69.2297 19.1236 70.5333 21.3742L71.2562 22.6229C72.5558 24.8758 72.9084 27.5524 72.2365 30.0651C71.567 32.5687 69.9349 34.7058 67.6967 36.0107L67.2252 36.2936C67.2094 36.3031 67.1936 36.3124 67.1777 36.3216C66.6782 36.6099 66.2639 37.0251 65.9765 37.5251C65.6892 38.0251 65.539 38.5921 65.5413 39.1688L65.5414 39.1818L65.5413 40.8182L65.5413 40.8312C65.539 41.4079 65.6892 41.9749 65.9765 42.4749C66.2563 42.9617 66.6565 43.3681 67.1383 43.6553L67.5724 43.8868C67.6061 43.9048 67.6395 43.9234 67.6726 43.9426C69.9232 45.2462 71.5646 47.3896 72.2365 49.9022C72.9069 52.4093 72.5574 55.0796 71.2649 57.3294L70.5518 58.5934L70.5333 58.6258C69.2297 60.8764 67.0863 62.5178 64.5737 63.1897C62.0803 63.8564 59.4256 63.5144 57.1835 62.2392L56.7358 62.0004C56.7212 61.9926 56.7066 61.9847 56.6921 61.9767C56.6745 61.967 56.657 61.9571 56.6395 61.947C56.142 61.6597 55.5776 61.5085 55.0031 61.5085C54.43 61.5085 53.8669 61.6591 53.3702 61.945L53.3668 61.947L51.9681 62.7602L51.9595 62.7652C51.4625 63.0521 51.0496 63.4647 50.7624 63.9616C50.4752 64.4585 50.3237 65.0222 50.3231 65.5961V66.1818C50.3231 68.7858 49.2887 71.2831 47.4474 73.1243C45.6062 74.9656 43.1089 76 40.5049 76H39.0649C36.461 76 33.9637 74.9656 32.1224 73.1243C30.2811 71.2831 29.2467 68.7858 29.2467 66.1818L29.2467 65.5961L29.2467 65.5946C29.2459 65.0212 29.0944 64.4581 28.8074 63.9616C28.5202 63.4647 28.1074 63.0521 27.6104 62.7652L27.6018 62.7602L26.2031 61.947L26.1999 61.9451C25.7031 61.6591 25.14 61.5085 24.5667 61.5085C23.9922 61.5085 23.4279 61.6597 22.9304 61.947C22.8986 61.9653 22.8665 61.9832 22.8341 62.0004L22.3864 62.2392C20.1443 63.5144 17.4896 63.8564 14.9962 63.1897C12.4836 62.5178 10.3402 60.8764 9.03655 58.6258L8.31364 57.3771C7.01402 55.1242 6.66145 52.4476 7.33333 49.9349C8.00282 47.4312 9.63495 45.2942 11.8733 43.9893L12.3447 43.7064C12.3605 43.6969 12.3763 43.6876 12.3922 43.6784C12.8916 43.3901 13.306 42.9749 13.5933 42.4749C13.8807 41.9749 14.0308 41.4079 14.0286 40.8312L14.0285 40.8182V39.1606C14.0237 38.5924 13.8709 38.0351 13.5852 37.5437C13.2981 37.0499 12.8869 36.6399 12.3922 36.3543C12.3313 36.3192 12.2716 36.2821 12.2131 36.2431L11.7994 35.9672C9.59905 34.6586 7.99543 32.5411 7.33333 30.0651C6.66145 27.5524 7.01402 24.8758 8.31364 22.6229L9.03621 21.3748C10.3398 19.1241 12.4836 17.4822 14.9962 16.8103C17.4895 16.1436 20.1443 16.4856 22.3864 17.7608L22.8341 17.9996C22.8665 18.0168 22.8986 18.0347 22.9304 18.053C23.4279 18.3402 23.9922 18.4915 24.5667 18.4915C25.1398 18.4915 25.7029 18.341 26.1995 18.0551L26.2031 18.053L27.6104 17.2348C28.1074 16.9479 28.5202 16.5353 28.8074 16.0384C29.0944 15.5419 29.2459 14.9788 29.2467 14.4054L29.2467 14.4039L29.2467 13.8182C29.2467 11.2142 30.2811 8.71694 32.1224 6.87568ZM39.0649 10.5455C38.1969 10.5455 37.3645 10.8903 36.7508 11.504C36.137 12.1178 35.7922 12.9502 35.7922 13.8182L35.7922 14.4106C35.7904 16.1324 35.3359 17.8234 34.4743 19.314C33.6136 20.803 32.3768 22.0398 30.8879 22.9006L30.8831 22.9034L29.4758 23.7215C27.9833 24.5833 26.2902 25.0369 24.5667 25.0369C22.8635 25.0369 21.1899 24.5938 19.7102 23.7517L19.263 23.5132C19.2309 23.4961 19.1992 23.4785 19.1678 23.4603C18.4168 23.0271 17.5246 22.9096 16.687 23.1336C15.8497 23.3575 15.1354 23.9044 14.7008 24.6543V24.6543L13.9834 25.8935L13.9826 25.8949C13.55 26.6456 13.4328 27.5372 13.6566 28.3742C13.8806 29.2118 14.4277 29.9262 15.1779 30.3608C15.2374 30.3952 15.2958 30.4315 15.353 30.4697L15.7651 30.7444C17.2043 31.5981 18.4021 32.806 19.2438 34.2538C20.105 35.7351 20.5636 37.4159 20.5739 39.1293L20.574 39.1491V40.8125C20.5796 42.54 20.1292 44.2385 19.2684 45.7364C18.4113 47.2276 17.1778 48.4673 15.6912 49.3317L15.2214 49.6136C15.207 49.6223 15.1925 49.6308 15.1779 49.6392C14.4277 50.0738 13.8806 50.7882 13.6566 51.6258C13.4329 52.4626 13.55 53.354 13.9823 54.1046L13.9834 54.1065L14.7005 55.3451V55.3451C15.1351 56.095 15.8497 56.6425 16.687 56.8664C17.5246 57.0904 18.4168 56.9729 19.1678 56.5397C19.1992 56.5215 19.2309 56.5039 19.263 56.4868L19.7101 56.2484C21.1898 55.4062 22.8634 54.9631 24.5667 54.9631C26.2902 54.9631 27.9833 55.4167 29.4758 56.2785L29.4844 56.2834L30.8831 57.0966L30.8875 57.0992C32.3766 57.96 33.6135 59.1968 34.4743 60.686C35.3359 62.1766 35.7904 63.8676 35.7922 65.5894L35.7922 65.5927L35.7922 66.1818C35.7922 67.0498 36.137 67.8822 36.7508 68.496C37.3645 69.1097 38.1969 69.4545 39.0649 69.4545H40.5049C41.3729 69.4545 42.2053 69.1097 42.8191 68.496C43.4329 67.8822 43.7777 67.0498 43.7777 66.1818V65.5894C43.7794 63.8676 44.2339 62.1766 45.0956 60.686C45.9562 59.1971 47.1929 57.9603 48.6817 57.0996L48.6868 57.0966L50.0855 56.2834L50.094 56.2785C51.5866 55.4167 53.2797 54.9631 55.0031 54.9631C56.7064 54.9631 58.38 55.4062 59.8597 56.2483L60.3069 56.4868C60.3389 56.5039 60.3706 56.5215 60.4021 56.5397C61.1531 56.9729 62.0453 57.0904 62.8828 56.8664C63.7154 56.6438 64.4264 56.1018 64.8616 55.3584L65.5709 54.1011L65.5865 54.0738C66.0197 53.3228 66.1372 52.4306 65.9132 51.5931C65.6934 50.7708 65.162 50.0672 64.4329 49.6306L64.0012 49.4004C63.9689 49.3832 63.9368 49.3653 63.905 49.347C62.4067 48.482 61.1636 47.2364 60.3015 45.7364C59.4406 44.2385 58.9903 42.54 58.9959 40.8125V39.1875C58.9903 37.46 59.4406 35.7615 60.3015 34.2636C61.1585 32.7724 62.3922 31.5326 63.8787 30.6682L64.3484 30.3864C64.3534 30.3834 64.3584 30.3804 64.3634 30.3775C64.3729 30.3719 64.3824 30.3663 64.3919 30.3608C65.1421 29.9262 65.6893 29.2118 65.9132 28.3742C66.137 27.5373 66.0198 26.6459 65.5875 25.8953L65.5865 25.8935L64.8694 24.6549V24.6549C64.4348 23.905 63.7201 23.3575 62.8828 23.1336C62.0453 22.9096 61.1531 23.0271 60.4021 23.4603C60.3706 23.4785 60.3389 23.4961 60.3069 23.5132L59.8597 23.7517C58.38 24.5938 56.7064 25.0369 55.0031 25.0369C53.2797 25.0369 51.5866 24.5833 50.094 23.7215L50.0855 23.7166L48.6868 22.9034L48.6819 22.9006C47.193 22.0398 45.9563 20.803 45.0956 19.314C44.2339 17.8234 43.7794 16.1324 43.7777 14.4106V13.8182C43.7777 12.9502 43.4329 12.1178 42.8191 11.504C42.2053 10.8903 41.3729 10.5455 40.5049 10.5455H39.0649ZM39.7849 33.4545C36.17 33.4545 33.2395 36.385 33.2395 40C33.2395 43.615 36.17 46.5455 39.7849 46.5455C43.3999 46.5455 46.3304 43.6149 46.3304 40C46.3304 36.385 43.3999 33.4545 39.7849 33.4545ZM26.694 40C26.694 32.7701 32.555 26.9091 39.7849 26.9091C47.0149 26.9091 52.8759 32.7701 52.8759 40C52.8759 47.2299 47.0149 53.0909 39.7849 53.0909C32.555 53.0909 26.694 47.2299 26.694 40Z\" />",
	[M.SHARE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M59.3638 10.5455C55.7489 10.5455 52.8184 13.476 52.8184 17.0909C52.8184 20.7059 55.7489 23.6364 59.3638 23.6364C62.9788 23.6364 65.9093 20.7059 65.9093 17.0909C65.9093 13.476 62.9788 10.5455 59.3638 10.5455ZM46.2729 17.0909C46.2729 9.861 52.1339 4 59.3638 4C66.5938 4 72.4548 9.861 72.4548 17.0909C72.4548 24.3208 66.5938 30.1818 59.3638 30.1818C52.1339 30.1818 46.2729 24.3208 46.2729 17.0909Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M20.0909 33.4545C16.476 33.4545 13.5455 36.385 13.5455 40C13.5455 43.615 16.476 46.5455 20.0909 46.5455C23.7059 46.5455 26.6364 43.615 26.6364 40C26.6364 36.385 23.7059 33.4545 20.0909 33.4545ZM6.99998 40C6.99998 32.7701 12.861 26.9091 20.0909 26.9091C27.3209 26.9091 33.1819 32.7701 33.1819 40C33.1819 47.2299 27.3209 53.0909 20.0909 53.0909C12.861 53.0909 6.99998 47.2299 6.99998 40Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M59.3638 56.3636C55.7489 56.3636 52.8184 59.2941 52.8184 62.9091C52.8184 66.524 55.7489 69.4545 59.3638 69.4545C62.9788 69.4545 65.9093 66.524 65.9093 62.9091C65.9093 59.2941 62.9788 56.3636 59.3638 56.3636ZM46.2729 62.9091C46.2729 55.6792 52.1339 49.8182 59.3638 49.8182C66.5938 49.8182 72.4548 55.6792 72.4548 62.9091C72.4548 70.139 66.5938 76 59.3638 76C52.1339 76 46.2729 70.139 46.2729 62.9091Z\"/>\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M25.7397 43.2941C26.6497 41.7324 28.6534 41.2041 30.2151 42.1142L52.5679 55.1396C54.1296 56.0496 54.6579 58.0533 53.7478 59.615C52.8378 61.1767 50.8341 61.705 49.2724 60.7949L26.9196 47.7695C25.3579 46.8595 24.8296 44.8557 25.7397 43.2941Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M53.7141 20.3832C54.6251 21.9443 54.0981 23.9483 52.537 24.8593L30.2169 37.8848C28.6558 38.7958 26.6517 38.2688 25.7407 36.7077C24.8297 35.1466 25.3567 33.1426 26.9178 32.2316L49.2379 19.2061C50.799 18.2951 52.803 18.8221 53.7141 20.3832Z\"/>\n        ",
	[M.SKIP_BACK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M9.42047 4C11.3093 4 12.8405 5.53119 12.8405 7.42V20.2609L17.3927 16.1639L17.4195 16.14C23.1706 11.0725 30.4574 8.0839 38.1105 7.65377C45.7636 7.22364 53.3393 9.37692 59.622 13.7681C65.9047 18.1592 70.5302 24.5337 72.7561 31.8685C74.982 39.2034 74.6793 47.0733 71.8966 54.2156C69.1139 61.3578 64.0125 67.3581 57.4111 71.2538C50.8097 75.1494 43.0909 76.7145 35.4935 75.6978C27.896 74.6811 20.8603 71.1417 15.5154 65.6474C10.1706 60.1531 6.82634 53.0226 6.01945 45.4C5.82062 43.5217 7.18212 41.8379 9.06045 41.639C10.9388 41.4402 12.6227 42.8017 12.8215 44.68C13.467 50.7781 16.1424 56.4825 20.4183 60.8779C24.6942 65.2733 30.3227 68.1049 36.4007 68.9182C42.4787 69.7315 48.6537 68.4795 53.9348 65.363C59.216 62.2465 63.297 57.4462 65.5232 51.7324C67.7494 46.0187 67.9915 39.7227 66.2108 33.8548C64.4301 27.9869 60.7297 22.8874 55.7035 19.3744C50.6774 15.8615 44.6168 14.1389 38.4943 14.483C32.3776 14.8268 26.5535 17.2135 21.9546 21.2605L18.3329 24.52H29.9406C31.8294 24.52 33.3606 26.0512 33.3606 27.94C33.3606 29.8288 31.8294 31.36 29.9406 31.36H9.42047C7.53164 31.36 6.00045 29.8288 6.00045 27.94V7.42C6.00045 5.53119 7.53164 4 9.42047 4Z\"/>\n        <path d=\"M24.8106 43.0795V39.6829C26.4638 39.0617 27.8014 38.2301 28.8234 37.1881C29.8454 36.136 30.5468 34.7633 30.9275 33.07H34.4143V53.5399H30.8975V38.9465C29.2843 40.9905 27.2553 42.3682 24.8106 43.0795Z\" />\n        <path d=\"M38.1116 47.438H41.6885C41.909 49.6624 43.2817 50.7745 45.8066 50.7745C47.1392 50.7745 48.1712 50.4138 48.9027 49.6924C49.6341 48.971 49.9998 47.944 49.9998 46.6114V46.5513C49.9998 45.3189 49.6341 44.347 48.9027 43.6356C48.1812 42.9142 47.2043 42.5535 45.9719 42.5535C44.9199 42.5535 44.0482 42.7689 43.3568 43.1998C42.6755 43.6306 42.0893 44.2368 41.5984 45.0183L38.4873 43.0795L39.9602 33.1001H52.5247V36.3013H42.5452L41.8388 41.1408C42.951 40.0286 44.4189 39.4725 46.2425 39.4725C48.4668 39.4725 50.2653 40.1238 51.638 41.4263C53.0107 42.7188 53.697 44.4372 53.697 46.5814C53.697 48.8458 52.9856 50.6443 51.5629 51.9769C50.1501 53.3095 48.2464 53.9758 45.8517 53.9758C43.5672 53.9758 41.7036 53.3696 40.2608 52.1572C38.828 50.9449 38.1116 49.3718 38.1116 47.438Z\" />\n        ",
	[M.SKIP_FORWARD]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M70.8095 4C72.6983 4 74.2295 5.53119 74.2295 7.42V27.94C74.2295 29.8288 72.6983 31.36 70.8095 31.36H50.2894C48.4006 31.36 46.8694 29.8288 46.8694 27.94C46.8694 26.0512 48.4006 24.52 50.2894 24.52H67.3895V7.42C67.3895 5.53119 68.9207 4 70.8095 4Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M41.7357 14.483C35.6132 14.1389 29.5526 15.8615 24.5264 19.3744C19.5003 22.8874 15.7999 27.9869 14.0192 33.8548C12.2385 39.7227 12.4806 46.0187 14.7068 51.7324C16.9329 57.4462 21.014 62.2465 26.2952 65.363C31.5763 68.4795 37.7513 69.7315 43.8293 68.9182C49.9073 68.1049 55.5358 65.2733 59.8117 60.8779C64.0876 56.4825 66.763 50.7781 67.4085 44.68C67.6073 42.8017 69.2912 41.4402 71.1695 41.639C73.0479 41.8379 74.4094 43.5217 74.2105 45.4001C73.4036 53.0226 70.0594 60.1531 64.7146 65.6474C59.3697 71.1417 52.334 74.6811 44.7365 75.6978C37.1391 76.7145 29.4203 75.1494 22.8189 71.2538C16.2175 67.3581 11.1161 61.3578 8.3334 54.2156C5.55071 47.0733 5.24802 39.2034 7.47392 31.8685C9.69982 24.5337 14.3252 18.1592 20.608 13.7681C26.8907 9.37692 34.4664 7.22364 42.1195 7.65377C49.7726 8.0839 57.0594 11.0725 62.8105 16.14L62.8373 16.1639L73.0974 25.398C74.5013 26.6615 74.6152 28.8239 73.3516 30.2279C72.088 31.6318 69.9256 31.7456 68.5216 30.4821L58.2753 21.2604C53.6765 17.2134 47.8524 14.8268 41.7357 14.483Z\" />\n        <path d=\"M24.6393 43.0795V39.6829C26.2925 39.0617 27.6301 38.2301 28.6521 37.1881C29.6741 36.136 30.3755 34.7633 30.7562 33.07H34.243V53.5399H30.7262V38.9465C29.113 40.9905 27.084 42.3682 24.6393 43.0795Z\" />\n        <path d=\"M37.9403 47.438H41.5173C41.7377 49.6624 43.1104 50.7746 45.6353 50.7746C46.9679 50.7746 47.9999 50.4139 48.7314 49.6924C49.4628 48.971 49.8285 47.944 49.8285 46.6114V46.5513C49.8285 45.3189 49.4628 44.347 48.7314 43.6356C48.0099 42.9142 47.033 42.5535 45.8006 42.5535C44.7486 42.5535 43.8769 42.7689 43.1855 43.1998C42.5042 43.6306 41.918 44.2368 41.4271 45.0183L38.316 43.0795L39.7889 33.1001H52.3534V36.3013H42.3739L41.6676 41.1408C42.7797 40.0286 44.2476 39.4725 46.0712 39.4725C48.2955 39.4725 50.094 40.1238 51.4667 41.4263C52.8394 42.7188 53.5257 44.4372 53.5257 46.5814C53.5257 48.8458 52.8143 50.6443 51.3916 51.9769C49.9788 53.3095 48.0751 53.9758 45.6804 53.9758C43.3959 53.9758 41.5323 53.3696 40.0895 52.1573C38.6567 50.9449 37.9403 49.3718 37.9403 47.438Z\" />\n        ",
	[M.SKIP_TO_FIRST]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M38.4937 10.5063C40.5021 12.5147 40.5021 15.771 38.4937 17.7794L16.416 39.8571L38.4937 61.9349C40.5021 63.9433 40.5021 67.1996 38.4937 69.208C36.4853 71.2164 33.229 71.2164 31.2206 69.208L5.50631 43.4937C3.4979 41.4853 3.4979 38.229 5.50631 36.2206L31.2206 10.5063C33.229 8.4979 36.4853 8.4979 38.4937 10.5063ZM74.4937 10.5063C76.5021 12.5147 76.5021 15.771 74.4937 17.7794L52.416 39.8571L74.4937 61.9349C76.5021 63.9433 76.5021 67.1996 74.4937 69.208C72.4853 71.2164 69.229 71.2164 67.2206 69.208L41.5063 43.4937C39.4979 41.4853 39.4979 38.229 41.5063 36.2206L67.2206 10.5063C69.229 8.4979 72.4853 8.4979 74.4937 10.5063Z\"/>",
	[M.SKIP_TO_LAST]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M5.50631 10.6489C7.51472 8.64048 10.771 8.64048 12.7794 10.6489L38.4937 36.3632C40.5021 38.3716 40.5021 41.6279 38.4937 43.6363L12.7794 69.3506C10.771 71.359 7.51472 71.359 5.50631 69.3506C3.4979 67.3421 3.4979 64.0859 5.50631 62.0775L27.584 39.9997L5.50631 17.922C3.4979 15.9136 3.4979 12.6573 5.50631 10.6489ZM41.5063 10.6489C43.5147 8.64048 46.771 8.64048 48.7794 10.6489L74.4937 36.3632C76.5021 38.3716 76.5021 41.6279 74.4937 43.6363L48.7794 69.3506C46.771 71.359 43.5147 71.359 41.5063 69.3506C39.4979 67.3421 39.4979 64.0859 41.5063 62.0775L63.584 39.9997L41.5063 17.922C39.4979 15.9136 39.4979 12.6573 41.5063 10.6489Z\"/>",
	[M.SKIP_TO_NEXT]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M20.5063 5.50631C22.5147 3.4979 25.771 3.4979 27.7794 5.50631L58.6365 36.3635C60.645 38.3719 60.645 41.6281 58.6365 43.6365L27.7794 74.4937C25.771 76.5021 22.5147 76.5021 20.5063 74.4937C18.4979 72.4853 18.4979 69.229 20.5063 67.2206L47.7269 40L20.5063 12.7794C18.4979 10.771 18.4979 7.51472 20.5063 5.50631Z\" />",
	[M.SKIP_TO_PREVIOUS]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M58.6365 5.50631C60.645 7.51472 60.645 10.771 58.6365 12.7794L31.416 40L58.6365 67.2206C60.645 69.229 60.645 72.4853 58.6365 74.4937C56.6281 76.5021 53.3719 76.5021 51.3635 74.4937L20.5063 43.6365C18.4979 41.6281 18.4979 38.3719 20.5063 36.3635L51.3635 5.50631C53.3719 3.4979 56.6281 3.4979 58.6365 5.50631Z\"/>",
	[M.SMILEY_BELL]: "<path d=\"M22.4186 31.093C22.2632 32.2014 22.1763 33.3203 22.1587 34.4419H12.2041C11.3721 34.4419 10.6977 33.6922 10.6977 32.7674C10.6977 31.8427 11.3721 31.093 12.2041 31.093H22.4186Z\" />\n        <path d=\"M24.093 39.4651C24.0115 40.7087 23.8943 41.8201 23.7517 42.814H5.74235C4.78008 42.814 4 42.0643 4 41.1395C4 40.2148 4.78008 39.4651 5.74235 39.4651H24.093Z\" />\n        <path d=\"M22.4186 47.8372C21.4769 50.011 20.4349 50.8286 19.9334 51.1126L19.8164 51.186H14.2778C13.2253 51.186 12.3721 50.4364 12.3721 49.5116C12.3721 48.5869 13.2253 47.8372 14.2778 47.8372H22.4186Z\" />\n        <path d=\"M76 32.7674C76 33.6922 75.2656 34.4419 74.3597 34.4419H61.218C61.1995 33.3201 61.1033 32.201 60.9302 31.093H74.3597C74.7947 31.093 75.2119 31.2694 75.5196 31.5835C75.8272 31.8975 76 32.3234 76 32.7674Z\" />\n        <path d=\"M69.3014 41.0202C69.3157 41.4446 69.1561 41.8571 68.8579 42.1664C68.5597 42.4758 68.1475 42.6565 67.7125 42.6688L62.9119 42.814C62.7823 41.8773 62.6767 40.8 62.6046 39.6151L67.6357 39.4652C68.5323 39.4546 69.2728 40.1458 69.3014 41.0202Z\" />\n        <path d=\"M74.3256 47.8348C74.3256 48.759 73.5231 49.5089 72.5312 49.5116H64.3046C63.5329 48.4961 62.9576 47.3628 62.6046 46.1628H72.5312C73.521 46.1655 74.3227 46.9125 74.3256 47.8348Z\" />\n        <path d=\"M23.9918 36.1177C23.9918 48.217 21.2568 51.916 19.6041 52.9918C17.7785 54.2276 16.9705 56.5217 17.6146 58.6406C18.2587 60.7596 20.2032 62.2042 22.4025 62.1977H34.0641V62.3353C34.6328 66.4893 38.1484 69.5885 42.3099 69.6046C46.4715 69.6206 50.0105 66.5486 50.6107 62.3991V62.2665H60.9512C63.706 62.2477 65.9346 60.0021 65.9533 57.2263C65.9664 55.5536 65.1438 53.9863 63.7642 53.0557C62.0968 51.916 59.3765 48.217 59.3765 36.1865C59.3765 24.8879 52.5511 20.3881 47.5637 18.5017C47.6426 18.0803 47.6883 17.6532 47.7002 17.2245C47.7625 15.0221 46.632 12.9595 44.7488 11.8398C42.8655 10.7201 40.5271 10.7201 38.6439 11.8398C36.7607 12.9595 35.6302 15.0221 35.6925 17.2245C35.7027 17.6531 35.7468 18.0802 35.8241 18.5017C30.7977 20.2506 23.9918 24.824 23.9918 36.1177ZM42.3374 66.9038C40.1128 66.9167 38.0934 65.5961 37.1989 63.5437H47.5393C46.603 65.5891 44.5729 66.9004 42.3374 66.9038ZM41.6695 13.8006C42.5567 13.7913 43.4103 14.1423 44.0377 14.7745C44.6651 15.4066 45.0134 16.2667 45.0042 17.1606C45.0144 17.3415 44.993 17.5228 44.9408 17.6961C42.7611 17.2502 40.5146 17.2502 38.3348 17.6961C38.3348 17.4947 38.2666 17.3621 38.2666 17.1606C38.3089 15.2961 39.8186 13.8054 41.6695 13.8006ZM60.4149 53.5273C60.9131 54.2093 61.5231 54.8008 62.2187 55.2761C62.8676 55.7199 63.2649 56.4512 63.2864 57.2411C63.2706 58.534 62.2343 59.5782 60.9512 59.5941H22.3879C21.1048 59.5782 20.0684 58.534 20.0524 57.2411C20.0406 56.4424 20.446 55.6962 21.1203 55.2761C24.7914 52.7217 26.6586 46.3355 26.6586 36.1865C26.6586 25.9146 32.8648 21.9846 38.135 20.5109H38.2032C39.3528 20.1815 40.5426 20.0162 41.7378 20.0196C42.9141 20.0167 44.0837 20.199 45.2041 20.56H45.2723C50.4742 22.0338 56.7487 25.9637 56.7487 36.157C56.7487 42.5431 57.48 47.4555 58.9474 50.8107C59.3473 51.7624 59.8388 52.6722 60.4149 53.5273Z\"/>\n        <path d=\"M51.7209 39.4651C53.1081 39.4651 54.2326 38.3406 54.2326 36.9535C54.2326 35.5664 53.1081 34.4419 51.7209 34.4419C50.3338 34.4419 49.2093 35.5664 49.2093 36.9535C49.2093 38.3406 50.3338 39.4651 51.7209 39.4651Z\" />\n        <path d=\"M34.9767 39.4651C36.3639 39.4651 37.4884 38.3406 37.4884 36.9535C37.4884 35.5664 36.3639 34.4419 34.9767 34.4419C33.5896 34.4419 32.4651 35.5664 32.4651 36.9535C32.4651 38.3406 33.5896 39.4651 34.9767 39.4651Z\" />\n        <path d=\"M42.5341 46.1626C41.2073 46.1737 39.9297 45.7471 38.9831 44.9768C38.0365 44.2065 37.4987 43.1559 37.4884 42.0566C37.5313 41.5403 38.0494 41.1395 38.6741 41.1395C39.2989 41.1395 39.817 41.5403 39.8598 42.0566C39.8598 43.27 41.0471 44.2536 42.5116 44.2536C43.9762 44.2536 45.1634 43.27 45.1634 42.0566C45.2063 41.5403 45.7244 41.1395 46.3491 41.1395C46.9739 41.1395 47.492 41.5403 47.5349 42.0566C47.5133 44.3313 45.2798 46.1652 42.5341 46.1626Z\" />\n        ",
	[M.SOCIAL_FACEBOOK]: "<path d=\"M23.1495 42.3472H30.9614V74.8387C30.9614 75.4802 31.4759 76 32.1109 76H45.3564C45.9913 76 46.5058 75.4802 46.5058 74.8387V42.5003H55.4864C56.0703 42.5003 56.5616 42.0576 56.6282 41.4716L57.9922 29.5098C58.0297 29.1807 57.9264 28.8511 57.7085 28.6043C57.4903 28.3571 57.1781 28.2157 56.8505 28.2157H46.5063V20.7175C46.5063 18.4571 47.7109 17.3109 50.0871 17.3109C50.4257 17.3109 56.8505 17.3109 56.8505 17.3109C57.4855 17.3109 58 16.7909 58 16.1497V5.16988C58 4.52839 57.4855 4.00859 56.8505 4.00859H47.5296C47.4638 4.00534 47.3178 4 47.1026 4C45.4853 4 39.8638 4.32075 35.4232 8.44797C30.503 13.0216 31.187 18.4978 31.3504 19.4473V28.2155H23.1495C22.5145 28.2155 22 28.7353 22 29.3767V41.1857C22 41.8272 22.5145 42.3472 23.1495 42.3472Z\"/>",
	[M.SOCIAL_LINKED_IN]: "<path d=\"M76 47.2003V73.2H60.5681V48.9416C60.5681 42.8477 58.336 38.6888 52.7502 38.6888C48.4861 38.6888 45.9485 41.4916 44.8321 44.2028C44.425 45.172 44.3203 46.5211 44.3203 47.8778V73.2H28.8831C28.8831 73.2 29.091 32.1142 28.8831 27.8574H44.3187V34.2845C44.2874 34.3326 44.2468 34.3844 44.2173 34.431H44.3187V34.2845C46.3695 31.1994 50.032 26.7922 58.2297 26.7922C68.3862 26.792 76 33.2728 76 47.2003ZM12.7352 6C7.45422 6 4 9.38337 4 13.8326C4 18.1849 7.35429 21.6709 12.5303 21.6709H12.6335C18.0168 21.6709 21.3647 18.1855 21.3647 13.8326C21.2632 9.38337 18.0168 6 12.7352 6ZM4.91683 73.2H20.3481V27.8574H4.91683V73.2Z\" />",
	[M.SOCIAL_X]: "<path d=\"M46.9287 34.4871L73.1562 4H66.9411L44.1678 30.4715L25.9788 4H5L32.5053 44.0296L5 76H11.2154L35.2646 48.0452L54.4735 76H75.4523L46.9272 34.4871H46.9287ZM38.4158 44.3823L13.4549 8.67885H23.0014L66.944 71.5339H57.3975L38.4158 44.3838V44.3823Z\"/>",
	[M.SPOTLIGHT]: "<path d=\"M71.4367 13.1308C72.5205 12.8299 73.6842 13.0549 74.5797 13.7355C75.4746 14.4163 76 15.4762 76 16.6007V59.8007C76 60.8926 75.5052 61.9265 74.6535 62.6097C73.8019 63.2928 72.6853 63.553 71.6195 63.3164L6.81953 48.9164C5.1724 48.5503 4 47.0881 4 45.4007V34.6007L4.04922 34.0066C4.27646 32.6451 5.27286 31.5097 6.63672 31.1308L71.4367 13.1308ZM11.2 37.3359V42.5109L68.8 55.3113V21.3363L11.2 37.3359Z\"/>\n<path d=\"M14.2104 48.7645C14.739 46.8481 16.7201 45.7225 18.6365 46.2508C20.5528 46.7795 21.6783 48.7607 21.1502 50.677C20.8977 51.5923 20.8293 52.5508 20.9463 53.493C21.0634 54.4344 21.3641 55.3433 21.8322 56.1684C22.3009 56.9941 22.929 57.7189 23.6779 58.3024C24.4269 58.8859 25.2834 59.319 26.1986 59.5715C27.1134 59.8237 28.0694 59.8923 29.0111 59.7754C29.9532 59.6584 30.8644 59.3581 31.69 58.8895C32.5155 58.4209 33.2406 57.7926 33.824 57.0438C34.4073 56.295 34.8372 55.4381 35.0896 54.5231L35.2057 54.175C35.8655 52.4738 37.7191 51.5147 39.5158 52.0094C41.4325 52.5381 42.5582 54.5225 42.0295 56.4391L41.8256 57.1176C41.3077 58.6891 40.5208 60.162 39.5018 61.47C38.3375 62.964 36.8916 64.2157 35.2443 65.1508C33.5963 66.0862 31.7776 66.6857 29.8971 66.9192C28.0168 67.1525 26.1091 67.0152 24.2826 66.5114C22.4559 66.0075 20.7466 65.1482 19.2518 63.9836C17.7569 62.819 16.5063 61.3707 15.5709 59.7227C14.6357 58.0748 14.0325 56.2593 13.799 54.3789C13.5656 52.4987 13.7066 50.591 14.2104 48.7645Z\"/>",
	[M.THRIVE]: "<path d=\"M50.846 66.4053H33.3985V32.361C33.3934 31.7971 33.2714 31.24 33.0399 30.7229C32.8083 30.2059 32.472 29.7396 32.051 29.3519C31.658 28.9763 31.1902 28.6829 30.6764 28.4899C30.1625 28.2968 29.6134 28.208 29.063 28.2291C27.9558 28.2636 26.9051 28.7126 26.1301 29.4824C25.355 30.2523 24.9155 31.2836 24.9032 32.361V70.5458C24.9176 71.6373 25.3698 72.6801 26.1633 73.452C26.9568 74.2238 28.0288 74.6637 29.1509 74.6777H50.846C51.4259 74.6734 51.9988 74.555 52.5304 74.3297C53.062 74.1045 53.5413 73.777 53.9395 73.3669C54.3255 72.9846 54.6271 72.5296 54.8256 72.0297C55.0241 71.5298 55.1153 70.9957 55.0937 70.4603C55.0597 69.3828 54.5985 68.3599 53.8068 67.6057C53.0151 66.8514 51.9541 66.4244 50.846 66.4138\" />\n        <path d=\"M74.7025 6.13893C74.3256 5.76127 73.8758 5.46554 73.3809 5.27005C72.886 5.07457 72.3565 4.98349 71.8253 5.00245C70.7587 5.03468 69.7458 5.4812 68.9987 6.24856C68.2516 7.01591 67.8281 8.04461 67.8169 9.11933V27.1637H49.8966C48.8161 27.1777 47.7838 27.6162 47.0198 28.3858C46.2557 29.1554 45.8203 30.1951 45.8065 31.2834V49.6374C45.8116 50.1999 45.9294 50.7556 46.1529 51.2712C46.3763 51.7867 46.7008 52.2515 47.1068 52.6377C47.8268 53.3576 48.7976 53.7654 49.812 53.7742H49.984C51.0506 53.7412 52.0631 53.294 52.8097 52.5261C53.5563 51.7582 53.9791 50.7292 53.9895 49.6545V35.4173H71.9099C72.9906 35.4026 74.0229 34.9634 74.7869 34.1934C75.5508 33.4234 75.9861 32.3833 76 31.2948V9.13353C75.9937 8.57232 75.8756 8.0181 75.6527 7.50371C75.4298 6.98932 75.1067 6.52522 74.7025 6.13893Z\" />\n        <path d=\"M51.6218 11.8571C52.0055 11.4801 52.3054 11.0318 52.503 10.5394C52.7007 10.047 52.792 9.52093 52.7713 8.99339C52.7368 7.93077 52.2774 6.92208 51.4891 6.17795C50.7007 5.43383 49.6444 5.0118 48.5407 5H8.2335C7.11567 5.01382 6.04762 5.44749 5.25685 6.20862C4.46609 6.96976 4.01512 7.99821 4 9.07489V31.1018C4.00564 31.6581 4.12766 32.2077 4.35876 32.7175C4.58986 33.2274 4.9253 33.6872 5.34503 34.0694C6.09056 34.7802 7.09414 35.1834 8.14305 35.1935H8.32103C9.42623 35.1587 10.4745 34.7133 11.2463 33.9505C12.0181 33.1877 12.4535 32.1669 12.4612 31.1018V13.1526H48.5407C49.1183 13.1472 49.6889 13.0296 50.2182 12.807C50.7476 12.5844 51.225 12.2614 51.6218 11.8571Z\" />\n        ",
	[M.TOUCH_ID]: "<path d=\"M22.8129 56.0327C23.0184 55.4984 22.7513 54.8922 22.217 54.6765C21.6827 54.471 21.0766 54.7381 20.8608 55.2724C19.556 58.6218 17.3983 61.6014 14.6243 63.8823C14.1825 64.2521 14.1106 64.9097 14.4804 65.3515C14.6859 65.5981 14.9839 65.7316 15.2921 65.7316C15.5284 65.7316 15.7545 65.6597 15.9497 65.4953C19.0114 62.9884 21.3848 59.7212 22.8129 56.0327Z\" />\n        <path d=\"M15.3435 44.957L15.2203 44.392C15.0148 43.2618 14.8915 42.1213 14.8504 40.9809C14.8298 40.4055 14.3367 39.9534 13.7613 39.9843C13.1859 40.0048 12.7339 40.498 12.7647 41.0733C12.8263 42.5118 13.001 43.9604 13.2887 45.3783L13.3811 45.8098C14.0695 49.9915 12.5078 54.2348 9.26114 56.9883C8.81934 57.3582 8.76797 58.0157 9.13785 58.4575C9.34333 58.7041 9.64129 58.8274 9.93925 58.8274C10.1756 58.8274 10.4221 58.7452 10.6174 58.5808C14.5627 55.2417 16.3813 50.0223 15.3538 44.957H15.3435Z\" />\n        <path d=\"M11.0591 45.82L10.9461 45.2754C9.56936 37.7238 11.1413 30.0694 15.4052 23.648C19.7718 17.0827 26.4295 12.6031 34.1558 11.0414C37.4025 10.3838 40.7006 10.2811 43.9473 10.7126C44.5226 10.7845 45.0466 10.3838 45.1186 9.81872C45.2007 9.24336 44.7898 8.71937 44.2247 8.64745C40.7417 8.17483 37.2176 8.29812 33.7449 8.99677C25.4638 10.6612 18.3334 15.4593 13.6585 22.487C8.98372 29.5146 7.32955 37.9498 9.00427 46.231L9.07619 46.5597C9.43579 48.8817 8.71659 51.2654 7.10352 53.0017C6.71309 53.423 6.73364 54.0908 7.15489 54.4812C7.36038 54.6662 7.60696 54.7587 7.86382 54.7587C8.14123 54.7587 8.41863 54.6456 8.63439 54.4196C10.7715 52.1079 11.6859 48.892 11.0591 45.8097V45.82Z\" />\n        <path d=\"M41.0294 39.789C40.9164 39.2239 40.3616 38.854 39.7965 38.9671C39.2314 39.0801 38.8615 39.6349 38.9745 40.2C40.1766 46.1591 39.9711 52.1285 38.3581 57.9437C36.8169 63.4919 33.9915 68.7215 30.19 73.0573C29.8098 73.4888 29.8509 74.1464 30.2825 74.5265C30.4777 74.7012 30.7243 74.7834 30.9708 74.7834C31.2585 74.7834 31.5462 74.6601 31.7517 74.4238C35.7689 69.8517 38.7485 64.3447 40.3719 58.4883C42.0671 52.3545 42.2931 46.0563 41.0191 39.7685L41.0294 39.789Z\"/>\n        <path d=\"M28.1864 42.3781L28.0323 41.6178C27.1795 35.371 31.3406 29.4325 37.608 28.1687C38.7073 27.9427 39.8272 27.8811 40.9369 27.9632C41.5122 28.0043 42.0157 27.5831 42.0568 27.0077C42.0979 26.4324 41.6663 25.9289 41.091 25.8878C39.7861 25.7851 38.4813 25.8673 37.1867 26.1241C29.5323 27.6653 24.5596 35.145 26.1007 42.7994L26.2959 43.7857C27.6624 52.3545 24.5082 61.1082 17.9018 66.8208C17.4703 67.2009 17.4189 67.8585 17.7991 68.29C18.0045 68.5263 18.2922 68.6496 18.5902 68.6496C18.8368 68.6496 19.0731 68.5674 19.2786 68.3927C26.7069 61.961 30.118 51.9846 28.1761 42.3679L28.1864 42.3781Z\" />\n        <path d=\"M32.81 43.5391C32.7278 42.9638 32.2038 42.5631 31.6387 42.6453C31.0633 42.7275 30.6626 43.2514 30.7448 43.8165C32.0291 53.2689 28.618 62.8138 21.6212 69.3585C21.2 69.749 21.1794 70.4168 21.5698 70.838C21.7753 71.0538 22.0527 71.1668 22.3301 71.1668C22.587 71.1668 22.8438 71.0743 23.0391 70.8894C30.5188 63.8823 34.1764 53.6696 32.7997 43.5391H32.81Z\" />\n        <path d=\"M34.4127 59.4747C33.8785 59.2692 33.2723 59.5261 33.0565 60.0706C31.3818 64.3447 28.9159 68.1873 25.7104 71.4751C25.3097 71.8861 25.3199 72.5539 25.7309 72.9546C25.9364 73.1498 26.1933 73.2526 26.4604 73.2526C26.7275 73.2526 27.0049 73.1498 27.2104 72.9341C30.6112 69.4408 33.2414 65.3722 35.0086 60.8309C35.2141 60.2966 34.9573 59.6905 34.4127 59.4747Z\" />\n        <path d=\"M19.6176 44.0939L19.4532 43.272C18.282 35.9361 21.0869 28.5488 26.8919 23.8329C27.3337 23.4733 27.4056 22.8158 27.046 22.3637C26.6864 21.9116 26.0288 21.85 25.5767 22.2096C18.9395 27.5933 15.8675 36.1416 17.5628 44.5152L17.7066 45.2549C18.6108 51.0599 16.3607 56.8855 11.7372 60.5945C11.2852 60.9541 11.2132 61.6116 11.5831 62.0637C11.7886 62.3206 12.0968 62.4542 12.3948 62.4542C12.6208 62.4542 12.8571 62.3822 13.0523 62.2281C18.4875 57.8615 21.0047 50.9161 19.6279 44.1042L19.6176 44.0939Z\"/>\n        <path d=\"M35.471 17.5554C33.7346 17.9047 32.0394 18.4493 30.4366 19.189C29.9126 19.4253 29.6865 20.0521 29.9228 20.5761C30.1591 21.1001 30.7859 21.3261 31.3099 21.0898C32.7688 20.4219 34.2997 19.9288 35.882 19.6103C42.026 18.3774 48.3242 19.9391 53.1839 23.9152C53.3791 24.0693 53.6155 24.1515 53.8415 24.1515C54.1394 24.1515 54.4477 24.018 54.6532 23.7714C55.023 23.3296 54.9511 22.672 54.5093 22.3022C49.1667 17.9253 42.2315 16.2095 35.471 17.5657V17.5554Z\" />\n        <path d=\"M7.11383 48.1317C7.00081 47.6591 6.88779 47.1659 6.78505 46.683C6.77477 46.6214 6.75422 46.5597 6.73368 46.4981C5.25417 38.967 6.3227 31.3845 9.81598 24.5624C10.0831 24.0487 9.87762 23.4219 9.3639 23.1548C8.85019 22.8877 8.22345 23.0932 7.95632 23.6069C4.21646 30.9222 3.09656 39.0389 4.73018 47.1043C4.74045 47.1659 4.761 47.2378 4.79183 47.2995C4.8843 47.7516 4.98704 48.1934 5.10006 48.6351C5.21307 49.1078 5.6446 49.4263 6.11722 49.4263C6.19941 49.4263 6.2816 49.4263 6.3638 49.3954C6.92889 49.2619 7.26794 48.6865 7.1241 48.1317H7.11383Z\" />\n        <path d=\"M11.1618 20.2369C11.3467 20.3705 11.5625 20.4424 11.7783 20.4424C12.0968 20.4424 12.4153 20.2986 12.6208 20.0109C17.6244 13.1476 24.9705 8.45225 33.2927 6.77753C40.68 5.28775 48.1494 6.25354 54.8996 9.56188C55.4134 9.81874 56.0401 9.60297 56.297 9.08926C56.5538 8.57554 56.338 7.94881 55.8243 7.69195C48.6528 4.16785 40.7211 3.14042 32.8817 4.72267C24.0458 6.5104 16.2476 11.5037 10.9358 18.778C10.5967 19.2403 10.6995 19.8979 11.1618 20.2369Z\" />\n        <path d=\"M64.6499 35.0217L64.7527 35.5046C64.9376 36.4498 65.102 37.4156 65.2459 38.3608C65.3178 38.8746 65.7699 39.2547 66.2733 39.2547C66.3247 39.2547 66.376 39.2547 66.4274 39.2444C66.9925 39.1622 67.3932 38.628 67.311 38.0629C67.1466 36.9224 66.9411 35.7614 66.7048 34.621L66.5404 33.8299H66.5302C63.2115 19.5485 49.0638 10.3838 34.6078 13.2915C29.1213 14.4011 24.1793 17.1135 20.3162 21.1411C16.5455 25.0761 14.0591 29.9873 13.1344 35.3402C13.0317 35.9053 13.4118 36.4498 13.9872 36.5423C14.5523 36.645 15.0968 36.2649 15.1893 35.6895C16.0523 30.7476 18.3435 26.2166 21.8265 22.5795C25.3917 18.8602 29.9535 16.3532 35.0188 15.3258C48.622 12.5825 61.917 21.4185 64.6499 35.0217Z\" />\n        <path d=\"M49.5981 38.0527C49.0844 35.4841 47.5946 33.2751 45.4165 31.8264C43.2383 30.3778 40.6184 29.864 38.0601 30.3778C34.2072 31.1586 31.2071 34.1382 30.4057 37.9808C30.2927 38.5459 30.6523 39.1007 31.2173 39.2137C31.7824 39.337 32.3372 38.9671 32.4503 38.402C33.077 35.3814 35.4504 33.0285 38.471 32.4121C40.4951 32.0011 42.5499 32.4121 44.2658 33.5525C45.8685 34.6211 46.9987 36.2033 47.4713 38.063L47.5535 38.4534C48.17 41.4946 48.4782 44.5872 48.4885 47.6592C48.4885 48.2346 48.9611 48.6969 49.5365 48.6969C50.1118 48.6969 50.5845 48.2243 50.5742 47.6489C50.5742 44.731 50.2968 41.7925 49.7625 38.9055H49.7831L49.6084 38.0321L49.5981 38.0527Z\" />\n        <path d=\"M62.3486 35.0937C61.6705 31.9703 60.3759 29.0935 58.506 26.5249C58.167 26.0626 57.5094 25.9598 57.0471 26.2989C56.5847 26.6379 56.482 27.2955 56.821 27.7578C58.5882 30.1826 59.7903 32.9155 60.3862 35.8848L60.4376 36.1109C62.6363 47.2174 61.6705 58.6527 57.6327 69.1942C57.4272 69.7285 57.6943 70.3347 58.2389 70.5402C58.3622 70.5915 58.4855 70.6121 58.6088 70.6121C59.03 70.6121 59.4204 70.3552 59.5848 69.9442C63.787 58.961 64.7734 47.053 62.4411 35.4738L62.3589 35.0937H62.3486Z\" />\n        <path d=\"M66.7973 42.6659C66.222 42.707 65.7802 43.2001 65.8213 43.7755C66.2631 50.7107 65.5747 57.6253 63.787 64.3344C63.6431 64.8892 63.9719 65.4646 64.5267 65.6084C64.6192 65.629 64.7116 65.6393 64.7938 65.6393C65.2562 65.6393 65.6774 65.331 65.8007 64.8687C67.6501 57.9335 68.359 50.7929 67.907 43.6419C67.8659 43.0666 67.3727 42.6248 66.7973 42.6659Z\" />\n        <path d=\"M70.8043 32.8641H70.794C68.2871 22.0453 60.2526 13.2812 49.6186 9.88044C49.0741 9.70578 48.4782 10.0037 48.3035 10.5585C48.1288 11.1031 48.4268 11.699 48.9816 11.8737C59.1738 15.1409 66.8179 23.6789 68.9344 34.169L69.0577 34.7752C70.4344 41.9055 70.6707 49.1387 69.7871 56.2999C69.7152 56.8752 70.1262 57.389 70.6913 57.4609C70.7324 57.4609 70.7735 57.4609 70.8248 57.4609C71.3488 57.4609 71.7906 57.0705 71.8626 56.5465C72.8078 48.964 72.5098 41.2994 70.9892 33.7477L70.8043 32.8641Z\" />\n        <path d=\"M75.2737 32.8745C75.2634 32.8026 75.2428 32.7409 75.212 32.6793C73.3421 23.6789 68.1844 15.8294 60.6636 10.5483C60.1909 10.2196 59.5437 10.3326 59.2046 10.8052C58.8758 11.2778 58.9888 11.9251 59.4615 12.2642C66.6021 17.278 71.4824 24.7475 73.2085 33.306C73.2188 33.3676 73.2394 33.4293 73.2599 33.4807C73.7325 35.8643 73.938 38.2788 73.8969 40.683C73.8866 41.2583 74.3387 41.7412 74.9243 41.7515H74.9449C75.51 41.7515 75.9826 41.2994 75.9929 40.7241C76.0442 38.1144 75.8079 35.4739 75.2839 32.8847L75.2737 32.8745Z\" />\n        <path d=\"M45.478 39.8404H45.4986L45.3136 38.9157C45.026 37.4875 44.204 36.2649 42.9917 35.4635C41.7793 34.6621 40.3306 34.3744 38.9127 34.6621C35.9743 35.258 34.0735 38.1246 34.6592 41.063L34.8544 42.0494H34.8749C35.6044 46.3235 35.5222 50.6181 34.6181 54.8409C34.4948 55.406 34.8544 55.9608 35.4195 56.0841C35.9846 56.2074 36.5394 55.8478 36.6627 55.2827C37.7004 50.4538 37.7209 45.5221 36.7346 40.6418L36.6421 40.1897C36.5394 38.5458 37.6695 37.0355 39.3237 36.7067C40.197 36.532 41.0909 36.7067 41.8409 37.1999C42.4985 37.6314 42.9711 38.2787 43.1971 39.0184L43.2588 39.3267C45.7246 51.5428 42.7245 64.2008 35.0393 74.0334C34.6797 74.4854 34.7619 75.143 35.214 75.5026C35.4092 75.6464 35.6352 75.7286 35.8613 75.7286C36.1695 75.7286 36.4777 75.5951 36.6832 75.3279C44.5533 65.2591 47.7384 52.3751 45.478 39.8404Z\"/>\n        <path d=\"M54.0264 38.0321H54.0367L53.8723 37.1998C53.0504 33.1415 50.5023 29.6482 46.8857 27.6242C46.3823 27.3468 45.7453 27.5214 45.4679 28.0249C45.1905 28.5283 45.3651 29.1653 45.8686 29.4427C48.8379 31.0969 50.9647 33.9223 51.7455 37.2101L51.8277 37.6005C54.3244 50.0017 52.177 62.8343 45.7864 73.7354C45.4987 74.2285 45.6631 74.8758 46.1563 75.1635C46.3207 75.256 46.5056 75.3073 46.6803 75.3073C47.0399 75.3073 47.3892 75.1224 47.5844 74.7936C54.0983 63.6871 56.3792 50.6592 54.0367 38.0218L54.0264 38.0321Z\" />\n        <path d=\"M58.5368 57.1423C59.6362 50.464 59.554 43.6932 58.28 36.9943L58.1464 36.3265C56.1224 26.309 46.3412 19.8054 36.3237 21.8294C26.3063 23.8535 19.8129 33.6346 21.8266 43.6521L22.0116 44.5665C22.289 46.3645 22.3404 48.1831 22.1452 49.9811C22.0835 50.5565 22.4945 51.0702 23.0698 51.1318C23.6452 51.1935 24.1589 50.7825 24.2206 50.2071C24.4672 47.8954 24.3644 45.5426 23.8918 43.2411L23.7274 42.4295C22.4431 33.8401 28.1248 25.6207 36.7347 23.8843C45.5193 22.1171 54.1086 27.7372 56.0299 36.4498L56.0916 36.758C57.4375 43.4261 57.5608 50.1763 56.4717 56.8135C56.3792 57.3786 56.7594 57.9232 57.3347 58.0156C57.3964 58.0156 57.4478 58.0259 57.5094 58.0259C58.0129 58.0259 58.4546 57.6663 58.5368 57.1526V57.1423Z\" />\n        <path d=\"M49.3309 52.1798C48.7556 52.1181 48.2419 52.5291 48.1699 53.0942C47.3069 60.6561 44.5637 67.992 40.2382 74.3107C39.9094 74.7833 40.0327 75.4409 40.5053 75.7594C40.6902 75.8827 40.8957 75.9443 41.0909 75.9443C41.4197 75.9443 41.7485 75.7902 41.954 75.4922C46.4644 68.8961 49.3309 61.2315 50.2351 53.3305C50.2967 52.7551 49.8858 52.2414 49.3207 52.1695L49.3309 52.1798Z\" />\n        <path d=\"M56.6051 61.4062C56.0503 61.2624 55.475 61.5911 55.3311 62.146C54.4167 65.5776 53.153 68.9373 51.5913 72.1429C51.3344 72.6566 51.5502 73.2833 52.0742 73.5402C52.218 73.6121 52.3721 73.6429 52.5262 73.6429C52.9167 73.6429 53.2865 73.4272 53.4612 73.0573C55.0845 69.7284 56.3894 66.2454 57.3346 62.6802C57.4887 62.1254 57.1497 61.55 56.5949 61.4062H56.6051Z\" />\n        ",
	[M.UNLOCK]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M16.8183 40C15.0108 40 13.5456 41.4652 13.5456 43.2727V66.1818C13.5456 67.9893 15.0108 69.4545 16.8183 69.4545H62.6363C64.4438 69.4545 65.909 67.9893 65.909 66.1818V43.2727C65.909 41.4652 64.4438 40 62.6363 40H16.8183ZM7.00012 43.2727C7.00012 37.8503 11.3959 33.4545 16.8183 33.4545H62.6363C68.0587 33.4545 72.4545 37.8503 72.4545 43.2727V66.1818C72.4545 71.6042 68.0587 76 62.6363 76H16.8183C11.3959 76 7.00012 71.6042 7.00012 66.1818V43.2727Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M39.7273 10.5455C36.2554 10.5455 32.9257 11.9247 30.4707 14.3797C28.0156 16.8347 26.6364 20.1644 26.6364 23.6364V36.7273C26.6364 38.5348 25.1712 40 23.3637 40C21.5562 40 20.091 38.5348 20.091 36.7273V23.6364C20.091 18.4285 22.1598 13.4339 25.8423 9.75136C29.5249 6.06883 34.5194 4 39.7273 4C44.9352 4 49.9297 6.06883 53.6123 9.75136C54.8903 11.0294 54.8903 13.1016 53.6123 14.3797C52.3342 15.6578 50.262 15.6578 48.9839 14.3797C46.5289 11.9247 43.1992 10.5455 39.7273 10.5455Z\" />\n        ",
	[M.USER_COG]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M30.5468 13.6367C25.0488 13.6367 20.5917 18.0937 20.5917 23.5918C20.5917 29.0898 25.0488 33.5468 30.5468 33.5468C36.0448 33.5468 40.5019 29.0898 40.5019 23.5918C40.5019 18.0937 36.0448 13.6367 30.5468 13.6367ZM13.955 23.5918C13.955 14.4284 21.3834 7 30.5468 7C39.7102 7 47.1385 14.4284 47.1385 23.5918C47.1385 32.7551 39.7102 40.1835 30.5468 40.1835C21.3834 40.1835 13.955 32.7551 13.955 23.5918ZM66.1089 34.7022C67.8476 35.2818 68.7872 37.161 68.2076 38.8996L68.0758 39.2952C69.133 40.0432 70.076 40.9419 70.8735 41.96L71.4484 41.73C73.15 41.0494 75.0811 41.877 75.7618 43.5786C76.4424 45.2802 75.6148 47.2114 73.9132 47.8921L73.5278 48.0462C73.6358 48.7278 73.6918 49.4266 73.6918 50.1386C73.6918 50.6333 73.6648 51.1217 73.612 51.6024L73.7288 51.6414C75.4674 52.2209 76.4071 54.1001 75.8275 55.8388C75.248 57.5774 73.3688 58.517 71.6301 57.9375L71.251 57.8111C70.496 58.8751 69.5881 59.8231 68.5595 60.623L68.7932 61.2074C69.4739 62.909 68.6462 64.8402 66.9446 65.5208C65.243 66.2014 63.3119 65.3738 62.6312 63.6722L62.4644 63.2552C61.7975 63.3584 61.1142 63.4119 60.4184 63.4119C59.9196 63.4119 59.4272 63.3844 58.9427 63.3308L58.9098 63.4295C58.3302 65.1681 56.451 66.1078 54.7124 65.5282C52.9737 64.9487 52.0341 63.0694 52.6137 61.3308L52.7359 60.964C51.6875 60.2186 50.7521 59.3248 49.9602 58.3132L49.3626 58.5523C47.661 59.2329 45.7298 58.4052 45.0492 56.7036C44.3685 55.002 45.1962 53.0709 46.8978 52.3902L47.3082 52.226C47.2008 51.546 47.145 50.8488 47.145 50.1386C47.145 49.6545 47.1709 49.1766 47.2214 48.706L47.0808 48.6591C45.3422 48.0795 44.4026 46.2003 44.9821 44.4617C45.5616 42.723 47.4409 41.7834 49.1795 42.3629L49.5674 42.4922C50.3224 41.4227 51.2316 40.4697 52.2626 39.6657L52.0293 39.0827C51.3487 37.3811 52.1764 35.4499 53.878 34.7693C55.5796 34.0886 57.5107 34.9163 58.1914 36.6179L58.3541 37.0247C59.0268 36.9197 59.7163 36.8652 60.4184 36.8652C60.907 36.8652 61.3893 36.8915 61.8642 36.943L61.9115 36.8009C62.491 35.0623 64.3703 34.1227 66.1089 34.7022ZM57.0215 44.4359C57.2394 44.3967 57.4566 44.3351 57.6701 44.2497C57.9643 44.132 58.2323 43.9769 58.471 43.7922C59.0868 43.6034 59.7408 43.5018 60.4184 43.5018C62.8204 43.5018 64.9244 44.7779 66.0894 46.6891C66.1281 46.918 66.1917 47.1464 66.2814 47.3708C66.4059 47.6821 66.5723 47.9642 66.7715 48.2131C66.956 48.8225 67.0551 49.469 67.0551 50.1386C67.0551 52.573 65.7444 54.7012 63.7902 55.8561C63.576 55.8954 63.3625 55.9564 63.1525 56.0404C62.8659 56.155 62.6042 56.3051 62.3702 56.4836C61.7531 56.6732 61.0977 56.7752 60.4184 56.7752C59.604 56.7752 58.8237 56.6285 58.1028 56.3601C58.0224 56.3246 57.94 56.2919 57.8557 56.2624C56.5363 55.7096 55.4332 54.7427 54.7091 53.5243C54.6698 53.3185 54.6103 53.1134 54.5295 52.9115C54.4146 52.6241 54.264 52.3617 54.0848 52.1273C53.8879 51.4994 53.7817 50.8314 53.7817 50.1386C53.7817 47.7146 55.0812 45.5942 57.0215 44.4359ZM8.85961 51.6798C11.9712 48.5683 16.1913 46.8202 20.5918 46.8202H33.8652C35.6978 46.8202 37.1835 48.3059 37.1835 50.1386C37.1835 51.9712 35.6978 53.4569 33.8652 53.4569H20.5918C17.9515 53.4569 15.4194 54.5057 13.5525 56.3727C11.6855 58.2396 10.6367 60.7717 10.6367 63.412V70.0486C10.6367 71.8813 9.15102 73.367 7.31835 73.367C5.48568 73.367 4 71.8813 4 70.0486V63.412C4 59.0115 5.74805 54.7914 8.85961 51.6798Z\"/>",
	[M.USER_EXTERNAL]: "<path d=\"M50.2673 36.7224C50.2673 31.3008 45.872 26.9058 40.4505 26.9056C35.0288 26.9056 30.6336 31.3007 30.6336 36.7224C30.6336 41.9748 34.7582 46.264 39.9452 46.5268L40.4505 46.5392L40.9557 46.5268C46.1424 46.2637 50.2673 41.9746 50.2673 36.7224ZM40.4543 53.0841C37.115 53.0832 33.8551 54.1035 31.113 56.009C28.9621 57.5037 27.2125 59.488 25.9956 61.7841C29.8623 65.0349 34.8446 67.4979 40.438 69.4295C40.4622 69.4379 40.4868 69.4464 40.5109 69.4554C46.0825 67.5111 51.0492 65.0429 54.9073 61.7917C53.6915 59.4952 51.9436 57.5105 49.7937 56.0148C47.0525 54.1077 43.7936 53.085 40.4543 53.0841ZM56.8112 36.7224C56.8112 41.6994 54.5885 46.1566 51.0822 49.1574C51.9254 49.5993 52.7441 50.0945 53.5316 50.6424C55.9013 52.2911 57.9239 54.3636 59.5079 56.7395C61.9197 53.1682 63.3561 48.7868 63.3561 43.2682V20.3626C55.7647 20.3626 46.8944 15.9867 40.8071 10.6733C40.7072 10.5898 40.5808 10.544 40.4505 10.5439C40.3181 10.5439 40.1897 10.5913 40.089 10.6772C34.0375 15.9537 25.1362 20.3626 17.5439 20.3626V43.2682C17.5439 48.787 18.9793 53.1687 21.392 56.7376C22.9783 54.3587 25.0052 52.2842 27.3789 50.6347C28.1632 50.0897 28.9783 49.5974 29.8178 49.1574C26.3115 46.1566 24.0888 41.6993 24.0888 36.7224C24.0888 27.6863 31.4143 20.3607 40.4505 20.3607C49.4864 20.3609 56.8112 27.6864 56.8112 36.7224ZM69.9009 43.2682C69.9009 52.3132 66.6959 59.2651 61.5432 64.5518C61.4408 64.6568 61.3364 64.7597 61.2326 64.8633C61.2013 64.8965 61.1695 64.9292 61.1367 64.9611C56.1187 69.9287 49.4937 73.2567 42.6401 75.6455C42.6313 75.6486 42.6221 75.6512 42.6132 75.6542C41.2123 76.1289 39.6928 76.114 38.3021 75.6149C31.2428 73.1771 24.4322 69.7421 19.3625 64.5498C14.2038 59.2663 11 52.3129 11 43.2682V20.3626C11 18.627 11.6892 16.9624 12.9164 15.7351C14.1437 14.5079 15.8083 13.8179 17.5439 13.8178C23.0295 13.8178 30.4751 10.3864 35.8105 5.72561L35.8373 5.70165C37.1231 4.60313 38.7593 4 40.4505 4C42.0356 4.00007 43.572 4.53007 44.8172 5.50128L45.0626 5.70165L45.0904 5.72657C50.4554 10.4171 57.8681 13.8178 63.3561 13.8178C65.0918 13.8178 66.7562 14.5078 67.9836 15.7351C69.2109 16.9625 69.9009 18.627 69.9009 20.3626V43.2682Z\"/>",
	[M.USER_NONE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M30.1815 13.5454C24.7591 13.5454 20.3634 17.9411 20.3634 23.3634C20.3634 28.7858 24.7591 33.1815 30.1815 33.1815C35.6038 33.1815 39.9995 28.7858 39.9995 23.3634C39.9995 17.9411 35.6038 13.5454 30.1815 13.5454ZM13.8181 23.3634C13.8181 14.3262 21.1442 7 30.1815 7C39.2188 7 46.5449 14.3262 46.5449 23.3634C46.5449 32.4007 39.2188 39.7269 30.1815 39.7269C21.1442 39.7269 13.8181 32.4007 13.8181 23.3634ZM54.0497 24.322C55.3278 23.0439 57.4 23.0439 58.678 24.322L64.5456 30.1896L70.4132 24.322C71.6912 23.0439 73.7634 23.0439 75.0414 24.322C76.3195 25.6 76.3195 27.6722 75.0414 28.9503L69.1739 34.8178L75.0414 40.6854C76.3195 41.9635 76.3195 44.0356 75.0414 45.3137C73.7634 46.5917 71.6912 46.5917 70.4132 45.3137L64.5456 39.4461L58.678 45.3137C57.4 46.5917 55.3278 46.5917 54.0497 45.3137C52.7717 44.0356 52.7717 41.9635 54.0497 40.6854L59.9173 34.8178L54.0497 28.9503C52.7717 27.6722 52.7717 25.6 54.0497 24.322ZM8.79274 51.065C11.8615 47.9962 16.0236 46.2722 20.3634 46.2722H39.9995C44.3394 46.2722 48.5015 47.9962 51.5702 51.065C54.639 54.1337 56.363 58.2958 56.363 62.6357V69.181C56.363 70.9885 54.8977 72.4537 53.0903 72.4537C51.2828 72.4537 49.8176 70.9885 49.8176 69.181V62.6357C49.8176 60.0317 48.7832 57.5345 46.942 55.6932C45.1007 53.852 42.6035 52.8176 39.9995 52.8176H20.3634C17.7595 52.8176 15.2623 53.852 13.421 55.6932C11.5798 57.5345 10.5454 60.0317 10.5454 62.6357V69.181C10.5454 70.9885 9.08014 72.4537 7.27269 72.4537C5.46523 72.4537 4 70.9885 4 69.181V62.6357C4 58.2958 5.724 54.1337 8.79274 51.065Z\"/>",
	[M.USER_PASSKEY]: "<path d=\"M44.2613 21.3911C44.2611 15.6281 39.5892 10.956 33.8262 10.956C28.0633 10.9562 23.3913 15.6283 23.3911 21.3911C23.3911 27.1541 28.0632 31.826 33.8262 31.8262C39.5893 31.8262 44.2613 27.1543 44.2613 21.3911ZM51.2183 21.3911C51.2183 30.9963 43.4314 38.7833 33.8262 38.7833C24.2211 38.7831 16.4351 30.9962 16.4351 21.3911C16.4353 11.7862 24.2212 4.00018 33.8262 4C43.4313 4 51.2181 11.786 51.2183 21.3911Z\" fill=\"black\"/>\n      <path d=\"M63.8011 48.2146C62.3182 48.0471 60.8219 48.3875 59.5577 49.1806C58.2935 49.9738 57.3364 51.173 56.842 52.5812C56.3475 53.9894 56.3459 55.5241 56.8369 56.9336C57.1438 57.8154 56.9193 58.7954 56.2591 59.4557L46.7962 68.9186C46.7319 68.9828 46.6953 69.0703 46.6953 69.1612V71.13H48.769V70.7876C48.7691 69.7736 49.172 68.801 49.889 68.084C50.6059 67.367 51.5786 66.9642 52.5925 66.9641H52.9349V66.6217C52.9349 65.6078 53.338 64.6352 54.0549 63.9181L54.1924 63.7877C54.8939 63.1524 55.8086 62.7982 56.7594 62.7982H56.9969C57.0877 62.7982 57.1752 62.7616 57.2394 62.6973L58.3705 61.5672L58.4979 61.448C59.153 60.8805 60.066 60.7014 60.8927 60.9894C62.3021 61.4804 63.8368 61.4787 65.2451 60.9843C66.6532 60.4899 67.8515 59.5317 68.6446 58.2675C69.4377 57.0032 69.7783 55.5072 69.6107 54.0242C69.443 52.5413 68.7775 51.1591 67.7224 50.1039C66.667 49.0485 65.2841 48.3822 63.8011 48.2146ZM57.805 68.0106C57.8049 69.0246 57.402 69.9972 56.685 70.7142C55.968 71.4311 54.9955 71.8341 53.9815 71.8341H53.6391V72.1765C53.6391 73.1906 53.2362 74.163 52.5192 74.8801C51.8021 75.5971 50.8296 76 49.8156 76H45.6497C44.6357 76 43.6632 75.597 42.9462 74.8801C42.2291 74.163 41.8263 73.1906 41.8263 72.1765V69.1601L41.8324 68.9013C41.8965 67.6131 42.4363 66.3904 43.3528 65.4742L51.8221 57.0049C51.4225 55.0002 51.5635 52.9149 52.2471 50.968C53.1067 48.5195 54.7721 46.4347 56.9704 45.0555C59.1686 43.6765 61.7698 43.0847 64.3483 43.3761C66.927 43.6676 69.3307 44.8255 71.1657 46.6605C73.0007 48.4955 74.1587 50.8994 74.4501 53.478C74.7415 56.0565 74.1488 58.6577 72.7697 60.8559C71.3906 63.054 69.3066 64.7195 66.8582 65.5792C64.911 66.2628 62.8254 66.4019 60.8203 66.0021L60.6838 66.1407C59.8988 66.9259 58.8883 67.433 57.805 67.603V68.0106Z\" fill=\"black\"/>\n      <path d=\"M6 70.0885V63.1314C6.00009 58.519 7.8317 54.095 11.0932 50.8335C14.3547 47.572 18.7786 45.7404 23.3911 45.7403H45.3048C47.2258 45.7403 48.7838 47.2973 48.7838 49.2183C48.7838 51.1394 47.2258 52.6964 45.3048 52.6964H23.3911C20.6237 52.6964 17.9701 53.7966 16.0132 55.7535C14.0563 57.7104 12.9561 60.364 12.956 63.1314V70.0885C12.956 72.0095 11.3991 73.5665 9.47802 73.5665C7.55697 73.5665 6 72.0095 6 70.0885Z\"/>",
	[M.USER_PLUS]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M30.1818 13.5455C24.7594 13.5455 20.3636 17.9412 20.3636 23.3636C20.3636 28.7861 24.7594 33.1818 30.1818 33.1818C35.6042 33.1818 40 28.7861 40 23.3636C40 17.9412 35.6043 13.5455 30.1818 13.5455ZM13.8182 23.3636C13.8182 14.3262 21.1444 7 30.1818 7C39.2192 7 46.5455 14.3262 46.5455 23.3636C46.5455 32.401 39.2192 39.7273 30.1818 39.7273C21.1444 39.7273 13.8182 32.401 13.8182 23.3636ZM62.9091 23.3636C64.7166 23.3636 66.1818 24.8289 66.1818 26.6364V33.1818H72.7273C74.5347 33.1818 76 34.6471 76 36.4545C76 38.262 74.5347 39.7273 72.7273 39.7273H66.1818V46.2727C66.1818 48.0802 64.7166 49.5455 62.9091 49.5455C61.1016 49.5455 59.6364 48.0802 59.6364 46.2727V39.7273H53.0909C51.2834 39.7273 49.8182 38.262 49.8182 36.4545C49.8182 34.6471 51.2834 33.1818 53.0909 33.1818H59.6364V26.6364C59.6364 24.8289 61.1016 23.3636 62.9091 23.3636ZM8.7928 51.0655C11.8616 47.9968 16.0237 46.2727 20.3636 46.2727H40C44.3399 46.2727 48.5021 47.9968 51.5708 51.0655C54.6396 54.1343 56.3636 58.2965 56.3636 62.6364V69.1818C56.3636 70.9893 54.8984 72.4545 53.0909 72.4545C51.2834 72.4545 49.8182 70.9893 49.8182 69.1818V62.6364C49.8182 60.0324 48.7838 57.5351 46.9425 55.6939C45.1012 53.8526 42.6039 52.8182 40 52.8182H20.3636C17.7597 52.8182 15.2624 53.8526 13.4211 55.6939C11.5799 57.5351 10.5455 60.0324 10.5455 62.6364V69.1818C10.5455 70.9893 9.0802 72.4545 7.27273 72.4545C5.46525 72.4545 4 70.9893 4 69.1818V62.6364C4 58.2965 5.72402 54.1343 8.7928 51.0655Z\" />",
	[M.USER_SEARCH]: "<path d=\"M67.1458 58.86C67.1458 55.0738 64.0772 52.007 60.2913 52.0055C56.5042 52.0055 53.4288 55.0729 53.4288 58.86C53.4288 62.6471 56.5042 65.7145 60.2913 65.7145C61.9406 65.7139 63.4479 65.1264 64.6306 64.1556C64.7537 63.9713 64.9018 63.7959 65.0645 63.6333C65.227 63.4711 65.4029 63.3302 65.5868 63.2074C66.5591 62.0238 67.1458 60.5113 67.1458 58.86ZM46.5743 24.5715C46.5728 16.9985 40.4306 10.8625 32.8573 10.8625C25.2852 10.864 19.1497 16.9994 19.1483 24.5715C19.1483 32.1448 25.2843 38.2871 32.8573 38.2885C40.4315 38.2885 46.5743 32.1457 46.5743 24.5715ZM74.0003 58.86C74.0003 61.4015 73.2926 63.7702 72.0878 65.8109L76.4271 70.1502C77.7648 71.4885 77.7637 73.6568 76.4271 74.9958C75.0881 76.3347 72.9124 76.3347 71.5735 74.9958L67.2422 70.6645C65.2023 71.8688 62.8316 72.5766 60.2913 72.577C52.7171 72.577 46.5743 66.4342 46.5743 58.86C46.5743 51.2858 52.7171 45.143 60.2913 45.143C67.8643 45.1445 74.0003 51.2867 74.0003 58.86ZM53.4288 24.5715C53.4288 31.6841 49.8196 37.953 44.3323 41.6475C44.6568 42.3857 44.7335 43.2377 44.4689 44.0662C43.8917 45.8683 41.9646 46.8599 40.1617 46.2841C36.564 45.1352 32.7442 44.8517 29.0162 45.4564C25.289 46.0611 21.7559 47.537 18.7063 49.7636C15.656 51.9912 13.1769 54.914 11.4661 58.2814C9.75579 61.6483 8.86305 65.3694 8.86252 69.1458C8.86235 71.0392 7.32467 72.577 5.43126 72.577C3.53771 72.5769 1.99983 71.0393 2 69.1458C2.00053 64.2896 3.15139 59.5011 5.35091 55.1716C7.55047 50.8427 10.743 47.0907 14.6643 44.2269C16.46 42.9159 18.3895 41.8154 20.4099 40.9242C15.4819 37.166 12.2858 31.2475 12.2858 24.5715C12.2872 13.2123 21.4981 4.00145 32.8573 4C44.2177 4 53.4273 13.2114 53.4288 24.5715Z\" />",
	[M.USERS]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M30.1821 13.5455C24.7596 13.5455 20.3639 17.9412 20.3639 23.3637C20.3639 28.7861 24.7596 33.1819 30.1821 33.1819C35.6045 33.1819 40.0002 28.7861 40.0002 23.3637C40.0002 17.9412 35.6045 13.5455 30.1821 13.5455ZM13.8184 23.3637C13.8184 14.3263 21.1447 7 30.1821 7C39.2194 7 46.5457 14.3263 46.5457 23.3637C46.5457 32.4011 39.2194 39.7274 30.1821 39.7274C21.1447 39.7274 13.8184 32.4011 13.8184 23.3637ZM49.9207 9.88642C50.369 8.13543 52.1519 7.0794 53.9029 7.52773C57.4228 8.42896 60.5426 10.4761 62.7705 13.3463C64.9984 16.2165 66.2077 19.7466 66.2077 23.38C66.2077 27.0135 64.9984 30.5436 62.7705 33.4138C60.5426 36.284 57.4228 38.3311 53.9029 39.2324C52.1519 39.6807 50.369 38.6247 49.9207 36.8737C49.4724 35.1227 50.5284 33.3398 52.2794 32.8914C54.3913 32.3507 56.2632 31.1224 57.6 29.4003C58.9367 27.6782 59.6623 25.5601 59.6623 23.38C59.6623 21.2 58.9367 19.0819 57.6 17.3598C56.2632 15.6377 54.3913 14.4094 52.2794 13.8687C50.5284 13.4203 49.4724 11.6374 49.9207 9.88642ZM8.79304 51.0656C11.8618 47.9969 16.024 46.2728 20.3639 46.2728H40.0002C44.3402 46.2728 48.5023 47.9969 51.5711 51.0656C54.6399 54.1344 56.3639 58.2966 56.3639 62.6365V69.182C56.3639 70.9895 54.8986 72.4547 53.0912 72.4547C51.2837 72.4547 49.8184 70.9895 49.8184 69.182V62.6365C49.8184 60.0326 48.784 57.5353 46.9427 55.694C45.1015 53.8527 42.6042 52.8183 40.0002 52.8183H20.3639C17.7599 52.8183 15.2626 53.8527 13.4214 55.694C11.5801 57.5353 10.5457 60.0326 10.5457 62.6365V69.182C10.5457 70.9895 9.08045 72.4547 7.27297 72.4547C5.46549 72.4547 4.00024 70.9895 4.00024 69.182V62.6365C4.00024 58.2966 5.72427 54.1344 8.79304 51.0656ZM59.7405 49.1528C60.1924 47.4028 61.9774 46.3503 63.7275 46.8022C67.238 47.7086 70.3481 49.7553 72.5695 52.6208C74.7908 55.4863 75.9975 59.0084 76.0002 62.6341V69.182C76.0002 70.9895 74.535 72.4547 72.7275 72.4547C70.92 72.4547 69.4548 70.9895 69.4548 69.182V62.639C69.4532 60.4635 68.7291 58.3503 67.3963 56.631C66.0635 54.9117 64.1975 53.6837 62.0911 53.1398C60.3411 52.688 59.2887 50.9029 59.7405 49.1528Z\"/>",
	[M.VIDEO]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M14.8648 11.7143C13.1251 11.7143 11.7148 13.1246 11.7148 14.8643V65.1357C11.7148 66.8754 13.1251 68.2857 14.8648 68.2857H65.1362C66.8759 68.2857 68.2862 66.8754 68.2862 65.1357V14.8643C68.2862 13.1246 66.8759 11.7143 65.1362 11.7143H14.8648ZM4.00051 14.8643C4.00051 8.86411 8.86462 4 14.8648 4H65.1362C71.1364 4 76.0005 8.86411 76.0005 14.8643V65.1357C76.0005 71.1359 71.1364 76 65.1362 76H14.8648C8.86462 76 4.00051 71.1359 4.00051 65.1357V14.8643Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M23.9272 4C26.0574 4 27.7843 5.7269 27.7843 7.85714V72.1429C27.7843 74.2731 26.0574 76 23.9272 76C21.797 76 20.0701 74.2731 20.0701 72.1429V7.85714C20.0701 5.7269 21.797 4 23.9272 4Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M56.0732 4C58.2034 4 59.9303 5.7269 59.9303 7.85714V72.1429C59.9303 74.2731 58.2034 76 56.0732 76C53.9429 76 52.216 74.2731 52.216 72.1429V7.85714C52.216 5.7269 53.9429 4 56.0732 4Z\"/>\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4.0002 40.0031C4.0002 37.8729 5.7271 36.146 7.85734 36.146H72.143C74.2733 36.146 76.0002 37.8729 76.0002 40.0031C76.0002 42.1334 74.2733 43.8603 72.143 43.8603H7.85734C5.7271 43.8603 4.0002 42.1334 4.0002 40.0031Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4.00051 23.9336C4.00051 21.8034 5.72741 20.0765 7.85765 20.0765H23.9291C26.0593 20.0765 27.7862 21.8034 27.7862 23.9336C27.7862 26.0638 26.0593 27.7907 23.9291 27.7907H7.85765C5.72741 27.7907 4.00051 26.0638 4.00051 23.9336Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4.00051 56.0727C4.00051 53.9424 5.72741 52.2155 7.85765 52.2155H23.9291C26.0593 52.2155 27.7862 53.9424 27.7862 56.0727C27.7862 58.2029 26.0593 59.9298 23.9291 59.9298H7.85765C5.72741 59.9298 4.00051 58.2029 4.00051 56.0727Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M52.216 56.0727C52.216 53.9424 53.9429 52.2155 56.0732 52.2155H72.1446C74.2749 52.2155 76.0018 53.9424 76.0018 56.0727C76.0018 58.2029 74.2749 59.9298 72.1446 59.9298H56.0732C53.9429 59.9298 52.216 58.2029 52.216 56.0727Z\" />\n        <path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M52.216 23.9336C52.216 21.8034 53.9429 20.0765 56.0732 20.0765H72.1446C74.2749 20.0765 76.0018 21.8034 76.0018 23.9336C76.0018 26.0638 74.2749 27.7907 72.1446 27.7907H56.0732C53.9429 27.7907 52.216 26.0638 52.216 23.9336Z\" />\n        ",
	[M.WARNING]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M34.6586 8.35983C36.187 7.46923 37.9243 7 39.6932 7C41.4622 7 43.1995 7.46923 44.7278 8.35983C46.2546 9.24949 47.5184 10.5278 48.3905 12.0646C48.3914 12.0662 48.3923 12.0679 48.3932 12.0695L75.0466 58.713C75.048 58.7154 75.0494 58.7177 75.0507 58.7201C75.9253 60.2378 76.3859 61.9587 76.3864 63.7104C76.3868 65.4649 75.9257 67.1887 75.0492 68.7085C74.1727 70.2284 72.9118 71.491 71.3931 72.3694C69.8743 73.2478 68.1511 73.7112 66.3966 73.713H13.0736C11.3162 73.7259 9.58637 73.2755 8.05836 72.407C6.52563 71.5358 5.25046 70.2748 4.36212 68.752C3.47378 67.2291 3.00384 65.4984 2.99993 63.7354C2.99604 61.9751 3.45684 60.2451 4.33572 58.7201C4.33711 58.7177 4.3385 58.7153 4.33989 58.7129L30.9932 12.0695C30.9943 12.0675 30.9954 12.0656 30.9965 12.0636C31.8686 10.5273 33.1321 9.24929 34.6586 8.35983ZM39.6932 13.6667C39.1036 13.6667 38.5245 13.8231 38.015 14.1199C37.5056 14.4168 37.084 14.8435 36.7932 15.3565L36.7874 15.3668L10.1207 62.0335L10.1132 62.0465C9.81937 62.5554 9.66528 63.133 9.66658 63.7206C9.66788 64.3083 9.82453 64.8852 10.1206 65.3928C10.4168 65.9004 10.8418 66.3208 11.3527 66.6112C11.8636 66.9016 12.4423 67.0517 13.0299 67.0465L13.0599 67.0463H66.3898C66.9746 67.0457 67.549 66.8913 68.0553 66.5985C68.5615 66.3057 68.9818 65.8848 69.274 65.3782C69.5662 64.8715 69.7199 64.297 69.7197 63.7121C69.7196 63.1273 69.5656 62.5528 69.2731 62.0463L69.2658 62.0335L42.5991 15.3668L42.5932 15.3565C42.3025 14.8435 41.8809 14.4168 41.3714 14.1199C40.862 13.8231 40.2829 13.6667 39.6932 13.6667ZM39.7266 27.0463C41.5675 27.0463 43.0599 28.5387 43.0599 30.3797V43.713C43.0599 45.5539 41.5675 47.0463 39.7266 47.0463C37.8856 47.0463 36.3932 45.5539 36.3932 43.713V30.3797C36.3932 28.5387 37.8856 27.0463 39.7266 27.0463ZM36.3932 57.0463C36.3932 55.2054 37.8856 53.713 39.7266 53.713H39.7599C41.6008 53.713 43.0932 55.2054 43.0932 57.0463C43.0932 58.8873 41.6008 60.3797 39.7599 60.3797H39.7266C37.8856 60.3797 36.3932 58.8873 36.3932 57.0463Z\" />",
	[M.WARNING_BADGE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M40.0961 10.6716C34.0444 15.9508 25.1395 20.3626 17.5445 20.3626V43.2682C17.5445 50.5847 20.0667 55.9024 24.0456 59.9775C28.1135 64.1438 33.8524 67.1547 40.4383 69.4289L40.5122 69.4555C47.0734 67.1658 52.7963 64.1495 56.8566 59.9836C60.8335 55.9035 63.3557 50.5845 63.3557 43.2682V20.3626C55.7632 20.3626 46.8911 15.9858 40.8037 10.6714C40.7042 10.5894 40.5792 10.5445 40.4501 10.5445C40.3208 10.5445 40.1956 10.5895 40.0961 10.6716ZM35.8376 5.70205C37.1234 4.60355 38.759 4 40.4501 4C42.1412 4 43.7768 4.60355 45.0625 5.70205L45.0909 5.72629L45.0907 5.72645C50.4556 10.4169 57.8678 13.8182 63.3557 13.8182C65.0914 13.8182 66.756 14.5077 67.9833 15.735C69.2106 16.9623 69.9001 18.6269 69.9001 20.3626V43.2682C69.9001 52.313 66.6959 59.265 61.5432 64.5515C56.4796 69.7468 49.6798 73.1907 42.6396 75.6446L42.6128 75.6539L42.6128 75.6538C41.2017 76.132 39.6701 76.1142 38.2711 75.6042C31.2229 73.1671 24.4253 69.7342 19.363 64.5495C14.2042 59.266 11 52.3129 11 43.2682V20.3626C11 18.6269 11.6895 16.9623 12.9168 15.735C14.1442 14.5077 15.8088 13.8182 17.5445 13.8182C23.03 13.8182 30.475 10.3863 35.8104 5.72557L35.8375 5.7019L35.8376 5.70205ZM40.4501 23.6348C42.2573 23.6348 43.7223 25.0999 43.7223 26.9071V39.996C43.7223 41.8032 42.2573 43.2682 40.4501 43.2682C38.6429 43.2682 37.1778 41.8032 37.1778 39.996V26.9071C37.1778 25.0999 38.6429 23.6348 40.4501 23.6348ZM37.1778 53.0849C37.1778 51.2777 38.6429 49.8127 40.4501 49.8127H40.4828C42.29 49.8127 43.755 51.2777 43.755 53.0849C43.755 54.8921 42.29 56.3571 40.4828 56.3571H40.4501C38.6429 56.3571 37.1778 54.8921 37.1778 53.0849Z\" />",
	[M.WEBPAGE]: "<path fillRule=\"evenodd\" clipRule=\"evenodd\" d=\"M4 16.55C4 11.828 7.82796 8 12.55 8H67.45C72.172 8 76 11.828 76 16.55V63.35C76 68.072 72.172 71.9 67.45 71.9H12.55C7.82797 71.9 4 68.072 4 63.35V16.55ZM12.55 14.3C11.3074 14.3 10.3 15.3074 10.3 16.55V26.1029H69.7V16.55C69.7 15.3074 68.6926 14.3 67.45 14.3H12.55ZM69.7 32.4029H30.707V65.6H67.45C68.6926 65.6 69.7 64.5926 69.7 63.35V32.4029ZM24.407 65.6V32.4029H10.3V63.35C10.3 64.5926 11.3074 65.6 12.55 65.6H24.407Z\" />"
}, R = ({ iconName: e, className: t = "", color: n = "black", sizeInPx: r = "24" }) => {
	let i = re(e), a = ie(i?.paths || i);
	return /* @__PURE__ */ p("div", {
		"data-testid": "thrive-icon",
		className: `thrive-icon ${t ?? ""}`,
		children: /* @__PURE__ */ p("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fillRule: "evenodd",
			viewBox: "0 0 80 80",
			width: `${r}px`,
			height: `${r}px`,
			"aria-hidden": !0,
			children: a.map((e, t) => /* @__PURE__ */ p("path", {
				d: e,
				fill: n
			}, t))
		})
	});
}, z = ({ ariaLabel: e, className: t, isDisabled: n = !1, onButtonClick: r, iconName: i, parentRef: a }) => /* @__PURE__ */ p("button", {
	className: `icon-button ${t ?? ""}`,
	disabled: n,
	"aria-label": e,
	onClick: r,
	type: "button",
	ref: a,
	children: /* @__PURE__ */ p(R, {
		iconName: i,
		sizeInPx: "12",
		color: "var(--thriveCharcoal)"
	})
}), le = ({ conditions: e, onAddConditionalValueClick: t }) => /* @__PURE__ */ m("div", {
	className: "toggle-item",
	children: [e.map((e, t) => /* @__PURE__ */ m("div", {
		className: `${t !== 0 && "toggle-wrapper"}`,
		children: [t === 0 && /* @__PURE__ */ p("h2", {
			className: "toggle-label",
			children: e.label || " "
		}), /* @__PURE__ */ m("span", {
			className: "toggle-option",
			children: [t !== 0 && /* @__PURE__ */ p(z, {
				className: "cancel-option-button",
				ariaLabel: "",
				onButtonClick: () => e.removeOption?.(),
				iconName: M.CIRCLE_CLOSE
			}), /* @__PURE__ */ p(L, {
				selectedItem: e.selectedItem,
				defaultTitle: e.defaultTitle || "",
				ariaLabel: e.ariaLabel,
				buttonList: e.buttonList
			})]
		})]
	}, `${t}-${e.id}`)), /* @__PURE__ */ p(F, {
		className: "add-toggle-button",
		content: /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p("span", {
			className: "add-icon",
			children: "+"
		}), "or"] }),
		ariaLabel: "add an additional OR condition",
		onButtonClick: () => t?.()
	})]
}), ue = ({ id: e, className: t, labelText: n, labelIsHidden: r, placeholderText: i, textString: a, setTextString: o, maxLength: s, isDisabled: c, isReadOnly: l }) => /* @__PURE__ */ m("div", {
	className: `basic-text-input-wrapper ${t ?? ""} `,
	children: [/* @__PURE__ */ p("label", {
		htmlFor: "basic-text-input",
		className: `${r ? "sr-only" : ""} basic-text-input-label`,
		children: n
	}), /* @__PURE__ */ p("input", {
		type: "text",
		id: `basic-text-input-${e || ""}`,
		className: "basic-text-input",
		placeholder: i,
		defaultValue: a,
		onBlur: (e) => o(e.target.value),
		"aria-label": "Add your Text",
		maxLength: s,
		disabled: c,
		readOnly: l
	}, e ? `basic-text-input-${e}` : "")]
}), B = ({ id: e, className: t, labelText: n, labelIsHidden: r, placeholderText: i, textString: a, setTextString: o, maxLength: s, isDisabled: c, isReadOnly: l, type: u = "text", autofocus: d = !1, onReturnPressed: f, inputMode: h = "text", onBlur: g }) => /* @__PURE__ */ m("div", {
	className: `basic-text-input-wrapper ${t ?? ""} `,
	children: [/* @__PURE__ */ p("label", {
		htmlFor: `basic-text-input-${e || ""}`,
		className: `${r ? "sr-only" : ""} basic-text-input-label`,
		children: n
	}), /* @__PURE__ */ p("input", {
		type: u,
		id: `basic-text-input-${e || ""}`,
		className: "basic-text-input",
		placeholder: i,
		value: a,
		onChange: (e) => o(e.target.value),
		maxLength: s,
		disabled: c,
		readOnly: l,
		autoFocus: d,
		inputMode: h,
		onBlur: g,
		onKeyDown: (e) => {
			e.code === "Enter" && f?.();
		},
		"aria-label": r ? n ?? "Add your text" : ""
	}, e ? `basic-text-input-${e}` : "")]
}), de = ({ conditions: e }) => /* @__PURE__ */ p("div", {
	className: "toggle-item",
	children: e.map((e, t) => /* @__PURE__ */ m("div", {
		className: `${t !== 0 && "toggle-wrapper"}`,
		children: [e.label && t === 0 && /* @__PURE__ */ p("h2", {
			className: "toggle-label",
			children: e.label
		}), /* @__PURE__ */ m("span", {
			className: "toggle-option",
			children: [e.label && t !== 0 && /* @__PURE__ */ p(z, {
				className: "cancel-option-button",
				ariaLabel: "",
				iconName: M.CIRCLE_CLOSE,
				onButtonClick: () => e.removeOption?.()
			}), e.updateOnBlur ? /* @__PURE__ */ p(ue, {
				id: e.id,
				labelText: e.ariaLabel,
				placeholderText: e.placeholderText ?? "Value",
				textString: e.text,
				setTextString: e.setTextInput,
				labelIsHidden: !0
			}, `${e.id}-input`) : /* @__PURE__ */ p(B, {
				id: e.id,
				labelText: e.ariaLabel,
				placeholderText: e.placeholderText ?? "Value",
				textString: e.text,
				setTextString: e.setTextInput,
				labelIsHidden: !0
			}, `${e.id}-input`)]
		})]
	}, `${e.id}-wrapper`))
}), fe = ({ textConditions: e, toggleConditions: t, onAddConditionalValueClick: n }) => {
	if (!e && !t) return /* @__PURE__ */ p(f, {});
	if (t) return /* @__PURE__ */ p(le, {
		conditions: t,
		onAddConditionalValueClick: n
	});
	if (e) return /* @__PURE__ */ p(de, { conditions: e });
}, pe = ({ condition: e }) => {
	let { selectedItem: t, defaultTitle: n, ariaLabel: r, className: i, toggleDisabled: a, buttonList: o, label: s } = e;
	return /* @__PURE__ */ m("div", {
		className: "toggle-item",
		children: [s && /* @__PURE__ */ p("h2", {
			className: "toggle-label",
			children: s
		}), /* @__PURE__ */ p(L, {
			className: i,
			selectedItem: t,
			defaultTitle: n || "",
			ariaLabel: r,
			buttonList: o,
			toggleDisabled: a
		})]
	});
}, me = ({ showButton: e, buttonLabel: t, onButtonClick: n }) => e ? /* @__PURE__ */ p(F, {
	className: "remove-condition-button",
	ariaLabel: t ?? "Remove Condition",
	content: /* @__PURE__ */ p(R, {
		iconName: M.BIN,
		sizeInPx: "12",
		color: "var(--thriveGreyDark)"
	}),
	onButtonClick: n
}) : /* @__PURE__ */ p(f, {}), he = ({ panelClassName: e, title: t, toggleItems: n, removeConditionButtonLabel: r, onAddConditionClick: a, onRemoveConditionClick: o, combinator: s, setCombinator: c }) => {
	let l = (e) => [{
		id: e + 1,
		isDisabled: !1,
		label: "and",
		onButtonClick: () => {
			c?.("and");
		},
		text: "and"
	}, {
		id: e + 2,
		isDisabled: !1,
		label: "or",
		onButtonClick: () => {
			c?.("or");
		},
		text: "or"
	}], u = s === "and" ? 0 : 1;
	return /* @__PURE__ */ m("div", {
		className: `conditional-logic-panel ${e ?? ""}`,
		children: [
			t && /* @__PURE__ */ p("h2", {
				className: "title",
				children: t
			}),
			n.map((e, t) => {
				let { conditionOne: a, conditionTwo: s, textConditions: c, toggleConditions: d, addToggleOption: f } = e;
				return /* @__PURE__ */ m(i.Fragment, { children: [/* @__PURE__ */ m("div", {
					className: `toggle-row toggle-row-id-${e.id} ${c || d ? "two-rows" : "one-row"}`,
					children: [/* @__PURE__ */ p(pe, { condition: a }), /* @__PURE__ */ m("div", {
						className: "condition-two-and-three-container",
						children: [s && /* @__PURE__ */ p(pe, { condition: s }), /* @__PURE__ */ p(fe, {
							textConditions: c,
							toggleConditions: d,
							onAddConditionalValueClick: f
						})]
					})]
				}), n.length > 1 && t < n.length - 1 && /* @__PURE__ */ m("div", {
					className: "add-remove-condition-wrapper",
					children: [/* @__PURE__ */ p(L, {
						className: "change-condition-button",
						selectedItem: l(Number(e.id))[u],
						defaultTitle: "",
						ariaLabel: "select condition type",
						buttonList: l(Number(e.id)),
						toggleDisabled: t !== 0
					}), /* @__PURE__ */ p(me, {
						showButton: n.length > 1,
						buttonLabel: r,
						onButtonClick: () => o(n[t + 1])
					})]
				})] }, e.id || t);
			}),
			!!a && /* @__PURE__ */ p(te, {
				content: n.length < 1 ? /* @__PURE__ */ p(f, { children: "+ Add Condition" }) : /* @__PURE__ */ m(f, { children: [
					/* @__PURE__ */ p("span", {
						className: "add-icon",
						children: "+"
					}),
					" ",
					l(0)[u].label
				] }),
				ariaLabel: "Add an additional condition",
				onAddConditionClick: a ?? void 0
			})
		]
	});
};
//#endregion
//#region helpers/formElements.ts
function ge(e) {
	switch (e) {
		case P.SHORT_TEXT: return M.DASH;
		case P.LONG_TEXT: return M.PARAGRAPH;
		case P.DROPDOWN: return M.INPUT_DOTS;
		case P.USER_SELECT: return M.USER_SEARCH;
		case P.CHECKBOX: return M.CHECKBOX;
		case P.IMAGE_SELECT: return M.IMAGE;
		case P.VIDEO_SELECT: return M.VIDEO;
		case P.FILE_SELECT: return M.FILE_UPLOAD;
		case P.SUBMIT_BUTTON: return M.DASH;
		case P.CHOICE_BUTTON: return M.CHOICE_PILL;
		case P.SINGLE_SELECT:
		case P.POLL: return M.POLL;
		default: return M.DASH;
	}
}
//#endregion
//#region components/featureSpecific/formBuilder/FormElements/elements/ElementTypeInformation.tsx
var V = ({ className: e, elementType: t, withBrackets: n }) => {
	let r = n ? `(${t})` : t;
	return /* @__PURE__ */ m("div", {
		className: `element-type-information ${e} ${t.replaceAll(" ", "-")}`,
		children: [/* @__PURE__ */ p(R, {
			className: "element-type-icon",
			iconName: ge(t),
			sizeInPx: "12",
			color: "var(--thriveGreyDark)"
		}), /* @__PURE__ */ p("span", {
			className: "element-type-text",
			children: r
		})]
	});
}, H = ({ elementType: e, ariaLabel: t, onButtonClick: n }) => /* @__PURE__ */ p(F, {
	className: "form-element-menu-button",
	content: /* @__PURE__ */ p(V, { elementType: e }),
	ariaLabel: t,
	onButtonClick: n
}), _e = ({ onShortTextClick: e, onLongTextClick: t, onDropdownClick: n, onUserSelectClick: r, onCheckboxClick: i, onImageSelectClick: a, onVideoSelectClick: o, onFileSelectClick: s, onChoiceButtonClick: c, onSingleSelectClick: l, isOpen: u, handleClose: d, containerRef: f }) => (C(u, f, d), /* @__PURE__ */ m("div", {
	className: "form-element-select-menu",
	children: [
		/* @__PURE__ */ p(H, {
			elementType: P.SHORT_TEXT,
			ariaLabel: "Add a short text element to form",
			onButtonClick: e
		}),
		/* @__PURE__ */ p(H, {
			elementType: P.LONG_TEXT,
			ariaLabel: "Add a long text element to form",
			onButtonClick: t
		}),
		/* @__PURE__ */ p(H, {
			elementType: P.DROPDOWN,
			ariaLabel: "Add a dropdown element to form",
			onButtonClick: n
		}),
		/* @__PURE__ */ p(H, {
			elementType: P.CHOICE_BUTTON,
			ariaLabel: "Add a choice button element to form",
			onButtonClick: c
		}),
		/* @__PURE__ */ p(H, {
			elementType: P.USER_SELECT,
			ariaLabel: "Add a user select element to form",
			onButtonClick: r
		}),
		/* @__PURE__ */ p(H, {
			elementType: P.CHECKBOX,
			ariaLabel: "Add a checkbox element to form",
			onButtonClick: i
		}),
		/* @__PURE__ */ p(H, {
			elementType: P.IMAGE_SELECT,
			ariaLabel: "Add an image select element to form",
			onButtonClick: a
		}),
		/* @__PURE__ */ p(H, {
			elementType: P.VIDEO_SELECT,
			ariaLabel: "Add a video select element to form",
			onButtonClick: o
		}),
		/* @__PURE__ */ p(H, {
			elementType: P.FILE_SELECT,
			ariaLabel: "Add a file select element to form",
			onButtonClick: s
		})
	]
})), U = ({ id: e, isChecked: t, onChange: n, label: r, isDisabled: i, ariaLabel: a, hideLabel: o }) => /* @__PURE__ */ m("label", {
	className: "basic-checkbox-wrapper",
	children: [
		/* @__PURE__ */ p("svg", {
			className: "basic-checkbox-symbol",
			"aria-hidden": "true",
			children: /* @__PURE__ */ p("symbol", {
				id: "check",
				viewBox: "0 0 18 6",
				children: /* @__PURE__ */ p("polyline", {
					points: "2 6 4.5 8 9.5 1",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: "3"
				})
			})
		}),
		/* @__PURE__ */ m("div", {
			className: `basic-checkbox-container ${i ? "disabled-checkbox" : ""}`,
			children: [/* @__PURE__ */ p("input", {
				className: "basic-checkbox-input",
				disabled: i,
				id: e,
				type: "checkbox",
				checked: t,
				onChange: n,
				"aria-label": a,
				"aria-checked": t
			}), /* @__PURE__ */ p("span", {
				className: "basic-checkbox",
				"aria-hidden": "true",
				children: /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p("svg", {
					width: "12px",
					height: "10px",
					children: /* @__PURE__ */ p("use", { xlinkHref: "#check" })
				}) })
			})]
		}),
		/* @__PURE__ */ p("span", {
			className: o ? "sr-only" : "label-text",
			children: r
		})
	]
}), ve = ({ formElementId: e, isRequiredElement: t, setIsRequiredElement: n, conditionalRuleEnabled: r, setConditionalRuleEnabled: i }) => /* @__PURE__ */ p("div", {
	className: "condition-checkbox-panel",
	children: /* @__PURE__ */ m("div", {
		className: "checkboxes",
		children: [/* @__PURE__ */ p(U, {
			id: `required-checkbox-for-input-${e}`,
			isChecked: t,
			onChange: n,
			label: "Required",
			ariaLabel: "Make element required"
		}), /* @__PURE__ */ p(U, {
			id: `condition-enable-checkbox-for-input-${e}`,
			isChecked: r,
			onChange: i,
			label: "Add Conditional Logic",
			ariaLabel: "Add Conditional Logic"
		})]
	})
}), ye = ({ elementType: e, labelText: t, isRequiredElement: n, onDeleteElementClick: r, onEditElementClick: i, dragRef: a, validationErrors: o }) => /* @__PURE__ */ m("div", {
	className: `form-element-details-wrapper ${(o?.length ?? 0) >= 1 ? "form-validation-errors" : ""}`,
	children: [/* @__PURE__ */ m("div", {
		className: "form-element-type-details",
		children: [/* @__PURE__ */ m("h3", {
			className: "form-element-label-text",
			onClick: i,
			role: "button",
			tabIndex: 0,
			onKeyDown: (e) => {
				(e.key === "Enter" || e.key === " ") && i();
			},
			children: [t, n ? "*" : ""]
		}), /* @__PURE__ */ p(V, {
			className: "reversed-elements",
			elementType: e,
			withBrackets: !0
		})]
	}), /* @__PURE__ */ m("div", {
		className: "form-element-control-panel",
		children: [
			!!r && /* @__PURE__ */ p(z, {
				ariaLabel: "Remove Form Element",
				className: "icon-button-squared control-button",
				iconName: M.BIN,
				onButtonClick: r || (() => {})
			}),
			/* @__PURE__ */ p(z, {
				ariaLabel: "Edit Form Element",
				className: "icon-button-squared control-button",
				iconName: M.PENCIL,
				onButtonClick: i
			}),
			/* @__PURE__ */ p(z, {
				ariaLabel: "Drag to Reorder Element",
				className: "icon-button-squared control-button drag",
				iconName: M.DRAG,
				parentRef: a
			})
		]
	})]
}), W = ({ panelClassName: e, upDisabled: t, downDisabled: n, upText: r, downText: i, ariaLabelUp: a, ariaLabelDown: o, onUpClick: s, onDownClick: c }) => /* @__PURE__ */ m("div", {
	className: `up-down-button-panel-wrapper ${e ?? ""}`,
	children: [/* @__PURE__ */ p(F, {
		className: "up-down-button-panel-button move-up-button",
		content: /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p(R, {
			className: "arrow-icon",
			iconName: M.ARROW_LEFT,
			sizeInPx: "10",
			color: "var(--thriveNavy)"
		}), r || ""] }),
		ariaLabel: a,
		isDisabled: t,
		onButtonClick: s
	}), /* @__PURE__ */ p(F, {
		className: "up-down-button-panel-button move-down-button",
		content: /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p(R, {
			className: "arrow-icon",
			iconName: M.ARROW_LEFT,
			sizeInPx: "10",
			color: "var(--thriveNavy)"
		}), i || ""] }),
		ariaLabel: o,
		isDisabled: n,
		onButtonClick: c
	})]
}), be = ({ index: e, elementType: t, labelTextName: n, labelText: r, setLabelText: i, isRequiredElement: a, isFirstElement: o, isLastElement: s, formElementComponent: c, onMoveElementUp: l, onMoveElementDown: u, rulesComponent: d, onSaveClick: f, onDeleteElementClick: h, conditionalCheckboxPanel: g, advancedOptions: _, validationErrors: v }) => {
	let y = v?.includes(ee.TITLE_IS_REQUIRED), b = (v?.length ?? 0) >= 1, x = [
		P.FILE_SELECT,
		P.IMAGE_SELECT,
		P.VIDEO_SELECT
	].includes(t) ? 20 : t === P.POLL ? 256 : 512;
	function S(e) {
		return y && !e.trim() || e.length > x;
	}
	return /* @__PURE__ */ m("div", {
		className: `form-element-edit-details-wrapper ${b ? "form-validation-errors" : ""}`,
		children: [
			/* @__PURE__ */ m("div", {
				className: "header-panel",
				children: [/* @__PURE__ */ m("div", {
					className: "header-details",
					children: [/* @__PURE__ */ m("h3", {
						className: "header-label-text",
						"aria-label": r || "Form Element Header",
						children: [r, a ? "*" : ""]
					}), /* @__PURE__ */ p(V, {
						className: "reversed-elements",
						elementType: t,
						withBrackets: !0
					})]
				}), /* @__PURE__ */ p(W, {
					upDisabled: o,
					downDisabled: s,
					ariaLabelUp: "Move element up in the form order",
					ariaLabelDown: "Move element down in the form order",
					onUpClick: l,
					onDownClick: u
				})]
			}),
			/* @__PURE__ */ p(B, {
				id: `form-element-label-input-${e}`,
				className: `form-element-label-input ${S(r) ? "form-builder-error" : ""}`,
				labelText: n ?? `${t.toUpperCase()} LABEL*`,
				placeholderText: "Describe your input here",
				textString: r,
				setTextString: i,
				maxLength: x + 1,
				autofocus: !0
			}),
			y && /* @__PURE__ */ p("span", {
				className: "error-text",
				children: "Label is required"
			}),
			r.length > x && /* @__PURE__ */ m("span", {
				className: "error-text",
				children: [
					"Please enter a maximum of ",
					x,
					" characters"
				]
			}),
			c,
			_,
			g,
			d,
			/* @__PURE__ */ m("div", {
				className: "button-panel edit-element-button-panel",
				children: [!!h && /* @__PURE__ */ p(F, {
					ariaLabel: "Remove Field from form",
					className: "full-width-remove-button",
					content: /* @__PURE__ */ m("span", { children: [/* @__PURE__ */ p(R, {
						iconName: M.BIN,
						color: "var(--thriveCharcoal)",
						sizeInPx: "12"
					}), " Remove Field"] }),
					onButtonClick: h || (() => {})
				}), /* @__PURE__ */ p(F, {
					ariaLabel: "Done",
					content: "Done",
					onButtonClick: f,
					isClassicThriveStyle: !0,
					className: `thrive-navy-style ${h ? "" : "full-width-done-button"}`
				})]
			})
		]
	});
}, G = ({ content: e, ariaLabel: t, className: n, isDisabled: r = !1, onButtonClick: i }) => e ? /* @__PURE__ */ p("button", {
	className: `panel-button ${n ?? ""}`,
	disabled: r,
	"aria-label": t,
	onClick: i,
	type: "button",
	children: e
}) : /* @__PURE__ */ p(f, {}), xe = ({ showAdvancedOptions: e, setShowAdvancedOptions: t }) => /* @__PURE__ */ p(G, {
	className: "advanced-settings-button",
	content: /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p("span", {
		className: "advanced-options-button-text",
		children: "Advanced Options"
	}), /* @__PURE__ */ p(R, {
		className: `${e ? "show-advanced-options" : ""}`,
		iconName: M.CHEVRON_DOWN,
		color: "var(--thriveGreyDark)",
		sizeInPx: "9"
	})] }),
	ariaLabel: `${e ? "Hide advanced options for form element." : "Show advanced options for form element."}`,
	onButtonClick: t
}), Se = ({ hideButton: e, text: t, ariaLabel: n, onButtonClick: r }) => /* @__PURE__ */ p(F, {
	className: `add-form-option-button ${e ? "hidden" : ""}`,
	content: /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p("span", {
		className: "add-icon",
		children: "+"
	}), /* @__PURE__ */ p("span", {
		className: "add-form-option-button-text",
		children: t || "Add Form Option"
	})] }),
	ariaLabel: n,
	onButtonClick: r
}), Ce = ({ elementId: e, placeholderText: t, submitButtonText: n, setSubmitButtonText: r, onContinueClick: i, validationErrors: a, type: o }) => {
	let s = a?.includes(ee.TITLE_IS_REQUIRED), c = (a?.length ?? 0) >= 1;
	function l(e) {
		return c || e.length >= 21;
	}
	return /* @__PURE__ */ m("div", {
		className: `form-element-edit-details-wrapper edit-submit-button-details ${l(n) ? "form-validation-errors" : ""}`,
		children: [
			/* @__PURE__ */ m("div", {
				className: "header-panel",
				children: [/* @__PURE__ */ p("h3", {
					className: "header-label-text",
					"aria-label": n || `${o} Button Label Text`,
					children: n
				}), /* @__PURE__ */ p("span", {
					className: "element-type-text",
					children: `(${o})`
				})]
			}),
			/* @__PURE__ */ p(B, {
				id: `submit-button-label-input-${e}`,
				className: "form-element-label-input",
				labelText: `${o?.toUpperCase()}`,
				placeholderText: t,
				textString: n,
				setTextString: r,
				maxLength: 21,
				autofocus: !0
			}),
			s && /* @__PURE__ */ m("span", {
				className: "error-text",
				children: [o, " text is required"]
			}),
			n.length >= 21 && /* @__PURE__ */ p("span", {
				className: "error-text",
				children: "Please enter a maximum of 20 characters"
			}),
			/* @__PURE__ */ p("div", {
				className: "button-panel",
				children: /* @__PURE__ */ p(F, {
					ariaLabel: "Done",
					className: "thrive-navy-style full-width-continue-button",
					content: "Done",
					onButtonClick: i,
					isClassicThriveStyle: !0
				})
			})
		]
	});
}, we = ({ submitButtonText: e, onEditClick: t, validationErrors: n, type: r }) => /* @__PURE__ */ m("div", {
	className: `submit-button-details form-element-details-wrapper ${(n?.length ?? 0) >= 1 ? "form-validation-errors" : ""}`,
	children: [/* @__PURE__ */ m("div", {
		className: "form-element-type-details",
		children: [/* @__PURE__ */ p("h3", {
			className: "form-element-label-text",
			onClick: t,
			role: "button",
			tabIndex: 0,
			onKeyDown: (e) => {
				(e.key === "Enter" || e.key === " ") && t();
			},
			children: e
		}), /* @__PURE__ */ p("span", {
			className: "element-type-text",
			children: `(${r})`
		})]
	}), /* @__PURE__ */ p(z, {
		ariaLabel: `Edit ${r} Text`,
		className: "icon-button-squared control-button",
		iconName: M.PENCIL,
		onButtonClick: t
	})]
}), Te = ({ elementId: e, submitButtonText: t, setSubmitButtonText: n, validationErrors: r, formButtonType: i }) => {
	let [a, o] = d(!1);
	return a ? /* @__PURE__ */ p(Ce, {
		elementId: e,
		type: i,
		placeholderText: "Enter your text here",
		submitButtonText: t,
		setSubmitButtonText: n,
		onContinueClick: () => o(!1),
		validationErrors: r
	}) : /* @__PURE__ */ p(we, {
		type: i,
		submitButtonText: t,
		onEditClick: () => o(!0),
		validationErrors: r ?? []
	});
}, K = ({ ariaLabel: e, onButtonClick: t }) => /* @__PURE__ */ p("button", {
	className: "close-button",
	"aria-label": e,
	onClick: t,
	type: "button",
	children: /* @__PURE__ */ p(R, {
		iconName: M.CLOSE,
		sizeInPx: "10",
		color: "var(--thriveLightSlate)"
	})
}), q = ({ showModal: e, className: t, headerContent: n, bodyContent: r, footerContent: i, onCloseClick: a, isFullPageModal: o, canEscapeClose: c, parentSelector: l }) => {
	let u = () => {
		c && a();
	};
	return s(() => (e ? document.body.style.overflowY = "hidden" : document.body.style.overflowY = "initial", () => {
		document.body.style.overflowY = "initial";
	}), [e]), /* @__PURE__ */ m(h, {
		style: { overlay: { zIndex: 50 } },
		closeTimeoutMS: 200,
		isOpen: e,
		parentSelector: l ?? void 0,
		contentLabel: "",
		className: `thrive-modal thrive-basic-modal-wrapper ${t ?? ""}`,
		overlayClassName: `thrive-modal-overlay ${o ? "fullpage-modal" : ""}`,
		onRequestClose: () => {
			u();
		},
		ariaHideApp: !1,
		aria: { labelledby: "thrive-modal-labelled-by" },
		children: [
			/* @__PURE__ */ m("span", {
				id: "thrive-modal-labelled-by",
				className: "thrive-basic-modal-header",
				children: [n ?? /* @__PURE__ */ p("span", { className: "blank" }), /* @__PURE__ */ p(K, {
					onButtonClick: a,
					ariaLabel: "Close Modal"
				})]
			}),
			/* @__PURE__ */ p("span", {
				className: "thrive-basic-modal-body",
				children: r ?? /* @__PURE__ */ p(f, {})
			}),
			/* @__PURE__ */ p("span", {
				className: "thrive-basic-modal-footer",
				children: i ?? /* @__PURE__ */ p(f, {})
			})
		]
	});
}, Ee = ({ cancelContent: e, confirmContent: t, ariaLabelCancel: n, ariaLabelConfirm: r, panelClassName: i, confirmIsDisabled: a = !1, onCancelClick: o, onConfirmClick: s, confirmLinkUrl: c, cancelLinkUrl: l }) => /* @__PURE__ */ m("div", {
	className: `cancel-confirm-panel ${i ?? ""}`,
	children: [/* @__PURE__ */ p(F, {
		className: "button-panel-cancel cancel-button-style",
		content: e,
		ariaLabel: n,
		isLink: l !== void 0,
		linkUrl: l ?? void 0,
		onButtonClick: o ?? void 0
	}), /* @__PURE__ */ p(F, {
		className: "button-panel-confirm thrive-navy-style",
		content: t,
		ariaLabel: r,
		isDisabled: a,
		isLink: c !== void 0,
		linkUrl: c ?? void 0,
		onButtonClick: s ?? void 0
	})]
}), De = ({ className: e, isAlertStyle: t, headerContent: n, bodyContent: r, onCloseClick: i, cancelButtonText: a, cancelButtonAriaLabel: o, confirmButtonText: s, confirmButtonAriaLabel: c, onCancelClick: l, onConfirmClick: u }) => /* @__PURE__ */ p(q, {
	showModal: !0,
	className: `cancel-confirm-modal ${e}`,
	headerContent: n,
	bodyContent: r,
	footerContent: /* @__PURE__ */ p(Ee, {
		panelClassName: `cancel-confirm-modal-panel ${t ? "alert-style" : ""}`,
		cancelContent: a,
		confirmContent: s,
		ariaLabelCancel: o,
		ariaLabelConfirm: c,
		onCancelClick: l,
		onConfirmClick: u
	}),
	onCloseClick: i
}), Oe = ({ headerText: e, questionText: t, onCloseClick: n, onConfirmClick: r }) => /* @__PURE__ */ p(De, {
	className: "form-builder-modal",
	isAlertStyle: !0,
	headerContent: /* @__PURE__ */ p("div", {
		className: "form-builder-modal-header",
		children: e
	}),
	bodyContent: /* @__PURE__ */ p("div", {
		className: "form-builder-modal-question",
		children: t
	}),
	onCloseClick: n,
	cancelButtonText: "Cancel",
	cancelButtonAriaLabel: "Cancel and close modal",
	confirmButtonText: "Confirm",
	confirmButtonAriaLabel: "Confirm and close modal",
	onCancelClick: n,
	onConfirmClick: r
}), ke = ({ elementType: e, labelTextName: t, labelText: n, setLabelText: r, formElementId: i, isRequiredElement: a, conditionalCheckboxPanel: o, onSaveClick: c, onDeleteElementClick: l, onDragElementClick: f, formElementComponent: h, isFirstElement: g, isLastElement: y, onMoveElementDown: b, onMoveElementUp: x, isEditModeOpen: S, setIsEditModeOpen: C, rulesComponent: w, advancedOptions: T, validationErrors: E, index: D }) => {
	let [O, k] = d(!1), A = u(null), [{ isDragging: j }, M] = _({
		type: "FormWidget",
		item: { index: D },
		collect: (e) => ({ isDragging: e.isDragging() }),
		end: () => {}
	}), [{ isOver: N }, P] = v({
		accept: "FormWidget",
		hover(e, t) {
			if (!A.current) return;
			let n = e.index, r = D;
			if (n === r) return;
			let i = A.current.getBoundingClientRect(), a = (i.bottom - i.top) / 2, o = t.getClientOffset().y - i.top;
			n < r && o < a || n > r && o > a || (f?.(n, r), e.index = r);
		},
		collect: (e) => ({ isOver: e.isOver() })
	});
	return P(A), s(() => (j ? document.body.classList.add("is-dragging-cursor") : document.body.classList.remove("is-dragging-cursor"), () => document.body.classList.remove("is-dragging-cursor")), [j]), /* @__PURE__ */ m("div", {
		className: `form-element-wrapper ${j && "is-hovering"}  ${N && "is-dragging"}`,
		ref: A,
		children: [S ? /* @__PURE__ */ p(be, {
			index: D,
			elementType: e,
			labelTextName: t,
			labelText: n,
			setLabelText: r,
			isRequiredElement: a,
			formElementId: i,
			formElementComponent: h,
			isFirstElement: g,
			isLastElement: y,
			onMoveElementUp: x,
			onMoveElementDown: b,
			rulesComponent: w,
			onDeleteElementClick: l ? () => k(!0) : void 0,
			onSaveClick: c,
			conditionalCheckboxPanel: o,
			advancedOptions: T,
			validationErrors: E
		}) : /* @__PURE__ */ p(ye, {
			elementType: e,
			labelText: n || "INCOMPLETED ELEMENT",
			isRequiredElement: a,
			onDeleteElementClick: l ? () => k(!0) : void 0,
			onEditElementClick: () => C?.(),
			dragRef: M,
			validationErrors: E
		}), O && /* @__PURE__ */ p(Oe, {
			headerText: "Delete form field",
			questionText: "Are you sure you want to delete this form field?",
			onCloseClick: () => k(!1),
			onConfirmClick: () => {
				k(!1), l();
			}
		})]
	}, `formElement-${i}`);
}, Ae = ({ children: e }) => /* @__PURE__ */ p(g, {
	backend: y,
	options: { enableMouseEvents: !0 },
	children: /* @__PURE__ */ p("div", {
		className: "form-builder-wrapper",
		children: e
	})
}), J = ({ content: e, closeAriaLabel: t, className: n, isDisabled: r = !1, onButtonClick: i }) => /* @__PURE__ */ m("div", {
	className: `tag-button ${n} ${r ? "disabled-tag-button" : ""}`,
	children: [/* @__PURE__ */ p("span", { children: e }), /* @__PURE__ */ p(K, {
		ariaLabel: t,
		onButtonClick: i
	})]
}), je = ({ id: e, className: t, labelText: n, labelIsHidden: r, placeholderText: i, textString: a, setTextString: o, maxLength: s, isDisabled: c, isReadOnly: l, buttonContent: u, onButtonClick: d }) => {
	let f = !a || !((e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e))(a);
	return /* @__PURE__ */ m("div", {
		className: `basic-email-input-wrapper ${t ?? ""} `,
		children: [
			/* @__PURE__ */ p("label", {
				htmlFor: `basic-email-input-${e || ""}`,
				className: `${r ? "sr-only" : ""} basic-email-input-label`,
				children: n
			}),
			/* @__PURE__ */ p("input", {
				type: "email",
				id: `basic-email-input-${e || ""}`,
				className: "basic-text-input",
				placeholder: i,
				value: a,
				onChange: (e) => o(e.target.value),
				"aria-label": "Add your Text",
				maxLength: s,
				disabled: c,
				readOnly: l
			}, e ? `basic-email-input-${e}` : ""),
			u && /* @__PURE__ */ p(F, {
				isDisabled: f || c,
				onButtonClick: d,
				content: u,
				ariaLabel: "Save Email",
				className: "basic-email-button"
			})
		]
	});
}, Me = ({ emailTextInput: e, setEmailTextInput: t, handleAddEmailClick: n, children: r, title: i, emailRecipientsList: a, removeEmailFromList: o, className: s }) => /* @__PURE__ */ m("div", {
	className: `conditional-email-wrapper conditional-logic-panel ${s ?? ""}`,
	children: [
		r,
		i && /* @__PURE__ */ p("h2", {
			className: "title",
			children: i
		}),
		/* @__PURE__ */ p("div", {
			className: "recipients-panel",
			children: a.map((e, t) => /* @__PURE__ */ p(J, {
				content: e,
				closeAriaLabel: `Remove ${e} from recipients`,
				onButtonClick: () => o(e)
			}, `${e}-${t}`))
		}),
		/* @__PURE__ */ p(je, {
			className: "form-settings-email-input",
			id: "form-settings-email-input",
			labelText: "Insert Email Address",
			labelIsHidden: !0,
			placeholderText: "E.g. name@company.com",
			setTextString: t,
			textString: e,
			buttonContent: "Add Email",
			onButtonClick: n
		})
	]
}), Ne = ({ defaultAdvancedSettings: e = !1, children: t }) => {
	let [n, r] = d(e);
	return /* @__PURE__ */ m("div", {
		className: "collapsable-options-container",
		children: [n && t, /* @__PURE__ */ p(xe, {
			showAdvancedOptions: n,
			setShowAdvancedOptions: () => r(!n)
		})]
	});
}, Pe = ({ breadCrumbs: e }) => e.length ? /* @__PURE__ */ p("nav", {
	id: "basic-breadcrumb-container",
	className: "basic-breadcrumb-container",
	"aria-label": "Navigate through the nested content",
	children: /* @__PURE__ */ p("ol", {
		className: "basic-breadcrumb-list",
		children: e.map((t, n) => /* @__PURE__ */ p("li", {
			className: "basic-breadcrumb-item",
			children: n === e.length - 1 ? /* @__PURE__ */ p("span", {
				"aria-current": "page",
				className: "basic-breadcrumb-title",
				children: t.title
			}) : /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p("button", {
				type: "button",
				className: "basic-breadcrumb-button",
				onClick: () => {
					t.onClick?.(), t.url && (window.location.href = t.url);
				},
				children: t.title
			}), /* @__PURE__ */ p("span", {
				className: "basic-breadcrumb-chevron",
				children: " › "
			})] })
		}, n))
	})
}) : null, Fe = ({ currentStep: e, totalSteps: t }) => /* @__PURE__ */ p("div", {
	className: "minimal-breadcrumb",
	children: Array.from({ length: t }, (e, t) => t + 1).map((t) => {
		let n = "";
		return n = t < e ? "completed-step" : t === e ? "current-step" : "not-started-breadcrumb", /* @__PURE__ */ p("div", {
			"data-testid": "minimal-breadcrumb",
			className: `breadcrumb-step ${n}`
		}, t);
	})
}), Ie = ({ panelTitle: e, items: t }) => /* @__PURE__ */ m("div", {
	className: "basic-checkbox-panel-container",
	children: [/* @__PURE__ */ p("span", {
		className: "panel-title",
		children: e
	}), t.map((e) => /* @__PURE__ */ p("div", {
		className: "basic-check-box-item",
		children: /* @__PURE__ */ p(U, {
			id: e.id,
			isChecked: e.isChecked,
			onChange: e.onChange,
			label: e.label,
			ariaLabel: e.ariaLabel,
			isDisabled: e.isDisabled
		})
	}, e.id))]
}), Le = {
	enter: (e) => ({
		y: e > 0 ? 10 : -10,
		opacity: 0
	}),
	center: {
		y: 0,
		opacity: 1
	},
	exit: (e) => ({
		y: e > 0 ? -10 : 10,
		opacity: 0
	})
}, Re = ({ value: t, className: r }) => {
	let i = u(t), a = t >= i.current ? 1 : -1;
	return s(() => {
		i.current = t;
	}, [t]), /* @__PURE__ */ p("span", {
		className: `number-animation ${r || ""}`,
		children: /* @__PURE__ */ p(e, {
			mode: "popLayout",
			initial: !1,
			custom: a,
			children: /* @__PURE__ */ p(n.span, {
				className: "number-animation-span",
				custom: a,
				variants: Le,
				initial: "enter",
				animate: "center",
				exit: "exit",
				transition: {
					duration: .2,
					ease: "easeOut"
				},
				children: t
			}, t)
		})
	});
}, ze = ({ panelClassName: e, contentId: t, likingEnabled: n = !1, commentingEnabled: r = !1, totalLikes: i = 0, totalComments: a = 0, userLiked: o = !1, onLikeClick: c, onCommentClick: l }) => {
	let [u, f] = d(o), [h, g] = d(i ?? 0);
	return s(() => {
		f(o);
	}, [o]), s(() => {
		g(i ?? 0);
	}, [i]), /* @__PURE__ */ m("div", {
		className: `basic-social-button-panel-wrapper ${e ?? ""}`,
		children: [n && /* @__PURE__ */ m("button", {
			className: `social-button-panel-button ${u ? "active-social-button" : "in-active-social-button"}`,
			"aria-label": u ? "Liked content" : "Like content",
			onClick: () => {
				f((e) => {
					let t = !e;
					return g((e) => e + (t ? 1 : -1)), !e;
				}), c?.();
			},
			type: "button",
			children: [/* @__PURE__ */ p(R, {
				className: "button-panel-like-icon",
				iconName: M.LIKE,
				color: "var(--thriveWhite)",
				sizeInPx: "16"
			}), /* @__PURE__ */ p(Re, { value: h })]
		}), r && /* @__PURE__ */ m("button", {
			className: "social-button-panel-button in-active-social-button",
			"aria-label": "Add comment to content",
			onClick: l,
			type: "button",
			children: [/* @__PURE__ */ p(R, {
				className: "button-panel-comment-icon",
				iconName: M.COMMENT,
				color: "var(--thriveCharcoal)",
				sizeInPx: "16"
			}), /* @__PURE__ */ p("span", {
				className: "total-comments-span",
				children: a
			})]
		})]
	}, `${t}-social-bar`);
}, Be = ({ isDisabled: e, ariaLabel: t, onButtonClick: n }) => /* @__PURE__ */ p("button", {
	className: "menu-button",
	disabled: e,
	"aria-label": t,
	onClick: n,
	children: /* @__PURE__ */ p(R, {
		iconName: M.MENU_MORE,
		sizeInPx: "12",
		color: "var(--thriveLightSlate)"
	})
}), Ve = ({ isDisabled: e, ariaLabel: t, onButtonClick: n, link: r, text: i, openInNewTab: a = !0 }) => r ? /* @__PURE__ */ p("a", {
	className: `bold-text-button ${e ? "disabled" : ""}`,
	"aria-label": t,
	href: e ? void 0 : r,
	target: a ? "_blank" : void 0,
	rel: "noopener noreferrer",
	onClick: (t) => e && t.preventDefault(),
	children: i
}) : /* @__PURE__ */ p("button", {
	className: "bold-text-button",
	disabled: e,
	"aria-label": t,
	onClick: n,
	type: "button",
	children: i
}), He = ({ isDisabled: e, ariaLabel: t, onButtonClick: n, includeText: r, isActive: i, isReply: a, buttonText: o }) => {
	let s = a ? "Reply" : "Comment";
	return /* @__PURE__ */ m("button", {
		className: "social-comment-button",
		disabled: e,
		"aria-label": t,
		onClick: n,
		children: [/* @__PURE__ */ p(R, {
			iconName: i ? M.COMMENT_ACTIVE : M.COMMENT,
			sizeInPx: "12"
		}), r && (o ?? s)]
	});
}, Ue = ({ isDisabled: e, ariaLabel: t, onButtonClick: n, includeText: r, isActive: i, numberOfComments: a, buttonText: o, isReply: s }) => {
	let c = s ? a === 1 ? "1 reply" : `${a} replies` : a === 1 ? "1 comment" : `${a} comments`;
	return /* @__PURE__ */ m("button", {
		className: "social-comments-button",
		disabled: e,
		"aria-label": t,
		onClick: n,
		children: [/* @__PURE__ */ p(R, {
			iconName: i ? M.COMMENT_ACTIVE : M.COMMENT,
			sizeInPx: "12"
		}), r && (o ?? c)]
	});
}, We = ({ isDisabled: e, ariaLabel: t, href: n, text: r }) => /* @__PURE__ */ m("a", {
	className: `external-link-button ${e ? "disabled" : ""}`,
	"aria-label": t,
	href: e ? void 0 : n,
	target: "_blank",
	rel: "noopener noreferrer",
	onClick: (t) => e && t.preventDefault(),
	children: [r, /* @__PURE__ */ p(R, {
		iconName: M.LINK,
		sizeInPx: "12"
	})]
}), Ge = ({ isDisabled: e, ariaLabel: t, onButtonClick: n, includeText: r, isActive: i, colour: a, className: o, buttonText: s }) => {
	let c = i ? "Liked" : "Like";
	return /* @__PURE__ */ m("button", {
		className: `social-like-button ${o ?? ""}`,
		disabled: e,
		"aria-label": t,
		onClick: n,
		children: [/* @__PURE__ */ p(R, {
			iconName: i ? M.LIKE_ACTIVE : M.LIKE,
			sizeInPx: "12",
			color: a
		}), r && (s ?? c)]
	});
}, Ke = ({ isDisabled: e, ariaLabel: t, onButtonClick: n, includeText: r, isActive: i, numberOfLikes: a, buttonText: o }) => {
	let s = a === 1 ? "1 like" : `${a} likes`;
	return /* @__PURE__ */ m("button", {
		className: "social-likes-button",
		disabled: e,
		"aria-label": t,
		onClick: n,
		children: [/* @__PURE__ */ p(R, {
			iconName: i ? M.LIKE_ACTIVE : M.LIKE,
			sizeInPx: "12"
		}), r && (o ?? s)]
	});
}, qe = ({ id: e, text: t, isChecked: n, onClick: r, className: i }) => /* @__PURE__ */ m("span", {
	className: `basic-radio-button ${i || ""}`,
	children: [/* @__PURE__ */ p("input", {
		id: `radio-button-${e}`,
		className: "basic-radio-button-input",
		onChange: r,
		type: "radio",
		checked: n
	}), /* @__PURE__ */ p("label", {
		htmlFor: `radio-button-${e}`,
		className: "basic-radio-button-text",
		children: t
	})]
}, `basic-radio-button-${e}`), Je = ({ content: e, ariaLabel: t, className: n, isDisabled: r = !1, onButtonClick: i, isLink: a, linkUrl: o, openInNewTab: s = !1 }) => /* @__PURE__ */ p(F, {
	content: /* @__PURE__ */ m("span", {
		className: "caret-button-content",
		children: [e, /* @__PURE__ */ p(R, {
			className: "caret-button-icon",
			iconName: M.CHEVRON_RIGHT,
			color: "var(--thriveCharcoal",
			sizeInPx: "10"
		})]
	}),
	ariaLabel: t,
	className: `${n} basic-caret-button`,
	isDisabled: r,
	onButtonClick: i,
	isLink: a,
	linkUrl: o,
	openInNewTab: s
}), Ye = ({ className: e, textToCopy: t, iconOnly: n }) => {
	let [r, i] = d("ready");
	async function a() {
		try {
			await navigator.clipboard.writeText(t), i("success");
		} catch {
			i("fail");
		} finally {
			setTimeout(() => {
				i("ready");
			}, 3e3);
		}
	}
	return /* @__PURE__ */ p("button", {
		className: `basic-button TC-c2c-button ${r} ${e ?? ""}`,
		name: "copy to clipboard",
		onClick: a,
		"aria-label": "copy to clipboard",
		disabled: r !== "ready",
		children: (() => {
			switch (r) {
				case "ready": return /* @__PURE__ */ m(f, { children: [!n && /* @__PURE__ */ p("span", { children: "Copy to clipboard" }), /* @__PURE__ */ p(R, {
					iconName: M.COPY,
					color: "var(--thriveGreyDark)",
					sizeInPx: "16"
				})] });
				case "success": return /* @__PURE__ */ m(f, { children: [!n && /* @__PURE__ */ p("span", { children: "Copied to clipboard" }), /* @__PURE__ */ p(R, {
					iconName: M.CIRCLE_CHECK,
					color: "var(--thriveWhite)",
					sizeInPx: "16"
				})] });
				case "fail": return /* @__PURE__ */ m(f, { children: [!n && /* @__PURE__ */ p("span", { children: "Could not copy" }), /* @__PURE__ */ p(R, {
					iconName: M.CIRCLE_CLOSE,
					color: "var(--thriveWhite)",
					sizeInPx: "16"
				})] });
			}
		})()
	});
}, Xe = ({ className: e, isDisabled: t, ariaLabel: n, onButtonClick: r, content: i }) => /* @__PURE__ */ m("button", {
	className: `dismissable-pill-style-button ${e ?? ""}`,
	disabled: t,
	"aria-label": n,
	onClick: r,
	children: [/* @__PURE__ */ p("span", { children: i }), /* @__PURE__ */ p("span", {
		className: "icon-wrapper",
		children: /* @__PURE__ */ p(R, {
			iconName: M.CLOSE,
			color: "var(--thriveGreyLight)",
			sizeInPx: "6"
		})
	})]
}), Y = ({ dragRef: e, className: t }) => /* @__PURE__ */ p("button", {
	ref: e,
	className: `drag-button ${t ?? ""}`,
	"aria-hidden": "true",
	tabIndex: -1,
	children: /* @__PURE__ */ p(R, {
		iconName: M.DRAG,
		color: "#999EA5",
		sizeInPx: "12"
	})
}), Ze = ({ className: e, isDisabled: t, ariaLabel: n, onButtonClick: r, content: i }) => {
	let a = /* @__PURE__ */ m(f, { children: ["Filter ", /* @__PURE__ */ p(R, {
		iconName: M.FILTERS,
		color: "var(--thriveSky)",
		sizeInPx: "16"
	})] });
	return /* @__PURE__ */ p("button", {
		className: `filter-style-button ${e ?? ""}`,
		disabled: t,
		"aria-label": n,
		onClick: r,
		children: i ?? a
	});
};
//#endregion
//#region components/global/buttons/FullWidthActionButton.tsx
function Qe(e, t) {
	let n = "";
	return e && (n += "app-theme-button"), t && (n += "translucent-button"), n;
}
var $e = ({ onClick: e, text: t, label: n, isDisabled: r, useAppThemeColors: i, useTranslucentButton: a }) => /* @__PURE__ */ p("button", {
	className: `button-full-width-action ${Qe(i, a)}`,
	onClick: e,
	"aria-label": n,
	disabled: r,
	type: "button",
	children: t
}), X = ({ children: e, className: t, text: n, tooltipDisabled: r }) => {
	let [i, a] = d(!1);
	return r ? /* @__PURE__ */ p(f, { children: e }) : /* @__PURE__ */ m("span", {
		className: `basic-tooltip-wrapper ${t ?? ""}`,
		onMouseEnter: () => a(!0),
		onMouseLeave: () => a(!1),
		children: [e, i && /* @__PURE__ */ p("span", {
			className: "basic-tooltip",
			children: n
		})]
	});
}, et = ({ ariaLabel: e, className: t, isDisabled: n = !1, onButtonClick: r, iconName: i, tooltipText: a }) => /* @__PURE__ */ p("div", {
	className: "app-icon-tooltip-wrapper",
	children: /* @__PURE__ */ p(X, {
		text: a,
		className: t,
		children: /* @__PURE__ */ p(z, {
			ariaLabel: e,
			iconName: i,
			isDisabled: n,
			onButtonClick: r
		})
	})
}), tt = ({ ariaLabel: e, className: t, isDisabled: n = !1, onButtonClick: r, text: i, hideText: a = !1 }) => /* @__PURE__ */ m("div", {
	className: "minimise-button-wrapper",
	children: [!a && /* @__PURE__ */ p("div", {
		className: "minimise-button-text",
		children: i || "Minimise"
	}), /* @__PURE__ */ p(z, {
		className: `icon-button-squared minimise-button ${t}`,
		ariaLabel: e,
		iconName: M.DASH,
		isDisabled: n,
		onButtonClick: r
	})]
}), nt = ({ id: e, text: t, isChecked: n, onClick: r, className: i, isNew: a, imageSrc: o, imageAlt: s }) => /* @__PURE__ */ m("span", {
	className: `radio-image-button 
                ${i || ""} 
                ${n ? "selected-radio-image-button" : "not-selected-radio-image-button"}`,
	children: [/* @__PURE__ */ p("img", {
		src: o,
		alt: s,
		className: "radio-image",
		onClick: r
	}), /* @__PURE__ */ m("span", {
		className: "basic-image-radio-button-container",
		children: [/* @__PURE__ */ p(qe, {
			className: "basic-image-radio-button",
			id: e,
			text: t,
			isChecked: n,
			onClick: r
		}), a && /* @__PURE__ */ p("span", {
			className: "new-display-icon",
			children: "New"
		})]
	})]
}, `radio-image-button-${e}`), rt = ({ id: e, text: t, textDescription: n, isChecked: r, onClick: i, className: a }) => /* @__PURE__ */ m("div", {
	className: "tc-radio-wrapper",
	children: [/* @__PURE__ */ m("label", {
		className: `larger-radio-button ${a || ""}`,
		children: [
			/* @__PURE__ */ p("input", {
				type: "radio",
				name: "option",
				onChange: i,
				checked: r
			}),
			/* @__PURE__ */ p("span", { className: "circle" }),
			t
		]
	}, `basic-radio-button-${e}`), !!n && /* @__PURE__ */ p("p", {
		className: "label-description",
		children: n
	})]
}), it = () => /* @__PURE__ */ p("div", { className: "divider-line" }), at = ({ item: e, index: t, moveItem: n, onMoveUp: r, onMoveDown: i, isFirst: a, isLast: o }) => {
	let c = u(null), [{ isDragging: l }, d] = _({
		type: "CONTENT_ITEM",
		item: { index: t },
		collect: (e) => ({ isDragging: e.isDragging() }),
		end: () => {}
	}), [, f] = v({
		accept: "CONTENT_ITEM",
		hover(e) {
			e.index !== t && c.current?.getBoundingClientRect() && (n(e.index, t), e.index = t);
		}
	});
	return d(f(c)), s(() => (l ? document.body.classList.add("is-dragging-cursor") : document.body.classList.remove("is-dragging-cursor"), () => document.body.classList.remove("is-dragging-cursor")), [l]), /* @__PURE__ */ m("li", {
		ref: c,
		className: "content-item",
		children: [/* @__PURE__ */ m("span", {
			className: "left-panel",
			draggable: !1,
			children: [/* @__PURE__ */ p(Y, {
				dragRef: void 0,
				className: "content-drag-button"
			}), /* @__PURE__ */ p("span", {
				className: "content-title",
				children: e.title
			})]
		}), /* @__PURE__ */ p(W, {
			panelClassName: "right-panel",
			ariaLabelUp: "Move Content Up",
			ariaLabelDown: "Move Content Down",
			upDisabled: a,
			downDisabled: o,
			onUpClick: r,
			onDownClick: i
		})]
	});
}, ot = ({ content: e, setContent: t }) => {
	let n = (n, r) => {
		let i = [...e], [a] = i.splice(n, 1);
		i.splice(r, 0, a), t(i);
	}, r = (n) => {
		if (n === 0) return;
		let r = [...e];
		[r[n - 1], r[n]] = [r[n], r[n - 1]], t(r);
	}, i = (n) => {
		if (n === e.length - 1) return;
		let r = [...e];
		[r[n], r[n + 1]] = [r[n + 1], r[n]], t(r);
	};
	return /* @__PURE__ */ p(g, {
		backend: y,
		options: { enableMouseEvents: !0 },
		children: /* @__PURE__ */ p("ul", {
			className: "content-order-setter-container",
			children: e.map((t, a) => /* @__PURE__ */ p(at, {
				item: t,
				index: a,
				moveItem: n,
				onMoveUp: () => r(a),
				onMoveDown: () => i(a),
				isFirst: a === 0,
				isLast: a === e.length - 1
			}, t.id))
		})
	});
};
//#endregion
//#region helpers/Dates.ts
function st(e, t) {
	return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
//#endregion
//#region components/global/dates/ReactCalendar.tsx
var ct = ({ className: e, selectedDates: t, setSelectedDates: n, isSelectPastOnly: r, isSelectFutureOnly: i, isSingleDateSelect: a }) => {
	function o(e) {
		let r = [];
		t?.length === 2 && (t = []), r = t ? [...t, e].sort((e, t) => e.getTime() - t.getTime()) : [e], r.length >= 2 && st(r[0], r[1]) && (r = [r[0]]), n(r);
	}
	function s() {
		let e = [];
		if (t?.[0] && e.push(new Date(t[0].toDateString())), t?.[1] && e.push(new Date(t[1].toDateString())), e.length === 1) return e[0];
		if (e.length === 2) return e;
	}
	return /* @__PURE__ */ p("div", {
		className: "thrive-react-calendar",
		children: /* @__PURE__ */ p(b, {
			className: e,
			onClickDay: (e) => o(e),
			showWeekNumbers: !0,
			showNeighboringMonth: !1,
			selectRange: !a,
			minDate: i ? /* @__PURE__ */ new Date() : void 0,
			maxDate: r ? /* @__PURE__ */ new Date() : void 0,
			maxDetail: "month",
			minDetail: "month",
			prev2Label: null,
			next2Label: null,
			value: s()
		})
	});
}, lt = () => /* @__PURE__ */ m("svg", {
	"data-testid": "thrive-app-logo",
	className: "thrive-app-logo",
	width: "92",
	height: "30",
	viewBox: "0 0 92 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: [/* @__PURE__ */ m("g", {
		clipPath: "url(#clip0_2389_404)",
		children: [
			/* @__PURE__ */ p("path", {
				d: "M20.1698 26.4383H12.6577V11.7803C12.6555 11.5375 12.603 11.2976 12.5033 11.075C12.4036 10.8524 12.2588 10.6516 12.0775 10.4847C11.9083 10.323 11.7069 10.1967 11.4857 10.1136C11.2644 10.0304 11.028 9.99223 10.791 10.0013C10.3143 10.0161 9.86192 10.2095 9.52822 10.5409C9.19452 10.8724 9.00528 11.3164 9 11.7803V28.221C9.00621 28.6909 9.20088 29.1399 9.54252 29.4723C9.88416 29.8046 10.3457 29.994 10.8288 30H20.1698C20.4195 29.9981 20.6662 29.9472 20.895 29.8502C21.1239 29.7532 21.3303 29.6122 21.5017 29.4356C21.6679 29.271 21.7978 29.0751 21.8833 28.8599C21.9687 28.6447 22.008 28.4147 21.9987 28.1842C21.984 27.7203 21.7855 27.2798 21.4446 26.9551C21.1037 26.6304 20.6469 26.4465 20.1698 26.4419",
				fill: "#FF0064"
			}),
			/* @__PURE__ */ p("path", {
				d: "M30.4413 0.490372C30.2791 0.327767 30.0854 0.20044 29.8723 0.116273C29.6592 0.0321065 29.4313 -0.00710825 29.2025 0.00105691C28.7433 0.0149298 28.3072 0.207183 27.9856 0.537573C27.6639 0.867962 27.4815 1.31088 27.4767 1.7736V9.54269H19.761C19.2958 9.54872 18.8514 9.73753 18.5224 10.0689C18.1934 10.4002 18.006 10.8479 18 11.3165V19.2189C18.0022 19.4611 18.0529 19.7003 18.1491 19.9223C18.2453 20.1443 18.3851 20.3444 18.5599 20.5107C18.8699 20.8206 19.2878 20.9962 19.7246 21H19.7987C20.2579 20.9858 20.6938 20.7932 21.0153 20.4626C21.3368 20.132 21.5188 20.689 21.5233 19.2262V13.0963H29.239C29.7043 13.09 30.1487 12.9009 30.4777 12.5694C30.8066 12.2378 30.994 11.79 31 11.3214V1.77972C30.9973 1.53808 30.9464 1.29946 30.8505 1.07799C30.7545 0.856512 30.6154 0.656694 30.4413 0.490372Z",
				fill: "#B7D2E5"
			}),
			/* @__PURE__ */ p("path", {
				d: "M20.5038 2.95235C20.669 2.79006 20.7982 2.59701 20.8833 2.38501C20.9684 2.17301 21.0077 1.94651 20.9988 1.71938C20.9839 1.26186 20.7861 0.827561 20.4467 0.507174C20.1073 0.186786 19.6525 0.00508025 19.1773 0H1.82276C1.34147 0.0059499 0.881613 0.192668 0.541145 0.52038C0.200678 0.848091 0.00650904 1.2909 0 1.75447L0 11.2383C0.00242896 11.4778 0.0549635 11.7144 0.154464 11.9339C0.253966 12.1535 0.398391 12.3514 0.579112 12.516C0.900102 12.822 1.3322 12.9956 1.78381 13H1.86044C2.33629 12.985 2.78765 12.7932 3.11995 12.4648C3.45224 12.1364 3.63969 11.6968 3.643 11.2383V3.51014H19.1773C19.4259 3.50781 19.6716 3.4572 19.8995 3.36137C20.1274 3.26553 20.333 3.12642 20.5038 2.95235Z",
				fill: "#203554"
			}),
			/* @__PURE__ */ p("path", {
				d: "M45.9974 14.3465H43.2033V17.6225C43.2021 17.8695 43.2162 18.1163 43.2453 18.3617C43.2674 18.5644 43.3322 18.7607 43.4358 18.9387C43.5412 19.1082 43.7011 19.2405 43.8916 19.3158C44.1506 19.4134 44.428 19.4584 44.7061 19.4478C44.9289 19.4442 45.1514 19.4274 45.3721 19.3976C45.6002 19.3817 45.818 19.3007 45.9974 19.165V21.6956C45.6416 21.8176 45.2722 21.8995 44.8966 21.9394C44.524 21.9792 44.1495 21.9993 43.7747 21.9998C43.2761 22.004 42.7789 21.9495 42.2943 21.8376C41.869 21.7401 41.4675 21.5646 41.112 21.3209C40.7733 21.0812 40.5024 20.7645 40.3238 20.3995C40.1216 19.9671 40.0241 19.4965 40.0388 19.0229V14.3465H38V11.9152H40.0322V9H43.2059V11.9152H46L45.9974 14.3465Z",
				fill: "#121F2D"
			}),
			/* @__PURE__ */ p("path", {
				d: "M49.8842 7V13.6663H49.9235C49.9981 13.4617 50.1091 13.2734 50.2506 13.1108C50.4119 12.9192 50.5998 12.7532 50.8081 12.6182C51.047 12.4627 51.3057 12.3425 51.5769 12.2611C51.8888 12.1661 52.2127 12.1192 52.5379 12.1219C53.2693 12.1219 53.8594 12.2377 54.3083 12.4692C54.7371 12.6837 55.0999 13.0166 55.3564 13.431C55.6176 13.8741 55.7905 14.3665 55.865 14.8793C55.9578 15.4763 56.003 16.0801 55.9998 16.6847V21.9988H53.1157V17.2771C53.1157 16.9988 53.1061 16.7114 53.087 16.415C53.0703 16.1329 53.012 15.8551 52.9139 15.5911C52.8234 15.3481 52.6702 15.1352 52.4711 14.9754C52.2717 14.8165 51.9876 14.7377 51.6151 14.7377C51.3014 14.7235 50.9896 14.7953 50.7114 14.9458C50.4883 15.0763 50.3051 15.2687 50.1826 15.5012C50.0574 15.7451 49.9765 16.0106 49.9438 16.2845C49.9045 16.587 49.8849 16.8918 49.8853 17.197V22H47V7H49.8842Z",
				fill: "#121F2D"
			}),
			/* @__PURE__ */ p("path", {
				d: "M58 12.2406H61.0723V13.8073H61.1129C61.3832 13.2701 61.7823 12.8052 62.276 12.4524C62.7277 12.1508 63.2942 12 63.9755 12C64.1534 12 64.3301 12.0075 64.5081 12.0199C64.6743 12.0313 64.8391 12.0584 65 12.101V14.8518C64.7887 14.7864 64.5729 14.736 64.3543 14.701C64.1344 14.6669 63.9121 14.6502 63.6895 14.6511C63.1022 14.6511 62.6362 14.7313 62.2913 14.8917C61.9682 15.0373 61.6946 15.2709 61.5032 15.5648C61.3092 15.8798 61.1869 16.2323 61.1447 16.598C61.0879 17.0374 61.0607 17.4801 61.0634 17.923V22H58V12.2406Z",
				fill: "#121F2D"
			}),
			/* @__PURE__ */ p("path", {
				d: "M66 8.79341C66.0004 8.49831 66.0615 8.20787 66.1779 7.94776C66.2943 7.68765 66.4624 7.46589 66.6674 7.30209C66.8724 7.13829 67.1079 7.0375 67.3532 7.00862C67.5985 6.97974 67.8459 7.02367 68.0736 7.13653C68.3013 7.24938 68.5023 7.42768 68.6588 7.65566C68.8153 7.88363 68.9225 8.15427 68.9708 8.44363C69.0192 8.733 69.0073 9.03217 68.9361 9.3147C68.865 9.59724 68.7368 9.85442 68.5629 10.0635C68.3532 10.3156 68.0857 10.4875 67.7944 10.5573C67.503 10.6271 67.2009 10.5918 66.9264 10.4557C66.6518 10.3196 66.4172 10.089 66.2523 9.79307C66.0874 9.49713 65.9996 9.1492 66 8.79341ZM66.2068 11.9546H68.7964V22H66.2068V11.9546Z",
				fill: "#121F2D"
			}),
			/* @__PURE__ */ p("path", {
				d: "M71 12H74.2258L76.6854 18.7893H76.7249L78.9892 12H82L78.1685 22H75.007L71 12Z",
				fill: "#121F2D"
			}),
			/* @__PURE__ */ p("path", {
				d: "M91.537 20.1223C91.0538 20.7249 90.4264 21.2026 89.7099 21.5135C88.9919 21.8345 88.2113 22.0004 87.4216 21.9999C86.6996 22.0043 85.9824 21.885 85.3028 21.6472C84.6643 21.4261 84.0775 21.083 83.5766 20.6379C83.0838 20.1947 82.6908 19.6563 82.4225 19.0571C82.1436 18.4054 82 17.7063 82 17.0001C82 16.294 82.1436 15.5949 82.4225 14.9432C82.6909 14.344 83.0839 13.8057 83.5766 13.3624C84.0775 12.9173 84.6643 12.5742 85.3028 12.3531C85.9824 12.1153 86.6996 11.9959 87.4216 12.0004C88.0718 11.992 88.717 12.112 89.3185 12.3531C89.8729 12.5777 90.3675 12.9229 90.7643 13.3624C91.1735 13.8248 91.4841 14.3623 91.6779 14.9432C91.9003 15.6067 92.0089 16.3015 91.9994 16.9995V17.9201H85.0124C85.1098 18.4398 85.3859 18.9116 85.7951 19.2577C86.2114 19.5952 86.7398 19.7725 87.2807 19.7563C87.7224 19.7706 88.1586 19.6586 88.5358 19.434C88.8835 19.2121 89.1864 18.9298 89.4294 18.6011L91.537 20.1223ZM88.9845 15.9306C88.9958 15.6964 88.9573 15.4623 88.8715 15.2432C88.7857 15.0242 88.6545 14.8247 88.486 14.6575C88.312 14.4823 88.1023 14.3448 87.8704 14.2537C87.6386 14.1626 87.3897 14.1199 87.1399 14.1285C86.838 14.1225 86.5379 14.1759 86.2575 14.2853C86.0173 14.3807 85.7963 14.5165 85.6044 14.6866C85.4261 14.8462 85.2828 15.0394 85.1831 15.2545C85.0827 15.4673 85.0248 15.6967 85.0124 15.9306H88.9845Z",
				fill: "#121F2D"
			})
		]
	}), /* @__PURE__ */ p("defs", { children: /* @__PURE__ */ p("clipPath", {
		id: "clip0_2389_404",
		children: /* @__PURE__ */ p("rect", {
			width: "92",
			height: "30",
			fill: "white"
		})
	}) })]
}), ut = ({ imageUrl: e, appName: t, isDefault: n }) => !e || n ? /* @__PURE__ */ p(R, {
	className: "app-image default-app-icon",
	iconName: M.THRIVE,
	sizeInPx: "14",
	color: "var(--thriveGreyDark)"
}) : /* @__PURE__ */ p("img", {
	"data-tooltip-id": "app-image-tooltip",
	src: e,
	className: "app-image",
	alt: t ?? "App Icon"
}), dt = ({ imageUrl: e, className: t, appName: n }) => n ? /* @__PURE__ */ p("div", {
	className: `app-icon-tooltip-wrapper ${t ?? ""}`,
	"aria-hidden": "true",
	children: /* @__PURE__ */ p(X, {
		text: n,
		children: /* @__PURE__ */ p(ut, {
			imageUrl: e,
			appName: n
		})
	})
}) : /* @__PURE__ */ p(ut, { imageUrl: e }), ft = /* @__PURE__ */ function(e) {
	return e[e.Thumbnail = 160] = "Thumbnail", e[e.XS = 240] = "XS", e[e.S = 360] = "S", e[e.M = 540] = "M", e[e.L = 720] = "L", e[e.XL = 1080] = "XL", e[e.XXL = 1440] = "XXL", e;
}({});
function Z(e, t, n, r) {
	if (r) return t;
	let i = n ? `&access_token=${n}` : "", a;
	return a = e <= 160 ? 160 : e <= 240 ? 240 : e <= 360 ? 360 : e <= 540 ? 540 : e <= 720 ? 720 : e <= 1080 ? 1080 : 1440, `${t}?width=${a}&quality=70&upscale=false${i}`;
}
//#endregion
//#region components/global/images/ProgressiveLoadingImage.tsx
var pt = ({ imageUrl: e, maxWidth: t, token: n, altText: r }) => {
	let [i, a] = d(!1), o = Z(100, e, n), s = Z(t, e, n);
	return /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p("img", {
		className: `progressive-loading-image-low-res ${i && "is-loaded"}`,
		src: o,
		alt: r || ""
	}), /* @__PURE__ */ p("img", {
		className: `progressive-loading-image-high-res ${i && "display-high-res"}`,
		src: s,
		alt: r || "",
		onLoad: () => a(!0)
	})] });
}, mt = ({ className: e, contentUrl: t, token: n, caption: r }) => /* @__PURE__ */ m("div", {
	className: `content-image-component ${e ?? ""}`,
	children: [/* @__PURE__ */ m("div", {
		className: "content-image-wrapper",
		children: [/* @__PURE__ */ p("img", {
			className: "background-content-image-component",
			src: Z(160, t, n),
			alt: ""
		}), /* @__PURE__ */ p(pt, {
			imageUrl: t,
			maxWidth: 600,
			token: n
		})]
	}), r && /* @__PURE__ */ p("span", {
		className: "image-caption",
		children: r
	})]
}), ht = ({ className: e, mediaItems: t, maxVisible: n, totalMediaItems: r }) => {
	if (!Array.isArray(t) || t.length === 0) return /* @__PURE__ */ p(f, {});
	let i = r > n ? r - n : 0, a = Array.isArray(t) ? t.slice(0, n) : [], o = (e) => {
		let t = e.target;
		t.style.display = "none";
	};
	function s(e) {
		return e === n - 1 && i > 0;
	}
	return /* @__PURE__ */ p("div", {
		className: `content-image-preview-panel ${e ?? ""}`,
		children: a.map((e, t) => /* @__PURE__ */ m("div", {
			className: "image-wrapper",
			children: [/* @__PURE__ */ p("img", {
				src: `${e?.thumbnail?.url}?size=thumbnail`,
				alt: `content preview ${t + 1} of ${a.length}`,
				className: "content-image-preview-item",
				onError: o
			}), s(t) ? /* @__PURE__ */ p("div", {
				className: "content-image-preview-item-overlay",
				children: /* @__PURE__ */ m("span", {
					className: "item-overlay-count",
					children: ["+", i]
				})
			}) : /* @__PURE__ */ p("div", {
				className: `content-image-preview-item-icon-overlay ${!e?.url && "imageless"}`,
				children: /* @__PURE__ */ p("span", {
					className: "item-overlay-icon",
					children: /* @__PURE__ */ p(R, {
						iconName: se(e.mediaType),
						color: "var(--thriveWhite)",
						sizeInPx: "12"
					})
				})
			})]
		}, e.url))
	});
}, gt = ({ iconUrl: e }) => /* @__PURE__ */ p("div", {
	className: "external-login-icon-wrapper",
	"aria-hidden": "true",
	"data-testid": "external-login-icon",
	children: e ? /* @__PURE__ */ p("img", {
		src: Z(10, e),
		className: "external-login-icon",
		alt: ""
	}) : /* @__PURE__ */ p(R, {
		className: "external-login-icon default-external-login-icon",
		iconName: M.USER_EXTERNAL,
		sizeInPx: "6",
		color: "var(--thriveBlue)"
	})
}), _t = ({ profileImageUrl: e, providerIconUrl: t }) => /* @__PURE__ */ m("div", {
	className: "external-login-profile-image-wrapper",
	"aria-hidden": "true",
	children: [e ? /* @__PURE__ */ p("img", {
		src: Z(30, e),
		className: "external-login-user-profile-image",
		alt: ""
	}) : /* @__PURE__ */ p(R, {
		className: "default-no-user-icon",
		iconName: M.USER_NONE,
		sizeInPx: "10",
		color: "var(--thriveLightSlate)"
	}), /* @__PURE__ */ p(gt, { iconUrl: t })]
}), Q = ({ profileImageUrl: e, className: t, secondProfileImageUrl: n, isSquareImage: r, defaultSecondProfileImage: i, accessToken: a, isStaticAsset: o, isSecondProfileStatic: s, imageAssetSize: c = 30 }) => /* @__PURE__ */ m("div", {
	className: `tc-profile-image-wrapper ${t ?? ""} ${r ? "square-image" : ""}`,
	"aria-hidden": "true",
	children: [
		e ? /* @__PURE__ */ p("img", {
			src: Z(c, e, a, o),
			className: "profile-image",
			alt: ""
		}) : /* @__PURE__ */ p(R, {
			className: "default-no-user-icon",
			iconName: M.USER_NONE,
			sizeInPx: "14",
			color: "var(--thriveLightSlate)"
		}),
		n && /* @__PURE__ */ p("img", {
			src: `${Z(30, n, a, s)}`,
			className: "second-profile-image",
			alt: ""
		}),
		i && /* @__PURE__ */ p(R, {
			className: "default-no-user-icon",
			iconName: M.USER_NONE,
			sizeInPx: "14",
			color: "var(--thriveLightSlate)"
		})
	]
}), vt = ({ activity: e }) => /* @__PURE__ */ p("div", {
	className: `user-activity-image-wrapper ${e}`,
	"aria-hidden": "true",
	children: /* @__PURE__ */ p(R, {
		className: oe(e),
		iconName: oe(e),
		sizeInPx: "10"
	})
}), yt = ({ profileImageUrl: e, userActivity: t, secondProfileImageUrl: n, defaultSecondProfileImage: r }) => /* @__PURE__ */ m("div", {
	className: "user-activity-profile-image-wrapper",
	"aria-hidden": "true",
	children: [
		e ? /* @__PURE__ */ p("img", {
			src: Z(30, e),
			className: "profile-image",
			alt: ""
		}) : /* @__PURE__ */ p(R, {
			className: "default-no-user-icon",
			iconName: M.USER_NONE,
			sizeInPx: "14",
			color: "var(--thriveLightSlate)"
		}),
		/* @__PURE__ */ p(vt, { activity: t }),
		n && /* @__PURE__ */ p("img", {
			src: Z(30, n),
			className: "second-profile-image",
			alt: ""
		}),
		r && /* @__PURE__ */ p(R, {
			className: "default-no-user-icon second-default-image",
			iconName: M.USER_NONE,
			sizeInPx: "14",
			color: "var(--thriveLightSlate)"
		})
	]
}), bt = ({ imageUrl: e, isSingleProfile: t = !1, imageCap: n, plusUserPlaceholder: r, isDoubleIconOffset: i }) => {
	let a = i && e.length > 1 && !t ? 2 : n, o = e?.slice(0, a) || [];
	return /* @__PURE__ */ m("div", {
		className: `user-profile-image-wrapper ${t ? "single-item" : ""} ${!t && i ? "double-icon-offset" : ""}`,
		"aria-hidden": "true",
		children: [o.map((e, t) => /* @__PURE__ */ p("img", {
			src: Z(140, e),
			className: `profile-image-icon profile-${t}`,
			alt: "",
			"data-testid": `profile-image-${t}`
		}, t)), r && /* @__PURE__ */ m("span", {
			className: "plus-users",
			children: [" +", r]
		})]
	});
}, xt = ({ accessibileName: e, handleMediaLibrary: t, className: n, asset: r, removeAsset: i }) => {
	let [a, o] = d(!1), [c, l] = d(!1);
	s(() => {
		c && i();
	}, [c]);
	function u() {
		l(!1), t();
	}
	return s(() => {
		o(!1);
	}, [r?.url]), /* @__PURE__ */ p(f, { children: r && !c ? /* @__PURE__ */ m("div", {
		className: "tc-add-image-image-preview-wrapper",
		onMouseEnter: () => o(!0),
		onMouseLeave: () => o(!1),
		children: [/* @__PURE__ */ p("img", {
			className: "tc-add-image-image-preview",
			src: Z(ft.M, r.url),
			alt: e,
			onError: () => l(!0)
		}), a && /* @__PURE__ */ p("button", {
			"aria-label": `${e} delete`,
			name: `${e} delete`,
			type: "button",
			className: "tc-add-image-image-preview-remove-image-button",
			onClick: i,
			children: /* @__PURE__ */ p(R, {
				iconName: M.BIN,
				sizeInPx: "24",
				color: "red",
				className: ""
			})
		})]
	}) : /* @__PURE__ */ p(X, {
		text: "Image has been removed from media library, please select a new image",
		tooltipDisabled: !c,
		className: "below error-tooltip",
		children: /* @__PURE__ */ p("button", {
			"aria-label": `${e} add`,
			name: `${e} add`,
			type: "button",
			className: `tc-add-image-button ${n} ${c ? "image-error" : ""}`,
			onClick: u,
			children: /* @__PURE__ */ p(R, {
				iconName: M.IMAGE_UPLOAD,
				sizeInPx: "24",
				color: c ? "#D12A36" : "#5B6C7F",
				className: ""
			})
		})
	}) });
}, St = ({ className: e, alertMessage: t }) => /* @__PURE__ */ m("div", {
	className: `alert-error-container ${e}`,
	"data-testid": "alert-error",
	children: [/* @__PURE__ */ p("div", {
		className: "alert-error-icon",
		children: /* @__PURE__ */ p(R, {
			iconName: M.ALERT_INFO,
			color: "white"
		})
	}), t]
}), Ct = ({ feedbackType: e, feedbackMessage: t }) => e ? /* @__PURE__ */ m("div", {
	className: `action-feedback-wrapper ${e}`,
	children: [/* @__PURE__ */ p(R, {
		iconName: ae(e),
		sizeInPx: "12",
		color: "white"
	}), t && /* @__PURE__ */ p("span", {
		className: "action-feedback-message",
		children: t
	})]
}) : /* @__PURE__ */ p(f, {}), wt = ({ information: e, className: t }) => e ? /* @__PURE__ */ p("div", {
	className: `muted-information-panel ${t ?? ""}`,
	children: /* @__PURE__ */ p("span", {
		className: "muted-information-message",
		children: e
	})
}) : /* @__PURE__ */ p(f, {});
//#endregion
//#region components/global/information/containers/InformationContainer.tsx
function Tt(e) {
	switch (e) {
		case "info": return "var(--thriveCharcoal)";
		case "warning":
		case "error": return "var(--thriveRed)";
	}
}
var Et = ({ type: e = "info", className: t, children: n }) => /* @__PURE__ */ m("div", {
	className: `thrive-components-information-container ${t || ""}`,
	children: [/* @__PURE__ */ p("div", {
		className: `icon-wrapper ${e}`,
		children: /* @__PURE__ */ p(R, {
			iconName: M.INFO,
			color: Tt(e),
			sizeInPx: "12"
		})
	}), /* @__PURE__ */ p("div", {
		className: "message-wrapper",
		children: n
	})]
}), Dt = ({ information: e }) => e ? /* @__PURE__ */ p("div", {
	className: "information-oval",
	children: e
}) : /* @__PURE__ */ p(f, {}), Ot = ({ className: e, profileImageUrl: t, displayName: n, mediaTitle: r, date: i }) => /* @__PURE__ */ m("div", {
	className: `media-info-wrapper ${e}`,
	children: [/* @__PURE__ */ p("div", {
		className: "left-panel",
		children: /* @__PURE__ */ p(Q, {
			profileImageUrl: t,
			isSquareImage: !0
		})
	}), /* @__PURE__ */ m("div", {
		className: "right-panel",
		children: [/* @__PURE__ */ p("span", {
			className: "user-data",
			children: n
		}), /* @__PURE__ */ m("span", {
			className: "media-data",
			children: [
				r,
				/* @__PURE__ */ p(R, {
					iconName: M.MIDDOT,
					sizeInPx: "8",
					className: "mid-dot",
					color: "var(--thriveLightSlate)"
				}),
				i
			]
		})]
	})]
}), kt = ({ className: e, profileImageUrl: t, authorName: n, authorJobInformation: r, date: i, accessToken: a }) => /* @__PURE__ */ m("div", {
	className: `content-post-information-wrapper ${e}`,
	children: [/* @__PURE__ */ p("div", {
		className: "left-panel",
		children: /* @__PURE__ */ p(Q, {
			profileImageUrl: t,
			accessToken: a,
			isSquareImage: !0
		})
	}), /* @__PURE__ */ m("div", {
		className: "right-panel",
		children: [
			/* @__PURE__ */ p("span", {
				className: "author-name",
				children: n
			}),
			r && /* @__PURE__ */ m("span", {
				className: "author-job-information",
				children: [/* @__PURE__ */ p(R, {
					iconName: M.BRIEFCASE,
					sizeInPx: "12",
					className: "content-post-information-icon",
					color: "var(--thriveGreyDark)"
				}), r]
			}),
			i && /* @__PURE__ */ m("span", {
				className: "content-post-time",
				children: [/* @__PURE__ */ p(R, {
					iconName: M.CLOCK,
					sizeInPx: "12",
					className: "content-post-information-icon",
					color: "var(--thriveGreyDark)"
				}), i]
			})
		]
	})]
}), At = ({ className: e, contentPostInformation: t, contentTitle: n, socialInfo: r, viewContentButton: i, contentLink: a, contentButtonClick: o, children: s }) => /* @__PURE__ */ m("div", {
	className: `social-content-post-wrapper ${e}`,
	children: [
		/* @__PURE__ */ p(kt, { ...t }),
		/* @__PURE__ */ p("h3", {
			className: "social-content-title",
			children: n
		}),
		s,
		/* @__PURE__ */ m("div", {
			className: "social-content-bottom-panel",
			children: [/* @__PURE__ */ p(ze, { ...r }), /* @__PURE__ */ p(Je, {
				className: "social-content-button-wrapper",
				content: i,
				ariaLabel: "View Content",
				isLink: !!a,
				linkUrl: a,
				onButtonClick: o
			})]
		})
	]
}), jt = ({ index: e, hoverIndex: t, containerRef: n, moveListItem: r, setHoverIndex: i, dragAndDropAction: a }) => {
	let o = u(null), c = u(null), [{ isDragging: l }, d, f] = _({
		type: "ROW",
		item: { index: e },
		collect: (e) => ({ isDragging: e.isDragging() }),
		end: () => {
			i(null);
		}
	});
	d(c);
	let [, p] = v({
		accept: "ROW",
		hover(t) {
			if (!o.current) return;
			let n = t.index, a = e;
			n !== a && (r(n, a, !1), i(a), t.index = a);
		},
		drop() {
			i(null), a?.(t ?? 0);
		}
	});
	return s(() => {
		f(p(o));
	}, [f, p]), s(() => {
		document.body.style.cursor = l ? "grabbing" : "inherit";
	}, [l]), s(() => {
		let e = (e) => {
			n.current && !n.current.contains(e.relatedTarget) && i(null);
		};
		return n?.current.addEventListener("dragleave", e), () => n?.current.addEventListener("dragleave", e);
	}, [n]), {
		isDragging: l,
		dragRef: c,
		rowRef: o
	};
}, Mt = ({ id: e, text: t, placeholderText: n, index: r, hoverIndex: i, onEditOptionText: a, onDeleteOptionClick: o, containerRef: s, moveListItem: c, setHoverIndex: l, dragAndDropAction: u, key: d }) => {
	let { isDragging: f, dragRef: h, rowRef: g } = jt({
		index: r,
		hoverIndex: i,
		containerRef: s,
		moveListItem: c,
		setHoverIndex: l,
		dragAndDropAction: u
	});
	return /* @__PURE__ */ m("li", {
		ref: g,
		className: `text-option-list-item ${f ? "is-dragging" : ""}  ${r === i ? "is-hovering" : ""}`,
		children: [
			/* @__PURE__ */ p(B, {
				id: "text-element",
				className: "text-option-input",
				labelText: `Option text input at index ${e}`,
				labelIsHidden: !0,
				placeholderText: n || "Option",
				textString: t,
				setTextString: (t) => a(e, t)
			}),
			/* @__PURE__ */ p(F, {
				className: "remove-text-option-button",
				ariaLabel: "remove option from list",
				content: /* @__PURE__ */ p(R, {
					iconName: M.BIN,
					color: "var(--thriveGreyDark)",
					sizeInPx: "12"
				}),
				onButtonClick: () => o(e)
			}),
			/* @__PURE__ */ p(Y, {
				dragRef: h,
				className: "text-option-drag-and-drop"
			})
		]
	}, d);
}, Nt = ({ optionList: e, setOptionList: t, optionListTitle: n, showOptionListTitle: r, optionPlaceholderText: i, optionLimit: a }) => {
	let o = u(null), [s, c] = d(null), l = !!a && a === e.length, f = e.some((e) => !e.text || e.text.trim() === ""), h = l || f;
	function _() {
		let n = {
			id: (e.length > 0 ? Math.max(...e.map((e) => e.id)) : 0) + 1,
			text: ""
		};
		t([...e, n]);
	}
	function v(n, r) {
		t(e.map((e) => e.id === n ? {
			...e,
			text: r
		} : e));
	}
	function b(n) {
		t(e.filter((e) => e.id !== n));
	}
	function x(n, r) {
		let i = e[n], a = [...e];
		a.splice(n, 1), a.splice(r, 0, i), t(a), c(null);
	}
	return /* @__PURE__ */ p(g, {
		backend: y,
		options: { enableMouseEvents: !0 },
		children: /* @__PURE__ */ m("div", {
			className: "text-option-list-container",
			ref: o,
			children: [
				r && /* @__PURE__ */ p("h2", { children: n || "Options" }),
				/* @__PURE__ */ p("ul", {
					className: "text-option-list",
					children: e.map((e, t) => /* @__PURE__ */ p(Mt, {
						id: e.id,
						text: e.text,
						index: t,
						onEditOptionText: v,
						onDeleteOptionClick: () => b(e.id),
						containerRef: o,
						moveListItem: x,
						hoverIndex: s,
						setHoverIndex: c,
						placeholderText: i
					}, `${e.id}-${e.id}`))
				}),
				/* @__PURE__ */ p(G, {
					className: "add-option-panel-button",
					isDisabled: h,
					content: "+ Add Option",
					ariaLabel: "Add an option to the list",
					onButtonClick: () => _()
				})
			]
		})
	});
}, Pt = ({ title: e, items: t, className: n = "" }) => /* @__PURE__ */ m("div", {
	className: `checkbox-list-wrapper ${n}`,
	children: [e && /* @__PURE__ */ p("p", {
		className: "checkbox-list-title",
		children: e
	}), /* @__PURE__ */ p("ul", {
		className: "checkbox-list",
		children: t.map((e) => {
			let t = `${e.text}-${e.value}`.toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-"), n = `checkbox-item-${t}`;
			return /* @__PURE__ */ m("li", {
				className: `checkbox-list-item ${e.disabled ? "disabled-style" : ""}`,
				children: [/* @__PURE__ */ p("input", {
					type: "checkbox",
					id: n,
					className: "checkbox-input",
					checked: e.checked,
					disabled: e.disabled,
					onChange: (t) => {
						t.preventDefault(), e.onChange();
					},
					"aria-checked": e.checked,
					"aria-disabled": e.disabled
				}), /* @__PURE__ */ p("label", {
					className: "checkbox-label-text",
					htmlFor: n,
					onClick: (t) => {
						t.preventDefault(), e.onChange();
					},
					children: e.text
				})]
			}, `checkbox-list-item-${t}`);
		})
	})]
}), Ft = ({ buttons: e = [], className: t = "", allButtonOnClick: n, fixedPosition: r }) => {
	let [i, a] = d(0), o = u(null), c = (t) => {
		if (i !== null) switch (t.key) {
			case "ArrowDown":
				t.preventDefault(), a((t) => t === null ? 0 : Math.min(t + 1, e.length - 1));
				break;
			case "ArrowUp":
				t.preventDefault(), a((e) => e === null ? 0 : Math.max(e - 1, 0));
				break;
			case "Enter":
			case " ":
				t.preventDefault(), l(e[i].onClick);
				break;
			case "Escape":
				a(null);
				break;
			default: break;
		}
	};
	if (s(() => {
		if (i !== null && o.current) {
			let e = o.current.children[i];
			if (e) {
				e?.scrollIntoView?.({ block: "nearest" });
				let t = e.querySelector("button");
				t && t.focus();
			}
		}
	}, [i]), !e || e.length === 0) return null;
	function l(e) {
		e(), n && n();
	}
	return /* @__PURE__ */ p("ul", {
		ref: o,
		className: `select-button-list ${e.length === 1 ? "single-button" : ""} ${t} ${r ? "fixed-position" : ""}`,
		role: "listbox",
		"aria-activedescendant": i === null ? void 0 : `button-${i}`,
		tabIndex: 0,
		onKeyDown: c,
		style: r || void 0,
		children: e.map((e, t) => e && /* @__PURE__ */ p("li", {
			id: `button-${t}`,
			className: "select-button-list-item",
			role: "option",
			"aria-selected": i === t,
			children: /* @__PURE__ */ p("button", {
				type: "button",
				className: `select-button ${e.isSelected && "selected-button"}`,
				onClick: (t) => l(() => e.onClick(t)),
				disabled: e?.isDisabled,
				children: e.content
			})
		}, t))
	});
}, It = ({ items: e, showCheckbox: t, handleClick: n }) => {
	let [r, i] = d(0), a = u(null), o = (t, r) => {
		switch (t.key) {
			case "ArrowDown":
				t.preventDefault(), i((t) => t === null ? 0 : Math.min(t + 1, e.length - 1));
				break;
			case "ArrowUp":
				t.preventDefault(), i((e) => e === null ? 0 : Math.max(e - 1, 0));
				break;
			case "Enter":
			case " ":
				t.preventDefault(), n(r);
				break;
			case "Escape": i(null);
			default: break;
		}
	}, c = (e, t) => {
		e.preventDefault(), n(t);
	};
	return s(() => {
		if (r !== null && a.current) {
			let e = a.current.children[r];
			if (e) {
				e.scrollIntoView({ block: "nearest" });
				let t = e.querySelector(".select-list-item");
				t && t.focus();
			}
		}
	}, [r]), /* @__PURE__ */ p("ul", {
		ref: a,
		className: `select-list ${e.length === 1 ? "single-item" : ""}`,
		role: "menu",
		children: e.map((e, n) => /* @__PURE__ */ m("button", {
			className: `select-list-item ${e.isSelected && "is-selected"}`,
			onClick: ((e) => c(e, n)),
			onKeyDown: (e) => o(e, n),
			role: "menuitem",
			tabIndex: 0,
			"aria-disabled": e?.isDisabled,
			children: [/* @__PURE__ */ m("div", {
				className: "list-content",
				children: [/* @__PURE__ */ m("span", {
					className: "header",
					children: [
						e.header,
						" ",
						e?.tooltipIcon
					]
				}), /* @__PURE__ */ p("span", {
					className: "content",
					children: e.content
				})]
			}), t && /* @__PURE__ */ m("div", {
				className: "custom-checkbox",
				children: [/* @__PURE__ */ p("input", {
					type: "checkbox",
					checked: e.isSelected,
					readOnly: !0,
					tabIndex: -1,
					"aria-label": `Select ${e.header}`,
					disabled: e?.isDisabled
				}), /* @__PURE__ */ p("span", { className: "custom-list-checkmark" })]
			})]
		}, n))
	});
}, Lt = ({ size: e }) => /* @__PURE__ */ m("div", {
	className: "lds-spinner",
	"data-testid": "lds-spinner",
	style: {
		height: `${e}px`,
		width: `${e}px`,
		margin: "8px auto"
	},
	children: [
		/* @__PURE__ */ p("div", {}),
		/* @__PURE__ */ p("div", {}),
		/* @__PURE__ */ p("div", {}),
		/* @__PURE__ */ p("div", {}),
		/* @__PURE__ */ p("div", {}),
		/* @__PURE__ */ p("div", {}),
		/* @__PURE__ */ p("div", {}),
		/* @__PURE__ */ p("div", {})
	]
}), Rt = ({ currentItem: e, totalItems: t, isPaused: n, onPlayButtonClick: r, onLeftClick: i, onRightClick: a }) => /* @__PURE__ */ m("div", {
	className: "content-preview-carousel-controls",
	children: [
		/* @__PURE__ */ p("div", {
			className: "carousel-play-pause-controls",
			children: /* @__PURE__ */ p(z, {
				className: "carousel-play-pause-button",
				ariaLabel: n ? "Play Carousel" : "Pause Carousel",
				iconName: n ? M.PLAY : M.PAUSE,
				onButtonClick: r
			})
		}),
		/* @__PURE__ */ m("div", {
			className: "carousel-count-information",
			children: [
				e + 1,
				" ",
				"of",
				" ",
				t
			]
		}),
		/* @__PURE__ */ m("div", {
			className: "left-right-controls",
			children: [/* @__PURE__ */ p(z, {
				className: "carousel-left-button",
				ariaLabel: "View Previous Item",
				iconName: M.CHEVRON_RIGHT,
				onButtonClick: i
			}), /* @__PURE__ */ p(z, {
				className: "carousel-right-button",
				ariaLabel: "View Next Item",
				iconName: M.CHEVRON_RIGHT,
				onButtonClick: a
			})]
		})
	]
}), zt = ({ uniqueId: e, animationDuration: i = 5, autoStart: a = !0, isPaused: o = !1, backgroundColor: c = "var(--thriveGreyLight)", fillColor: l = "var(--thrivePink)" }) => {
	let d = t(0), f = u(null);
	return s(() => {
		if (!a || o) return;
		let e = d.get();
		return f.current = r(d, 1, {
			duration: (1 - e) * i,
			ease: "linear"
		}), () => f.current?.stop();
	}, [
		a,
		o,
		i
	]), s(() => {
		o && f.current?.stop();
	}, [o]), /* @__PURE__ */ p("div", {
		style: {
			width: "100%",
			height: 4,
			position: "relative",
			overflow: "hidden",
			marginTop: -4,
			background: c,
			borderBottomLeftRadius: 6,
			borderBottomRightRadius: 6
		},
		children: /* @__PURE__ */ p(n.div, { style: {
			position: "absolute",
			inset: 0,
			background: l,
			originX: 0,
			scaleX: d
		} }, e)
	});
}, Bt = {
	enter: { opacity: 0 },
	center: { opacity: 1 },
	exit: { opacity: 0 }
}, Vt = ({ className: t, mediaItems: r, token: i, videoAutoPlayEnabled: a }) => {
	if (!Array.isArray(r) || r.length === 0) return /* @__PURE__ */ p(f, {});
	let [o, c] = d(0), [l, h] = d(!1), g = r[o], _ = u(null), v = u(null), y = u(null), b = k(v);
	s(() => {
		if (!y.current) return;
		let e = new IntersectionObserver(([e]) => {
			y.current && (e.isIntersecting ? h(!1) : h(!0));
		}, { threshold: 1 });
		return e.observe(y.current), () => {
			e.disconnect();
		};
	}, []), s(() => {
		v.current && (!l && a ? (b(), v.current.play().catch(() => {
			console.error("Browser may have blocked autoplay");
		})) : v.current.pause());
	}, [l]), s(() => {
		if (!l) return x(), () => {
			_.current && clearInterval(_.current);
		};
	}, [l, r.length]);
	function x() {
		_.current && clearInterval(_.current), _.current = setInterval(() => {
			c((e) => (e + 1) % r.length);
		}, 6e3);
	}
	function S() {
		h(!l);
	}
	function C(e) {
		c((t) => e === "previous" ? t === 0 ? r.length - 1 : t - 1 : t === r.length - 1 ? 0 : t + 1), x();
	}
	return /* @__PURE__ */ m("div", {
		ref: y,
		className: `content-preview-carousel ${t ?? ""}`,
		children: [/* @__PURE__ */ p("div", {
			className: "carousel-frame",
			children: /* @__PURE__ */ p(e, {
				mode: "wait",
				children: /* @__PURE__ */ m(n.div, {
					className: `slide ${g.mediaType === "video" ? "is-video" : "is-image"}`,
					variants: Bt,
					initial: "enter",
					animate: "center",
					exit: "exit",
					transition: {
						duration: .3,
						ease: "easeInOut"
					},
					children: [
						(g.mediaType === "image" || g.mediaType === "audio") && g.url && /* @__PURE__ */ p(pt, {
							imageUrl: g.url,
							maxWidth: 600,
							token: i
						}),
						g.mediaType === "video" && /* @__PURE__ */ p(f, { children: /* @__PURE__ */ p("video", {
							ref: v,
							autoPlay: !l && a,
							muted: !0,
							disablePictureInPicture: !0,
							"aria-label": "",
							src: `${i ? `${g.url}?access_token=${i}` : g.url}`
						}) }),
						/* @__PURE__ */ p(zt, {
							uniqueId: o,
							animationDuration: 6,
							isPaused: l
						})
					]
				}, o)
			})
		}), /* @__PURE__ */ p(Rt, {
			currentItem: o,
			totalItems: r.length,
			isPaused: l,
			onPlayButtonClick: S,
			onLeftClick: () => C("previous"),
			onRightClick: () => C("next")
		})]
	});
}, Ht = () => /* @__PURE__ */ m("svg", {
	className: "audio-background-image",
	width: "170px",
	height: "140px",
	viewBox: "0 0 51 40",
	version: "1.1",
	xmlns: "http://www.w3.org/2000/svg",
	children: [
		/* @__PURE__ */ p("title", { children: "audio_icon" }),
		/* @__PURE__ */ p("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ p("g", {
			id: "MP3-Content-Widget-",
			stroke: "none",
			strokeWidth: "1",
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ m("g", {
				id: "audio_icon",
				transform: "translate(0.236084, 0.000000)",
				fillRule: "nonzero",
				children: [/* @__PURE__ */ m("g", {
					id: "video_icon",
					transform: "translate(0.490385, 0.000000)",
					children: [
						/* @__PURE__ */ p("path", {
							d: "M41.31,33.89 L41.31,33.89 L41.31,33.89 C41.3055598,33.9398975 41.3055598,33.9901025 41.31,34.04 L41.31,34.04 C41.2158235,34.456621 41.1664934,34.8824723 41.1628846,35.31 L41.1628846,35.31 C41.1576526,35.3531692 41.1576526,35.3968308 41.1628846,35.44 L41.1628846,35.44 C41.1580334,35.3901223 41.1580334,35.3398777 41.1628846,35.29 C41.1571259,34.8190278 41.2065135,34.3490378 41.31,33.89 Z",
							id: "Path",
							fill: "var(--thriveGreyDark)"
						}),
						/* @__PURE__ */ p("polygon", {
							id: "Path",
							fill: "var(--thriveGreyDark)",
							points: "42.1730769 38.62 42.0161538 38.39 42.0161538 38.39"
						}),
						/* @__PURE__ */ p("polygon", {
							id: "Path",
							fill: "var(--thriveGreyDark)",
							points: "43.5461538 40 43.5461538 40 43.35 39.86"
						}),
						/* @__PURE__ */ p("path", {
							d: "M45.4586538,29.88 L45.4586538,29.88 L45.4586538,29.88 L45.39,29.88 L45.1153846,30 L45.0173077,30 C44.7895216,30.0752404 44.5667486,30.1654288 44.3503846,30.27 C43.9348299,30.4503501 43.5480549,30.6930325 43.2028846,30.99 C42.8849331,31.247444 42.5984584,31.5428932 42.3496154,31.87 L42.3496154,31.87 C43.1281574,30.8589992 44.2272681,30.1554922 45.4586538,29.88 L45.4586538,29.88 Z",
							id: "Path",
							fill: "var(--thriveGreyDark)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M49.0973077,30.35 L49.0973077,30.35 C48.9109615,30.26 48.7344231,30.18 48.5480769,30.11 L48.0576923,30 C47.8750773,29.9414119 47.6881249,29.8979376 47.4986538,29.87 L47.4986538,29.87 C48.0527409,29.9444375 48.5920841,30.1063767 49.0973077,30.35 L49.0973077,30.35 Z",
							id: "Path",
							fill: "#var(--thriveGreyDark)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M49.9309777,35.37 C49.932029,35.6096737 49.8276479,35.8372089 49.6465385,35.99 L49.6465385,35.99 C49.5079678,36.1052199 49.3349559,36.1687254 49.1561538,36.17 L47.4103846,36.17 L47.4103846,38 C47.4098801,38.1029287 47.3898994,38.204791 47.3515385,38.3 C47.3107138,38.4117362 47.2433119,38.5113854 47.1553846,38.59 C47.0072711,38.7256687 46.8150651,38.8004954 46.6159615,38.8000048 C46.1826304,38.8000048 45.8313462,38.4418278 45.8313462,38 L45.8313462,36.18 L44.2032692,36.18 C43.817397,36.1845617 43.4870531,35.8989031 43.4284615,35.51 C43.4231217,35.480247 43.4231217,35.449753 43.4284615,35.42 L43.4284615,35.42 C43.4338312,34.9765595 43.7879387,34.6199662 44.2228846,34.62 L45.8313462,34.62 L45.8313462,34.62 L45.8313462,32.48 C45.8295251,32.2630235 45.9187508,32.0556 46.0765385,31.91 C46.1788129,31.8002022 46.3128373,31.7266201 46.4590385,31.7 L46.5865385,31.7 L46.5865385,31.7 C46.7969046,31.7003527 46.9983207,31.7868223 47.1455769,31.94 C47.29772,32.0888115 47.3828857,32.2950461 47.3809615,32.51 L47.3809615,34.6 L49.1365385,34.6 C49.3242214,34.6039346 49.5046416,34.6746876 49.6465385,34.8 C49.7874582,34.9089079 49.8793826,35.0711275 49.9015385,35.25 C49.9173893,35.2882025 49.9273156,35.3286864 49.9309777,35.37 Z",
							id: "Path",
							fill: "var(--thriveGreyDark)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M3.63865385,7.35 L3.63865385,30.29 L1.67711538,30.29 L1.67711538,8.66 C1.68223705,7.94643094 2.24262272,7.3661988 2.94230769,7.35 L3.63865385,7.35 Z",
							id: "Path",
							fill: "var(--thriveGreyDark)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M29.0111538,21.05 L29.0111538,30.29 L5.2275,30.29 L5.2275,7.35 L27.7851923,7.35 C28.494772,7.35 29.07,7.93650698 29.07,8.66 L29.07,14.52 L29.0111538,21.05 Z",
							id: "Path",
							fill: "var(--thriveGreyDark)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M29.0210275,31.91 L29.0210275,37.27 C29.0240893,37.7185523 28.8068888,38.1389496 28.4423077,38.39 L5.59038462,38.39 C3.89084926,38.3899228 2.37676933,37.2952511 1.81442308,35.66 L15.1136538,35.66 C15.5524015,35.66 15.9080769,35.2973506 15.9080769,34.85 C15.9080769,34.4026494 15.5524015,34.04 15.1136538,34.04 L1.63788462,34.04 L1.63788462,31.91 L29.0210275,31.91 Z",
							id: "Path",
							fill: "var(--thriveGreyDark)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M33.0617308,33.89 C32.7779108,33.89 32.5156501,34.0443851 32.3737402,34.295 C32.2318301,34.5456149 32.2318301,34.8543851 32.3737402,35.105 C32.5156501,35.3556149 32.7779108,35.51 33.0617308,35.51 L41.1923077,35.51 C41.1870757,35.4668308 41.1870757,35.4231692 41.1923077,35.38 L41.1923077,35.38 C41.1959164,34.9524723 41.2452466,34.526621 41.3394231,34.11 L41.3394231,34.11 C41.3349828,34.0601025 41.3349828,34.0098975 41.3394231,33.96 L41.3394231,33.96 L33.0617308,33.89 Z M41.9965385,38.39 L41.9965385,38.39 L42.1534615,38.62 L41.9965385,38.39 Z M43.3401923,39.86 L43.5363462,40 L43.5363462,40 L43.3401923,39.86 Z M42.2907692,31.91 L42.2907692,31.91 C42.5408158,31.5717643 42.8306803,31.2661405 43.1538462,31 C43.4990164,30.7030325 43.8857915,30.4603501 44.3013462,30.28 C44.5333847,30.1699515 44.7726092,30.076395 45.0173077,30 L45.1153846,30 L45.3801923,29.93 L45.4488462,29.93 L45.4488462,29.93 L45.4488462,29.93 C44.2010436,30.192087 43.0832421,30.892908 42.2907692,31.91 L42.2907692,31.91 Z M47.5084615,29.83 L47.5084615,29.83 C47.6957275,29.8715024 47.8794012,29.9283538 48.0576923,30 L48.5382692,30.15 C48.7246154,30.22 48.9011538,30.3 49.0875,30.39 L49.0875,30.39 C48.5929596,30.1206478 48.0601929,29.9317042 47.5084615,29.83 L47.5084615,29.83 Z M33.0617308,33.89 C32.7779108,33.89 32.5156501,34.0443851 32.3737402,34.295 C32.2318301,34.5456149 32.2318301,34.8543851 32.3737402,35.105 C32.5156501,35.3556149 32.7779108,35.51 33.0617308,35.51 L41.1923077,35.51 C41.1870757,35.4668308 41.1870757,35.4231692 41.1923077,35.38 L41.1923077,35.38 C41.1959164,34.9524723 41.2452466,34.526621 41.3394231,34.11 L41.3394231,34.11 C41.3349828,34.0601025 41.3349828,34.0098975 41.3394231,33.96 L41.3394231,33.96 L33.0617308,33.89 Z M8.00574884e-16,34.67 C-0.00530692221,34.729878 -0.00530692221,34.790122 3.56485674e-16,34.85 C-0.00179747411,34.9670907 0.0216387958,35.083156 0.0686538462,35.19 C0.0309183917,35.0190437 0.00794593826,34.8450451 4.67507977e-16,34.67 L8.00574884e-16,34.67 Z",
							id: "Shape",
							fill: "var(--thriveCharcoal)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M43.5069231,0 L5.59038462,0 C2.50131464,0.00551601541 0,2.5603552 0,5.71 L0,34.3 C0,34.43 0,34.55 0,34.67 C0.00148561472,34.8444575 0.017893961,35.0184503 0.0490384615,35.19 C0.483488633,37.9652972 2.83401043,40.0055975 5.59038462,40.0000229 L43.5363462,40.0000229 L43.3401923,39.86 L43.1538462,39.73 L43.1538462,39.67 C43.0842708,39.6222388 43.0186652,39.5687252 42.9576923,39.51 L42.8007692,39.35 L42.8007692,39.35 L42.8007692,39.35 L42.8007692,39.35 L42.8007692,39.35 L42.7125,39.25 L42.4967308,38.99 C42.4555137,38.9478043 42.4193038,38.9008153 42.3888462,38.85 L42.1730769,38.62 L42.0161538,38.39 L5.59038462,38.39 C3.89084926,38.3899228 2.37676933,37.2952511 1.81442308,35.66 L15.1136538,35.66 C15.5524015,35.66 15.9080769,35.2973506 15.9080769,34.85 C15.9080769,34.4026494 15.5524015,34.04 15.1136538,34.04 L1.57903846,34.04 L1.57903846,31.91 L42.2907692,31.91 C43.0825289,30.8834693 44.2045029,30.1751266 45.4586538,29.91 L45.4586538,7.2 C45.4478926,5.25109821 43.8981764,3.67545906 41.9867308,3.67 L7.12038462,3.67 C5.20511212,3.66996901 3.64944411,5.24720413 3.63865385,7.2 L3.63865385,30.29 L1.57903846,30.29 L1.57903846,5.71 C1.57903187,3.44953203 3.37339377,1.61551334 5.59038462,1.61 L43.5069231,1.61 C44.5707992,1.61264893 45.5900694,2.0461009 46.3405041,2.81500076 C47.0909388,3.58390062 47.5110659,4.62526357 47.5084615,5.71 L47.5084615,29.83 C48.0613615,29.9180958 48.5974128,30.0935355 49.0973077,30.35 L49.0973077,5.71 C49.0973077,2.5603552 46.5959931,0.00551601541 43.5069231,0 Z M5.25692308,7.2 C5.2673047,6.15178173 6.09248945,5.30156041 7.12038462,5.28 L41.9867308,5.28 C43.0244958,5.2854684 43.8644445,6.14188664 43.8698077,7.2 L43.8698077,30.29 L5.2275,30.29 L5.25692308,7.2 Z",
							id: "Shape",
							fill: "var(--thriveCharcoal)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M49.9015385,35.22 C49.8793826,35.0411275 49.7874582,34.8789079 49.6465385,34.77 C49.5046416,34.6446876 49.3242214,34.5739346 49.1365385,34.57 L47.4103846,34.57 L47.4103846,32.48 C47.4123088,32.2650461 47.3271431,32.0588115 47.175,31.91 C47.0277438,31.7568223 46.8263277,31.6703527 46.6159615,31.67 L46.6159615,31.67 L46.4884615,31.67 C46.3422604,31.6966201 46.208236,31.7702022 46.1059615,31.88 C45.9481739,32.0256 45.8589481,32.2330235 45.8607692,32.45 L45.8607692,34.52 L45.8607692,34.52 L44.2032692,34.52 C43.7683233,34.5199662 43.4142159,34.8765595 43.4088462,35.32 L43.4088462,35.32 C43.4035064,35.349753 43.4035064,35.380247 43.4088462,35.41 C43.4674377,35.7989031 43.7977816,36.0845617 44.1836538,36.08 L45.8117308,36.08 L45.8117308,38 C45.8117308,38.4418278 46.163015,38.8000048 46.5963462,38.8000048 C46.7954498,38.8004954 46.9876557,38.7256687 47.1357692,38.59 C47.2236965,38.5113854 47.2910985,38.4117362 47.3319231,38.3 C47.370284,38.204791 47.3902647,38.1029287 47.3907692,38 L47.3907692,36.18 L49.1365385,36.18 C49.3153405,36.1787254 49.4883524,36.1152199 49.6269231,36 L49.6269231,36 C49.8080325,35.8472089 49.9124136,35.6196737 49.9113462,35.38 C49.9186998,35.3265383 49.9153636,35.2721121 49.9015385,35.22 L49.9015385,35.22 Z",
							id: "Path",
							fill: "var(--thriveCharcoal)"
						}),
						/* @__PURE__ */ p("path", {
							d: "M49.9309777,35.37 C49.932029,35.6096737 49.8276479,35.8372089 49.6465385,35.99 L49.6465385,35.99 C49.5079678,36.1052199 49.3349559,36.1687254 49.1561538,36.17 L47.4103846,36.17 L47.4103846,38 C47.4098801,38.1029287 47.3898994,38.204791 47.3515385,38.3 C47.3107138,38.4117362 47.2433119,38.5113854 47.1553846,38.59 C47.0072711,38.7256687 46.8150651,38.8004954 46.6159615,38.8000048 C46.1826304,38.8000048 45.8313462,38.4418278 45.8313462,38 L45.8313462,36.18 L44.2032692,36.18 C43.817397,36.1845617 43.4870531,35.8989031 43.4284615,35.51 C43.4231217,35.480247 43.4231217,35.449753 43.4284615,35.42 L43.4284615,35.42 C43.4338312,34.9765595 43.7879387,34.6199662 44.2228846,34.62 L45.8509615,34.62 L45.8509615,32.48 C45.8491404,32.2630235 45.9383662,32.0556 46.0961538,31.91 C46.1984283,31.8002022 46.3324527,31.7266201 46.4786538,31.7 L46.6061538,31.7 L46.6061538,31.7 C46.81652,31.7003527 47.0179361,31.7868223 47.1651923,31.94 C47.3173354,32.0888115 47.4025011,32.2950461 47.4005769,32.51 L47.4005769,34.6 L49.1365385,34.6 C49.3242214,34.6039346 49.5046416,34.6746876 49.6465385,34.8 C49.7874582,34.9089079 49.8793826,35.0711275 49.9015385,35.25 C49.9173893,35.2882025 49.9273156,35.3286864 49.9309777,35.37 Z",
							id: "Path",
							fill: "var(--thriveCharcoal)"
						})
					]
				}), /* @__PURE__ */ p("path", {
					d: "M32.3643489,21.563916 C32.3643489,23.228226 31.0796767,24.5774159 29.4949531,24.5774159 C27.9102295,24.5774159 26.6255572,23.228226 26.6255572,21.563916 C26.6255572,19.8996059 27.9102295,18.550416 29.4949531,18.550416 C29.9843409,18.5506274 30.4654134,18.6833297 30.891734,18.9357135 L30.891734,13.5544636 L22.0089044,15.4422061 L22.0089044,23.4688784 C22.0126627,24.8335973 21.1450611,26.0316244 19.891796,26.3922858 C18.638531,26.7529472 17.310618,26.1867398 16.6514431,25.010635 C15.9922681,23.8345303 16.1654148,22.3403953 17.0739529,21.3646696 C17.982491,20.3889439 19.4009539,20.1737676 20.5352647,20.8395997 L20.5352647,12.2866411 C20.5387877,11.9205906 20.7850991,11.6067655 21.1265651,11.5332661 L31.4809849,9.32480117 C31.6989086,9.28055619 31.9242748,9.34051624 32.0958554,9.48839116 C32.267447,9.63461493 32.3665823,9.85471916 32.3653953,10.0867862 L32.3653953,21.563916 L32.3643489,21.563916 Z",
					id: "Path",
					fill: "var(--thriveCharcoal)"
				})]
			})
		})
	]
}), Ut = ({ className: e, contentTitle: t, contentUrl: n, audioCaption: r, featuredImage: i }) => /* @__PURE__ */ m("div", {
	className: `audio-player-wrapper ${e}`,
	children: [/* @__PURE__ */ m("div", {
		className: "audio-player-background",
		children: [i ? /* @__PURE__ */ p("img", {
			className: "audio-featured-image-background",
			src: i
		}) : /* @__PURE__ */ p(Ht, {}), /* @__PURE__ */ m("div", {
			className: "audio-player-details",
			children: [/* @__PURE__ */ p("h4", {
				className: "audio-content-title",
				children: t
			}), /* @__PURE__ */ m("audio", {
				className: "audio-player-component",
				controls: !0,
				preload: "metadata",
				children: [/* @__PURE__ */ p("source", {
					src: n,
					type: "audio/mpeg"
				}), "Your browser does not support the audio element."]
			})]
		})]
	}), r && /* @__PURE__ */ p("span", {
		className: "audio-caption",
		children: r
	})]
}), Wt = ({ currentItem: e, totalItems: t, isPaused: n, onPlayButtonClick: r, onLeftClick: i, onRightClick: a }) => /* @__PURE__ */ m("div", {
	className: "content-preview-carousel-controls",
	children: [
		/* @__PURE__ */ p("div", {
			className: "carousel-play-pause-controls",
			children: /* @__PURE__ */ p(z, {
				className: "carousel-play-pause-button",
				ariaLabel: n ? "Play Carousel" : "Pause Carousel",
				iconName: n ? M.PLAY : M.PAUSE,
				onButtonClick: r
			})
		}),
		/* @__PURE__ */ m("div", {
			className: "carousel-count-information",
			children: [
				e + 1,
				" ",
				"of",
				" ",
				t
			]
		}),
		/* @__PURE__ */ m("div", {
			className: "left-right-controls",
			children: [/* @__PURE__ */ p(z, {
				className: "carousel-left-button",
				ariaLabel: "View Previous Item",
				iconName: M.CHEVRON_RIGHT,
				onButtonClick: i
			}), /* @__PURE__ */ p(z, {
				className: "carousel-right-button",
				ariaLabel: "View Next Item",
				iconName: M.CHEVRON_RIGHT,
				onButtonClick: a
			})]
		})
	]
}), Gt = ({ uniqueId: e, animationDuration: i = 6, autoStart: a = !0, isPaused: o = !1, backgroundColor: c = "var(--thriveGreyLight)", fillColor: l = "var(--thrivePink)" }) => {
	let d = t(0), f = u(null);
	return s(() => {
		if (!a || o) return;
		let e = d.get();
		return f.current = r(d, 1, {
			duration: (1 - e) * i,
			ease: "linear"
		}), () => f.current?.stop();
	}, [
		a,
		o,
		i
	]), s(() => {
		o && f.current?.stop();
	}, [o]), /* @__PURE__ */ p("div", {
		style: {
			width: "100%",
			height: 4,
			position: "relative",
			overflow: "hidden",
			marginTop: -4,
			background: c,
			borderBottomLeftRadius: 6,
			borderBottomRightRadius: 6
		},
		children: /* @__PURE__ */ p(n.div, { style: {
			position: "absolute",
			inset: 0,
			background: l,
			originX: 0,
			scaleX: d
		} }, e)
	});
}, Kt = ({ mediaItems: e, token: t, videoAutoPlayEnabled: n }) => {
	let r = 6e3, [i, a] = d(0), [o, c] = d(!1), l = u(null), [f, p] = d(() => /* @__PURE__ */ new Set()), m = u([]), h = u(null), g = k(h), _ = u(null), v = u(null), y = u(r);
	s(() => {
		h.current = m.current[i] ?? null;
	}, [i]), s(() => {
		let t = [], n = e[i];
		if (n?.mediaType === "video" && n.url && t.push(C(n.url)), e.length > 1) {
			let n = e[(i + 1) % e.length];
			n?.mediaType === "video" && n.url && t.push(C(n.url));
		}
		t.length !== 0 && p((e) => {
			let n = new Set(e), r = !1;
			return t.forEach((e) => {
				n.has(e) || (n.add(e), r = !0);
			}), r ? n : e;
		});
	}, [
		i,
		e,
		t
	]), s(() => {
		let t = m.current[i] ?? null;
		if (h.current = t, m.current.forEach((e, t) => {
			e && t !== i && e.pause();
		}), o || !n || e[i]?.mediaType !== "video") {
			t?.pause();
			return;
		}
		t && (g(), t.play().catch(() => {
			console.error("Browser may have blocked autoplay");
		}));
	}, [i, o]), s(() => {
		if (!l.current) return;
		let e = new IntersectionObserver(([e]) => {
			l.current && (e.isIntersecting ? c(!1) : c(!0));
		}, { threshold: 1 });
		return e.observe(l.current), () => {
			e.disconnect();
		};
	}, []), s(() => {
		if (o) {
			if (v.current !== null) {
				let e = Date.now() - v.current;
				y.current = Math.max(0, y.current - e);
			}
			_.current !== null && (window.clearTimeout(_.current), _.current = null), v.current = null;
			return;
		}
		return v.current = Date.now(), _.current = window.setTimeout(() => {
			a((t) => (t + 1) % e.length), y.current = r, v.current = null, _.current = null;
		}, y.current), () => {
			_.current !== null && (window.clearTimeout(_.current), _.current = null);
		};
	}, [
		o,
		i,
		e.length
	]);
	function b(e, t) {
		m.current[e] = t, e === i && (h.current = t);
	}
	function x() {
		c((e) => !e);
	}
	function S(t) {
		y.current = r, a((n) => t === "previous" ? n === 0 ? e.length - 1 : n - 1 : n === e.length - 1 ? 0 : n + 1);
	}
	function C(e) {
		return t ? `${e}?access_token=${t}` : e;
	}
	return {
		containerRef: l,
		counter: i,
		getVideoUrl: C,
		loadedVideoUrls: f,
		setVideoRef: b,
		isPaused: o,
		onPlayClick: x,
		onNavigateClick: S,
		FADE_DURATION: .3,
		SLIDE_DURATION: r
	};
}, qt = ({ className: e, mediaItems: t, token: r, videoAutoPlayEnabled: i }) => {
	if (!(Array.isArray(t) && t.length > 0)) return null;
	let { containerRef: a, counter: o, getVideoUrl: s, loadedVideoUrls: c, setVideoRef: l, isPaused: u, onPlayClick: d, onNavigateClick: f, FADE_DURATION: h, SLIDE_DURATION: g } = Kt({
		mediaItems: t,
		token: r,
		videoAutoPlayEnabled: i
	});
	return /* @__PURE__ */ m("div", {
		ref: a,
		className: `content-preview-carousel ${e ?? ""}`,
		children: [
			/* @__PURE__ */ p("div", {
				className: "carousel-frame",
				children: t.map((e, t) => {
					let i = t === o, a = e.mediaType === "video" && e.url ? s(e.url) : null, u = a !== null && c.has(a);
					return /* @__PURE__ */ m(n.div, {
						className: `slide ${e.mediaType === "video" ? "is-video" : "is-image"}`,
						initial: !1,
						animate: { opacity: +!!i },
						transition: {
							duration: h,
							ease: "easeInOut"
						},
						style: {
							position: "absolute",
							inset: 0,
							zIndex: i ? 2 : 1,
							pointerEvents: i ? "auto" : "none"
						},
						"aria-hidden": !i,
						children: [(e.mediaType === "image" || e.mediaType === "audio") && e.url && /* @__PURE__ */ p(pt, {
							imageUrl: e.url,
							maxWidth: 600,
							token: r
						}), e.mediaType === "video" && e.url && /* @__PURE__ */ p("video", {
							ref: (e) => l(t, e),
							muted: !0,
							playsInline: !0,
							preload: i ? "auto" : "metadata",
							disablePictureInPicture: !0,
							"aria-label": "",
							src: u ? a ?? void 0 : void 0
						})]
					}, `${e.url ?? t}-${t}`);
				})
			}),
			/* @__PURE__ */ p(Gt, {
				uniqueId: o,
				animationDuration: g / 1e3,
				isPaused: u
			}, o),
			/* @__PURE__ */ p(Wt, {
				currentItem: o,
				totalItems: t.length,
				isPaused: u,
				onPlayButtonClick: d,
				onLeftClick: () => f("previous"),
				onRightClick: () => f("next")
			})
		]
	});
}, Jt = ({ className: e, contentUrl: t, caption: n, autoPlayEnabled: r }) => {
	let i = u(null), a = u(null), [o, c] = d(r), [l, f] = d(!1), h = k(i);
	return s(() => {
		if (!r || !i.current || !a.current) return;
		let e = new IntersectionObserver(([e]) => {
			i.current && (e.isIntersecting ? i.current.play().catch(() => {
				console.error("Browser may have blocked autoplay");
			}) : i.current.pause());
		}, { threshold: 1 });
		return e.observe(a.current), () => {
			e.disconnect();
		};
	}, [r]), /* @__PURE__ */ m("div", {
		ref: a,
		className: `video-player-wrapper ${e}`,
		children: [/* @__PURE__ */ m("div", {
			className: `video-player-component ${e}`,
			children: [/* @__PURE__ */ p("video", {
				className: "video-player",
				ref: i,
				src: t,
				controls: o,
				onPlay: () => {
					f(!0), h();
				},
				onPause: () => f(!1),
				onEnded: () => f(!1),
				playsInline: !0,
				muted: r
			}), !l && /* @__PURE__ */ p("button", {
				className: "video-play-button",
				onClick: () => {
					i.current && (i.current.paused ? (c(!0), i.current.play().catch(() => {
						console.error("Browser may have blocked autoplay");
					})) : i.current.pause());
				},
				"aria-label": "Play video",
				children: /* @__PURE__ */ p(R, {
					iconName: M.PLAY,
					sizeInPx: "40",
					color: "var(--thriveWhite)"
				})
			})]
		}), n && /* @__PURE__ */ p("span", {
			className: "video-caption",
			children: n
		})]
	});
}, Yt = ({ appName: e }) => /* @__PURE__ */ m("div", {
	className: "app-header",
	children: [
		/* @__PURE__ */ p(R, {
			iconName: M.MENU,
			sizeInPx: "14"
		}),
		/* @__PURE__ */ p("h1", {
			className: "app-banner-title",
			children: e || "Your App Name"
		}),
		/* @__PURE__ */ m("div", {
			className: "right-panel",
			children: [/* @__PURE__ */ p(R, {
				iconName: M.SEARCH_GLASS,
				sizeInPx: "14"
			}), /* @__PURE__ */ p(R, {
				iconName: M.BELL,
				sizeInPx: "14"
			})]
		})
	]
}), Xt = ({ appContent: e }) => e?.length ? /* @__PURE__ */ m("div", {
	className: "app-preview-content-wrapper",
	children: [/* @__PURE__ */ p("div", {
		className: "hero-content-item",
		children: /* @__PURE__ */ m("div", {
			className: "content-item",
			children: [/* @__PURE__ */ p("img", {
				src: Z(239, e[0].featuredImageUrl),
				alt: e[0].title
			}), /* @__PURE__ */ p("div", {
				className: "overlay",
				children: /* @__PURE__ */ p("h2", {
					className: "hero-content-title",
					children: e[0].title
				})
			})]
		}, 0)
	}), /* @__PURE__ */ p("div", {
		className: "grid",
		children: e.slice(1).map((e, t) => /* @__PURE__ */ m("div", {
			className: "content-item",
			children: [/* @__PURE__ */ p("img", {
				src: Z(113, e.featuredImageUrl),
				alt: e.title
			}), /* @__PURE__ */ p("div", {
				className: "overlay",
				children: /* @__PURE__ */ p("h3", {
					className: "content-title",
					children: e.title
				})
			})]
		}, t))
	})]
}) : /* @__PURE__ */ p("div", {
	className: "loading-app-preview-content-wrapper",
	children: /* @__PURE__ */ p(R, {
		iconName: M.THRIVE,
		color: "var(--thriveChalk)",
		sizeInPx: "40"
	})
}), Zt = ({ appName: e, appContent: t }) => /* @__PURE__ */ m("div", {
	className: "mobile-app-preview-container",
	children: [/* @__PURE__ */ p("div", { className: "mock-camera-panel" }), /* @__PURE__ */ m("div", {
		className: "preview-content-wrapper",
		children: [/* @__PURE__ */ p(Yt, { appName: e }), /* @__PURE__ */ p(Xt, { appContent: t })]
	})]
}), Qt = ({ className: e, title: t, buttonList: n, onCloseClick: r, footerContent: i }) => /* @__PURE__ */ p(q, {
	showModal: !0,
	className: `button-select-modal ${e}`,
	headerContent: /* @__PURE__ */ p("h1", {
		className: "button-select-modal-header",
		children: t
	}),
	bodyContent: /* @__PURE__ */ p("div", {
		className: "button-select-modal-body",
		children: n && n.length > 0 ? n?.map((e, t) => /* @__PURE__ */ p(F, {
			className: "button-select-modal-button",
			content: e.text,
			ariaLabel: e.label,
			isDisabled: e.isDisabled,
			onButtonClick: e.onButtonClick
		}, t)) : /* @__PURE__ */ p("p", {
			className: "button-select-no-options",
			children: "No options available"
		})
	}),
	footerContent: i,
	onCloseClick: r
}), $t = ({ className: e, profileImageUrl: t, userDisplayName: n, mediaTitle: r, mediaUploadDate: i, mediaContent: a, onCloseClick: o }) => /* @__PURE__ */ p(q, {
	showModal: !0,
	className: `media-modal ${e}`,
	headerContent: /* @__PURE__ */ p(Ot, {
		profileImageUrl: t,
		displayName: n,
		mediaTitle: r,
		date: i
	}),
	bodyContent: a,
	footerContent: void 0,
	onCloseClick: o
}), en = ({ showModal: e, onHideModal: t, setContentTileOrder: n, contentTiles: r }) => {
	let [i, a] = d([...r]);
	return s(() => {
		a([...r]);
	}, [r, e]), /* @__PURE__ */ p(q, {
		showModal: e,
		canEscapeClose: !0,
		className: "reorder-content-tiles-modal",
		headerContent: /* @__PURE__ */ p("h1", {
			className: "reorder-content-header",
			children: "Reorder tiles"
		}),
		bodyContent: /* @__PURE__ */ m("div", {
			className: "reorder-content-modal-body",
			children: [/* @__PURE__ */ p("div", {
				className: "reorder-explainer",
				children: "Drag tiles to reorder them, or use the arrow buttons to move them up and down."
			}), /* @__PURE__ */ p("div", {
				className: "content-order-component",
				children: /* @__PURE__ */ p(ot, {
					content: i,
					setContent: a
				})
			})]
		}),
		footerContent: /* @__PURE__ */ p(F, {
			className: "save-content-order-button",
			content: "Done",
			ariaLabel: "Done",
			onButtonClick: () => n(i)
		}),
		onCloseClick: t
	});
}, tn = /* @__PURE__ */ function(e) {
	return e.Red = "E63946", e.Coral = "FF595E", e.Orange = "F77F00", e.Yellow = "FCBF49", e.Teal = "2A9D8F", e.Ice = "A8DADC", e.Navy = "1D3557", e.DarkTeal = "264653", e.Blue = "457B9D", e.BrightBlue = "1982C4", e.Purple = "6A4C93", e.Lilac = "C77DFF", e.Lime = "8AC926", e.Crimson = "D62828", e.DeepBlue = "023E8A", e;
}({}), nn = [
	"E63946",
	"FF595E",
	"F77F00",
	"FCBF49",
	"2A9D8F",
	"A8DADC",
	"1D3557",
	"264653"
], rn = [
	"457B9D",
	"1982C4",
	"6A4C93",
	"C77DFF",
	"8AC926",
	"D62828",
	"023E8A"
], an = (e) => Object.entries(tn).find(([, t]) => t === e)?.[0], on = ({ colour: e, setColour: t, isSelected: n }) => {
	let r = an(e);
	return /* @__PURE__ */ p("button", {
		className: `colour-button ${n ? "selected" : ""}`,
		style: { background: `#${e}` },
		onClick: t,
		"aria-label": `Select ${r}`
	}, e);
}, sn = ({ pickerLabel: e, setHasError: t, color: n, setColor: r, isDisabled: i }) => {
	let [a, o] = d(!1), [c, l] = d(""), u = T(n, 500);
	return s(() => {
		u && !/^[0-9A-F]{6}$/i.test(u) ? (l("Invalid hex code"), t(!0)) : (l(""), t(!1));
	}, [u]), E("colour-container", (e) => {
		e || o(!1);
	}), /* @__PURE__ */ m("div", {
		className: "colour-picker",
		children: [/* @__PURE__ */ p("label", {
			htmlFor: "colour-input",
			className: "colour-picker-label",
			children: e ?? "COLOUR"
		}), /* @__PURE__ */ m("div", {
			className: "colour-container",
			children: [
				/* @__PURE__ */ m("div", {
					className: "colour-input-container",
					onClick: () => {
						o(!0);
					},
					children: [
						/* @__PURE__ */ p("div", {
							className: "hex",
							children: "#"
						}),
						/* @__PURE__ */ p("input", {
							id: "colour-input",
							disabled: i,
							type: "text",
							value: n,
							maxLength: 6,
							onChange: (e) => {
								r(e.target.value), o(!1);
							}
						}),
						/* @__PURE__ */ p("div", {
							className: "colour-rep",
							style: { backgroundColor: `#${n}` }
						})
					]
				}),
				c && /* @__PURE__ */ p("span", {
					className: "error-hex",
					children: c
				}),
				a && !i && /* @__PURE__ */ p("div", {
					className: "picker-container-wrapper",
					children: /* @__PURE__ */ m("div", {
						className: "picker-container",
						children: [/* @__PURE__ */ p(K, {
							ariaLabel: "Close Picker",
							onButtonClick: () => o(!1)
						}), /* @__PURE__ */ p(x, {
							color: n,
							onChange: (e) => r(e.replace("#", ""))
						})]
					})
				})
			]
		})]
	});
}, cn = ({ colour: e, setColour: t }) => {
	let n = u(null), [r, i] = d(!1), a = [...nn, ...rn].includes(e);
	return C(r, n, () => {
		i(!1);
	}), /* @__PURE__ */ m("div", {
		className: "theme-colour-container",
		children: [/* @__PURE__ */ p("h3", { children: "Theme colour" }), /* @__PURE__ */ m("div", {
			className: "colour-grid",
			children: [/* @__PURE__ */ p("div", {
				className: "row",
				children: nn.map((n) => /* @__PURE__ */ p(on, {
					colour: n,
					setColour: () => t(n),
					isSelected: n === e
				}, n))
			}), /* @__PURE__ */ m("div", {
				className: "row",
				children: [rn.map((n) => /* @__PURE__ */ p(on, {
					colour: n,
					setColour: () => t(n),
					isSelected: n === e
				}, n)), /* @__PURE__ */ m("div", {
					className: "add-button-wrapper",
					ref: n,
					children: [/* @__PURE__ */ p("button", {
						className: `colour-button add-button ${a ? "" : "selected-add-button"}`,
						onClick: () => i(!r),
						children: "+"
					}), r && /* @__PURE__ */ p("div", {
						className: "colour-picker-container",
						children: /* @__PURE__ */ p(sn, {
							setHasError: () => {},
							color: e,
							setColor: t
						})
					})]
				})]
			})]
		})]
	});
}, ln = ({ isDisabled: e, onClickButton: t, buttonLabel: n, iconColor: r }) => /* @__PURE__ */ p("button", {
	id: "thrive-component-search-bar-button",
	className: "thrive-component-search-bar-button",
	type: "button",
	onClick: t,
	"aria-label": n,
	disabled: e,
	children: /* @__PURE__ */ p(R, {
		iconName: M.SEARCH_GLASS,
		color: `${r ?? "var(--thriveWhite)"}`,
		sizeInPx: "28"
	})
}), un = ({ placeholderText: e, ariaLabel: t, searchInput: n, setSearchInput: r, handleKeyDown: i }) => /* @__PURE__ */ p("input", {
	id: "thrive-component-search-bar-input",
	className: "thrive-component-search-bar-input",
	type: "text",
	placeholder: e,
	autoComplete: "off",
	"aria-label": t,
	value: n,
	onChange: (e) => r(e.target.value),
	onKeyDown: i
}), dn = ({ className: e = "", placeholderText: t, ariaLabel: n, searchInput: r, setSearchInput: i, onClickSearch: a, buttonLabel: o, buttonIconColor: s }) => /* @__PURE__ */ m("div", {
	className: `thrive-component-search-bar-wrapper ${e}`,
	children: [/* @__PURE__ */ p(un, {
		placeholderText: t,
		ariaLabel: n,
		searchInput: r,
		setSearchInput: i,
		handleKeyDown: (e) => {
			e.key === "Enter" && a();
		}
	}), /* @__PURE__ */ p(ln, {
		onClickButton: a,
		buttonLabel: o,
		iconColor: s
	})]
}), fn = (e, t, n, r, i, a) => {
	let [o, c] = d([]), [l, f] = d(!1), [p, m] = d(void 0), [h, g] = d(null), [_, v] = d(!1), y = u(null), [b, x] = d(!1), S = D(n, a ?? !1) ?? void 0, C = t ? o : o.slice(0, r), w = i ?? "No data found.", T = !e || e.length < 1, E = M(o), [O, k] = d({}), A = (e, t) => {
		k((n) => {
			let r = { ...n };
			return Object.keys(r).forEach((e) => {
				r[parseInt(e)] = I.BOTH;
			}), r[e] = t, r;
		});
	};
	s(() => {
		c(e);
	}, [e]), s(() => {
		v(!!(a && t));
	}, [t, a]);
	function j(e, t, n) {
		let r = o[e], i = [...o];
		i.splice(e, 1), n || i.splice(t, 0, r), c(i), g(null);
	}
	function M(e) {
		return e.some((e) => e?.controls?.some((e) => e?.content !== void 0 && e.content !== null));
	}
	return {
		rowContent: o,
		noContentMessage: w,
		showNoContentMessage: T,
		infiniteScrollRef: S,
		displayedContent: C,
		hasControlsColumn: E,
		controlIndex: p,
		setControlIndex: m,
		toggleDirections: O,
		handleToggleDirection: A,
		containerRef: y,
		setHoverIndex: g,
		hoverIndex: h,
		moveRow: j,
		openMenu: l,
		setOpenMenu: f,
		defaultSortIsUnchecked: b,
		setDefaultSortIsUnchecked: x,
		isLoadingMore: _
	};
}, pn = /* @__PURE__ */ function(e) {
	return e.ASCENDING = "asc", e.DESCENDING = "desc", e.NONE = "none", e;
}({}), mn = ({ direction: e, sortAscending: t, sortDescending: n, defaultSort: r, onRemoveDefaultSort: i, ascendingLabel: a, descendingLabel: o }) => {
	let s = () => r && !e ? r === pn.ASCENDING ? I.UP : I.DOWN : !r && !e ? I.BOTH : e;
	return {
		handleClick: () => {
			i?.(), s() === I.DOWN ? t() : n();
		},
		getAriaLabel: () => s() === I.DOWN ? a ?? "Sort ascending" : o ?? "Sort descending",
		getToggleIcon: () => ne(s())
	};
}, hn = ({ direction: e, sortAscending: t, sortDescending: n, text: r, defaultSort: i, onRemoveDefaultSort: a, ascendingLabel: o, descendingLabel: s }) => {
	let { getAriaLabel: c, handleClick: l, getToggleIcon: u } = mn({
		direction: e,
		sortAscending: t,
		sortDescending: n,
		text: r,
		defaultSort: i,
		onRemoveDefaultSort: a,
		ascendingLabel: o,
		descendingLabel: s
	});
	return /* @__PURE__ */ m("button", {
		className: "toggle-caret",
		"aria-label": c(),
		onClick: l,
		children: [r && /* @__PURE__ */ p("span", { children: r }), u()]
	});
}, $ = ({ className: e, color: t, iconName: n, text: r }) => /* @__PURE__ */ m("div", {
	className: `button-content ${e}`,
	children: [/* @__PURE__ */ p(R, {
		iconName: n,
		sizeInPx: "12",
		color: `${t ?? "#0570B6"}`
	}), /* @__PURE__ */ p("span", { children: r })]
}), gn = ({ index: e, rowContentLength: t, paginationInformation: n, isPaginated: r, handleButtonMove: i }) => {
	if (!r) {
		let t = n?.totalItems ?? 0;
		return [
			e !== 0 && {
				content: /* @__PURE__ */ p($, {
					iconName: M.ORDER_TOP,
					text: "Send to top"
				}),
				onClick: () => i(e, 0)
			},
			e !== 0 && {
				content: /* @__PURE__ */ p($, {
					iconName: M.ORDER_UP,
					text: "Move up"
				}),
				onClick: () => i(e, e - 1)
			},
			e !== t - 1 && {
				content: /* @__PURE__ */ p($, {
					iconName: M.ORDER_DOWN,
					text: "Move down"
				}),
				onClick: () => i(e, e + 1)
			},
			e !== t - 1 && {
				content: /* @__PURE__ */ p($, {
					iconName: M.ORDER_BOTTOM,
					text: "Send to bottom"
				}),
				onClick: () => i(e, t)
			}
		].filter(Boolean);
	}
	let a = n?.currentPage ?? 1, o = n?.totalPages ?? 1, s = n?.totalItems ?? 0, c = n?.resultsPerPage ?? 0, l = a > 1, u = a < o, d = e - 1, f = e + 1, m = s, h = e === 0 && l, g = l ? (a - 1) * c + d : d, _ = l ? (a - 1) * c + f : f, v = a * c, y = (a - 2) * c;
	return [
		e !== 0 || h ? {
			content: /* @__PURE__ */ p($, {
				iconName: M.ORDER_TOP,
				text: "Send to top"
			}),
			onClick: () => i(e, 0, l)
		} : void 0,
		e !== 0 || h ? {
			content: /* @__PURE__ */ p($, {
				iconName: M.ORDER_UP,
				text: "Move up"
			}),
			onClick: () => i(e, g, h)
		} : void 0,
		e === t - 1 ? void 0 : {
			content: /* @__PURE__ */ p($, {
				iconName: M.ORDER_DOWN,
				text: "Move down"
			}),
			onClick: () => i(e, _, !1)
		},
		e === t - 1 ? void 0 : {
			content: /* @__PURE__ */ p($, {
				iconName: M.ORDER_BOTTOM,
				text: "Send to bottom"
			}),
			onClick: () => i(e, m, u)
		},
		l ? {
			content: /* @__PURE__ */ p($, {
				iconName: M.ORDER_UP,
				text: "Move to previous page"
			}),
			onClick: () => i(e, y, !0)
		} : void 0,
		o > 1 && u ? {
			content: /* @__PURE__ */ p($, {
				iconName: M.ORDER_DOWN,
				text: "Move to next page"
			}),
			onClick: () => i(e, v, !0)
		} : void 0
	].filter(Boolean);
}, _n = ({ containerRef: e, row: t, index: n, hoverIndex: r, controlIndex: i, setControlIndex: a, moveRow: o, rowContentLength: c, setHoverIndex: l, openMenu: d, setOpenMenu: f, dragAndDropAction: h, isPaginated: g, paginationInformation: y }) => {
	let b = u(null), x = u(null), S = u(null), C = u(null), w = gn({
		index: n,
		rowContentLength: c,
		paginationInformation: y,
		isPaginated: g,
		handleButtonMove: A
	}), [{ isDragging: T }, D, O] = _({
		type: "ROW",
		item: { index: n },
		collect: (e) => ({ isDragging: e.isDragging() }),
		end: () => {
			l(null);
		}
	});
	D(C);
	let [, k] = v({
		accept: "ROW",
		hover(e) {
			if (!b.current) return;
			let t = e.index, r = n;
			t !== r && (o(t, r, !1), l(r), e.index = r);
		},
		drop() {
			l(null), h?.(r ?? 0);
		}
	});
	s(() => {
		O(k(b));
	}, [O, k]), s(() => {
		document.body.style.cursor = T ? "grabbing" : "inherit";
	}, [T]), s(() => {
		let t = (t) => {
			e.current && !e.current.contains(t.relatedTarget) && l(null);
		};
		return e?.current.addEventListener("dragleave", t), () => e?.current.addEventListener("dragleave", t);
	}, [e]), E("control-cell", (e) => {
		e || f(!1);
	});
	function A(e, t, n) {
		h?.(t), o(e, t, n);
	}
	return /* @__PURE__ */ m("tr", {
		ref: b,
		className: `drag-item ${T ? "is-dragging" : ""}  ${n === r ? "is-hovering" : ""}`,
		children: [t.content.map((e, t) => /* @__PURE__ */ p("td", { children: e }, t)), /* @__PURE__ */ m("td", {
			className: "rc-control-cell",
			ref: x,
			children: [
				/* @__PURE__ */ p("button", {
					type: "button",
					ref: C,
					className: "drag-and-drop-controller",
					"aria-hidden": "true",
					tabIndex: -1,
					children: /* @__PURE__ */ p(R, {
						iconName: M.DRAG,
						color: "#999EA5",
						sizeInPx: "12"
					})
				}),
				/* @__PURE__ */ p("button", {
					type: "button",
					className: "simple-table-menu",
					"aria-label": "Open menu",
					onClick: () => {
						f(!d), a(n);
					},
					tabIndex: 0,
					children: /* @__PURE__ */ p(R, {
						iconName: M.MENU_MORE,
						color: "#343D4C",
						sizeInPx: "12"
					})
				}),
				i === n && d && /* @__PURE__ */ p("div", {
					ref: S,
					children: /* @__PURE__ */ p(Ft, {
						className: "drag-and-drop-list",
						allButtonOnClick: () => f(!1),
						buttons: [...w, ...t.controls ?? []].filter(Boolean)
					})
				})
			]
		})]
	});
}, vn = ({ isControlIndex: e, setControlIndex: t, buttons: n }) => {
	let [r, i] = d(!1), a = u(null);
	return C(r, a, () => {
		i(!1);
	}), /* @__PURE__ */ m("td", {
		className: "control-cell",
		ref: a,
		onBlur: (e) => {
			a.current && !a.current.contains(e.relatedTarget) && i(!1);
		},
		children: [/* @__PURE__ */ p("button", {
			type: "button",
			className: "rc-simple-table-menu",
			"aria-label": "Open menu",
			onClick: () => {
				t(), i(!r);
			},
			children: /* @__PURE__ */ p(R, {
				iconName: M.MENU_MORE,
				color: "#343D4C",
				sizeInPx: "12"
			})
		}), e && r && /* @__PURE__ */ p(Ft, {
			className: "simple-controls drag-and-drop-list",
			buttons: n ?? [],
			allButtonOnClick: () => i(!1)
		})]
	});
}, yn = ({ row: e, rowIndex: t, setControlIndex: n, isControlIndex: r, hasControlsColumn: i }) => {
	let a = e.controls?.some((e) => e.content !== void 0) ?? !1;
	return /* @__PURE__ */ m("tr", {
		className: "rc-simple-row",
		children: [e.content.map((e, n) => /* @__PURE__ */ p("td", { children: e }, t - n)), a ? /* @__PURE__ */ p(vn, {
			isControlIndex: r,
			setControlIndex: n,
			buttons: e.controls
		}) : i && /* @__PURE__ */ p("td", {})]
	});
}, bn = ({ simpleTableContent: e, noDataMessage: t, isInfiniteScroll: n = !1, maxContentLength: r, getMoreContent: i, isDragAndDrop: a = !1, isPaginated: o = !1, paginationInformation: s, infiniteScrollFetchCondition: c, isLoading: l = !0, hideActionsColumn: u }) => {
	let { noContentMessage: d, showNoContentMessage: h, infiniteScrollRef: _, displayedContent: v, hasControlsColumn: b, controlIndex: x, setControlIndex: S, toggleDirections: C, handleToggleDirection: w, containerRef: T, setHoverIndex: E, hoverIndex: D, moveRow: O, openMenu: k, setOpenMenu: A, defaultSortIsUnchecked: j, setDefaultSortIsUnchecked: M, isLoadingMore: N } = fn(e.rows, n, i, r, t, c);
	return /* @__PURE__ */ p(g, {
		backend: y,
		options: { enableMouseEvents: !0 },
		children: /* @__PURE__ */ m("div", {
			className: "rc-simple-table-wrapper",
			ref: T,
			children: [/* @__PURE__ */ m("table", {
				className: "rc-simple-table",
				children: [/* @__PURE__ */ p("thead", {
					className: "rc-simple-table-header",
					children: /* @__PURE__ */ m("tr", { children: [e.columns.map((e, t) => e ? /* @__PURE__ */ p("th", { children: e.isToggleButton ? /* @__PURE__ */ p(hn, {
						direction: C[t],
						sortAscending: () => (w(t, I.UP), e.onSortAscendingClick()),
						sortDescending: () => (w(t, I.DOWN), e.onSortDescendingClick()),
						text: e.title,
						defaultSort: j ? void 0 : e.defaultSort,
						onRemoveDefaultSort: () => M(!0)
					}) : /* @__PURE__ */ p(f, { children: e.title }) }, t) : /* @__PURE__ */ p("th", { className: "rc-empty-column" })), (a || b || l) && !u && /* @__PURE__ */ p("th", {
						className: "rc-controls-column",
						children: "Actions"
					})] }, 100)
				}), l ? /* @__PURE__ */ p("tbody", {
					className: "rc-full-width",
					children: /* @__PURE__ */ p("tr", { children: /* @__PURE__ */ p("td", {
						className: "rc-no-data-cell",
						colSpan: e.columns.length + (a || b ? 1 : 0),
						children: /* @__PURE__ */ p("span", {
							id: "no-data-message",
							className: "rc-no-data-message",
							children: /* @__PURE__ */ p(Lt, { size: 22 })
						})
					}) })
				}) : h ? /* @__PURE__ */ p("tbody", {
					className: "full-width",
					children: /* @__PURE__ */ p("tr", { children: /* @__PURE__ */ p("td", {
						className: "rc-no-data-cell",
						colSpan: e.columns.length + (a || b ? 1 : 0),
						children: /* @__PURE__ */ p("span", {
							id: "no-data-message",
							className: "rc-no-data-message",
							children: d
						})
					}) })
				}) : /* @__PURE__ */ m("tbody", {
					className: `rc-simple-table-body ${a && "drag-and-drop"} `,
					children: [a ? v.map((e, t) => /* @__PURE__ */ p(_n, {
						index: t,
						row: e,
						containerRef: T,
						hoverIndex: D,
						controlIndex: x,
						setControlIndex: S,
						moveRow: O,
						rowContentLength: v.length,
						setHoverIndex: E,
						openMenu: k,
						setOpenMenu: A,
						dragAndDropAction: e.dragAndDropAction,
						isPaginated: o,
						paginationInformation: s
					}, t)) : v.map((e, t) => /* @__PURE__ */ p(yn, {
						setControlIndex: () => S(t),
						row: e,
						isControlIndex: t === x,
						rowIndex: t,
						hasControlsColumn: b
					}, t)), N && /* @__PURE__ */ p("td", {
						className: "rc-no-data-cell rc-load-more-spinner",
						colSpan: e.columns.length + (a || b ? 1 : 0),
						children: /* @__PURE__ */ p(Lt, { size: 8 })
					})]
				})]
			}), n && /* @__PURE__ */ p("div", {
				"data-testid": "rc-infinite-scroll",
				ref: _
			})]
		})
	});
}, xn = [
	{
		ISOCountryCode: "AF",
		name: "Afghanistan",
		dialCode: "93"
	},
	{
		ISOCountryCode: "AL",
		name: "Albania",
		dialCode: "355"
	},
	{
		ISOCountryCode: "DZ",
		name: "Algeria",
		dialCode: "213"
	},
	{
		ISOCountryCode: "AS",
		name: "American Samoa",
		dialCode: "1684"
	},
	{
		ISOCountryCode: "AD",
		name: "Andorra",
		dialCode: "376"
	},
	{
		ISOCountryCode: "AO",
		name: "Angola",
		dialCode: "244"
	},
	{
		ISOCountryCode: "AI",
		name: "Anguilla",
		dialCode: "1264"
	},
	{
		ISOCountryCode: "AG",
		name: "Antigua & Barbuda",
		dialCode: "1268"
	},
	{
		ISOCountryCode: "AR",
		name: "Argentina",
		dialCode: "54"
	},
	{
		ISOCountryCode: "AM",
		name: "Armenia",
		dialCode: "374"
	},
	{
		ISOCountryCode: "AW",
		name: "Aruba",
		dialCode: "297"
	},
	{
		ISOCountryCode: "AC",
		name: "Ascension Island",
		dialCode: "247"
	},
	{
		ISOCountryCode: "AU",
		name: "Australia",
		dialCode: "61"
	},
	{
		ISOCountryCode: "AT",
		name: "Austria",
		dialCode: "43"
	},
	{
		ISOCountryCode: "AZ",
		name: "Azerbaijan",
		dialCode: "994"
	},
	{
		ISOCountryCode: "BS",
		name: "Bahamas",
		dialCode: "1242"
	},
	{
		ISOCountryCode: "BH",
		name: "Bahrain",
		dialCode: "973"
	},
	{
		ISOCountryCode: "BD",
		name: "Bangladesh",
		dialCode: "880"
	},
	{
		ISOCountryCode: "BB",
		name: "Barbados",
		dialCode: "1246"
	},
	{
		ISOCountryCode: "BY",
		name: "Belarus",
		dialCode: "375"
	},
	{
		ISOCountryCode: "BE",
		name: "Belgium",
		dialCode: "32"
	},
	{
		ISOCountryCode: "BZ",
		name: "Belize",
		dialCode: "501"
	},
	{
		ISOCountryCode: "BJ",
		name: "Benin",
		dialCode: "229"
	},
	{
		ISOCountryCode: "BM",
		name: "Bermuda",
		dialCode: "1441"
	},
	{
		ISOCountryCode: "BT",
		name: "Bhutan",
		dialCode: "975"
	},
	{
		ISOCountryCode: "BO",
		name: "Bolivia",
		dialCode: "591"
	},
	{
		ISOCountryCode: "BA",
		name: "Bosnia & Herzegovina",
		dialCode: "387"
	},
	{
		ISOCountryCode: "BW",
		name: "Botswana",
		dialCode: "267"
	},
	{
		ISOCountryCode: "BR",
		name: "Brazil",
		dialCode: "55"
	},
	{
		ISOCountryCode: "IO",
		name: "British Indian Ocean Territory",
		dialCode: "246"
	},
	{
		ISOCountryCode: "VG",
		name: "British Virgin Islands",
		dialCode: "1284"
	},
	{
		ISOCountryCode: "BN",
		name: "Brunei",
		dialCode: "673"
	},
	{
		ISOCountryCode: "BG",
		name: "Bulgaria",
		dialCode: "359"
	},
	{
		ISOCountryCode: "BF",
		name: "Burkina Faso",
		dialCode: "226"
	},
	{
		ISOCountryCode: "BI",
		name: "Burundi",
		dialCode: "257"
	},
	{
		ISOCountryCode: "KH",
		name: "Cambodia",
		dialCode: "855"
	},
	{
		ISOCountryCode: "CM",
		name: "Cameroon",
		dialCode: "237"
	},
	{
		ISOCountryCode: "CA",
		name: "Canada",
		dialCode: "1"
	},
	{
		ISOCountryCode: "CV",
		name: "Cape Verde",
		dialCode: "238"
	},
	{
		ISOCountryCode: "BQ",
		name: "Caribbean Netherlands",
		dialCode: "599"
	},
	{
		ISOCountryCode: "KY",
		name: "Cayman Islands",
		dialCode: "1345"
	},
	{
		ISOCountryCode: "CF",
		name: "Central African Republic",
		dialCode: "236"
	},
	{
		ISOCountryCode: "TD",
		name: "Chad",
		dialCode: "235"
	},
	{
		ISOCountryCode: "CL",
		name: "Chile",
		dialCode: "56"
	},
	{
		ISOCountryCode: "CN",
		name: "China",
		dialCode: "86"
	},
	{
		ISOCountryCode: "CX",
		name: "Christmas Island",
		dialCode: "61"
	},
	{
		ISOCountryCode: "CC",
		name: "Cocos (Keeling) Islands",
		dialCode: "61"
	},
	{
		ISOCountryCode: "CO",
		name: "Colombia",
		dialCode: "57"
	},
	{
		ISOCountryCode: "KM",
		name: "Comoros",
		dialCode: "269"
	},
	{
		ISOCountryCode: "CD",
		name: "Congo - Kinshasa",
		dialCode: "243"
	},
	{
		ISOCountryCode: "CG",
		name: "Congo - Brazzaville",
		dialCode: "242"
	},
	{
		ISOCountryCode: "CK",
		name: "Cook Islands",
		dialCode: "682"
	},
	{
		ISOCountryCode: "CR",
		name: "Costa Rica",
		dialCode: "506"
	},
	{
		ISOCountryCode: "HR",
		name: "Croatia",
		dialCode: "385"
	},
	{
		ISOCountryCode: "CU",
		name: "Cuba",
		dialCode: "53"
	},
	{
		ISOCountryCode: "CW",
		name: "Curaçao",
		dialCode: "599"
	},
	{
		ISOCountryCode: "CY",
		name: "Cyprus",
		dialCode: "357"
	},
	{
		ISOCountryCode: "CZ",
		name: "Czechia",
		dialCode: "420"
	},
	{
		ISOCountryCode: "CI",
		name: "Côte d'Ivoire",
		dialCode: "225"
	},
	{
		ISOCountryCode: "DK",
		name: "Denmark",
		dialCode: "45"
	},
	{
		ISOCountryCode: "DJ",
		name: "Djibouti",
		dialCode: "253"
	},
	{
		ISOCountryCode: "DM",
		name: "Dominica",
		dialCode: "1767"
	},
	{
		ISOCountryCode: "DO",
		name: "Dominican Republic",
		dialCode: "1"
	},
	{
		ISOCountryCode: "EC",
		name: "Ecuador",
		dialCode: "593"
	},
	{
		ISOCountryCode: "EG",
		name: "Egypt",
		dialCode: "20"
	},
	{
		ISOCountryCode: "SV",
		name: "El Salvador",
		dialCode: "503"
	},
	{
		ISOCountryCode: "GQ",
		name: "Equatorial Guinea",
		dialCode: "240"
	},
	{
		ISOCountryCode: "ER",
		name: "Eritrea",
		dialCode: "291"
	},
	{
		ISOCountryCode: "EE",
		name: "Estonia",
		dialCode: "372"
	},
	{
		ISOCountryCode: "ET",
		name: "Ethiopia",
		dialCode: "251"
	},
	{
		ISOCountryCode: "FK",
		name: "Falkland Islands",
		dialCode: "500"
	},
	{
		ISOCountryCode: "FO",
		name: "Faroe Islands",
		dialCode: "298"
	},
	{
		ISOCountryCode: "FJ",
		name: "Fiji",
		dialCode: "679"
	},
	{
		ISOCountryCode: "FI",
		name: "Finland",
		dialCode: "358"
	},
	{
		ISOCountryCode: "FR",
		name: "France",
		dialCode: "33"
	},
	{
		ISOCountryCode: "GF",
		name: "French Guiana",
		dialCode: "594"
	},
	{
		ISOCountryCode: "PF",
		name: "French Polynesia",
		dialCode: "689"
	},
	{
		ISOCountryCode: "GA",
		name: "Gabon",
		dialCode: "241"
	},
	{
		ISOCountryCode: "GM",
		name: "Gambia",
		dialCode: "220"
	},
	{
		ISOCountryCode: "GE",
		name: "Georgia",
		dialCode: "995"
	},
	{
		ISOCountryCode: "DE",
		name: "Germany",
		dialCode: "49"
	},
	{
		ISOCountryCode: "GH",
		name: "Ghana",
		dialCode: "233"
	},
	{
		ISOCountryCode: "GI",
		name: "Gibraltar",
		dialCode: "350"
	},
	{
		ISOCountryCode: "GR",
		name: "Greece",
		dialCode: "30"
	},
	{
		ISOCountryCode: "GL",
		name: "Greenland",
		dialCode: "299"
	},
	{
		ISOCountryCode: "GD",
		name: "Grenada",
		dialCode: "1473"
	},
	{
		ISOCountryCode: "GP",
		name: "Guadeloupe",
		dialCode: "590"
	},
	{
		ISOCountryCode: "GU",
		name: "Guam",
		dialCode: "1671"
	},
	{
		ISOCountryCode: "GT",
		name: "Guatemala",
		dialCode: "502"
	},
	{
		ISOCountryCode: "GG",
		name: "Guernsey",
		dialCode: "44"
	},
	{
		ISOCountryCode: "GN",
		name: "Guinea",
		dialCode: "224"
	},
	{
		ISOCountryCode: "GW",
		name: "Guinea-Bissau",
		dialCode: "245"
	},
	{
		ISOCountryCode: "GY",
		name: "Guyana",
		dialCode: "592"
	},
	{
		ISOCountryCode: "HT",
		name: "Haiti",
		dialCode: "509"
	},
	{
		ISOCountryCode: "HN",
		name: "Honduras",
		dialCode: "504"
	},
	{
		ISOCountryCode: "HK",
		name: "Hong Kong",
		dialCode: "852"
	},
	{
		ISOCountryCode: "HU",
		name: "Hungary",
		dialCode: "36"
	},
	{
		ISOCountryCode: "IS",
		name: "Iceland",
		dialCode: "354"
	},
	{
		ISOCountryCode: "IN",
		name: "India",
		dialCode: "91"
	},
	{
		ISOCountryCode: "ID",
		name: "Indonesia",
		dialCode: "62"
	},
	{
		ISOCountryCode: "IR",
		name: "Iran",
		dialCode: "98"
	},
	{
		ISOCountryCode: "IQ",
		name: "Iraq",
		dialCode: "964"
	},
	{
		ISOCountryCode: "IE",
		name: "Ireland",
		dialCode: "353"
	},
	{
		ISOCountryCode: "IM",
		name: "Isle of Man",
		dialCode: "44"
	},
	{
		ISOCountryCode: "IL",
		name: "Israel",
		dialCode: "972"
	},
	{
		ISOCountryCode: "IT",
		name: "Italy",
		dialCode: "39"
	},
	{
		ISOCountryCode: "JM",
		name: "Jamaica",
		dialCode: "1876"
	},
	{
		ISOCountryCode: "JP",
		name: "Japan",
		dialCode: "81"
	},
	{
		ISOCountryCode: "JE",
		name: "Jersey",
		dialCode: "44"
	},
	{
		ISOCountryCode: "JO",
		name: "Jordan",
		dialCode: "962"
	},
	{
		ISOCountryCode: "KZ",
		name: "Kazakhstan",
		dialCode: "7"
	},
	{
		ISOCountryCode: "KE",
		name: "Kenya",
		dialCode: "254"
	},
	{
		ISOCountryCode: "KI",
		name: "Kiribati",
		dialCode: "686"
	},
	{
		ISOCountryCode: "XK",
		name: "Kosovo",
		dialCode: "383"
	},
	{
		ISOCountryCode: "KW",
		name: "Kuwait",
		dialCode: "965"
	},
	{
		ISOCountryCode: "KG",
		name: "Kyrgyzstan",
		dialCode: "996"
	},
	{
		ISOCountryCode: "LA",
		name: "Laos",
		dialCode: "856"
	},
	{
		ISOCountryCode: "LV",
		name: "Latvia",
		dialCode: "371"
	},
	{
		ISOCountryCode: "LB",
		name: "Lebanon",
		dialCode: "961"
	},
	{
		ISOCountryCode: "LS",
		name: "Lesotho",
		dialCode: "266"
	},
	{
		ISOCountryCode: "LR",
		name: "Liberia",
		dialCode: "231"
	},
	{
		ISOCountryCode: "LY",
		name: "Libya",
		dialCode: "218"
	},
	{
		ISOCountryCode: "LI",
		name: "Liechtenstein",
		dialCode: "423"
	},
	{
		ISOCountryCode: "LT",
		name: "Lithuania",
		dialCode: "370"
	},
	{
		ISOCountryCode: "LU",
		name: "Luxembourg",
		dialCode: "352"
	},
	{
		ISOCountryCode: "MO",
		name: "Macau",
		dialCode: "853"
	},
	{
		ISOCountryCode: "MK",
		name: "North Macedonia",
		dialCode: "389"
	},
	{
		ISOCountryCode: "MG",
		name: "Madagascar",
		dialCode: "261"
	},
	{
		ISOCountryCode: "MW",
		name: "Malawi",
		dialCode: "265"
	},
	{
		ISOCountryCode: "MY",
		name: "Malaysia",
		dialCode: "60"
	},
	{
		ISOCountryCode: "MV",
		name: "Maldives",
		dialCode: "960"
	},
	{
		ISOCountryCode: "ML",
		name: "Mali",
		dialCode: "223"
	},
	{
		ISOCountryCode: "MT",
		name: "Malta",
		dialCode: "356"
	},
	{
		ISOCountryCode: "MH",
		name: "Marshall Islands",
		dialCode: "692"
	},
	{
		ISOCountryCode: "MQ",
		name: "Martinique",
		dialCode: "596"
	},
	{
		ISOCountryCode: "MR",
		name: "Mauritania",
		dialCode: "222"
	},
	{
		ISOCountryCode: "MU",
		name: "Mauritius",
		dialCode: "230"
	},
	{
		ISOCountryCode: "YT",
		name: "Mayotte",
		dialCode: "262"
	},
	{
		ISOCountryCode: "MX",
		name: "Mexico",
		dialCode: "52"
	},
	{
		ISOCountryCode: "FM",
		name: "Micronesia",
		dialCode: "691"
	},
	{
		ISOCountryCode: "MD",
		name: "Moldova",
		dialCode: "373"
	},
	{
		ISOCountryCode: "MC",
		name: "Monaco",
		dialCode: "377"
	},
	{
		ISOCountryCode: "MN",
		name: "Mongolia",
		dialCode: "976"
	},
	{
		ISOCountryCode: "ME",
		name: "Montenegro",
		dialCode: "382"
	},
	{
		ISOCountryCode: "MS",
		name: "Montserrat",
		dialCode: "1664"
	},
	{
		ISOCountryCode: "MA",
		name: "Morocco",
		dialCode: "212"
	},
	{
		ISOCountryCode: "MZ",
		name: "Mozambique",
		dialCode: "258"
	},
	{
		ISOCountryCode: "MM",
		name: "Myanmar",
		dialCode: "95"
	},
	{
		ISOCountryCode: "NA",
		name: "Namibia",
		dialCode: "264"
	},
	{
		ISOCountryCode: "NR",
		name: "Nauru",
		dialCode: "674"
	},
	{
		ISOCountryCode: "NP",
		name: "Nepal",
		dialCode: "977"
	},
	{
		ISOCountryCode: "NL",
		name: "Netherlands",
		dialCode: "31"
	},
	{
		ISOCountryCode: "NC",
		name: "New Caledonia",
		dialCode: "687"
	},
	{
		ISOCountryCode: "NZ",
		name: "New Zealand",
		dialCode: "64"
	},
	{
		ISOCountryCode: "NI",
		name: "Nicaragua",
		dialCode: "505"
	},
	{
		ISOCountryCode: "NE",
		name: "Niger",
		dialCode: "227"
	},
	{
		ISOCountryCode: "NG",
		name: "Nigeria",
		dialCode: "234"
	},
	{
		ISOCountryCode: "NU",
		name: "Niue",
		dialCode: "683"
	},
	{
		ISOCountryCode: "NF",
		name: "Norfolk Island",
		dialCode: "672"
	},
	{
		ISOCountryCode: "KP",
		name: "North Korea",
		dialCode: "850"
	},
	{
		ISOCountryCode: "MP",
		name: "Northern Mariana Islands",
		dialCode: "1670"
	},
	{
		ISOCountryCode: "NO",
		name: "Norway",
		dialCode: "47"
	},
	{
		ISOCountryCode: "OM",
		name: "Oman",
		dialCode: "968"
	},
	{
		ISOCountryCode: "PK",
		name: "Pakistan",
		dialCode: "92"
	},
	{
		ISOCountryCode: "PW",
		name: "Palau",
		dialCode: "680"
	},
	{
		ISOCountryCode: "PS",
		name: "Palestine",
		dialCode: "970"
	},
	{
		ISOCountryCode: "PA",
		name: "Panama",
		dialCode: "507"
	},
	{
		ISOCountryCode: "PG",
		name: "Papua New Guinea",
		dialCode: "675"
	},
	{
		ISOCountryCode: "PY",
		name: "Paraguay",
		dialCode: "595"
	},
	{
		ISOCountryCode: "PE",
		name: "Peru",
		dialCode: "51"
	},
	{
		ISOCountryCode: "PH",
		name: "Philippines",
		dialCode: "63"
	},
	{
		ISOCountryCode: "PL",
		name: "Poland",
		dialCode: "48"
	},
	{
		ISOCountryCode: "PT",
		name: "Portugal",
		dialCode: "351"
	},
	{
		ISOCountryCode: "PR",
		name: "Puerto Rico",
		dialCode: "1"
	},
	{
		ISOCountryCode: "QA",
		name: "Qatar",
		dialCode: "974"
	},
	{
		ISOCountryCode: "RO",
		name: "Romania",
		dialCode: "40"
	},
	{
		ISOCountryCode: "RU",
		name: "Russia",
		dialCode: "7"
	},
	{
		ISOCountryCode: "RW",
		name: "Rwanda",
		dialCode: "250"
	},
	{
		ISOCountryCode: "RE",
		name: "Réunion",
		dialCode: "262"
	},
	{
		ISOCountryCode: "BL",
		name: "Saint Barthélemy",
		dialCode: "590"
	},
	{
		ISOCountryCode: "SH",
		name: "Saint Helena",
		dialCode: "290"
	},
	{
		ISOCountryCode: "KN",
		name: "Saint Kitts & Nevis",
		dialCode: "1869"
	},
	{
		ISOCountryCode: "LC",
		name: "Saint Lucia",
		dialCode: "1758"
	},
	{
		ISOCountryCode: "MF",
		name: "Saint Martin",
		dialCode: "590"
	},
	{
		ISOCountryCode: "PM",
		name: "Saint Pierre & Miquelon",
		dialCode: "508"
	},
	{
		ISOCountryCode: "VC",
		name: "Saint Vincent & the Grenadines",
		dialCode: "1784"
	},
	{
		ISOCountryCode: "WS",
		name: "Samoa",
		dialCode: "685"
	},
	{
		ISOCountryCode: "SM",
		name: "San Marino",
		dialCode: "378"
	},
	{
		ISOCountryCode: "SA",
		name: "Saudi Arabia",
		dialCode: "966"
	},
	{
		ISOCountryCode: "SN",
		name: "Senegal",
		dialCode: "221"
	},
	{
		ISOCountryCode: "RS",
		name: "Serbia",
		dialCode: "381"
	},
	{
		ISOCountryCode: "SC",
		name: "Seychelles",
		dialCode: "248"
	},
	{
		ISOCountryCode: "SL",
		name: "Sierra Leone",
		dialCode: "232"
	},
	{
		ISOCountryCode: "SG",
		name: "Singapore",
		dialCode: "65"
	},
	{
		ISOCountryCode: "SX",
		name: "Sint Maarten",
		dialCode: "1721"
	},
	{
		ISOCountryCode: "SK",
		name: "Slovakia",
		dialCode: "421"
	},
	{
		ISOCountryCode: "SI",
		name: "Slovenia",
		dialCode: "386"
	},
	{
		ISOCountryCode: "SB",
		name: "Solomon Islands",
		dialCode: "677"
	},
	{
		ISOCountryCode: "SO",
		name: "Somalia",
		dialCode: "252"
	},
	{
		ISOCountryCode: "ZA",
		name: "South Africa",
		dialCode: "27"
	},
	{
		ISOCountryCode: "KR",
		name: "South Korea",
		dialCode: "82"
	},
	{
		ISOCountryCode: "SS",
		name: "South Sudan",
		dialCode: "211"
	},
	{
		ISOCountryCode: "ES",
		name: "Spain",
		dialCode: "34"
	},
	{
		ISOCountryCode: "LK",
		name: "Sri Lanka",
		dialCode: "94"
	},
	{
		ISOCountryCode: "SD",
		name: "Sudan",
		dialCode: "249"
	},
	{
		ISOCountryCode: "SR",
		name: "Suriname",
		dialCode: "597"
	},
	{
		ISOCountryCode: "SJ",
		name: "Svalbard & Jan Mayen",
		dialCode: "47"
	},
	{
		ISOCountryCode: "SZ",
		name: "Eswatini",
		dialCode: "268"
	},
	{
		ISOCountryCode: "SE",
		name: "Sweden",
		dialCode: "46"
	},
	{
		ISOCountryCode: "CH",
		name: "Switzerland",
		dialCode: "41"
	},
	{
		ISOCountryCode: "SY",
		name: "Syria",
		dialCode: "963"
	},
	{
		ISOCountryCode: "ST",
		name: "São Tomé & Príncipe",
		dialCode: "239"
	},
	{
		ISOCountryCode: "TW",
		name: "Taiwan",
		dialCode: "886"
	},
	{
		ISOCountryCode: "TJ",
		name: "Tajikistan",
		dialCode: "992"
	},
	{
		ISOCountryCode: "TZ",
		name: "Tanzania",
		dialCode: "255"
	},
	{
		ISOCountryCode: "TH",
		name: "Thailand",
		dialCode: "66"
	},
	{
		ISOCountryCode: "TL",
		name: "Timor-Leste",
		dialCode: "670"
	},
	{
		ISOCountryCode: "TG",
		name: "Togo",
		dialCode: "228"
	},
	{
		ISOCountryCode: "TK",
		name: "Tokelau",
		dialCode: "690"
	},
	{
		ISOCountryCode: "TO",
		name: "Tonga",
		dialCode: "676"
	},
	{
		ISOCountryCode: "TT",
		name: "Trinidad & Tobago",
		dialCode: "1868"
	},
	{
		ISOCountryCode: "TA",
		name: "Tristan da Cunha",
		dialCode: "290"
	},
	{
		ISOCountryCode: "TN",
		name: "Tunisia",
		dialCode: "216"
	},
	{
		ISOCountryCode: "TR",
		name: "Türkiye",
		dialCode: "90"
	},
	{
		ISOCountryCode: "TM",
		name: "Turkmenistan",
		dialCode: "993"
	},
	{
		ISOCountryCode: "TC",
		name: "Turks & Caicos Islands",
		dialCode: "1649"
	},
	{
		ISOCountryCode: "TV",
		name: "Tuvalu",
		dialCode: "688"
	},
	{
		ISOCountryCode: "VI",
		name: "U.S. Virgin Islands",
		dialCode: "1340"
	},
	{
		ISOCountryCode: "UG",
		name: "Uganda",
		dialCode: "256"
	},
	{
		ISOCountryCode: "UA",
		name: "Ukraine",
		dialCode: "380"
	},
	{
		ISOCountryCode: "AE",
		name: "United Arab Emirates",
		dialCode: "971"
	},
	{
		ISOCountryCode: "GB",
		name: "United Kingdom",
		dialCode: "44"
	},
	{
		ISOCountryCode: "US",
		name: "United States",
		dialCode: "1"
	},
	{
		ISOCountryCode: "UY",
		name: "Uruguay",
		dialCode: "598"
	},
	{
		ISOCountryCode: "UZ",
		name: "Uzbekistan",
		dialCode: "998"
	},
	{
		ISOCountryCode: "VU",
		name: "Vanuatu",
		dialCode: "678"
	},
	{
		ISOCountryCode: "VA",
		name: "Vatican City",
		dialCode: "39"
	},
	{
		ISOCountryCode: "VE",
		name: "Venezuela",
		dialCode: "58"
	},
	{
		ISOCountryCode: "VN",
		name: "Vietnam",
		dialCode: "84"
	},
	{
		ISOCountryCode: "WF",
		name: "Wallis & Futuna",
		dialCode: "681"
	},
	{
		ISOCountryCode: "EH",
		name: "Western Sahara",
		dialCode: "212"
	},
	{
		ISOCountryCode: "YE",
		name: "Yemen",
		dialCode: "967"
	},
	{
		ISOCountryCode: "ZM",
		name: "Zambia",
		dialCode: "260"
	},
	{
		ISOCountryCode: "ZW",
		name: "Zimbabwe",
		dialCode: "263"
	},
	{
		ISOCountryCode: "AX",
		name: "Åland Islands",
		dialCode: "358"
	}
];
function Sn(e) {
	return e ? xn.map((t) => ({
		value: t.ISOCountryCode,
		label: `${Cn(t.ISOCountryCode)} ${Tn(e, t.ISOCountryCode, t.name)} (+${t.dialCode})`
	})) : [];
}
function Cn(e) {
	let t = e.toUpperCase().split("").map((e) => 127397 + e.charCodeAt(0));
	return String.fromCodePoint(...t);
}
function wn(e) {
	return xn.find((t) => t.ISOCountryCode === e);
}
function Tn(e, t, n) {
	return e[`Countries.${t}`] ? e[`Countries.${t}`] : n;
}
function En() {
	let e = navigator.language?.split("-")[1] || "GB";
	return {
		location: e,
		prefix: xn?.find((t) => t?.ISOCountryCode === e)?.dialCode
	};
}
//#endregion
//#region components/global/textInputs/PhonenumberInput/PhonenumberInput.hooks.ts
var Dn = (e) => {
	let [t, n] = d({
		countryCode: "",
		prefix: "",
		phoneNumber: ""
	});
	return s(() => {
		if (e) {
			let { location: t, prefix: r } = En();
			n({
				countryCode: e.countryCode || t,
				prefix: r ?? "",
				phoneNumber: e.phoneNumber || ""
			});
		}
	}, [e]), {
		hidePhoneNumberInput: !e,
		handleCountryCode: (e) => {
			let r = wn(e);
			r?.ISOCountryCode && n({
				...t,
				countryCode: r.ISOCountryCode,
				prefix: r.dialCode
			});
		},
		formData: t,
		setFormData: n
	};
}, On = ({ defaultValue: e, options: t, setValue: n, id: r, canDeselect: i }) => {
	let a = u(void 0), [o, c] = d(!1), [l, f] = d(""), [p, m] = d(e), [h, g] = d(0), [_, v] = d(""), y = T(_, 500);
	s(() => {
		if (y) {
			let e = t.findIndex((e) => e.label.split(" ")[1].toLowerCase().startsWith(y.toLowerCase()));
			e > 0 && g(e);
		}
		v("");
	}, [y]), s(() => {
		function e(e) {
			a.current && !a.current.contains(e.target) && c(!1);
		}
		return document.addEventListener("mousedown", e), () => {
			document.removeEventListener("mousedown", e);
		};
	}, []), s(() => {
		n(p);
	}, [p]), s(() => {
		m(e);
	}, [e]), s(() => {
		o || (f(""), g(0));
	}, [o]), s(() => {
		o && S(C(h));
	}, [h, o]);
	function b(e) {
		switch (e.code) {
			case "ArrowDown":
			case "ArrowUp":
			case "Space":
			case "Enter":
			case "Home":
			case "End":
				e.preventDefault(), c(!o), g(e.code === "End" ? t.length - 1 : 0);
				break;
			case "Tab":
				c(!1), document.getElementById(`${r}-open-menu-button`)?.focus();
				break;
		}
	}
	function x(e) {
		switch (e.preventDefault(), e.code) {
			case "Tab":
				m(i && `${t[h].value}` === p ? "" : `${t[h].value}`), c(!1), document.getElementById(`${r}-open-menu-button`)?.focus();
				break;
			case "Enter":
			case "Space":
				m(i && `${t[h].value}` === p ? "" : `${t[h].value}`), c(!1), document.getElementById(`${r}-open-menu-button`)?.focus();
				break;
			case "ArrowDown":
				e.preventDefault(), g(h + 1 >= t.length ? 0 : h + 1);
				break;
			case "ArrowUp":
				e.preventDefault(), g(h - 1 < 0 ? t.length - 1 : h - 1);
				break;
			case "Home":
				e.preventDefault(), g(0);
				break;
			case "End":
				e.preventDefault(), g(t.length - 1);
				break;
			case "Esc":
				c(!1), document.getElementById(`${r}-open-menu-button`)?.focus();
				break;
			default: v(_ + e.key);
		}
	}
	function S(e) {
		if (!e) return;
		let t = document.getElementById(e);
		t && t.focus();
	}
	function C(e) {
		return `${r}-option-${e}`;
	}
	return {
		dropdownRef: a,
		setShowDropdown: c,
		showDropdown: o,
		activeElement: l,
		handleKeyPressOnButton: b,
		selectedElement: p,
		setActiveElement: f,
		setSelectedElement: m,
		handleKeyPressInList: x
	};
}, kn = ({ id: e, setValue: t, buttonLabel: n, options: r, defaultValue: i, canDeselect: a, buttonAriaLabel: o }) => {
	let { dropdownRef: s, setShowDropdown: c, showDropdown: l, activeElement: u, handleKeyPressOnButton: d, selectedElement: f, setActiveElement: h, setSelectedElement: g, handleKeyPressInList: _ } = On({
		defaultValue: i,
		options: r,
		setValue: t,
		id: e,
		canDeselect: a
	});
	return /* @__PURE__ */ m("div", {
		className: "country-select-drop-down-button-container",
		ref: s,
		children: [/* @__PURE__ */ m("button", {
			id: `${e}-open-menu-button`,
			name: `${n} select`,
			"aria-label": o,
			className: "country-select-dd-button",
			onClick: () => {
				c(!l);
			},
			role: "combobox",
			"aria-controls": e,
			"aria-owns": e,
			"aria-expanded": l,
			"aria-activedescendant": u,
			onKeyDown: (e) => d(e),
			type: "button",
			children: [/* @__PURE__ */ p("span", {
				className: "country-select-button-label",
				children: n
			}), /* @__PURE__ */ p(R, {
				iconName: M.CHEVRON_RIGHT,
				sizeInPx: "7",
				color: "var(--thriveOffBlack)",
				className: "chevron-down"
			})]
		}), l && /* @__PURE__ */ p("div", {
			className: "country-select-drop-down-container",
			id: e,
			role: "listbox",
			children: r.map((t, n) => /* @__PURE__ */ p("div", {
				tabIndex: -1,
				className: `country-select-dd-option ${f === t.value ? "selected" : u === `${e}-option-${n}` ? "active" : ""}`,
				id: `${e}-option-${n}`,
				role: "option",
				onMouseOver: () => {
					h(`${e}-option-${n}`);
				},
				onClick: () => {
					g(a && t.value === f ? "" : `${t.value}`), c(!1);
				},
				onKeyDown: (e) => _(e),
				onFocus: () => h(`${e}-option-${n}`),
				children: t.label
			}, `${e}-option-${n}`))
		})]
	});
}, An = ({ defaultData: e, phoneNumber: t, setPhoneNumberData: n, darkText: r, PhoneNumberInputStrings: i, localisedCountryNames: a }) => {
	let { hidePhoneNumberInput: o, handleCountryCode: c, formData: l, setFormData: u } = Dn(e);
	return o ? /* @__PURE__ */ p(f, {}) : (s(() => {
		n(l);
	}, [
		l.countryCode,
		l.phoneNumber,
		l.prefix
	]), /* @__PURE__ */ p("div", {
		className: `phone-number-input-container ${!r && "is-dark"}`,
		children: /* @__PURE__ */ p("div", {
			className: "phone-number-input-form",
			children: /* @__PURE__ */ m("div", {
				className: "phone-number-input-div",
				children: [/* @__PURE__ */ p(kn, {
					id: "country-select",
					setValue: (e) => c(e),
					buttonLabel: Cn(l.countryCode),
					options: Sn(a),
					defaultValue: l.countryCode,
					buttonAriaLabel: `select country - ${l.countryCode} selected`
				}), /* @__PURE__ */ p("input", {
					className: "phone-number-input",
					id: "phone-number-input",
					"data-testid": "phone-number-input",
					"aria-label": i?.AriaLabel,
					placeholder: t || i?.Placeholder,
					type: "tel",
					onInput: (e) => {
						let t = e.currentTarget.value.replace(/\D/g, "");
						u({
							...l,
							phoneNumber: t
						});
					},
					value: l.phoneNumber
				})]
			})
		})
	}));
}, jn = ({ id: e, className: t, labelText: n, labelIsHidden: r, placeholderText: i, textString: a, setTextString: o, maxLength: s, isDisabled: c, isReadOnly: l, buttonContent: u, onButtonClick: d }) => {
	let f = !a;
	return /* @__PURE__ */ m("div", {
		className: `basic-add-input-wrapper ${t ?? ""} `,
		children: [
			/* @__PURE__ */ p("label", {
				htmlFor: `basic-add-input-${e || ""}`,
				className: `${r ? "sr-only" : ""} basic-add-input-label`,
				children: n
			}),
			/* @__PURE__ */ p("input", {
				id: `basic-add-input-${e || ""}`,
				className: "basic-add-input",
				placeholder: i,
				value: a,
				onChange: (e) => o(e.target.value),
				"aria-label": "Add your Text",
				maxLength: s,
				disabled: c,
				readOnly: l
			}, e ? `basic-add-input-${e}` : ""),
			u && /* @__PURE__ */ p(F, {
				isDisabled: f || c,
				onButtonClick: d,
				content: u,
				ariaLabel: "Add",
				className: "add-button"
			})
		]
	});
}, Mn = ({ onRemoveItem: e, list: t, textString: n, setTextString: r, onAddTextClick: i, textInputLabel: a, inputPlaceholder: o }) => /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p("div", {
	className: "input-panel-tags",
	children: t.map((t, n) => /* @__PURE__ */ p(J, {
		content: t.title,
		closeAriaLabel: `Remove ${t.title} from selection`,
		onButtonClick: () => e(t.id)
	}, `${t.title}-${n}`))
}), /* @__PURE__ */ p(jn, {
	className: "add-input-panel-input",
	id: "add-input-panel-input",
	labelText: a ?? "",
	labelIsHidden: !a,
	placeholderText: o,
	setTextString: r,
	textString: n,
	buttonContent: "Add",
	onButtonClick: () => i()
})] }), Nn = ({ id: e, value: t, setValue: n, className: r, isDisabled: i = !1, placeholder: a, maxLength: o, labelText: s, labelIsHidden: c, hideMaxLength: l }) => {
	let u = !s || c;
	return /* @__PURE__ */ m("div", {
		className: "tc-textarea-wrapper",
		children: [
			/* @__PURE__ */ p("label", {
				htmlFor: `basic-text-area-${e || ""}`,
				className: `${u ? "sr-only" : ""} basic-text-input-label`,
				children: s
			}),
			/* @__PURE__ */ p("textarea", {
				id: `basic-text-area-${e || ""}`,
				className: `tc-textarea ${r ?? ""}`,
				placeholder: a ?? "",
				value: t,
				onChange: (e) => n(e.target.value),
				disabled: i,
				maxLength: o,
				"aria-label": u ? s ?? "Add your text" : ""
			}),
			!!o && !l && /* @__PURE__ */ m("span", {
				className: "tc-length-counter",
				children: [
					t.length,
					" / ",
					o
				]
			})
		]
	});
}, Pn = ({ codeLength: e = 5, size: t = 42, onChange: n }) => {
	let [r, i] = d([]), a = u([]);
	s(() => {
		i(Array(e).fill(""));
	}, [e]);
	function o(t, o) {
		let s = t.toUpperCase().slice(0, 1), c = r.map((e, t) => t === o ? s : e);
		i(c), n?.(c.join("")), s && o < e - 1 && a.current[o + 1]?.focus();
	}
	function c(t, n) {
		a && (n > 0 && (t.key === "Backspace" && !r[n] || t.key === "ArrowLeft") ? a.current[n - 1]?.focus() : n < e && (!Number.isNaN(+t.key) && r[n] || t.key === "ArrowRight") && a.current[n + 1]?.focus());
	}
	function l(t) {
		t.preventDefault();
		let r = t.clipboardData.getData("text").replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, e).split("");
		if (!r.length) return;
		let o = Array(e).fill("");
		r.forEach((e, t) => {
			o[t] = e, a.current[t] && (a.current[t].value = e);
		}), i(o), n?.(o.join(""));
		let s = Math.min(r.length, e - 1);
		a.current[s]?.focus();
	}
	return /* @__PURE__ */ p("div", {
		className: "tc-code-Input",
		children: r.map((e, n) => /* @__PURE__ */ p("input", {
			style: { "--input-character-size": `${t}px` },
			"data-testid": "recovery-form-code-input-item",
			className: "tc-code-input-item",
			"aria-label": `Input verification code value at index ${n + 1}`,
			type: "text",
			ref: (e) => {
				a.current[n] = e;
			},
			autoFocus: n === 0,
			id: `input-${n}`,
			value: e,
			maxLength: 1,
			pattern: "[a-zA-Z0-9]{1}",
			inputMode: "numeric",
			onKeyDown: (e) => {
				e.ctrlKey || e.metaKey || !/^[a-zA-Z0-9]$/.test(e.key) && e.key.length === 1 && e.preventDefault();
			},
			onChange: (e) => o(e.target.value.toUpperCase(), n),
			onKeyUp: (e) => c(e, n),
			onFocus: (e) => e.target.select(),
			onPaste: l
		}, `code-input-character-${n}`))
	});
}, Fn = ({ className: e, profilePictureUrl: t, placeholderText: n, commentString: r, setCommentString: i }) => /* @__PURE__ */ m("div", {
	className: `comment-text-input-wrapper ${e ?? ""} `,
	children: [
		/* @__PURE__ */ p("label", {
			htmlFor: "comment-input",
			className: "sr-only",
			children: "Add a comment"
		}),
		/* @__PURE__ */ p(Q, { profileImageUrl: t }),
		/* @__PURE__ */ p("input", {
			type: "text",
			id: "comment-input",
			className: "comment-input",
			placeholder: n,
			value: r,
			onChange: (e) => i(e.target.value),
			"aria-label": "Input Comment Text"
		})
	]
}), In = ({ className: e, ariaLabel: t, placeholder: n, setSearchString: r, searchString: i, isDisabled: a }) => {
	let o = c();
	return /* @__PURE__ */ m("div", {
		className: `simple-search-string-input-container ${e}`,
		children: [
			/* @__PURE__ */ p(R, {
				iconName: M.SEARCH_GLASS,
				color: "#9E9E9E",
				sizeInPx: "12"
			}),
			/* @__PURE__ */ p("input", {
				id: o,
				className: "search-string-input",
				type: "text",
				"aria-label": t,
				value: i,
				placeholder: n ?? "Search",
				onInput: (e) => {
					r(e?.target?.value);
				},
				disabled: a
			}),
			/* @__PURE__ */ p("label", {
				htmlFor: "simple-search-input sr-only",
				children: t
			})
		]
	});
}, Ln = ({ id: e, label: t, isPassword: n, setValue: r, defaultValue: i, placeholder: a, autoComplete: o, onReturnPressed: c, onBlur: l, disabled: u }) => {
	let [f, h] = d(i ?? ""), [g, _] = d(n);
	s(() => {
		r(f);
	}, [f]);
	function v() {
		_(!g);
	}
	return /* @__PURE__ */ m("div", {
		className: "thrive-component-form-element text-with-label",
		children: [
			/* @__PURE__ */ p("label", {
				htmlFor: e,
				children: t
			}),
			/* @__PURE__ */ p("input", {
				id: e,
				className: n ? "text-input-area password" : "text-input-area",
				type: g ? "password" : "text",
				placeholder: a,
				value: f,
				onChange: (e) => h(e.target.value),
				autoComplete: o,
				onKeyDown: (e) => {
					e.code === "Enter" && c?.();
				},
				onBlur: l ?? void 0,
				disabled: u
			}),
			n && /* @__PURE__ */ p("button", {
				name: g ? "show password" : "hide password",
				"aria-label": g ? "show password" : "hide password",
				className: "reveal-password-button",
				onClick: v,
				type: "button",
				disabled: u,
				children: /* @__PURE__ */ p(R, {
					iconName: g ? M.EYE_ON : M.EYE_OFF,
					sizeInPx: "22"
				})
			})
		]
	});
}, Rn = ({ showToast: e = !0, closeToast: t, toastOptions: n, children: r }) => (s(() => {
	e && setTimeout(() => {
		t(), n?.toastCompletionCallback?.();
	}, 5e3);
}, [e]), e ? /* @__PURE__ */ p("div", {
	className: "tcl-toast-wrapper",
	children: /* @__PURE__ */ m("div", {
		className: `tcl-toast ${n?.type}`,
		children: [!!n?.icon && /* @__PURE__ */ m("div", { children: [/* @__PURE__ */ p(R, {
			iconName: n?.icon,
			sizeInPx: "20",
			color: "var(--thriveWhite)"
		}), " "] }), /* @__PURE__ */ p("div", { children: r })]
	})
}) : /* @__PURE__ */ p(f, {})), zn = ({ ariaLabel: e, checked: t, onButtonClick: n, isDisabled: r = !1 }) => /* @__PURE__ */ p("button", {
	type: "button",
	className: `binary-toggle-button ${t ? "checked" : ""}`,
	"aria-label": e,
	"aria-pressed": t,
	disabled: r,
	onClick: n,
	children: /* @__PURE__ */ p("span", { className: "binary-toggle-button__thumb" })
}), Bn = () => /* @__PURE__ */ p("svg", {
	width: "14",
	height: "11",
	viewBox: "0 0 14 11",
	children: /* @__PURE__ */ p("path", {
		d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
		fill: "#fff",
		fillRule: "evenodd"
	})
}), Vn = () => /* @__PURE__ */ p("svg", {
	width: "10",
	height: "10",
	viewBox: "0 0 10 10",
	children: /* @__PURE__ */ p("path", {
		d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
		fill: "#fff",
		fillRule: "evenodd"
	})
});
//#endregion
//#region components/vendor/react-toggle/utils.ts
function Hn(e) {
	if (e) {
		let t = e.changedTouches;
		if (t && t.length > 0) {
			let e = t[0];
			return {
				x: e.clientX,
				y: e.clientY
			};
		}
		let n = e.pageX;
		if (n !== void 0) return {
			x: n,
			y: e.pageY
		};
	}
	return {
		x: 0,
		y: 0
	};
}
//#endregion
//#region components/vendor/react-toggle/toggle.tsx
var Un = {
	checked: /* @__PURE__ */ p(Bn, {}),
	unchecked: /* @__PURE__ */ p(Vn, {})
}, Wn = a(function(e, t) {
	let { className: n, icons: r, checked: i, defaultChecked: a, disabled: c, onChange: f, onFocus: h, onBlur: g, ..._ } = e, v = Object.prototype.hasOwnProperty.call(e, "checked"), [y, b] = d(!!(i || a)), [x, S] = d(!1), C = u(null), w = u(!!(i || a)), T = u(null), E = u(!1), D = u(!1);
	l(t, () => C.current), s(() => {
		v && b(!!i);
	}, [i]);
	let O = o((e) => {
		if (c) return;
		let t = C.current;
		if (!t) return;
		if (e.target !== t && !D.current) {
			w.current = t.checked, e.preventDefault(), t.focus(), t.click();
			return;
		}
		let n = v ? !!i : t.checked;
		b(n);
	}, [
		c,
		v,
		i
	]), k = o((e) => {
		c || (T.current = Hn(e).x, E.current = !0);
	}, [c]), A = o((e) => {
		if (E.current && (D.current = !0, T.current !== null)) {
			let t = Hn(e).x;
			y && t + 15 < T.current ? (b(!1), T.current = t, E.current = !0) : t - 15 > T.current && (b(!0), T.current = t, E.current = t < (T.current ?? 0) + 5);
		}
	}, [y]), j = o((e) => {
		if (!D.current) return;
		let t = C.current;
		if (t && (e.preventDefault(), T.current !== null)) {
			let n = Hn(e).x;
			w.current === !0 && T.current + 4 > n ? w.current !== y && (b(!1), w.current = y, t.click()) : T.current - 4 < n && w.current !== y && (b(!0), w.current = y, t.click()), E.current = !1, T.current = null, D.current = !1;
		}
	}, [y]), M = o((e) => {
		h && h(e), S(!0);
	}, [h]), N = o((e) => {
		g && g(e), S(!1);
	}, [g]), P = o((e) => r ? r === !0 || r[e] === void 0 ? Un[e] : r[e] : null, [r]);
	return /* @__PURE__ */ m("div", {
		className: (() => {
			let e = [n];
			return y && e.push("react-toggle--checked"), x && e.push("react-toggle--focus"), c && e.push("react-toggle--disabled"), e.join(" ");
		})(),
		onClick: O,
		onTouchStart: k,
		onTouchMove: A,
		onTouchEnd: j,
		children: [
			/* @__PURE__ */ m("div", {
				className: "react-toggle-track",
				children: [/* @__PURE__ */ p("div", {
					className: "react-toggle-track-check",
					children: P("checked")
				}), /* @__PURE__ */ p("div", {
					className: "react-toggle-track-x",
					children: P("unchecked")
				})]
			}),
			/* @__PURE__ */ p("div", { className: "react-toggle-thumb" }),
			/* @__PURE__ */ p("input", {
				..._,
				checked: y,
				disabled: c,
				onChange: f,
				ref: C,
				onFocus: M,
				onBlur: N,
				className: "react-toggle-screenreader-only",
				type: "checkbox"
			})
		]
	});
});
Wn.displayName = "Toggle";
//#endregion
//#region components/global/navigationBar/ClassicNavigationBar.tsx
var Gn = ({ navigationItems: e }) => e.length ? /* @__PURE__ */ p("nav", {
	id: "classic-navigation-container",
	className: "classic-navigation-container",
	"aria-label": "Navigate each tab",
	children: /* @__PURE__ */ p("ol", {
		className: "classic-navigation-bar",
		children: e.map((e, t) => /* @__PURE__ */ p("li", {
			className: "classic-navigation-item",
			children: /* @__PURE__ */ p("button", {
				type: "button",
				className: `classic-navigation-button ${e.isSelected ? "selected-navigation-item" : ""}`,
				onClick: () => {
					e.onClick?.();
				},
				children: e.title
			})
		}, t))
	})
}) : null;
//#endregion
export { N as ActionFeedback, Ct as ActionFeedbackBanner, Se as AddFormOptionButton, xt as AddImageFromMediaLibrary, Mn as AddInputPanelWithTags, Ne as AdditionOptionsContainer, xe as AdvancedSettingsButton, St as AlertError, ut as AppIcon, dt as AppIconWithTooltip, Ut as AudioPlayer, jn as BasicAddInput, Pe as BasicBreadcrumbs, F as BasicButton, U as BasicCheckbox, Ie as BasicCheckboxPanel, je as BasicEmailInput, Oe as BasicFormElementModal, qe as BasicRadioButton, ze as BasicSocialButtonPanel, Nn as BasicTextArea, B as BasicTextInput, X as BasicTooltip, zn as BinaryToggleButton, Ve as BoldTextButton, Qt as ButtonSelectModal, De as CancelConfirmModal, Ee as CancelConfirmPanel, Je as CaretButton, Pt as CheckboxList, Gn as ClassicNavigationBar, K as CloseButton, Pn as CodeInput, on as ColourButton, sn as ColourPicker, He as CommentButton, Fn as CommentTextInput, Ue as CommentsButton, ve as ConditionCheckboxPanel, Me as ConditionalEmailPanel, he as ConditonalLogicPanel, qt as ContentCarousel, Wt as ContentCarouselControls, mt as ContentImage, ht as ContentImagePreviewPanel, ot as ContentOrderSetter, kt as ContentPostInformation, Vt as ContentPreviewCarousel, Rt as ContentPreviewCarouselControls, Ye as CopyToClipboardButton, kn as CountrySelectDropdown, hn as DirectionalToggle, Xe as DismissablePillButton, it as Divider, Y as DragButton, be as EditElementDetails, We as ExternalLinkButton, gt as ExternalLoginIcon, _t as ExternalLoginUserImage, Ze as FilterStyleButton, Te as FormButtonElement, Ae as FormElementListWrapper, _e as FormElementSelectMenu, ke as FormElementWidget, $e as FullWidthActionButton, P as IFormElementType, z as IconButton, et as IconButtonWithTooltip, M as IconLibrary, Et as InformationContainer, Dt as InformationOval, rt as LargerRadioButton, Ge as LikeButton, Ke as LikesButton, Lt as LoadingSpinner, Ot as MediaInfo, $t as MediaModal, j as MediaType, Be as MenuButton, Fe as MinimalBreadcrumb, tt as MinimiseButton, ye as MinimisedElement, Zt as MobileAppPreview, wt as MutedInformationPanel, Re as NumberAnimation, ue as OnBlurTextInput, G as PanelButton, An as PhoneNumberInput, Q as ProfileImage, nt as RadioImageButton, ct as ReactCalendar, en as ReorderContentTilesModal, dn as SearchBar, ln as SearchBarButton, un as SearchBarInput, Ft as SelectButtonList, It as SelectItemList, In as SimpleSearchInput, bn as SimpleTable, At as SocialContentPost, J as TagButton, Ln as TextInputWithLabelAndPasswordToggle, Nt as TextOptionList, cn as ThemeColourPicker, lt as ThriveAppLogo, R as ThriveIcon, q as ThriveModal, Rn as ToastMessage, Wn as Toggle, L as ToggleSelectButton, W as UpDownButtonPanel, vt as UserActivityImage, yt as UserActivityProfileImage, bt as UserProfileImages, Jt as VideoPlayer, S as useBeforeNavigateAway, C as useClickAwayClose, w as useCountDown, T as useDebounce, E as useDetectClick, D as useInfiniteScroll, k as usePauseOtherMedia, A as useResizeListener };
